import type { AppTranslations } from './types'

export const fr = {
  amenities: {
    categories: {
      culture: 'Culture et divertissement',
      dining: 'Restaurants et bars',
      education: 'Éducation',
      grocery: 'Épicerie',
      healthcare: 'Santé',
      services: 'Services essentiels',
      shopping: 'Shopping',
      transport: 'Transports',
      wellness: 'Bien-être',
    },
    categoryCard: {
      clearFilters: 'Effacer les filtres',
      moreSubcategories: '+{{count}} de plus',
      noAmenities: 'Aucune commodité trouvée dans cette catégorie',
      noMatchingFilters: 'Aucune commodité ne correspond aux filtres actuels',
      showAll: 'Afficher tous les {{count}} autres',
      showingItems: 'Affichage de {{count}} sur {{total}} éléments',
      showMore: 'Afficher 10 de plus ({{count}} restants)',
    },
    error: {
      retry: 'Réessayer',
      title: 'Impossible de charger les données de commodités',
    },
    livabilityScore: 'Score de qualité de vie',
    loading: {
      description: "Analyse des points d'intérêt à proximité et calcul du score de qualité de vie",
      title: 'Chargement des données de commodités...',
    },
    noData: 'Aucune donnée de commodités disponible',
    pointsOfInterest: "Points d'intérêt",
    poiTypes: {
      adult_gaming_centre: 'Salle de jeux pour adultes',
      alcohol: 'Cave à vins',
      amusement_arcade: "Salle d'arcade",
      anime: 'Boutique anime',
      antiques: 'Antiquités',
      appliance: 'Électroménager',
      aquarium: 'Aquarium',
      art: "Galerie d'art",
      art_culture: 'Art et culture',
      art_music_hobbies: 'Art, musique et loisirs créatifs',
      arts_centre: 'Centre culturel',
      atm: 'Distributeur automatique',
      atv: 'Magasin de quads',
      baby_goods: 'Articles pour bébés',
      bag: 'Maroquinerie',
      bakery: 'Boulangerie',
      bandstand: 'Kiosque à musique',
      bank: 'Banque',
      bar: 'Bar',
      bathroom_furnishing: 'Aménagement salle de bain',
      beauty: 'Salon de beauté',
      bed: 'Literie',
      beverages: 'Boissons',
      bicycle: 'Magasin de vélos',
      biergarten: 'Jardin à bière',
      boat: 'Magasin nautique',
      boat_stop: 'Débarcadère',
      bookmaker: 'Bookmaker',
      books: 'Librairie',
      books_gifts: 'Livres et cadeaux',
      boutique: 'Boutique',
      bowling_alley: 'Bowling',
      brewing_supplies: 'Fournitures de brassage',
      bus_stop: 'Arrêt de bus',
      butcher: 'Boucherie',
      cable_car_stop: 'Arrêt de téléphérique',
      cafe: 'Café',
      camera: 'Magasin photo',
      candles: 'Bougies',
      cannabis: 'Boutique cannabis',
      car: 'Concessionnaire auto',
      car_parts: 'Pièces auto',
      car_repair: 'Garage auto',
      carpet: 'Magasin de tapis',
      casino: 'Casino',
      cheese: 'Fromagerie',
      chemist: 'Droguerie',
      chocolate: 'Chocolaterie',
      cinema: 'Cinéma',
      climbing: 'Escalade',
      clinic: 'Clinique',
      clothes: 'Magasin de vêtements',
      clothing: 'Vêtements',
      coffee: 'Torréfacteur',
      collector: 'Boutique de collection',
      college: 'Collège',
      community_centre: 'Centre communautaire',
      computer: 'Magasin informatique',
      confectionery: 'Confiserie',
      convenience: 'Supérette',
      copyshop: 'Reprographie',
      cosmetics: 'Cosmétiques',
      craft: 'Loisirs créatifs',
      curtain: 'Rideaux',
      dairy: 'Crémerie',
      dance: 'Danse',
      deli: 'Traiteur',
      dentist: 'Dentiste',
      department_store: 'Grand magasin',
      doctor: 'Médecin',
      doityourself: 'Bricolage',
      doors: 'Portes',
      dry_cleaning: 'Pressing',
      'e-cigarette': 'Cigarette électronique',
      electrical: 'Magasin électrique',
      electronics: 'Électronique',
      energy: 'Énergie',
      escape_game: 'Escape game',
      fabric: 'Mercerie',
      farm: 'Ferme',
      fashion: 'Mode',
      fast_food: 'Restauration rapide',
      financial: 'Services financiers',
      fireplace: 'Cheminées',
      fishing: 'Articles de pêche',
      fitness_centre: 'Centre de fitness',
      flooring: 'Revêtements de sol',
      florist: 'Fleuriste',
      food_court: 'Aire de restauration',
      frame: 'Encadrement',
      free_flying: 'Vol libre',
      frozen_food: 'Surgelés',
      fuel: 'Station-service',
      fuel_station: 'Station-service',
      funeral_directors: 'Pompes funèbres',
      furniture: 'Magasin de meubles',
      gallery: 'Galerie',
      games: 'Magasin de jeux',
      garden_centre: 'Jardinerie',
      garden_furniture: 'Mobilier de jardin',
      general: 'Magasin général',
      gift: 'Boutique cadeaux',
      golf_course: 'Parcours de golf',
      greengrocer: 'Primeur',
      hairdresser: 'Coiffeur',
      hairdresser_supply: 'Fournitures coiffure',
      hardware: 'Quincaillerie',
      health_beauty_store: 'Magasin de santé et beauté',
      health_food: 'Alimentation bio',
      hearing_aids: 'Appareils auditifs',
      herbalist: 'Herboristerie',
      hifi: 'Hi-Fi',
      horse_riding: 'Équitation',
      hospital: 'Hôpital',
      hospital_clinic: 'Hôpital et clinique',
      houseware: 'Articles ménagers',
      hunting: 'Armurerie',
      ice_cream: 'Glacier',
      ice_rink: 'Patinoire',
      interior_decoration: 'Décoration intérieure',
      jetski: 'Jet-ski',
      jewelry: 'Bijouterie',
      kindergarten: "Jardin d'enfants",
      kiosk: 'Kiosque',
      kitchen: 'Cuisines',
      lamps: 'Luminaires',
      laundry: 'Laverie',
      leather: 'Maroquinerie',
      leisure_tourism: 'Loisirs et tourisme',
      library: 'Bibliothèque',
      locksmith: 'Serrurier',
      lottery: 'Loterie',
      mall: 'Centre commercial',
      massage: 'Massage',
      medical_supply: 'Matériel médical',
      metro_station: 'Station de métro',
      miniature_golf: 'Mini-golf',
      mobile_phone: 'Téléphonie mobile',
      model: 'Modélisme',
      money_lender: 'Prêteur',
      motorcycle: 'Magasin moto',
      museum: 'Musée',
      music: 'Disquaire',
      music_school: 'École de musique',
      musical_instrument: 'Instruments de musique',
      newsagent: 'Marchand de journaux',
      nightclub: 'Boîte de nuit',
      nutrition_supplements: 'Compléments alimentaires',
      optician: 'Opticien',
      organic: 'Magasin bio',
      other_sport: 'Autre sport',
      outdoor: 'Magasin outdoor',
      outdoors_sport_vehicles: 'Plein air, sport et véhicules',
      paint: 'Peintures',
      park: 'Parc',
      park_forest: 'Parc et forêt',
      party: 'Articles de fête',
      pasta: 'Pâtes fraîches',
      pastry: 'Pâtisserie',
      perfumery: 'Parfumerie',
      pet: 'Animalerie',
      pharmacy: 'Pharmacie',
      photo: 'Photo',
      picnic_site: 'Aire de pique-nique',
      pitch: 'Terrain de sport',
      planetarium: 'Planétarium',
      plant_flower: 'Plantes et fleurs',
      playground: 'Aire de jeux',
      post_box: 'Boîte aux lettres',
      post_office: 'Bureau de poste',
      pub: 'Pub',
      pyrotechnics: "Feux d'artifice",
      radiotechnics: 'Radioélectronique',
      recycling: 'Point de recyclage',
      religion: 'Articles religieux',
      restaurant: 'Restaurant',
      robot: 'Robotique',
      running: 'Piste de course',
      sailing: 'Voile',
      school: 'École',
      scuba_diving: 'Plongée',
      seafood: 'Poissonnerie',
      second_hand: 'Occasion',
      security: 'Sécurité',
      sewing: 'Couture',
      shoes: 'Chaussures',
      shooting: 'Stand de tir',
      shopping_others: 'Autres commerces',
      skateboard: 'Skateboard',
      ski: 'Magasin de ski',
      snowmobile: 'Motoneige',
      social_centre: 'Centre social',
      specialty_food: 'Épicerie spécialisée',
      spices: 'Épices',
      sport_centre: 'Centre sportif',
      sports: 'Magasin de sport',
      sports_centre: 'Centre sportif',
      stadium: 'Stade',
      station: 'Gare',
      stationery: 'Papeterie',
      subway_entrance: 'Entrée de métro',
      supermarket: 'Supermarché',
      swimming: 'Natation',
      swimming_area: 'Zone de baignade',
      swimming_pool: 'Piscine',
      tailor: 'Tailleur',
      tattoo: 'Tatoueur',
      tea: 'Salon de thé',
      theatre: 'Théâtre',
      theme_park: "Parc d'attractions",
      ticket: 'Billetterie',
      tobacco: 'Bureau de tabac',
      toys: 'Magasin de jouets',
      trade: 'Négoce',
      train_station: 'Gare ferroviaire',
      tram_stop: 'Arrêt de tram',
      travel_agency: 'Agence de voyages',
      trophy: 'Trophées',
      tyres: 'Pneus',
      university: 'Université',
      vacant: 'Vacant',
      vacuum_cleaner: 'Aspirateurs',
      variety_store: 'Bazar',
      video: 'Vidéoclub',
      video_games: 'Jeux vidéo',
      watches: 'Horlogerie',
      water: 'Eau',
      weapons: 'Armurerie',
      wholesale: 'Grossiste',
      wine: 'Cave à vins',
      wood: 'Bois',
      zoo: 'Zoo',
    },
    radius: 'Rayon',
    sources: {
      googlePlaces: 'Google Places',
      label: 'Sources :',
      openStreetMap: 'OpenStreetMap',
      swissFederalStatisticalOffice: 'Office fédéral de la statistique suisse',
    },
    subcategories: {
      'Art & Culture': 'Art et culture',
      'Art, music, hobbies': 'Art, musique, loisirs',
      Bar: 'Bar',
      'Bus & Subway': 'Bus et métro',
      Cafe: 'Café',
      'Clothing, shoes, accessories': 'Vêtements, chaussures, accessoires',
      Convenience: 'Supérette',
      Dentist: 'Dentiste',
      Doctor: 'Médecin',
      Electronics: 'Électronique',
      Financial: 'Services financiers',
      'Fuel Station': 'Station-service',
      'Furniture and interior': 'Meubles et décoration',
      'Health and beauty': 'Santé et beauté',
      'Hospital & Clinic': 'Hôpital et clinique',
      Kindergarten: "Jardin d'enfants",
      'Leisure & Tourism': 'Loisirs et tourisme',
      Mall: 'Centre commercial',
      'Other Sport': 'Autres sports',
      Others: 'Autres',
      'Outdoor activity': 'Activités de plein air',
      'Outdoors and sport, vehicles': 'Plein air, sport et véhicules',
      'Park and Forest': 'Parc et forêt',
      Pharmacy: 'Pharmacie',
      Pitch: 'Terrain de sport',
      'Plant and flower': 'Plantes et fleurs',
      Playground: 'Aire de jeux',
      'Public Utility': 'Services publics',
      'Railway Station': 'Gare ferroviaire',
      Restaurant: 'Restaurant',
      School: 'École',
      'Specialty food store': 'Épicerie fine',
      'Sport Centre': 'Centre sportif',
      'Stationery, gifts, books, newspapers': 'Papeterie, cadeaux, livres, journaux',
      Supermarket: 'Supermarché',
      Swimming: 'Natation',
      University: 'Université',
    },
    subtitle: "Analyse des commodités locales et des points d'intérêt",
    title: 'Commodités',
    transitModes: {
      BOAT: 'Bateau',
      BUS: 'Bus',
      CABLE_CAR: 'Téléphérique',
      CABLE_RAILWAY: 'Funiculaire',
      CHAIRLIFT: 'Télésiège',
      METRO: 'Métro',
      RACK_RAILWAY: 'Chemin de fer à crémaillère',
      TRAIN: 'Train',
      TRAM: 'Tram',
    },
    walkTime: 'Temps de marche',
  },
  buildingAnalysis: {
    amenities: {
      loading: 'Chargement des commodités...',
      other_category: 'Autre',
      unknown_amenity: 'Inconnu',
    },
    building_title: 'Bâtiment {{egid}}',
    built_year: 'Construit en {{year}}',
    enums: {
      buildingCategory: {
        "Bâtiment d'habitation avec usage annexe": "Bâtiment d'habitation avec usage annexe",
        "Bâtiment exclusivement à usage d'habitation": "Bâtiment exclusivement à usage d'habitation",
        "Bâtiment partiellement à usage d'habitation": "Bâtiment partiellement à usage d'habitation",
        "Bâtiment sans usage d'habitation": "Bâtiment sans usage d'habitation",
        'Construction particulière': 'Construction particulière',
        'Habitation provisoire': 'Habitation provisoire',
      },
      buildingClass: {
        'Autre bâtiment non classé ailleurs': 'Autre bâtiment non classé ailleurs',
        "Autres bâtiments d'exploitation agricole": "Autres bâtiments d'exploitation agricole",
        "Autres bâtiments d'hébergement de tourisme": "Autres bâtiments d'hébergement de tourisme",
        "Autres bâtiments pour l'hébergement collectif": "Autres bâtiments pour l'hébergement collectif",
        "Bâtiment d'exploitation agricole": "Bâtiment d'exploitation agricole",
        'Bâtiment industriel': 'Bâtiment industriel',
        'Bâtiments commerciaux': 'Bâtiments commerciaux',
        "Bâtiments pour la garde d'animaux": "Bâtiments pour la garde d'animaux",
        'Bâtiments pour les cultures végétales': 'Bâtiments pour les cultures végétales',
        Garage: 'Garage',
        'Gares, aérogares, centraux téléphoniques': 'Gares, aérogares, centraux téléphoniques',
        'Habitat communautaire': 'Habitat communautaire',
        'Hôpital et établissement de santé': 'Hôpital et établissement de santé',
        'Immeuble à trois logements et plus': 'Immeuble à trois logements et plus',
        'Maison à deux logements': 'Maison à deux logements',
        'Maison individuelle': 'Maison individuelle',
        'Monument historique ou classé': 'Monument historique ou classé',
        'Réservoir, silo et entrepôt': 'Réservoir, silo et entrepôt',
        'Salle de sport': 'Salle de sport',
        'Salles de tir': 'Salles de tir',
      },
      buildingStatus: {
        autorisé: 'Autorisé',
        démoli: 'Démoli',
        'en construction': 'En construction',
        existant: 'Existant',
        inutilisable: 'Inutilisable',
        'non réalisé': 'Non réalisé',
        projeté: 'Projeté',
      },
    },
    environment: {
      loading: 'Chargement des données environnementales...',
      noise_levels: {
        moderate: 'Modéré',
        noisy: 'Bruyant',
        quiet: 'Silencieux',
        very_noisy: 'Très bruyant',
        very_quiet: 'Très silencieux',
      },
      sunlight_ratings: {
        excellent: 'Excellent',
        fair: 'Passable',
        good: 'Bon',
        poor: 'Mauvais',
      },
    },
    error_loading_data: 'Erreur de chargement des données',
    feasibility: {
      considerations: {
        excellent_transport: 'Excellent accès aux transports publics ({{quality}}) augmente la valeur du bien',
        high_energy: "Une consommation énergétique élevée peut dissuader les acheteurs soucieux de l'environnement",
        minergie: "La certification Minergie indique des coûts d'exploitation plus bas",
        moderate_age: 'Âge modéré du bâtiment ({{age}} ans) peut nécessiter des améliorations progressives',
        multiple_owners: 'Plusieurs propriétaires ({{count}}) peuvent compliquer la prise de décision',
        old_building: "L'âge du bâtiment ({{age}} ans) peut nécessiter un investissement de rénovation important",
        protected_status: 'Le statut protégé peut limiter les options de rénovation mais préserver la valeur',
        recent_activity: "L'activité de transaction récente indique une demande saine du marché",
        solar_potential: 'Un potentiel solaire important ({{area}}m²) peut compenser les coûts énergétiques',
        title: 'Considérations clés',
      },
      financial: {
        appreciation: {
          description: 'Potentiel de croissance de valeur à long terme basé sur la localisation et les facteurs de marché',
          label: "Potentiel d'appréciation de la valeur",
        },
        capital: {
          description: "Coûts de rénovation et d'amélioration attendus basés sur l'état du bâtiment",
          label: 'Besoins en capital',
        },
        complexity: {
          description: 'Complexité des transactions et de la prise de décision basée sur la structure de propriété',
          label: "Complexité de l'investissement",
        },
        operating: {
          description: "Coûts énergétiques et de maintenance continus basés sur les normes d'efficacité",
          label: "Coûts d'exploitation",
        },
        title: 'Indicateurs de faisabilité financière',
      },
      metrics: {
        building_age: {
          built_in: 'Construit en {{year}}',
          title: 'Âge du bâtiment',
          tooltip: {
            calculation: "Année actuelle moins l'année de construction",
            description: 'Âge du bâtiment depuis la construction originale',
            importance: "Affecte les besoins de rénovation, les préoccupations structurelles et le calendrier d'investissement",
            limitations: 'Ne reflète pas les reconstructions majeures ou les améliorations',
            source: 'Registre fédéral des bâtiments (RegBL)',
            title: "Évaluation de l'âge du bâtiment",
          },
          value: '{{years}} ans',
        },
        market_activity: {
          last_transaction: 'Dernière transaction : {{year}}',
          title: 'Activité du marché',
          tooltip: {
            calculation: "Nombre de transactions récentes et d'annonces actives",
            description: "Transactions récentes et activité d'annonces",
            importance: "Indique la liquidité du marché et l'intérêt des investisseurs",
            limitations: "Données historiques, non prédictives de l'activité future",
            source: "Bases de données de transactions et d'annonces",
            title: 'Activité récente du marché',
          },
          value: '{{count}} annonces',
        },
        ownership: {
          breakdown: '{{private}} privés, {{public}} publics',
          title: 'Structure de propriété',
          tooltip: {
            calculation: 'Nombre de propriétaires fonciers enregistrés',
            description: 'Nombre et type de propriétaires',
            importance: 'Affecte la complexité de la prise de décision et les processus de transaction',
            limitations: 'Basé sur le registre foncier, peut ne pas refléter toutes les parties prenantes',
            source: 'Registre foncier suisse',
            title: 'Complexité de la propriété',
          },
          value: '{{count}} propriétaire',
          value_plural: '{{count}} propriétaires',
        },
        renovation: {
          no_renovation: 'Pas de rénovation',
          renovated_in: 'Rénové en {{year}}',
          title: 'État de rénovation',
          tooltip: {
            calculation: 'Années depuis la dernière rénovation enregistrée',
            description: 'Temps depuis la dernière rénovation majeure',
            importance: "Indique les besoins de maintenance et les exigences potentielles d'investissement",
            limitations: 'Basé sur les registres officiels, peut ne pas inclure les améliorations mineures',
            source: 'Registre fédéral des bâtiments (RegBL)',
            title: 'Chronologie de rénovation',
          },
          value: 'Il y a {{years}} ans',
        },
      },
      no_data: "Aucune donnée d'étude de faisabilité n'est disponible pour ce bâtiment.",
      risk_assessment: {
        energy: {
          description: 'Risque de non-conformité aux normes énergétiques. Peut nécessiter des améliorations pour respecter les réglementations actuelles.',
          title: 'Risque de conformité énergétique',
        },
        market: {
          description: 'Indicateurs de liquidité et de demande du marché. Un risque plus faible suggère de meilleures opportunités de sortie.',
          title: 'Risque de marché',
        },
        renovation: {
          description: "Évaluation des besoins de rénovation basée sur l'âge et l'historique de maintenance. Un risque plus élevé indique des besoins en capital plus importants.",
          title: 'Risque de rénovation',
        },
        structural: {
          description: "Basé sur l'âge du bâtiment et les indicateurs structurels. Les bâtiments plus anciens peuvent nécessiter des évaluations structurelles plus approfondies.",
          title: 'Risque structurel',
        },
        title: 'Évaluation des risques',
      },
      risk_levels: {
        high: 'Risque élevé',
        low: 'Risque faible',
        medium: 'Risque modéré',
      },
      subtitle: "Viabilité de l'investissement et évaluation des risques",
      title: 'Étude de faisabilité',
      values: {
        high: 'Élevé',
        low: 'Faible',
        moderate: 'Modéré',
        variable: 'Variable',
      },
    },
    history: {
      empty_state: {
        no_data: {
          description: "Aucun événement historique ou donnée chronologique n'est disponible pour ce bâtiment. Cela peut être dû à des enregistrements limités ou à une construction récente.",
          title: 'Aucune donnée historique disponible',
        },
        no_matches: {
          description: "Essayez d'ajuster vos filtres pour voir plus d'événements historiques.",
          title: 'Aucun événement ne correspond à vos filtres',
        },
      },
      events: {
        building_permit: 'Permis de construire',
        for_rent: '{{propertyType}} à louer',
        for_sale: '{{propertyType}} à vendre',
        property_transaction: 'Transaction immobilière',
        rental_listing: 'Annonce de location',
        sale_listing: 'Annonce de vente',
      },
      filters: {
        building_permits: 'Permis de construire',
        rentals: 'Locations',
        sales: 'Ventes',
        transactions: 'Transactions',
      },
      labels: {
        online_days: 'En ligne {{count}} jours',
        owner: 'Propriétaire: {{name}}',
        participants: '{{count}} participants',
        permit_number: 'Permis n°{{number}}',
        properties_one: '{{count}} propriété',
        properties_other: '{{count}} propriétés',
        status_active: 'Actif',
        status_inactive: 'Inactif',
      },
    },
    listings: {
      filters: {
        any: 'Tout',
      },
      loading: 'Chargement des annonces...',
    },
    loading: "Chargement de l'analyse du bâtiment...",
    loading_failed: "Échec du chargement des données d'analyse du bâtiment",
    market: {
      available: 'Disponible',
      loading: 'Chargement des données de marché...',
      no_listings: 'Aucune annonce',
      properties: 'Propriétés',
      purchase: 'Achat',
      rental: 'Location',
      rentals: 'Locations',
    },
    overview: {
      building_overview: 'Aperçu du bâtiment',
      elevator: 'Ascenseur',
      property_features: 'Caractéristiques de la propriété',
    },
    section_not_shared: {
      description: "La section {{sectionName}} n'a pas été incluse dans cette analyse partagée.",
      title: 'Section non partagée',
    },
    sidebar: {
      items: {
        amenities: 'Commodités',
        buildingCharacteristics: 'Caractéristiques du bâtiment',
        buildingPermits: 'Permis de construire',
        demographics: 'Démographie',
        electricity: 'Électricité',
        employment: 'Emploi',
        energy: 'Énergie',
        history: 'Historique',
        noiseAnalysis: 'Analyse du bruit',
        purchaseListings: 'Annonces achat',
        purchaseMarket: 'Marché achat',
        rentalListings: 'Annonces location',
        rentalMarket: 'Marché location',
        summary: 'Résumé',
        sunlightStudy: "Étude d'ensoleillement",
        taxes: 'Impôts',
        transactions: 'Transactions',
        transportAccess: 'Transport & Accès',
        unitDetails: 'Détails des unités',
      },
      sections: {
        development: 'Développement',
        environment: 'Environnement',
        market: 'Marché',
        overview: 'Aperçu',
        socialEconomic: 'Social & Économique',
      },
    },
    summaryTab: {
      activity: {
        buildingPermits: 'Permis de construire',
        listingDetail_one: '{{count}} annonce, derniere en {{year}}',
        listingDetail_other: '{{count}} annonces, dernieres en {{year}}',
        noData: 'Aucune donnee disponible',
        permitDetail_one: '{{count}} permis, dernier en {{year}}',
        permitDetail_other: '{{count}} permis, derniers en {{year}}',
        recentTransactions: 'Transactions recentes',
        rentalListings: 'Annonces de location',
        saleListings: 'Annonces de vente',
        transactionDetail_one: '{{count}} transaction, derniere en {{year}}',
        transactionDetail_other: '{{count}} transactions, dernieres en {{year}}',
      },
      error: 'Erreur lors du chargement du resume :',
      labels: {
        address: 'Adresse',
        buildingCategory: 'Categorie de batiment',
        buildingType: 'Type de batiment',
        district: 'District',
        egid: 'ID du batiment (EGID)',
        institutionalOwners: 'Proprietaires institutionnels',
        municipality: 'Commune',
        numberOfOwners: 'Nombre de proprietaires',
        privateOwners: 'Proprietaires prives',
        publicOwners: 'Proprietaires publics',
        status: 'Statut',
        unknown: 'Inconnu',
      },
      loading: 'Chargement du resume du batiment...',
      metrics: {
        buildingVolume: {
          subtext: 'm3',
          title: 'Volume du batiment',
          tooltip: {
            calculation: "Calcule a partir de l'emprise au sol et des mesures de hauteur",
            importance: "Utilise pour les calculs d'assurance et les reglementations du batiment",
            shortDescription: 'Volume cubique total de la structure du batiment',
            source: 'Registre federal des batiments (RegBL)',
            title: 'Volume du batiment',
          },
        },
        dwellingArea: {
          subtext: 'Unite mediane : {{value}}m2',
          title: 'Surface habitable',
          tooltip: {
            calculation: 'Somme des surfaces habitables de toutes les unites enregistrees',
            importance: "Indicateur cle de la valeur locative et de la capacite d'habitation",
            shortDescription: 'Somme de toutes les surfaces habitables du batiment',
            source: 'Registre federal des batiments (RegBL)',
            title: 'Surface habitable totale',
          },
        },
        floors: {
          subtext: 'Hauteur : {{value}}m',
          title: 'Etages',
          tooltip: {
            calculation: 'Comprend le rez-de-chaussee et tous les niveaux superieurs',
            importance: "Important pour les exigences d'ascenseur et les reglementations d'accessibilite",
            shortDescription: "Nombre total d'etages hors sol",
            source: 'Registre federal des batiments (RegBL)',
            title: "Nombre d'etages",
          },
        },
        totalArea: {
          subtext: 'Unite mediane : {{value}}m2',
          title: 'Surface totale',
          tooltip: {
            calculation: 'Somme de toutes les surfaces au sol du Registre federal des batiments (RegBL)',
            importance: 'Indicateur cle pour comprendre la capacite du batiment et la valeur locative/de vente potentielle',
            limitations: "N'inclut pas les parties communes, le parking ou les espaces de stockage",
            shortDescription: 'La surface au sol combinee de toutes les unites du batiment',
            source: 'Registre federal des batiments (RegBL)',
            title: 'Surface totale du batiment',
          },
        },
        units: {
          subtext: 'Mediane : {{value}} pieces',
          title: 'Unites',
          tooltip: {
            calculation: "Nombre d'unites de logement enregistrees au registre federal",
            importance: "Essentiel pour comprendre la densite du batiment et le potentiel d'investissement",
            shortDescription: 'Nombre total de logements dans le batiment',
            source: 'Registre federal des batiments (RegBL)',
            title: "Nombre d'unites",
          },
        },
        yearBuilt: {
          subtext: 'Renove : {{value}}',
          title: 'Annee de construction',
          tooltip: {
            importance: 'Affecte les reglementations du batiment, les besoins de renovation et la valeur immobiliere',
            shortDescription: "L'annee de construction originale du batiment",
            source: 'Registre federal des batiments (RegBL)',
            title: 'Annee de construction',
          },
        },
      },
      noData: 'Aucune donnee de batiment disponible',
      sections: {
        buildingInfo: 'Informations sur le batiment',
        ownership: 'Propriete',
        recentActivity: 'Activite recente',
      },
      subtitle: 'Apercu de {{address}}, {{municipality}}',
      title: 'Resume du batiment',
    },
    tabs: {
      amenities: 'Commodités',
      history: 'Historique',
      noise: 'Bruit',
      overview: 'Aperçu',
      purchase_market: "Marché d'achat",
      rental_market: 'Marché locatif',
      sunlight: 'Ensoleillement',
      transactions: 'Transactions',
      units: 'Unités',
    },
    title: 'Analyse de bâtiment',
    transactions: {
      loading: 'Chargement des données de transaction...',
      types: {
        all_types: 'Tous les types',
        auction: 'Enchère',
        rental: 'Location',
        sale: 'Vente',
      },
    },
    units: {
      balcony: 'Balcon',
      floor: 'Étage',
      unknown_floor: 'Étage inconnu',
    },
  },
  buildings: {
    characteristics: {
      common: {
        na: 'N/D',
        no: 'Non',
        source: 'Données du Registre fédéral des bâtiments et des logements (RegBL)',
        sourceCalculated: 'Calculé à partir des données disponibles du bâtiment',
        years: 'ans',
        yes: 'Oui',
      },
      header: {
        subtitle: 'Analyse physique, historique et comparative complète du bâtiment',
        title: 'Caractéristiques du bâtiment',
      },
      neighborhood: {
        ageRanges: {
          '1919_1945': '1919-45',
          '1946_1960': '1946-60',
          '1961_1970': '1961-70',
          '1971_1980': '1971-80',
          '1981_1990': '1981-90',
          '1991_2000': '1991-00',
          '2001_2010': '2001-10',
          '2011_2020': '2011-20',
          post2020: 'Après 2020',
          pre1919: 'Avant 1919',
        },
        badges: {
          buildingOutlier: '⚠️ Bâtiment atypique',
        },
        cards: {
          ageDistribution: {
            title: "Distribution de l'âge des bâtiments",
          },
          areaComparison: {
            title: 'Comparaison de surface au sol',
            tooltip: {
              calculation: 'Compare la surface au sol de ce bâtiment avec les surfaces moyenne et maximale des bâtiments voisins',
              description: "Comment l'emprise au sol de ce bâtiment se compare aux bâtiments environnants",
              importance: "L'emprise au sol par rapport aux voisins indique l'intensité d'utilisation du sol, la densité de développement et si le bâtiment est typique pour la zone.",
              limitations: "L'emprise au sol seule ne reflète pas la taille totale du bâtiment. Vérifiez le nombre d'étages et la surface brute de plancher pour une évaluation complète.",
              title: 'Comparaison de surface avec les voisins',
            },
          },
          cohesionBreakdown: {
            title: 'Répartition de la cohésion',
          },
          comparativeAnalysis: {
            title: 'Analyse comparative',
          },
          conformityBreakdown: {
            title: 'Répartition de la conformité du bâtiment',
            tooltip: {
              calculation: 'Compare les caractéristiques de ce bâtiment au profil typique du quartier',
              description: 'Montre à quel point ce bâtiment spécifique correspond au modèle du quartier',
              importance: "Une faible conformité dans un quartier cohérent indique un bâtiment atypique, ce qui peut affecter la valorisation, les restrictions de développement ou l'harmonie architecturale.",
              title: 'Répartition de la conformité du bâtiment',
            },
          },
          heightComparison: {
            title: 'Comparaison de hauteur',
            tooltip: {
              calculation: 'Compare la hauteur totale de ce bâtiment avec les hauteurs moyenne et maximale des bâtiments voisins dans un rayon défini (généralement 100-200m)',
              description: 'Comment la hauteur de ce bâtiment se compare aux bâtiments environnants',
              importance: "La hauteur du bâtiment par rapport aux voisins affecte les vues, l'exposition au soleil, la vie privée, l'harmonie architecturale et la conformité aux règlements de zone locaux.",
              limitations: "Comparaison basée sur les bâtiments dans le rayon de recherche. La topographie locale et les différences d'altitude du terrain ne sont pas reflétées dans cette métrique.",
              title: 'Comparaison de hauteur avec les voisins',
            },
          },
          neighborhoodAnalysis: {
            title: 'Analyse du quartier et du bâtiment',
            tooltip: {
              calculation: 'La cohésion du quartier mesure à quel point les bâtiments environnants sont similaires. La conformité du bâtiment mesure à quel point CE bâtiment correspond au modèle du quartier.',
              description: "Analyse à la fois la cohésion du quartier et dans quelle mesure ce bâtiment s'intègre au quartier détecté",
              importance: 'Une cohésion élevée avec une conformité faible indique un bâtiment atypique dans un quartier cohérent, ce qui peut affecter la valorisation et le potentiel de développement.',
              title: 'Analyse du quartier et du bâtiment',
            },
          },
          quartierProfile: {
            title: 'Profil du quartier',
          },
          volumeComparison: {
            title: 'Comparaison de volume',
            tooltip: {
              calculation: 'Compare le volume total fermé de ce bâtiment avec les volumes moyen et maximal des bâtiments voisins',
              description: 'Comment le volume total de ce bâtiment se compare aux bâtiments environnants',
              importance: "Le volume du bâtiment est un indicateur clé de la masse totale et de l'intensité de développement. Utilisé pour la modélisation énergétique et la planification des capacités CVC.",
              limitations: 'Les calculs de volume peuvent utiliser des hypothèses géométriques simplifiées. Le volume interne réel peut varier en raison de la géométrie du toit et des agencements intérieurs.',
              title: 'Comparaison de volume avec les voisins',
            },
          },
        },
        chart: {
          areaAxis: 'Surface (m²)',
          buildingsAxis: 'Bâtiments',
          heightAxis: 'Hauteur (m)',
          neighborhoodAvg: 'Moyenne du quartier',
          neighborhoodMax: 'Maximum du quartier',
          thisBuilding: 'Ce bâtiment',
          volumeAxis: 'Volume (m³)',
        },
        cohesion: {
          density: {
            label: 'Cohésion de densité (10%)',
            tooltip: {
              calculation: 'Basé sur le nombre de bâtiments par kilomètre carré. Une densité plus élevée suggère un quartier urbain.',
              description: 'Mesure la densité de développement',
              title: 'Cohésion de densité',
            },
          },
          physical: {
            label: 'Cohésion physique (30%)',
            tooltip: {
              calculation: "Basé sur la similarité de hauteur, surface et nombre d'étages. Des scores plus élevés indiquent des caractéristiques de bâtiment uniformes.",
              description: 'Mesure la similarité architecturale',
              title: 'Cohésion physique',
            },
          },
          temporal: {
            label: 'Cohésion temporelle (40%)',
            tooltip: {
              calculation: 'Basé sur la similarité des années de construction. Des scores plus élevés indiquent des bâtiments de la même époque.',
              description: 'Mesure si les bâtiments ont été construits dans la même période',
              title: 'Cohésion temporelle',
            },
          },
          typological: {
            label: 'Cohésion typologique (20%)',
            tooltip: {
              calculation: 'Basé sur la prévalence de catégories de bâtiments similaires (ex: maison individuelle, immeuble, etc.)',
              description: 'Mesure la similarité des types de bâtiments',
              title: 'Cohésion typologique',
            },
          },
        },
        comparison: {
          aboveAverage: '{{percent}}% au-dessus de la moyenne',
          belowAverage: '{{percent}}% en-dessous de la moyenne',
          similar: 'Similaire à la moyenne',
        },
        conformity: {
          fitsWell: "S'intègre bien",
          outlier: 'Atypique',
          partialFit: 'Intégration partielle',
          physicalMatch: {
            label: 'Correspondance physique (40%)',
            tooltip: {
              calculation: "Moyenne de la similarité de hauteur, surface et nombre d'étages. ±20-30% = haute correspondance",
              description: 'Dans quelle mesure la taille et la hauteur de ce bâtiment correspondent au quartier typique',
              title: 'Correspondance physique',
            },
          },
          temporalMatch: {
            label: 'Correspondance temporelle (40%)',
            tooltip: {
              calculation: "Compare l'année du bâtiment à l'année typique. ±5 ans = 100%, ±10 ans = 75%, ±20 ans = 50%",
              description: "Dans quelle mesure l'année de construction de ce bâtiment correspond à la période typique du quartier",
              title: 'Correspondance temporelle',
            },
          },
          typologicalMatch: {
            label: 'Correspondance typologique (20%)',
            tooltip: {
              calculation: '100 si même catégorie que typique, 0 si différent',
              description: 'Si le type de ce bâtiment correspond à la catégorie dominante du quartier',
              title: 'Correspondance typologique',
            },
          },
        },
        errors: {
          loadFailed: "Échec du chargement de l'analyse du quartier",
        },
        loading: "Chargement de l'analyse du quartier...",
        metrics: {
          areaVsAverage: {
            label: 'Surface vs moyenne',
            tooltip: {
              calculation: 'Différence en pourcentage par rapport à la surface moyenne des bâtiments dans le rayon de recherche',
              description: "Comment l'emprise de ce bâtiment se compare aux bâtiments voisins",
              importance: 'Indique si le bâtiment est typique ou inhabituellement grand/petit pour la zone. Affecte le COS et le potentiel de développement.',
              title: 'Surface vs moyenne du quartier',
            },
          },
          avgNeighborAge: {
            label: 'Âge moyen des voisins',
            tooltip: {
              calculation: 'Moyenne des âges de tous les bâtiments dans le rayon de recherche',
              description: 'Âge moyen des bâtiments environnants',
              importance: 'Indique si le quartier est principalement ancien (>50 ans), établi (20-50 ans) ou nouveau (<20 ans).',
              title: 'Âge moyen des voisins',
            },
            value: '{{years}} ans',
          },
          buildingConformity: 'Conformité du bâtiment',
          buildingDensity: {
            label: 'Densité de bâtiments',
            tooltip: {
              calculation: 'Nombre de bâtiments dans un rayon défini divisé par la surface de ce rayon',
              description: 'Nombre de bâtiments par unité de surface dans la zone environnante',
              importance: 'Indique si la zone est urbaine, suburbaine ou rurale. Une densité élevée suggère un environnement urbain avec des bâtiments plus proches.',
              title: 'Densité de bâtiments',
            },
            value: '{{density}} bâtiments/km²',
          },
          buildingsAnalyzed: 'Bâtiments analysés',
          confidence: 'Confiance',
          heightVsAverage: {
            label: 'Hauteur vs moyenne',
            tooltip: {
              calculation: 'Différence en pourcentage par rapport à la hauteur moyenne des bâtiments dans le rayon de recherche',
              description: 'Comment la hauteur de ce bâtiment se compare aux bâtiments voisins',
              importance: 'Les bâtiments nettement plus hauts ou plus bas que les voisins peuvent faire face à des restrictions de zone ou se démarquer visuellement.',
              title: 'Hauteur vs moyenne du quartier',
            },
          },
          neighborhoodCohesion: 'Cohésion du quartier',
          neighboringBuildings: {
            label: 'Bâtiments voisins',
            tooltip: {
              calculation: 'Nombre de bâtiments trouvés dans le rayon de recherche sélectionné',
              description: "Nombre de bâtiments dans le rayon d'analyse",
              importance: 'Plus de voisins fournissent une meilleure comparaison statistique. Moins de 10 voisins peut indiquer une zone rurale ou une fiabilité des données limitée.',
              title: 'Bâtiments voisins',
            },
          },
          volumeVsAverage: {
            label: 'Volume vs moyenne',
            tooltip: {
              calculation: 'Différence en pourcentage par rapport au volume moyen des bâtiments dans le rayon de recherche',
              description: 'Comment le volume de ce bâtiment se compare aux bâtiments voisins',
              importance: 'Les volumes plus grands indiquent des structures plus importantes. Affecte les coûts de chauffage et la densité de développement.',
              title: 'Volume vs moyenne du quartier',
            },
          },
        },
        neighboringBuildings: '{{count}} bâtiments voisins',
        noData: 'Aucune donnée de comparaison de quartier disponible pour ce bâtiment',
        notes: {
          differsByPattern: 'Ce bâtiment diffère significativement du modèle du quartier.',
          physicalMismatch: 'La taille/hauteur diffère significativement.',
          temporalMismatch: 'Décalage de période de construction.',
          title: 'Note :',
          typologicalMismatch: 'Le type de bâtiment diffère de la catégorie dominante.',
        },
        profile: {
          description: {
            label: 'Description',
            tooltip: {
              calculation: "Généré à partir de l'année de construction typique et de la catégorie dominante",
              description: 'Caractérisation résumée du quartier',
              importance: "Fournit un aperçu rapide du caractère du quartier (ex: 'résidentiel des années 1960' ou 'mixte des années 1980').",
              title: 'Description du quartier',
            },
          },
          developmentPattern: {
            categories: {
              mixed: {
                description: 'Cohésion modérée, développement varié (score 55-74)',
                label: 'Mixte',
              },
              organic: {
                description: 'Faible cohésion, développement diversifié (score <55)',
                label: 'Organique',
              },
              planned: {
                description: 'Haute cohésion, développement uniforme (score ≥75)',
                label: 'Planifié',
              },
            },
            label: 'Modèle de développement',
            tooltip: {
              description: 'Classification du style de développement du quartier',
              importance: 'Les zones planifiées ont une zone plus strict. Les zones organiques offrent plus de flexibilité de rénovation.',
              title: 'Modèle de développement',
            },
          },
          typicalArea: {
            label: 'Surface typique',
            tooltip: {
              calculation: 'Surface au sol moyenne des bâtiments du quartier',
              description: 'Emprise au sol représentative pour le quartier',
              importance: "Indique la couverture du lot typique et l'échelle des bâtiments dans la zone.",
              title: 'Surface typique',
            },
          },
          typicalCategory: {
            label: 'Catégorie typique',
            tooltip: {
              calculation: 'Catégorie de bâtiment la plus courante parmi les bâtiments du quartier',
              description: 'Type de bâtiment dominant dans le quartier',
              importance: 'Définit le caractère du quartier : résidentiel, commercial, industriel ou mixte.',
              title: 'Catégorie typique',
            },
          },
          typicalHeight: {
            label: 'Hauteur typique',
            tooltip: {
              calculation: 'Hauteur moyenne des bâtiments du quartier',
              description: 'Hauteur de bâtiment représentative pour le quartier',
              importance: 'Indique si la zone est principalement de faible hauteur (<10m), moyenne hauteur (10-25m) ou grande hauteur (>25m).',
              title: 'Hauteur typique',
            },
          },
          typicalYear: {
            label: 'Année de construction typique',
            tooltip: {
              calculation: 'Année de construction moyenne des bâtiments du quartier',
              description: 'Année de construction la plus représentative pour le quartier',
              importance: "Définit l'ère architecturale et les normes de construction probables pour la zone.",
              title: 'Année de construction typique',
            },
          },
        },
        radius: {
          label: 'Rayon',
          value: 'Rayon de {{radius}}m',
        },
        statistics: {
          area: {
            mean: {
              tooltip: {
                calculation: 'Moyenne arithmétique de toutes les surfaces de bâtiments',
                description: 'Emprise au sol moyenne dans le quartier',
                importance: 'Indique la taille typique du lot. Influencé par les valeurs aberrantes.',
                title: 'Surface moyenne',
              },
            },
            median: {
              tooltip: {
                calculation: '50e percentile des surfaces de bâtiments',
                description: 'Valeur médiane des surfaces de bâtiments du quartier',
                importance: 'Plus représentatif que la moyenne lorsque des valeurs aberrantes existent.',
                title: 'Surface médiane',
              },
            },
            range: {
              tooltip: {
                calculation: 'Emprises au sol les plus petites et les plus grandes du quartier',
                description: 'Surfaces minimale et maximale des bâtiments',
                importance: 'Montre la diversité des tailles. Une large étendue indique des échelles de bâtiments mixtes.',
                title: 'Étendue des surfaces',
              },
            },
            title: 'Statistiques de surface',
          },
          floor: {
            floorsRange: '{{min}} - {{max}} étages',
            floorsValue: '{{floors}} étages',
            mean: {
              tooltip: {
                calculation: "Moyenne arithmétique de tous les nombres d'étages",
                description: "Nombre moyen d'étages dans le quartier",
                importance: "Indique l'échelle typique des bâtiments. Influencé par les valeurs aberrantes.",
                title: "Nombre d'étages moyen",
              },
            },
            median: {
              tooltip: {
                calculation: "50e percentile des nombres d'étages",
                description: "Valeur médiane des nombres d'étages du quartier",
                importance: 'Plus représentatif que la moyenne lorsque des valeurs aberrantes existent.',
                title: "Nombre d'étages médian",
              },
            },
            range: {
              tooltip: {
                calculation: "Nombres d'étages les plus bas et les plus hauts du quartier",
                description: "Nombres d'étages minimum et maximum",
                importance: 'Montre la diversité verticale. Une large étendue indique des niveaux de hauteur mixtes.',
                title: "Étendue du nombre d'étages",
              },
            },
            title: "Statistiques d'étages",
          },
          height: {
            mean: {
              tooltip: {
                calculation: 'Moyenne arithmétique de toutes les hauteurs de bâtiments',
                description: 'Hauteur moyenne des bâtiments dans le quartier',
                importance: "Indique l'échelle typique des bâtiments. Influencé par les valeurs aberrantes.",
                title: 'Hauteur moyenne',
              },
            },
            median: {
              tooltip: {
                calculation: '50e percentile des hauteurs de bâtiments',
                description: 'Valeur médiane des hauteurs de bâtiments du quartier',
                importance: 'Plus représentatif que la moyenne lorsque des valeurs aberrantes existent.',
                title: 'Hauteur médiane',
              },
            },
            range: {
              tooltip: {
                calculation: 'Hauteurs de bâtiment les plus basses et les plus hautes du quartier',
                description: 'Hauteurs minimale et maximale des bâtiments',
                importance: 'Montre la diversité des hauteurs. Une large étendue indique un développement mixte.',
                title: 'Étendue des hauteurs',
              },
            },
            title: 'Statistiques de hauteur',
          },
          mean: 'Moyenne',
          median: 'Médiane',
          range: 'Étendue',
        },
        title: 'Contexte du quartier',
        tooltips: {
          source: 'Registre fédéral des bâtiments et des logements (RegBL)',
          sourceCalculated: 'Calculé à partir des données du registre des bâtiments',
        },
        warnings: {
          outlierDescription: "Ce bâtiment ne correspond pas au modèle cohérent du quartier. Il peut être atypique en termes d'âge, de taille ou de type par rapport aux bâtiments environnants.",
          outlierTitle: '⚠️ Avertissement :',
        },
      },
      overview: {
        ageCategories: {
          contemporary: {
            description: 'Construit avec des méthodes et matériaux relativement récents',
            label: 'Contemporain',
            range: '10-30 ans',
          },
          historic: {
            description: 'Bâtiment historique avec potentiellement une valeur patrimoniale et des caractéristiques de caractère',
            label: 'Historique',
            range: '>50 ans',
          },
          mature: {
            description: 'Bâtiment établi pouvant bénéficier de rénovation ou modernisation',
            label: 'Mature',
            range: '30-50 ans',
          },
          new: {
            description: 'Construction récente avec des normes modernes et une efficacité énergétique',
            label: 'Neuf',
            range: '<10 ans',
          },
        },
        cards: {
          dimensions: {
            buildingVolume: 'Volume du bâtiment',
            footprintArea: 'Surface au sol',
            grossFloorArea: 'Surface brute de plancher',
            groundElevation: 'Altitude au sol',
            title: 'Dimensions physiques',
            tooltips: {
              elevation: {
                calculation: "Mesuré à partir de modèles numériques de terrain en utilisant l'altitude moyenne à l'emprise du bâtiment",
                description: "Hauteur du niveau du sol à l'emplacement du bâtiment au-dessus du niveau de la mer",
                importance: "Important pour l'évaluation du risque d'inondation, la planification du drainage et la compréhension de la topographie locale",
                title: 'Altitude au sol',
              },
              footprintImportance: 'Détermine la couverture du terrain et est crucial pour calculer le potentiel de développement et la conformité aux réglementations de zone',
              grossFloorArea: {
                calculation: "Somme de toutes les surfaces de plancher y compris les murs, escaliers et espaces communs. Calculé à partir du registre des bâtiments ou surface au sol × nombre d'étages",
                description: 'Surface totale de tous les étages, mesurée à la face extérieure des murs extérieurs',
                importance: "Métrique clé pour l'évaluation immobilière, les calculs de loyer et la comparaison des tailles de bâtiments",
                limitations: 'Peut inclure des zones non habitables comme les couloirs et locaux techniques. La surface utile nette est généralement 10-25% plus petite',
                title: 'Surface brute de plancher',
              },
              heightCalculation: "Hauteur mesurée du niveau du sol au faîte du toit à l'aide de données LiDAR et de relevés officiels",
              heightImportance: 'Crucial pour la conformité à la zone, les relations de voisinage et la détermination de la classification du bâtiment',
              volume: {
                calculation: 'Généralement calculé comme surface au sol × hauteur moyenne, ou à partir de modèles 3D détaillés du bâtiment',
                description: 'Volume total fermé du bâtiment des fondations au toit',
                importance: 'Utilisé pour la modélisation énergétique, le dimensionnement CVC et les calculs de densité de développement',
                title: 'Volume du bâtiment',
              },
            },
          },
          occupancy: {
            avgFloorArea: "Surface d'étage moyenne",
            avgFloorHeight: "Hauteur d'étage moyenne",
            buildingCategory: 'Catégorie du bâtiment',
            numberOfDwellings: 'Nombre de logements',
            primaryUse: 'Usage principal',
            title: 'Occupation et type',
            tooltips: {
              avgFloorArea: {
                calculation: "Calculé en divisant la surface brute de plancher par le nombre d'étages",
                description: 'La surface moyenne de chaque étage du bâtiment',
                importance: "Utile pour comprendre l'efficacité de la dalle de plancher et comparer des bâtiments similaires",
                title: "Surface d'étage moyenne",
              },
              avgFloorHeight: {
                calculation: "Calculé en divisant la hauteur totale du bâtiment par le nombre d'étages",
                description: 'La distance verticale moyenne entre les étages du bâtiment',
                importance: "Indique la qualité et l'époque du bâtiment. Des plafonds plus hauts suggèrent souvent une construction ancienne ou haut de gamme",
                title: "Hauteur d'étage moyenne",
              },
              category: {
                calculation: "Attribué par les autorités cantonales en fonction de l'utilisation, la structure et l'objectif du bâtiment",
                description: 'Classification officielle du bâtiment selon les catégories fédérales suisses de bâtiments',
                importance: 'Détermine les réglementations applicables, les évaluations fiscales et les utilisations autorisées',
                title: 'Catégorie du bâtiment',
              },
              dwellings: {
                calculation: 'Compté à partir des registres officiels des bâtiments, y compris les appartements, studios et maisons',
                description: "Nombre total d'unités résidentielles individuelles dans le bâtiment",
                importance: "Facteur clé pour la gestion des bâtiments, la planification des infrastructures et l'évaluation de la densité",
                title: 'Nombre de logements',
              },
              primaryUse: {
                calculation: "Déterminé à partir du registre des bâtiments en fonction de l'utilisation dominante de la surface du bâtiment",
                description: "L'objectif fonctionnel principal pour lequel le bâtiment est utilisé",
                importance: "Affecte la conformité à la zone, les exigences d'assurance et les options de développement potentielles",
                title: 'Usage principal',
              },
            },
          },
          occupancyType: {
            title: 'Occupation et type',
          },
          physicalDimensions: {
            title: 'Dimensions physiques',
          },
          status: {
            constructionYear: 'Année de construction',
            currentStatus: 'Statut actuel',
            lastRenovation: 'Dernière rénovation',
            minergieCertified: 'Certifié Minergie',
            protectedStatus: 'Statut de protection',
            title: 'Statut et état',
            tooltips: {
              constructionYear: {
                calculation: "Enregistré dans le registre officiel des bâtiments lors de l'achèvement du permis de construire",
                description: "L'année où le bâtiment a été initialement achevé",
                importance: "Essentiel pour les calculs d'âge, le contexte historique et la compréhension des normes de construction utilisées",
                limitations: 'Pour les bâtiments plus anciens, peut être estimé à partir de la plage de période de construction. Les reconstructions majeures peuvent ne pas mettre à jour cette date',
                title: 'Année de construction',
              },
              minergie: {
                calculation: "Attribué par l'association Minergie sur la base du respect de normes strictes d'efficacité énergétique",
                description: "Certification suisse d'efficacité énergétique pour les bâtiments",
                importance: "Indique une efficacité énergétique supérieure, un confort accru et généralement des coûts d'exploitation plus bas",
                source: "Base de données de certification de l'association Minergie",
                title: 'Certification Minergie',
              },
              protected: {
                calculation: "Évalué par les autorités cantonales du patrimoine en fonction de l'importance historique, architecturale ou culturelle",
                description: 'Niveau de protection du patrimoine attribué au bâtiment par les autorités cantonales',
                importance: 'Affecte les possibilités de rénovation, le potentiel de développement et peut fournir des avantages fiscaux',
                source: 'Office cantonal du patrimoine et registre des bâtiments',
                title: 'Statut de protection',
              },
              renovation: {
                calculation: 'Enregistré à partir des dossiers de permis de construire pour les projets de rénovation ou transformation majeurs',
                description: "L'année la plus récente où des travaux de rénovation importants ont été achevés",
                importance: "Indique des améliorations récentes et probablement un meilleur état que ce que l'année de construction seule suggérerait",
                limitations: 'Les rénovations mineures peuvent ne pas être enregistrées. Les rénovations intérieures sans permis ne sont pas saisies',
                title: 'Dernière rénovation',
              },
              status: {
                calculation: 'Enregistré dans le registre des bâtiments et mis à jour en fonction des permis de construction ou de démolition',
                description: "L'état opérationnel actuel du bâtiment",
                importance: 'Confirme si le bâtiment existe, est en construction ou a été démoli',
                title: 'Statut actuel du bâtiment',
              },
            },
          },
          statusCondition: {
            title: 'Statut et état',
          },
        },
        heightTypes: {
          highRise: 'Immeuble de grande hauteur',
          lowRise: 'Immeuble de faible hauteur',
          midRise: 'Immeuble de hauteur moyenne',
        },
        labels: {
          asl: 'alt.',
          estimated: 'estimé',
          period: 'période',
        },
        metrics: {
          buildingAge: {
            label: 'Âge du bâtiment',
            tooltip: {
              calculation: "Calculé comme l'année actuelle moins l'année de construction du registre officiel des bâtiments",
              calculationEstimated: 'Estimé sur la base de la période de construction {{period}}. Le point médian de la plage de période est utilisé pour le calcul',
              description: "Le nombre d'années depuis la construction originale du bâtiment",
              importance: "Facteur clé pour évaluer les besoins de maintenance, le potentiel de rénovation, l'efficacité énergétique et la valorisation immobilière",
              limitations: 'Ne tient pas compte des rénovations majeures ou reconstructions qui peuvent avoir significativement modernisé le bâtiment',
              limitationsEstimated: "L'âge est estimé à partir de la période de construction et peut ne pas être exact. L'année de construction réelle peut varier dans la plage de la période",
              title: 'Âge du bâtiment',
            },
          },
          buildingArea: {
            label: 'Surface du bâtiment',
            tooltip: {
              calculation: "Mesuré à partir des données cadastrales officielles ou du registre des bâtiments comme la projection horizontale de l'enveloppe du bâtiment",
              description: 'La surface au niveau du sol couverte par les murs extérieurs du bâtiment',
              importance: "Essentiel pour comprendre l'efficacité de l'utilisation du sol, calculer les ratios de surface de plancher et évaluer le potentiel de développement",
              limitations: "N'inclut pas les structures externes comme les terrasses, balcons ou zones souterraines. Peut différer de la surface totale de plancher",
              title: 'Surface au sol du bâtiment',
            },
          },
          buildingHeight: {
            label: 'Hauteur du bâtiment',
            tooltip: {
              calculation: "Mesuré à partir de données LiDAR ou de relevés officiels, du niveau du sol au faîte du toit ou à l'élément structurel le plus haut",
              description: 'La mesure verticale du niveau du sol au point le plus haut du bâtiment',
              importance: "Crucial pour la conformité à la zone, l'analyse des ombres, l'évaluation des vues et la détermination de la classification du bâtiment",
              limitations: 'Peut varier selon la méthode de mesure. Les antennes, cheminées et structures temporaires peuvent être incluses ou non',
              title: 'Hauteur totale du bâtiment',
            },
          },
          floorCount: {
            label: "Nombre d'étages",
            tooltip: {
              calculation: 'Compté à partir des données officielles du registre des bâtiments, y compris le rez-de-chaussée et tous les étages supérieurs',
              description: "Le nombre total d'étages hors sol du bâtiment",
              importance: "Indicateur clé pour la classification des bâtiments, la conformité à la zone et l'estimation de la surface brute de plancher",
              limitations: 'Peut ne pas inclure les niveaux de sous-sol, les mezzanines ou les étages techniques. Les étages souterrains sont comptés séparément',
              title: "Nombre total d'étages",
            },
          },
          numberOfFloors: {
            label: "Nombre d'étages",
          },
        },
        sizeIndicators: {
          compact: 'Compact',
          large: 'Grand',
          medium: 'Moyen',
        },
        values: {
          asl: 'ASL',
          estimated: '(est.)',
          estimatedFrom: 'estimé de {{period}}',
          na: 'N/D',
          no: 'Non',
          period: '(période)',
          years: 'ans',
          yearsAgo: 'il y a ans',
          yearsCount: '{{count}} ans',
          yes: 'Oui',
        },
      },
      states: {
        error: 'Erreur lors du chargement des caractéristiques du bâtiment',
        loading: 'Chargement des caractéristiques du bâtiment...',
        noData: 'Aucune donnée de bâtiment disponible',
      },
      tabs: {
        neighborhood: 'Contexte du quartier',
        overview: 'Aperçu',
        timeline: 'Chronologie de construction',
      },
      timeline: {
        ageComparison: {
          newerThanAverage: 'Plus récent que la moyenne',
          significantlyOlder: 'Significativement plus ancien',
          similarAge: 'Âge similaire',
          yearsOld: 'ans',
        },
        badges: {
          estimatedData: 'Données estimées',
          historicalData: 'Données historiques',
        },
        cards: {
          ageAnalysis: {
            title: "Analyse de l'âge",
          },
          ageComparison: {
            title: "Comparaison d'âge avec le quartier",
          },
          constructionPhases: {
            title: 'Phases de construction',
          },
          constructionTimeline: {
            title: 'Chronologie de construction',
          },
          renovationHistory: {
            title: 'Historique des rénovations',
          },
          timeline: {
            title: 'Chronologie de construction',
            tooltip: {
              calculation: 'Basé sur les dates de construction officielles, les registres de rénovation et les données du registre des bâtiments',
              description: "Représentation visuelle de l'historique de construction du bâtiment et des événements majeurs",
              importance: "Aide à comprendre l'évolution du bâtiment dans le temps et à planifier l'entretien futur",
              limitations: 'Certaines dates peuvent être estimées à partir des périodes de construction lorsque les années exactes ne sont pas disponibles',
              title: 'Chronologie de construction',
            },
          },
        },
        events: {
          constructionPhase: 'Phase de construction',
          dwellingAdded: 'Logement ajouté',
          majorRenovation: 'Rénovation majeure',
          originalConstruction: 'Construction originale',
          originalConstructionEst: 'Construction originale (est.)',
          present: 'Présent',
        },
        labels: {
          ageCategory: "Catégorie d'âge",
          buildingAge: 'Âge du bâtiment',
          buildingPeriod: 'Période de construction',
          comparison: 'Comparaison',
          constructionDates: 'Dates de construction',
          constructionYear: 'Année de construction',
          lastRenovation: 'Dernière rénovation',
          neighborhoodAverage: 'Moyenne du quartier',
          noRecord: 'Aucun enregistrement',
          numberOfPhases: 'Nombre de phases',
          phases: 'Phases',
          renovationPeriod: 'Période de rénovation',
          renovationStatus: 'État de rénovation',
          singlePhaseConstruction: 'Construction en phase unique',
          thisBuilding: 'Ce bâtiment',
          yearsSinceRenovation: 'Années depuis la rénovation',
        },
        noDataMessage: 'Aucune donnée de chronologie de construction disponible',
        phaseLabels: {
          noRecord: 'Aucun enregistrement',
          singlePhase: 'Construction en phase unique',
        },
        renovationStatuses: {
          considerUpdates: 'Envisager des mises à jour',
          goodCondition: 'Bon état',
          noRenovation: 'Pas de rénovation',
          recentlyRenovated: 'Récemment rénové',
          renovationNeeded: 'Rénovation nécessaire',
        },
      },
    },
    filters: {
      buildingDetails: {
        buildingVolume: 'Volume du bâtiment hors-sol (m³)',
        grossFloorArea: 'Surface brute de plancher utile (m²)',
        groundingArea: 'Surface au sol (m²)',
        height: 'Hauteur',
        numberOfFloors: "Nombre d'étages",
        numberOfUnits: "Nombre d'unités",
        title: 'Détails du bâtiment',
      },
      buildingHistory: {
        buildingPeriod: 'Période de construction',
        renovationPeriod: 'Période de rénovation',
        title: 'Historique du bâtiment',
        yearOfConstruction: 'Année de construction',
        yearOfRenovation: 'Année de rénovation',
      },
      buildingType: {
        buildingCategory: 'Catégorie de bâtiment (RegBL)',
        buildingClass: 'Classe de bâtiment (RegBL)',
        classifications: {
          garage: 'Garage',
          industrial: 'Industriel',
          mixed1: 'Mixte 1',
          mixed2: 'Mixte 2',
          notClassified: 'Non classé',
          offices: 'Bureaux',
          other: 'Autre',
          public: 'Public',
          residential: 'Résidentiel',
          retail: 'Commerce',
        },
        constructionType: 'Type de construction',
        constructionTypes: {
          normal: 'Normal',
          projected: 'Projeté',
          underground: 'Souterrain',
        },
        hasCivilProtectionShelter: 'Possède un abri de protection civile',
        popetyClassification: 'Classification Popety.io',
        protectedRank: 'Rang de protection',
        title: 'Type de bâtiment',
      },
      energy: {
        idc: 'IDC - MJ/m²/an',
        mainHeaterGenerator: 'Générateur de chaleur principal',
        mainHeatingEnergySource: "Source d'énergie principale pour le chauffage",
        mainHotWaterEnergySource: "Source d'énergie principale pour l'eau chaude",
        mainHotWaterGenerator: "Générateur d'eau chaude principal",
        minergieLabel: 'Label Minergie',
        title: 'Énergie, Chauffage & Eau chaude',
      },
      environmental: {
        distanceToPowerlines: 'Distance aux lignes haute tension',
        lakeView: 'Vue sur le lac',
        lakeViewArea: {
          large: 'Plus de 100 ha',
          none: '0 ha',
          small: '0 à 100 ha',
        },
        mountainView: 'Vue sur les montagnes',
        mountainViewQuality: {
          few: '0 à 4 sommets',
          many: 'Plus de 13 sommets',
          some: '5 à 13 sommets',
        },
        noiseExposure: 'Exposition au bruit',
        noiseExposureLevels: {
          high: 'Plus de 52 dB',
          low: "Jusqu'à 45 dB",
          medium: '45 à 52 dB',
        },
        powerlineDistance: {
          close: '0 à 100m',
          far: 'Plus de 100m',
        },
        publicTransportQuality: 'Qualité des transports publics',
        slope: 'Pente',
        slopeLevels: {
          flat: '0 à 4 degrés',
          moderate: '4 à 9 degrés',
          steep: 'Plus de 9 degrés',
        },
        taxBurden: 'Charge fiscale',
        taxBurdenLevels: {
          high: 'Élevé (plus de 7,1%)',
          medium: 'Moyen (5,1% à 7,1%)',
          small: 'Faible (0 à 5,1%)',
        },
        title: 'Caractéristiques environnementales',
        transportQuality: {
          badly: 'Mal desservi',
          medium: 'Moyennement desservi',
          veryBadly: 'Très mal desservi',
          veryWell: 'Très bien desservi',
          well: 'Bien desservi',
        },
        travelTime: {
          long: 'Long',
          medium: 'Moyen',
          short: 'Court',
        },
        travelTimeToCenters: 'Temps de trajet vers les centres',
      },
      history: {
        buildingPermitNumber: 'Nombre de permis de construire',
        buildingPermitsClassification: 'Classification des permis de construire',
        buildingPermitsDate: 'Date des permis de construire',
        listingRentNumber: "Nombre d'annonces de location",
        listingSaleNumber: "Nombre d'annonces de vente",
        listingsListingDate: 'Date des annonces',
        listingsPrice: 'Prix des annonces',
        listingsPricePerSquareMeter: 'Prix des annonces par mètre carré',
        listingsRentDate: "Date d'annonces de location",
        listingsRentDateTooltip: 'Période pendant laquelle les propriétés ont été mises en location. Trouvez les propriétés récemment mises en location.',
        listingsSaleDate: "Date d'annonces de vente",
        listingsSaleDateTooltip: 'Période pendant laquelle les propriétés ont été mises en vente. Trouvez les propriétés récemment mises en vente.',
        permitClassifications: {
          development: 'Développement',
          other: 'Autre',
        },
        title: 'Historique',
        transactionsDate: 'Date des transactions',
        transactionsNumber: 'Nombre de transactions',
        transactionsPrice: 'Prix des transactions',
      },
      solar: {
        averageSolarRadiation: 'Rayonnement solaire moyen (kWh/m²/an)',
        electricPotential: 'Potentiel électrique (kWh/an)',
        heatPotential: 'Potentiel thermique (kWh/an)',
        installationDate: "Date d'installation",
        installedPower: 'Puissance installée (kW)',
        roofArea: 'Surface du toit (m²)',
        roofPitch: 'Inclinaison du toit (°)',
        title: 'Énergie solaire',
        totalSolarRadiation: 'Rayonnement solaire total (kWh/an)',
      },
      user: {
        loadingTags: 'Chargement des tags...',
        myTags: 'Mes tags',
        noTagsAvailable: 'Aucun tag disponible. Créez des tags depuis le panneau de détails du bâtiment.',
        title: 'Filtres utilisateur',
      },
    },
    sidebar: {
      items: {
        amenities: 'Commodités',
        buildingPermits: 'Permis de construire',
        characteristics: 'Caractéristiques du bâtiment',
        demographics: 'Démographie',
        employment: 'Emploi',
        energy: 'Énergie',
        feasibilityStudy: 'Étude de faisabilité',
        history: 'Historique',
        land: 'Terrain',
        noiseAnalysis: 'Analyse du bruit',
        potential: 'Potentiel de surélévation',
        purchaseListings: 'Annonces achat',
        purchaseMarket: 'Marché achat',
        rentalListings: 'Annonces location',
        rentalMarket: 'Marché location',
        summary: 'Résumé',
        sunlightStudy: 'Étude ensoleillement',
        transactions: 'Transactions',
        transportAccess: 'Transport & Accès',
        units: 'Détails des unités',
      },
      sections: {
        elevation: 'Surélévation',
        environment: 'Environnement',
        market: 'Marché',
        overview: 'Aperçu',
        socialEconomic: 'Social & Économique',
      },
    },
    transactionsTab: {
      filters: {
        additionalFilters: 'Filtres supplémentaires',
        advancedFilters: 'Filtres avancés',
        allLocations: 'Tous les emplacements',
        clearAll: 'Tout effacer',
        hideFilters: 'Masquer les filtres',
        landArea: 'Surface du terrain (m²)',
        legalTypeBF: 'B-F',
        legalTypeCOP: 'COP',
        legalTypeDDP: 'DDP',
        legalTypeDP: 'DP',
        legalTypeOther: 'Autre',
        legalTypePPE: 'PPE',
        numberOfBuyers: "Nombre d'acheteurs",
        numberOfSellers: 'Nombre de vendeurs',
        others: 'Autres',
        participantAssociation: 'Association',
        participantCompany: 'Société',
        participantCooperative: 'Coopérative',
        participantFoundation: 'Fondation',
        participantIndividual: 'Particulier',
        participantOther: 'Autre',
        participantPublicEntity: 'Entité publique',
        participants: 'Participants',
        participantType: 'Type de participant',
        propertyLegalType: 'Type juridique de la propriété',
        radius: 'Rayon',
        showFilters: 'Afficher les filtres',
        stepTransactionPrice: 'Prix de transaction par étape (CHF)',
        transactionDate: 'Date de transaction',
        transactionType: 'Type de transaction',
        typeAreaPrice: 'Type, Surface & Prix',
        unitApartment: 'Appartement',
        unitCommercial: 'Commercial',
        unitHouse: 'Maison',
        unitLand: 'Terrain',
        unitOther: 'Autre',
        unitParking: 'Parking',
        unitType: "Type d'unité",
      },
      subtitle: "Explorez l'historique des transactions autour du bâtiment et enregistrez celles qui vous intéressent pour cette analyse.",
      tabs: {
        aroundBuilding: 'Transactions autour du bâtiment',
        saved: 'Transactions enregistrées',
      },
      title: 'Transactions',
    },
    unitDetails: {
      actions: {
        addFirstUnit: 'Ajouter la première unité',
        addUnit: 'Ajouter une unité',
        cancel: 'Annuler',
        edit: 'Modifier',
        save: 'Enregistrer',
        saving: 'Enregistrement...',
      },
      common: {
        chf: 'CHF',
        minMax: 'min-max',
        na: 'N/D',
        squareMeters: 'm²',
      },
      entrance: {
        egid: 'EGID :',
        floorsCount: '{{count}} étages',
        floorsCountOne: '{{count}} étage',
        mainEntrance: 'Entrée principale',
        unitsCount: '{{count}} unités',
        unitsCountOne: '{{count}} unité',
      },
      floor: {
        basement: 'Sous-sol {{level}}',
        floorNumber: 'Étage {{number}}',
        groundFloor: 'Rez-de-chaussée',
      },
      metrics: {
        dwellingArea: 'Surface habitable',
        floors: 'Étages',
        footprint: 'Emprise au sol',
        units: 'Unités',
      },
      multipleFloor: {
        no: 'Non',
        yes: 'Oui',
      },
      states: {
        error: 'Erreur lors du chargement des détails des unités :',
        loading: 'Chargement des détails des unités...',
        loadingConfigurations: 'Chargement des configurations des logements...',
        noBuilding: 'Aucune donnée de bâtiment disponible',
        noUnits: "Aucun détail d'unité disponible pour ce bâtiment",
        noUnitsOnFloor: 'Aucune unité à cet étage',
      },
      subtitle: 'Répartition détaillée de toutes les unités par entrée et étage',
      table: {
        headers: {
          adminNo: 'N° ADMIN',
          area: 'SURFACE',
          bathrooms: 'SDB',
          cYear: 'ANNÉE C.',
          edid: 'EDID',
          fid: 'ID F.',
          multiFloor: 'MULT. ÉT.',
          rentalValue: 'VALEUR LOCATIVE MENSUELLE',
          rooms: 'PIÈCES',
          type: 'TYPE',
        },
      },
      title: 'Détails des unités',
      unitTypes: {
        residential: 'Résidentiel',
        roomCount: '{{count}} Pièce',
        roomPlural: 'Pièces',
        roomsCount: '{{count}} Pièces',
        roomSingular: 'Pièce',
      },
      validation: {
        areaPositive: 'La surface doit être positive',
        bathroomsPositive: 'Le nombre de salles de bain doit être positif',
        constructionDateFuture: 'La date de construction ne peut pas être dans le futur',
        roomNumberRange: 'Le nombre de pièces doit être compris entre 1 et 10',
      },
    },
  },
  charts: {
    actions: {
      saveAsImage: 'Enregistrer comme image',
    },
    categories: {
      apartment: 'Appartement',
      apartmentTrend: 'Tendance appartements',
      house: 'Maison',
      houseTrend: 'Tendance maisons',
    },
    common: {
      averageValue: 'Valeur moyenne',
      avgPrice: 'Prix moyen',
      concentrated: 'concentrée',
      consistency: 'consistance',
      decrease: 'baisse',
      decreased: 'diminué',
      decreases: 'diminue',
      discount: 'une remise de',
      distributed: 'distribuée',
      downward: 'à la baisse',
      exponential: 'exponentiel',
      gradual: 'progressive',
      high: 'forte',
      higher: 'plus élevé',
      increase: 'hausse',
      increased: 'augmenté',
      increases: 'augmente',
      lessExpensive: 'moins cher',
      limited: 'limité',
      linear: 'linéaire',
      low: 'faible',
      lower: 'plus bas',
      moderate: 'modérée',
      mom: 'Mensuel',
      moreExpensive: 'plus cher',
      noData: 'Aucune donnée disponible',
      otherRegions: 'autres régions',
      smallestPremium: 'la plus petite prime à',
      stable: 'stable',
      steep: 'forte',
      strong: 'fort',
      strongUpward: 'forte hausse',
      totalTransactions: 'Total des transactions',
      totalValue: 'Valeur totale',
      totalVolume: 'Volume total',
      transactionCount: 'Nombre de transactions',
      transactions: 'Transactions',
      variation: 'variation',
      weak: 'faible',
      yoy: 'Annuel',
    },
    empty: {
      newVsResale: "Aucune donnée neuf vs existant n'est disponible pour les filtres sélectionnés.",
      priceEvolution: "Aucune donnée d'évolution des prix n'est disponible pour les filtres sélectionnés. Veuillez ajuster vos critères de recherche.",
      pricePerRoom: "Aucune donnée de prix par pièce n'est disponible pour les filtres sélectionnés. Veuillez ajuster vos critères de recherche.",
      pricePerSqmPerRoom: "Aucune donnée de prix/m² par pièce n'est disponible pour les filtres sélectionnés. Veuillez ajuster vos critères de recherche.",
      rentEvolution: "Aucune donnée d'évolution des loyers n'est disponible pour les filtres sélectionnés. Veuillez ajuster vos critères de recherche.",
      rentPerRoom: "Aucune donnée de loyer par pièce n'est disponible pour les filtres sélectionnés. Veuillez ajuster vos critères de recherche.",
      rentPerSqmPerRoom: "Aucune donnée de loyer/m² par pièce n'est disponible pour les filtres sélectionnés. Veuillez ajuster vos critères de recherche.",
      title: 'Aucune donnée disponible',
    },
    geographicDistribution: {
      activeCantons: 'Cantons actifs',
      avg: 'Moy',
      avgTransactionPrice: 'Prix moyen de transaction',
      topCitiesByVolume: 'Principales villes par volume de transactions',
      totalMarketVolume: 'Volume total du marché',
      transactionsByCanton: 'Transactions par canton',
    },
    inheritanceFlow: {
      donation: 'Donation',
      flowAnalysis: 'Analyse du flux de succession',
      flowAnalysisSubtext: 'Transfert de patrimoine des vendeurs aux acheteurs par type de propriété',
      heritage: 'Héritage',
      inheritanceOverTime: 'Transactions de succession dans le temps',
      inheritanceOverTimeSubtext: 'Tendances trimestrielles par type de transaction',
      noData: 'Aucune donnée de succession disponible',
      partage: 'Partage',
      shareDistribution: 'Analyse de la distribution des parts',
      shareDistributionSubtext: 'Schémas de parts de propriété dans les transferts',
    },
    insights: {
      agency: {
        marketConcentration: 'Concentration du marché',
        performanceDistribution: 'Distribution des performances',
        valueDistribution: 'Distribution de la valeur',
      },
      bestPerformer: 'Meilleure performance',
      bestValue: 'Meilleur rapport qualité-prix',
      city: {
        cityPriceRange: 'Fourchette de prix par ville',
        marketActivity: 'Activité du marché',
        marketDistribution: 'Distribution du marché',
        premiumSegment: 'Segment premium',
        priceConsistency: 'Consistance des prix',
      },
      descriptions: {
        agency: {
          marketConcentration: 'Les 5 premières agences contrôlent {{percentage}}% du marché avec {{count}} annonces combinées.',
          performanceDistribution: 'Avec une moyenne de {{avgListings}} annonces par agence, le marché montre une distribution {{distribution}} entre {{count}} agences.',
          valueDistribution: 'Les 10 premières agences par valeur de portefeuille gèrent {{percentage}}% de la valeur totale du marché à {{value}}.',
        },
        city: {
          cityPriceRange: 'Le prix au m² varie de {{variation}}% entre {{cityHigh}} ({{priceHigh}}) et {{cityLow}} ({{priceLow}}).',
          marketActivity: 'Les 5 premières villes par volume représentent {{percentage}}% de toutes les annonces, avec {{topCity}} en tête avec {{topCount}} biens.',
          marketDistribution: '{{count}} villes ont des prix supérieurs à la moyenne de {{average}}, représentant {{percentage}}% des emplacements analysés.',
          premiumSegment: '{{city}} a le marché premium le plus fort avec {{percentage}}% des annonces au-dessus de {{threshold}}.',
          priceConsistency: '{{city}} présente les prix les plus constants avec un écart-type de {{stdDev}} dans le prix/m².',
        },
        geography: {
          marketConcentration: 'Les 3 principaux marchés représentent {{percentage}}% de toutes les annonces, indiquant une concentration {{concentration}} du marché.',
          nationalBenchmark: '{{count}} sur {{total}} emplacements ont des prix supérieurs à la moyenne nationale de {{average}}.',
          priceM2Consistency: 'Le prix au m² montre une {{consistency}} entre les régions avec un coefficient de variation de {{variation}}%.',
          regionalPriceDisparity: '{{location1}} est {{priceDiff}}% plus cher que {{location2}}, montrant une variation significative des prix régionaux.',
          valueDensityLeader: '{{location}} a le prix au m² le plus élevé à {{priceM2}}, en tête du marché en densité de valeur.',
        },
        newVsResale: {
          constructionPremiumNegative: 'Les biens neufs sont vendus avec une remise de {{discount}}% avec un prix/m² {{priceType}} de {{newPrice}} contre {{existingPrice}} pour les biens existants.',
          constructionPremiumPositive: 'Les biens neufs affichent une prime de {{premium}}% avec un prix/m² {{priceType}} de {{newPrice}} contre {{existingPrice}} pour les biens existants.',
          marketComposition: 'Les biens neufs représentent {{newPercentage}}% du marché avec {{totalNew}} annonces, tandis que les biens existants dominent à {{existingPercentage}}% avec {{totalExisting}} annonces.',
          marketTrendChanged: 'La part de marché des constructions neuves a {{direction}} de {{change}} points de pourcentage de {{startPeriod}} à {{endPeriod}}.',
          marketTrendStable: 'La part de marché des constructions neuves est restée stable de {{startPeriod}} à {{endPeriod}}.',
          premiumVariations: 'Les biens {{highCategory}} affichent la prime de construction neuve la plus élevée à {{highPremium}}%, tandis que les biens {{lowCategory}} ont {{lowPremiumText}}.',
          regionalActivity: "{{topRegion}} est en tête de l'activité de construction neuve avec {{topPercentage}}% des annonces étant des biens neufs, suivi de {{secondRegion}}. La moyenne de toutes les régions est de {{avgPercentage}}%.",
        },
        portal: {
          geographicReach: 'Les portails opèrent dans une moyenne de {{avgRegions}} régions, avec {{topPortal}} ayant la portée la plus large à {{topRegions}} régions.',
          marketEfficiency: 'Les 10 principaux portails gèrent {{percentage}}% de toutes les annonces, démontrant une efficacité de marché {{efficiency}}.',
          portalEcosystem: 'Le marché se compose de {{large}} grands portails (>{{threshold}} annonces), {{medium}} moyens et {{small}} petits portails.',
          portalMarketConcentration: 'Les 5 principaux portails contrôlent {{percentage}}% du marché avec {{count}} annonces combinées.',
          pricePositioning: 'Le prix moyen sur tous les portails est de {{avgPrice}}, avec {{highPortal}} positionné le plus haut à {{highPrice}}.',
        },
        priceEvolution: {
          bestPerformer: 'Les biens {{category}} affichent la plus forte croissance à {{growth}}%, surpassant les autres catégories du marché.',
          marketStability: '{{category}} présente les prix les plus stables avec seulement {{volatility}}% de variation, indiquant des conditions de marché constantes.',
          marketTrend: 'Le marché global a {{direction}} de {{change}}% sur la période analysée, avec des prix {{priceType}} passant de {{startPrice}} à {{endPrice}}.',
          recentMomentum: 'La dernière année montre un élan {{momentum}} avec des prix {{direction}} de {{change}}% par rapport à la période précédente.',
        },
        priceM2PerRoom: {
          bestValue: 'Les {{category}}s de {{rooms}} pièces offrent le meilleur ratio prix/m² à {{priceM2}}, représentant la densité de valeur optimale du marché.',
          marketSweetSpot: 'Les {{category}}s de {{rooms}} pièces dominent le marché avec {{count}} annonces à une moyenne de {{priceM2}}/m².',
          priceM2Trend: "Le prix/m² {{direction}} d'environ {{change}} par pièce supplémentaire dans les {{category}}s.",
          propertyTypePremium: 'Les maisons ont un prix/m² {{premium}}% {{comparison}} que les appartements en moyenne.',
        },
        pricePerRoom: {
          bestValue: 'Les {{category}}s de {{rooms}} pièces offrent le meilleur rapport qualité-prix à {{price}} par bien, représentant le ratio prix-espace optimal du marché.',
          marketSweetSpot: 'Les {{category}}s de {{rooms}} pièces sont la configuration la plus courante avec {{count}} annonces, représentant {{percentage}}% du marché.',
          priceProgression: "Chaque pièce supplémentaire dans les {{category}}s augmente le prix d'environ {{increment}}, montrant une évolution des prix {{pattern}}.",
          propertyTypePremium: 'Les maisons sont en moyenne {{premium}}% {{comparison}} que les appartements pour toutes les configurations de pièces.',
        },
      },
      geography: {
        marketConcentration: 'Concentration du marché',
        nationalBenchmark: 'Référence nationale',
        priceM2Consistency: 'Consistance du prix/m²',
        regionalPriceDisparity: 'Disparité des prix régionaux',
        valueDensityLeader: 'Leader en densité de valeur',
      },
      keyInsights: 'Informations clés',
      marketStability: 'Stabilité du marché',
      marketSweetSpot: 'Point optimal du marché',
      marketTrend: 'Tendance du marché',
      newVsResale: {
        constructionPremium: 'Prime neuf',
        marketComposition: 'Composition du marché',
        premiumVariations: 'Variations de la prime',
        regionalActivity: 'Activité régionale',
      },
      portal: {
        geographicReach: 'Portée géographique',
        marketEfficiency: 'Efficacité du marché',
        portalEcosystem: 'Écosystème des portails',
        portalMarketConcentration: 'Concentration du marché des portails',
        pricePositioning: 'Positionnement des prix',
      },
      priceM2Trend: 'Tendance prix/m² {{category}}',
      priceProgression: 'Progression des prix {{category}}',
      propertyTypePremium: 'Prime par type de bien',
      recentMomentum: 'Élan récent',
    },
    kpis: {
      averagePrice: 'Prix moyen',
      averagePricePerSqm: 'Prix moyen/m²',
      averagePricePerSqmPerRoom: 'Prix moy./m² par pièce',
      averageRent: 'Loyer moyen',
      averageRentPerSqm: 'Loyer moyen/m²',
      averageRentPerSqmPerRoom: 'Loyer moy./m² par pièce',
      averageRooms: 'Pièces moyennes',
      avgPricePerRoom: 'Prix moy. par pièce',
      avgRentPerRoom: 'Loyer moy. par pièce',
      marketVolume: 'Volume du marché',
      medianPrice: 'Prix médian',
      medianPricePerRoom: 'Prix médian par pièce',
      medianPricePerSqm: 'Prix médian/m²',
      medianPricePerSqmPerRoom: 'Prix médian/m² par pièce',
      medianRent: 'Loyer médian',
      medianRentPerRoom: 'Loyer médian par pièce',
      medianRentPerSqm: 'Loyer médian/m²',
      medianRentPerSqmPerRoom: 'Loyer médian/m² par pièce',
      mostExpensive: 'Catégorie la plus chère',
      priceAllTypes: 'Prix {{priceType}} (Tous types)',
      rentAllTypes: 'Loyer {{priceType}} (Tous types)',
      totalListings: 'Annonces totales',
      yearGrowth: 'Croissance sur 1 an',
    },
    labels: {
      allRooms: 'Toutes pièces',
      allTypes: 'Tous types',
      count: 'Nombre',
      listings: 'Annonces',
      notAvailable: 'N/D',
      numberOfListings: "Nombre d'annonces",
      numberOfRooms: 'Nombre de pièces',
      percentage: 'Pourcentage (%)',
      percentile10: '10ème percentile',
      percentile10Short: '10ème %',
      percentile30: '30ème percentile',
      percentile30Short: '30ème %',
      percentile50Median: '50ème percentile (Médiane)',
      percentile50Short: '50ème % (Médiane)',
      percentile70: '70ème percentile',
      percentile70Short: '70ème %',
      percentile90: '90ème percentile',
      percentile90Short: '90ème %',
      price: 'Prix',
      priceChf: 'Prix (CHF)',
      pricePerM2Chf: 'Prix au m² (CHF)',
      propertyType: 'Type de bien',
      range: 'Plage',
      rent: 'Loyer',
      rentChf: 'Loyer (CHF)',
      rentPerM2Chf: 'Loyer au m² (CHF)',
      rooms: 'Pièces',
      stdDev: 'Écart-type',
    },
    marketTiming: {
      activityCalendar: "Calendrier d'activité du marché",
      activityCalendarSubtext: 'Volume de transactions par jour',
      avgLagDays: 'Délai moyen (jours)',
      monthlyActivity: 'Activité transactionnelle mensuelle',
      monthlyActivitySubtext: 'Volume de transactions dans le temps',
      noActivity: 'Aucune activité',
      noData: 'Aucune donnée de timing de marché disponible',
      numberOfTransactions: 'Nombre de transactions',
      publicationLag: 'Analyse du délai de publication',
      publicationLagSubtext: 'Jours moyens entre transaction et publication',
    },
    newVsResale: {
      kpis: {
        newShare: 'Part neuf',
        premium: 'Prime neuf',
        priceExisting: '{{priceType}} {{priceUnit}} - Existant',
        priceNew: '{{priceType}} {{priceUnit}} - Neuf',
      },
      legends: {
        existingProperties: 'Biens existants',
        newConstruction: 'Construction neuve',
      },
      titles: {
        activity: 'Activité neuf à {{location}}',
        composition: 'Composition du marché: Neuf vs Existant dans le temps',
        premium: 'Prime {{priceType}} pour le neuf par catégorie de bien',
      },
      tooltips: {
        existing: 'Existant',
        new: 'Neuf',
        premiumLabel: 'Prime',
        total: 'Total',
      },
    },
    participantDemographics: {
      buyersByGender: 'Acheteurs par sexe',
      companies: 'Entreprises',
      companyParticipants: 'Entreprises participantes',
      female: 'Femme',
      genderDistributionOverTime: 'Répartition des acheteurs par sexe dans le temps',
      genderParity: 'Parité 50%',
      individualParticipants: 'Participants individuels',
      individuals: 'Particuliers',
      male: 'Homme',
      participantTypesByLegalForm: 'Types de participants par forme juridique',
      personVsCompany: 'Particuliers vs Entreprises',
      sellersByGender: 'Vendeurs par sexe',
      totalBuyers: 'Total des acheteurs',
      totalSellers: 'Total des vendeurs',
    },
    priceDynamics: {
      avgTransactionPrice: 'Prix moyen de transaction',
      priceByPropertyType: 'Prix par type de propriété',
      priceDistribution: 'Distribution des prix',
      priceVelocityIndex: 'Indice de vélocité des prix',
      totalMarketVolume: 'Volume total du marché',
      yearlyMarketVolume: 'Volume du marché annuel',
    },
    priceM2PerRoom: {
      titles: {
        distribution: 'Distribution {{priceType}} par pièces',
        roomCountVsPrice: 'Nombre de pièces vs Prix/m² {{priceType}}',
        roomCountVsRent: 'Nombre de pièces vs Loyer/m² {{priceType}}',
      },
      tooltips: {
        listings: 'Annonces',
        price: 'Prix/m² {{priceType}}',
        range: 'Plage',
        rent: 'Loyer/m² {{priceType}}',
        rooms: 'Pièces',
        stdDev: 'Écart-type',
      },
    },
    priceTypes: {
      average: 'Moyenne',
      median: 'Médiane',
    },
    propertyCharacteristics: {
      avgSurfaceArea: 'Surface moyenne (m²)',
      complexityIndex: 'Indice de complexité du bâtiment',
      complexityIndexSubtext: "Prix et surface par nombre d'étages",
      noData: 'Aucune donnée de caractéristiques de propriété disponible',
      numberOfFloors: "Nombre d'étages",
      performanceMatrix: 'Matrice de performance par type de propriété',
      performanceMatrixSubtext: 'Surface moyenne vs Prix moyen',
    },
    seasonalPatterns: {
      averageTransactionCount: 'Nombre moyen de transactions',
      month: 'Mois',
      monthlyActivity: 'Activité transactionnelle mensuelle',
      monthlyActivitySubtext: 'Tendances de volume et valeur par mois',
      noData: 'Aucune donnée de schéma saisonnier disponible',
      quarterlyComparison: 'Comparaison trimestrielle',
      quarterlyComparisonSubtext: 'Volume de transactions par trimestre',
      seasonalPatterns: 'Schémas saisonniers',
      seasonalPatternsSubtext: 'Activité moyenne par mois sur toutes les années',
    },
    states: {
      loading: 'Chargement des données...',
      loadingNewVsResale: 'Chargement des données neuf vs existant...',
      loadingPriceM2PerRoom: 'Chargement des données prix/m² par pièce...',
      loadingPricePerRoom: 'Chargement des données prix par pièce...',
    },
    titles: {
      priceByRooms: 'Distribution des prix par pièces',
      priceDistribution: 'Distribution des prix par quantiles',
      priceDistributionByQuantiles: 'Distribution des prix par quantiles',
      priceEvolution: 'Évolution des prix par type de bien',
      priceEvolutionByType: 'Évolution des prix par type de bien',
      priceM2Distribution: 'Distribution du prix/m² par quantiles',
      rentByRooms: 'Distribution des loyers par pièces',
      rentDistribution: 'Distribution des loyers par quantiles',
      rentDistributionByQuantiles: 'Distribution des loyers par quantiles',
      rentEvolution: 'Évolution des loyers par type de bien',
      rentEvolutionByType: 'Évolution des loyers par type de bien',
      rentM2Distribution: 'Distribution du loyer/m² par quantiles',
      roomCountVsPrice: 'Nombre de pièces vs Prix {{priceType}}',
      roomCountVsRent: 'Nombre de pièces vs Loyer {{priceType}}',
    },
    titlesM2: {
      priceDistributionByRooms: 'Distribution du prix/m² par pièces',
      rentDistributionByRooms: 'Distribution du loyer/m² par pièces',
      roomCountVsPrice: 'Nombre de pièces vs Prix {{priceType}}/m²',
    },
    transactionType: {
      distributionTitle: 'Répartition par type de transaction',
      dominantType: 'Type dominant',
      trendsTitle: 'Évolution temporelle',
    },
    unitComposition: {
      averageArea: 'Surface moyenne',
      noData: "Aucune donnée de composition d'unités disponible",
      numberOfRooms: 'Nombre de pièces',
      numberOfUnits: "Nombre d'unités",
      room: 'Pièce',
      roomDistribution: 'Distribution des pièces',
      roomDistributionSubtext: "Nombre d'unités par nombre de pièces",
      rooms: 'Pièces',
      units: 'unités',
      unitTypeComposition: "Composition par type d'unité",
      unitTypeCompositionSubtext: "La taille représente le nombre d'unités, la couleur représente la surface moyenne",
    },
    views: {
      absolute: 'Prix absolus',
      growth: 'Croissance annuelle %',
      index: 'Indice des prix (Base 100)',
      quantile: 'Distribution par quantile',
    },
    viewTypes: {
      percentage: 'Vue en pourcentage',
      sideBySide: 'Côte à côte',
      stacked: 'Vue empilée',
    },
  },
  common: {
    about: 'À propos',
    app_description: 'Analyse immobilière publique',
    app_name: 'Popety.io',
    attachments: {
      clearSearch: 'Effacer la recherche',
      filesEmptyDescription: "Aucun fichier n'a été ajouté à cette analyse.",
      filesEmptyTitle: 'Aucun fichier',
      noResultsDescription: 'Essayez une autre recherche.',
      noResultsTitle: 'Aucun résultat',
      notesEmptyDescription: "Aucune note n'a été ajoutée à cette analyse.",
      notesEmptyTitle: 'Aucune note',
      searchNotes: 'Rechercher des notes...',
    },
    back: 'Retour',
    buildingPermits: {
      saved: {
        approved: 'Approuvés',
        buildingPermits: 'Permis de construire',
        emptyDescription: 'Sauvegardez des permis de construire depuis l\'onglet "Permis de construire" pour les comparer plus tard',
        emptyTitle: 'Aucun permis de construire sauvegardé',
        loading: 'Chargement des permis de construire sauvegardés...',
        mostCommonCategory: 'Catégorie la plus fréquente',
        permits: 'Permis',
        totalSaved: 'Total sauvegardés',
      },
    },
    cancel: 'Annuler',
    close: 'Fermer',
    contact: 'Contact',
    download: 'Télécharger',
    error: 'Erreur',
    error_loading_data: 'Erreur de chargement des données',
    export: 'Exporter',
    fields: {
      access_quality: "Qualité d'accès",
      buildable_area: 'Surface constructible',
      building_type: 'Type de bâtiment',
      canton: 'Canton :',
      condition: 'État',
      construction_year: 'Année de construction',
      coordinates: 'Coordonnées',
      description: 'Description',
      development_potential: 'Potentiel de développement',
      elevation: 'Altitude :',
      elevator: 'Ascenseur',
      energy_efficiency: 'Efficacité énergétique',
      energy_rating: 'Classe énergétique',
      filters: {
        location: 'Localisation',
        price_range: 'Gamme de prix',
        property_type: 'Type de propriété',
      },
      heating_system: 'Système de chauffage',
      land_area: 'Surface du terrain',
      last_renovation: 'Dernière rénovation',
      latitude: 'Latitude :',
      location: 'Localisation',
      longitude: 'Longitude :',
      max_floors: 'Étages max',
      municipality: 'Municipalité',
      parking_spaces: 'Places de parking',
      postal_code: 'Code postal :',
      propertyType: {
        Commercial: 'Commercial',
        Houseappartment: 'Maison/Appartement',
      },
      slope: 'Pente :',
      street: 'Rue :',
      terrain_type: 'Type de terrain',
      total_area: 'Surface totale',
      total_floors: 'Étages totaux',
      total_units: 'Unités totales',
      utilities: 'Services publics',
      zone_type: 'Type de zone',
    },
    filter: 'Filtrer',
    help: 'Aide',
    languages: {
      english: 'Anglais',
      french: 'Français',
      german: 'Allemand',
      italian: 'Italien',
      select_language: 'Sélectionner la langue',
    },
    loading: 'Chargement...',
    next: 'Suivant',
    no_data_available: 'Aucune donnée disponible',
    on: 'le',
    overview: {
      address_details: "Détails de l'adresse",
      building_overview: 'Aperçu du bâtiment',
      geographic_information: 'Informations géographiques',
      key_features: 'Caractéristiques principales',
      land_overview: 'Aperçu du terrain',
      location_information: 'Informations de localisation',
    },
    powered_by: 'Propulsé par Popety.io',
    privacy: 'Confidentialité',
    refresh: 'Actualiser',
    save: 'Enregistrer',
    scoreModal: {
      methodology: {
        dataAge: 'Certaines données sous-jacentes peuvent dater de 6 mois',
        dataSources: "Les sources de données comprennent les registres cadastraux, les réglementations de zone, les données géographiques et l'analyse de marché",
        generalPotential: 'Les scores reflètent un potentiel général, pas des résultats de développement garantis',
        howCalculated: 'Comment les scores sont calculés',
        limitations: 'Limites',
        localRegulations: 'Les réglementations locales peuvent imposer des contraintes supplémentaires non reflétées dans les scores',
        marketConditions: 'Les conditions du marché peuvent évoluer indépendamment de ces indicateurs',
        range: 'Les scores vont de 0 à 100, 100 étant optimal pour le développement',
        title: 'Méthodologie et limites',
        weightedCombination: 'Le score de développement est une combinaison pondérée des quatre indicateurs individuels',
      },
      overallScore: 'Score global',
      overallScoreDescription: 'Ce score représente le potentiel de développement global du terrain, calculé comme une combinaison pondérée des quatre indicateurs individuels affichés dans le graphique radar.',
      scoreBreakdown: 'Détail des scores',
      scores: {
        geometry: {
          description: "Basé sur la forme de la parcelle, la surface, la pente et les caractéristiques géographiques qui influencent la constructibilité et l'attrait du marché.",
          displayLabel: 'Forme géo.',
          radarLabel: 'Géométrie',
        },
        legacy: {
          description: "Évalue la qualité et l'état des structures existantes sur le terrain. Un score plus élevé indique moins de contraintes liées aux bâtiments existants.",
          displayLabel: 'Existant',
          radarLabel: 'Patrimoine',
        },
        livability: {
          description: "Mesure les facteurs de qualité de vie, notamment la proximité des commodités, l'accès aux transports publics et la qualité environnementale.",
          displayLabel: 'Environnement',
          radarLabel: 'Habitabilité',
        },
        potential: {
          description: "Indique la part du potentiel constructible autorisé actuellement inutilisée. Un score plus élevé signifie qu'il reste davantage d'opportunités de développement.",
          displayLabel: 'Sous-exploité',
          radarLabel: 'Potentiel',
        },
      },
      scoresUpdated: 'Les scores sont mis à jour périodiquement en fonction des dernières données disponibles.',
      title: 'Détails du score de développement',
    },
    search: 'Rechercher',
    settings: 'Paramètres',
    shared_by: 'par {{name}}',
    shared_on: 'Partagé le {{date}}',
    sidebar: {
      items: {
        amenities: 'Commodités',
        buildingCharacteristics: 'Caractéristiques du bâtiment',
        buildingDetails: 'Détails bâtiments',
        buildingPermits: 'Permis de construire',
        demographics: 'Démographie',
        electricity: 'Électricité',
        employment: 'Emploi',
        energy: 'Énergie',
        feasibilityStudy: 'Étude de faisabilité',
        files: 'Fichiers',
        geoAnalysis: 'Analyse géo',
        history: 'Historique',
        noiseAnalysis: 'Analyse du bruit',
        notes: 'Notes',
        purchaseListings: 'Annonces achat',
        purchaseMarket: 'Marché achat',
        rentalListings: 'Annonces location',
        rentalMarket: 'Marché location',
        restrictions: 'Restrictions',
        summary: 'Résumé',
        sunlightStudy: "Étude d'ensoleillement",
        taxes: 'Impôts',
        transactions: 'Transactions',
        transportAccess: 'Transport & Accès',
        unitDetails: 'Détails des unités',
        zoningRules: 'Règles de zone',
      },
      sections: {
        development: 'Développement',
        environment: 'Environnement',
        market: 'Marché',
        overview: 'Aperçu',
        socialEconomic: 'Social & Économique',
      },
    },
    sort: 'Trier',
    status: {
      address_not_available: 'Adresse non disponible',
      available: 'Disponible',
      not_available: 'Non disponible',
      unknown: 'Inconnu',
      unknown_location: 'Emplacement inconnu',
    },
    terms: 'Conditions',
    try_again: 'Réessayer',
    units: {
      buildingUnits: '{{count}} logements',
      currency: 'CHF',
      floors: '{{count}} étages',
      na: 'N/D',
      rooms: 'pièces',
      spaces: 'places',
      square_meters: 'm²',
    },
    validation: {
      failed_to_validate: "Échec de la validation de l'accès",
      invalid_link: 'Lien invalide',
      link_expired: 'Ce lien est invalide ou a expiré.',
      validating_access: "Validation de l'accès...",
    },
    view: 'Voir',
    yes_no: {
      no: 'Non',
      yes: 'Oui',
    },
  },
  comparables: {
    no_location_data: {
      listings: "Données de localisation non disponibles pour l'analyse des comparables",
      transactions: "Données de localisation non disponibles pour l'analyse des transactions",
    },
  },
  demographics: {
    charts: {
      annualizedGrowthRate: {
        subtitle: 'Taux de croissance annuel moyen sur différentes périodes pour une comparaison précise',
        title: 'Comparaison du taux de croissance annualisé',
      },
      axis: {
        annualGrowthRate: 'Taux de croissance annuel (%)',
        households: 'Ménages',
        population: 'Population',
      },
      communityStability: {
        descriptions: {
          established: 'Établis (6-10 ans)',
          longTerm: 'Long terme (10+ ans)',
          natives: 'Natifs (depuis la naissance)',
          newcomers: 'Nouveaux arrivants (0-1 an)',
          settling: 'En installation (1-5 ans)',
        },
        implications: {
          established: 'Locataires stables, potentiels primo-accedants',
          longTerm: 'Orientes vers la propriété, investis dans la communauté',
          mixed: 'Besoins de logement diversifies dans la communauté',
          natives: 'Liens communautaires profonds, souvent propriétés heritees',
          newcomers: 'Forte demande locative, unités meublees, termes flexibles',
          settling: 'Transition vers des baux plus longs, ameliorations de qualite',
        },
        legend: {
          '0to1Year': '0-1 An',
          '10plusYears': '10+ Ans',
          '1to5Years': '1-5 Ans',
          '6to10Years': '6-10 Ans',
          sinceBirth: 'Depuis la naissance',
        },
        levels: {
          high: 'Élevée',
          low: 'Faible',
          moderate: 'Modérée',
          veryHigh: 'Très élevée',
        },
        markets: {
          balanced: 'Marché équilibré location/propriété',
          mixed: 'Marché mixte avec besoins varies',
          ownershipFocused: 'Marché axé sur la propriété',
          rentalFocused: 'Marché axé sur la location',
        },
        subtitle: 'Modèles de durée de résidence indiquant le caractère communautaire et la dynamique du marché',
        summary: {
          establishedRésidents: 'Résidents établis',
          marketDynamics: 'Impacte les modèles de demande immobilière',
          newcomers: 'Nouveaux arrivants',
          ownershipPotential: 'Potentiel de marché de la propriété',
          rentalOpportunities: 'Opportunités de marché locatif',
          stability: 'Stabilité',
          title: 'Analyse de la stabilité communautaire',
          turnoverHigh: 'Élevé (marché locatif actif)',
          turnoverLow: 'Faible (communauté stable)',
          turnoverModerate: 'Modéré (dynamique équilibrée)',
          turnoverRate: 'Taux de rotation',
        },
        title: 'Stabilité de la communauté',
        tooltips: {
          count: 'Nombre',
          marketImpact: 'Impact sur le marché',
          percentage: 'Pourcentage',
          résidents: 'Résidents',
        },
      },
      growthComparison: {
        axis: {
          annualGrowthRate: 'Taux de croissance annuel (%)',
        },
        descriptions: {
          exceptional: 'Croissance exceptionnelle - Marché en plein essor',
          good: 'Bonné croissance - Marché sain',
          moderateDecline: 'Declin modéré - Conditions difficiles',
          modest: 'Croissance modeste - Zoné stable',
          significantDecline: 'Declin significatif - Marché sous pression',
          slightDecline: 'Leger déclin - Surveiller le marché attentivement',
          strong: 'Forte croissance - Zoné a forte demande',
        },
        implications: {
          careful: "Analyse minutieuse requise avant les decisions d'investissement",
          cautious: 'Approche prudente recommandee, surveiller les tendances du marché',
          excellent: "Excellent climat d'investissement avec fort potentiel d'appreciation",
          favorable: "Conditions favorables pour l'investissement et le développement immobilier",
          stable: "Marché stable adapte a l'investissement à long terme",
        },
        summary: {
          acrossAllPeriods: 'sur toutes les périodes',
          averageGrowth: 'Croissance moyenne',
          challengingPeriod: 'Période difficile',
          growthPattern: 'Modele de croissance',
          peakGrowth: 'Croissance maximale',
          positiveTrend: 'Tendance positive',
          ppRange: 'points de pourcentage',
          strongPerformance: 'Forte performance',
          title: 'Analyse des modèles de croissance',
          volatility: 'Volatilité',
          volatilityHigh: 'Élevée',
          volatilityLow: 'Faible',
          volatilityModerate: 'Modérée',
          weakestPeriod: 'Période la plus faible',
        },
        tooltips: {
          annualized: 'Croissance annualisée',
          marketImpact: 'Impact sur le marché',
          perYear: 'par an',
        },
        trends: {
          accelerating: 'En acceleration',
          consistent: 'Constant',
          decelerating: 'En ralentissement',
        },
      },
      growthPeriods: {
        fiveYears: '5 Ans',
        oneYear: '1 An',
        tenYears: '10 Ans',
        twoYears: '2 Ans',
      },
      householdComposition: {
        legend: {
          '1person': '1 Personne',
          '2people': '2 Personnes',
          '3people': '3 Personnes',
          '4people': '4 Personnes',
          '5people': '5 Personnes',
          '6plusPeople': '6+ Personnes',
        },
        markets: {
          diverse: 'Melange de ménages diversifies necessitant des types de propriétés varies',
          family: 'Zoné dominée par les familles avec demande de grandes propriétés et maisons',
          modern: 'Marché axé sur les couples avec demande de propriétés modernes 2-3 pièces',
          rental: 'Un ratio élevé de personnes seules indique un fort marché locatif pour studios et petits appartements',
        },
        recommendations: {
          couple: 'Appartements 2-3 pièces avec commodités modernes préférés',
          extendedFamily: 'Logement multigenerationnel avec zonés de vie separees',
          family: 'Appartements 4-5 pièces et maisons avec espace exterieur',
          largeFamily: 'Grandes propriétés 5+ pièces et maisons demandees',
          mixed: 'Types de propriétés diversifies pour repondre aux besoins varies des ménages',
          smallFamily: 'Appartements 3-4 pièces adaptes aux familles necessaires',
          studio: 'Studios et appartements 1-2 pièces sont très demandes',
        },
        subtitle: 'Distribution des tailles de ménages montrant les modèles de demande par type de propriété',
        summary: {
          couples: 'Couples',
          couplesUnits: 'Appartements modernes 2-3 pièces',
          families: 'Familles (3+ personnes)',
          familiesUnits: 'Appartements 3+ pièces et maisons',
          singlePerson: "Ménages d'une personne",
          singlePersonUnits: 'Studios et unités 1-2 pièces',
          title: 'Analyse de la demande immobilière',
        },
        title: 'Composition des ménages',
        tooltips: {
          count: 'Nombre',
          households: 'Ménages',
          percentage: 'Pourcentage',
          propertyDemand: 'Demande immobilière',
        },
      },
      householdSizes: {
        fivePeople: '5 Personnes',
        fourPeople: '4 Personnes',
        onePerson: '1 Personne',
        sixPlusPeople: '6+ Personnes',
        threePeople: '3 Personnes',
        twoPeople: '2 Personnes',
      },
      legend: {
        cantonal: 'Cantonal',
        female: 'Femmes',
        foreign: 'Étrangers',
        foreignPopulation: 'Population étrangere',
        households: 'Ménages',
        interCantonal: 'Intercantonal',
        international: 'International',
        local: 'Local',
        male: 'Hommes',
        newBorn: 'Nouveau-nés',
        swiss: 'Suisse',
        swissPopulation: 'Population suisse',
        totalPopulation: 'Population totale',
      },
      migrationChart: {
        descriptions: {
          cantonal: 'Du meme canton',
          interCantonal: "D'autrès cantons",
          international: "De l'étranger",
          local: 'Reste dans la meme ville',
          newBorn: "Ne au cours de l'année passee",
        },
        legend: {
          cantonal: 'Cantonal',
          interCantonal: 'Intercantonal',
          international: 'International',
          local: 'Local',
          newBorn: 'Nouveau-nés',
        },
        profiles: {
          balanced: {
            characteristics: 'Melange de rétention locale et de nouvelles arrivées, rotation saine',
            title: 'Migration équilibrée',
          },
          highInternational: {
            characteristics: 'Fort attrait pour les résidents internationaux, besoins culturels divers',
            title: 'Forte attraction internationale',
          },
          régionalHub: {
            characteristics: 'Attire des résidents de toute la Suisse, zone en croissance',
            title: 'Centre régional',
          },
          stableLocal: {
            characteristics: 'Taux de rétention élevé, résidents établis, stabilité communautaire',
            title: 'Communauté locale stable',
          },
        },
        sources: {
          cantonal: 'Dans le canton',
          international: 'International',
          local: 'Rétention locale',
          otherCantons: 'Autrès cantons',
        },
        summary: {
          dominantSource: 'Source dominante',
          externalNatural: 'Externé et naturel',
          growingInternational: 'Communauté internationale croissante avec des besoins de logement divers',
          healthyMix: 'Melange sain de stabilité et de croissance',
          highLocalRétention: 'Indique un fort attachement communautaire et une faible rotation',
          internalMovement: 'Mouvement interne',
          populationDynamics: 'Dynamique de la population',
        },
        tooltips: {
          origin: 'Origine',
        },
      },
      migrationOrigins: {
        subtitle: 'Sources et modèles de mouvement de population dans la zone',
        title: 'Originés migratoires',
      },
      nationalityChart: {
        legend: {
          foreign: 'Étrangers',
          swiss: 'Suisses',
        },
        profiles: {
          balanced: {
            characteristics: 'Melange de résidents suisses et internationaux, préférences diverses',
            title: 'Communauté équilibrée',
          },
          cosmopolitan: {
            characteristics: 'Diversité urbaine, influences culturelles mixtes, besoins de logement varies',
            title: 'Communauté cosmopolite',
          },
          internationalHub: {
            characteristics: 'Connecte mondialement, diversifie, préférences de style de vie moderne',
            title: 'Centre international',
          },
          traditional: {
            characteristics: 'Principalement suisse, coutumes locales, culture de la propriété',
            title: 'Communauté suisse traditionnelle',
          },
        },
        summary: {
          balanced: 'Marché équilibré repondant aux besoins locatifs et de propriété avec des préférences diverses',
          composition: 'Composition par nationalité',
          highForeign: 'Fort potentiel de marché locatif, commodités modernes valorisées, termes de bail flexibles préférés',
          lowForeign: 'Culture de la propriété dominante, préférences de logement traditionnelles, stabilité à long terme',
          marketImplications: 'Implications pour le marché',
        },
        tooltips: {
          foreignImplication: 'Potentiel de marché locatif, commodités modernes valorisées, normes internationales',
          housingImpact: 'Impact sur le logement',
          population: 'Population',
          swissImplication: 'Preferences traditionnelles de propriété, résidents stables à long terme',
        },
      },
      nationalityComposition: {
        subtitle: 'Repartition des résidents suisses et étrangers dans la zone locale',
        title: 'Composition par nationalité',
      },
      populationDistribution: {
        subtitle: 'Repartition par âge et sexe montrant les cibles démographiques pour le développement immobilier',
        title: 'Distribution de la population',
      },
      populationEvolution: {
        subtitle: 'Tendances historiques de la population montrant les modèles de croissance et le développement du marché',
        title: "Chronologie de l'évolution de la population",
      },
      populationPyramid: {
        annotations: {
          accessibility: 'Accessibilité importante',
          familyHousing: 'Demande de logement familial',
          strongRental: 'Fort potentiel locatif',
        },
        legend: {
          female: 'Femmes',
          male: 'Hommes',
        },
        summary: {
          accessibilityNeeds: "Besoins d'accessibilité et de reduction",
          families: 'Familles (30-54)',
          purchasingDemand: "Principal segment d'acheteurs immobiliers",
          rentalDemand: 'Segment clé du marché locatif',
          seniors: 'Seniors (65+)',
          title: 'Insights sur la structure démographique',
          totalPopulation: 'Population totale',
          youngAdults: 'Jeunes adultes (20-39)',
        },
        tooltips: {
          ageGroup: "Groupe d'age",
          population: 'Population',
          ratio: 'Ratio Hommes/Femmes',
        },
      },
      populationTrend: {
        axis: {
          households: 'Ménages',
          population: 'Population',
        },
        legend: {
          foreignPopulation: 'Population étrangere',
          households: 'Ménages',
          swissPopulation: 'Population suisse',
          totalPopulation: 'Population totale',
        },
        summary: {
          currentComposition: 'Composition actuelle',
          decreasing: 'En diminution',
          foreignPopulation: 'Population étrangere',
          householdTrend: 'Tendance des ménages',
          increasing: 'En augmentation',
          periodAnalysis: 'Analyse de la période',
          stable: 'Stable',
          title: 'Résumé des tendances',
          totalGrowth: 'Croissance totale',
          years: 'ans',
        },
        tooltips: {
          change: 'variation',
          décline: 'déclin',
          foreign: 'Étrangers',
          growth: 'croissance',
          households: 'Ménages',
          swiss: 'Suisses',
          total: 'Total',
          yearOverYear: 'Année apres année',
        },
      },
      résidentialTenure: {
        oneToFiveYears: '1-5 Ans',
        sinceBirth: 'Depuis la naissance',
        sixToTenYears: '6-10 Ans',
        tenPlusYears: '10+ Ans',
        zeroToOneYear: '0-1 An',
      },
      series: {
        growthRate: 'Taux de croissance',
        householdComposition: 'Composition des ménages',
        migrationOrigin: 'Origine de migration',
        nationality: 'Nationalité',
        residents: 'Résidents',
        zeroGrowth: 'Croissance nulle',
      },
    },
    filters: {
      byBicycle: 'À vélo',
      byCar: 'En voiture',
      byWalk: 'À pied',
      city: 'Ville',
      district: 'District',
      location: 'Emplacement:',
      minBike: '{{time}}min à vélo',
      minDrive: '{{time}}min en voiture',
      minWalk: '{{time}}min à pied',
      options: {
        radius: {
          '1km': '1km',
          '2km': '2km',
          '500m': '500m',
          '5km': '5km',
        },
        time: {
          '10min': '10 min',
          '15min': '15 min',
          '20min': '20 min',
          '30min': '30 min',
          '5min': '5 min',
        },
      },
      selectLocation: "Sélectionner l'emplacement",
    },
    insights: {
      currentComposition: 'Composition actuelle',
      decreasing: 'En diminution',
      foreignPopulationGrowth: 'Population étrangere',
      growth: 'croissance',
      growthDescriptions: {
        exceptionalGrowth: 'Croissance exceptionnelle',
        goodGrowth: 'Bonné croissance',
        moderateDecline: 'Declin modéré',
        modestGrowth: 'Croissance modeste',
        significantDecline: 'Declin significatif',
        slightDecline: 'Leger déclin',
        strongGrowth: 'Forte croissance',
      },
      growthPatternAnalysis: {
        acrossAllPeriods: 'sur toutes les périodes',
        averageGrowth: 'Croissance moyenne',
        growthPattern: 'Modele de croissance',
        patterns: {
          accelerating: 'En acceleration',
          consistent: 'Constant',
          decelerating: 'En ralentissement',
        },
        peakGrowth: 'Croissance maximale',
        performanceDescriptions: {
          challengingPeriod: '(Période difficile)',
          positiveTrend: '(Tendance positive)',
          strongPerformance: '(Forte performance)',
        },
        ppRange: 'plâge de {{range}}pp',
        title: 'Analyse des modèles de croissance',
        volatility: 'Volatilité',
        volatilityLevels: {
          high: 'Élevée',
          low: 'Faible',
          moderate: 'Modérée',
        },
        weakestPeriod: 'Période la plus faible',
      },
      householdMarkets: {
        couplesToModernProperties: 'Couples: {{percentage}}% - Propriétés modernes de 2-3 pièces',
        diverseHousingNeeds: 'Besoins de logement divers',
        familiesToLargerProperties: 'Familles: {{percentage}}% - Appartements 3+ pièces et maisons',
        highRentalMarketPotential: 'Fort potentiel de marché locatif',
        modernApartmentDemand: "Demande d'appartements modernes",
        singlePersonToStudios: 'Une personne: {{percentage}}% - Studios et appartements 1-2 pièces',
        strongFamilyHousingDemand: 'Forte demande de logement familial',
        title: 'Implications du marché',
      },
      householdTrend: 'Tendance des ménages',
      housingMarketImplications: {
        balancedMarket: 'Marché équilibré repondant aux besoins locatifs et de propriété avec des préférences diverses',
        modernAmenities: 'Commodites modernes valorisées, potentiel de marché locatif',
        ownershipCulture: 'Culture de la propriété dominante, préférences de logement traditionnelles, stabilité à long terme',
        strongRentalMarket: 'Fort potentiel de marché locatif, commodités modernes valorisées, termes de bail flexibles préférés',
        title: 'Implications pour le marché immobilier:',
        traditionalPreferences: 'Preferences de logement traditionnelles, culture de la propriété',
      },
      increasing: 'En augmentation',
      marketImpact: {
        carefulMarketAnalysisRequired: 'Analyse de marché minutieuse requise',
        cautiousOptimismWarranted: 'Optimisme prudent justifie',
        excellentInvestmentClimate: "Excellent climat d'investissement",
        favorableMarketConditions: 'Conditions de marché favorables',
        stableMarketPotential: 'Potentiel de marché stable',
      },
      marketImplications: {
        generationalOwnershipLowMobility: 'Propriété generationnelle, faible mobilité',
        highRentalDemand: 'Forte demande locative, baux flexibles',
        mixedMarketCharacteristics: 'Caractéristiques de marché mixtes',
        ownershipPreferenceFamilyProperties: 'Preference pour la propriété, propriétés familiales',
        rentalToOwnershipTransition: 'Marché de transition de la location a la propriété',
        stableOwnershipMarketLowTurnover: 'Marché immobilier stable, faible rotation',
        title: 'Implications du marché',
      },
      migrationCategories: {
        externalAndNatural: 'Externé et naturel:',
        internalMovement: 'Mouvement interne:',
      },
      migrationDescriptions: {
        bornInPastYear: "Ne au cours de l'année passee",
        fromAbroad: "De l'étranger",
        fromOtherCantons: "D'autrès cantons",
        fromWithinCanton: 'Du meme canton',
        stayedInSameCity: 'Reste dans la meme ville',
      },
      migrationProfiles: {
        balancedMigration: {
          characteristics: 'Melange de rétention locale et de nouvelles arrivées, rotation saine',
          profile: 'Migration équilibrée',
        },
        highInternationalAttraction: {
          characteristics: 'Fort attrait pour les résidents internationaux, besoins culturels divers',
          profile: 'Forte attraction internationale',
        },
        régionalHub: {
          characteristics: 'Attire des résidents de toute la Suisse, zone en croissance',
          profile: 'Centre régional',
        },
        stableLocalCommunity: {
          characteristics: 'Taux de rétention élevé, résidents établis, stabilité communautaire',
          profile: 'Communauté locale stable',
        },
      },
      nationalityComposition: 'Composition par nationalité:',
      nationalityProfiles: {
        balancedCommunity: {
          characteristics: 'Melange de résidents suisses et internationaux, préférences diverses',
          profile: 'Communauté équilibrée',
        },
        cosmopolitanCommunity: {
          characteristics: 'Diversité urbaine, influences culturelles mixtes, besoins de logement varies',
          profile: 'Communauté cosmopolite',
        },
        internationalHub: {
          characteristics: 'Connecte mondialement, diversifie, préférences de style de vie moderne',
          profile: 'Centre international',
        },
        traditionalSwissCommunity: {
          characteristics: 'Principalement suisse, coutumes locales, culture de la propriété',
          profile: 'Communauté suisse traditionnelle',
        },
      },
      populationDynamics: {
        dominantSource: 'Source dominante: {{source}} ({{percentage}}%)',
        dominantSources: {
          international: 'International',
          localRétention: 'Rétention locale',
          otherCantons: 'Autrès cantons',
          withinCanton: 'Dans le canton',
        },
        growingInternationalCommunity: ' - Communauté internationale croissante avec des besoins de logement divers',
        healthyMixOfStabilityAndGrowth: ' - Melange sain de stabilité et de croissance',
        strongCommunityAttachment: ' - Indique un fort attachement communautaire et une faible rotation',
        title: 'Dynamique de la population:',
      },
      propertyRecommendations: {
        couple: '2-3 pièces, commodités modernes',
        extendedFamily: 'Grandes maisons, multigenerationnelles',
        family: '4-5 pièces, espace exterieur',
        largeFamily: '5+ pièces, maisons',
        mixed: 'Types de propriété mixtes',
        smallFamily: '3-4 pièces, adapte aux familles',
        studio: 'Studios, 1-2 pièces',
      },
      pyramidAnnotations: {
        accessibilityImportant: 'Accessibilité\\nimportante',
        familyHousingDemand: 'Demande de\\nlogement familial',
        strongRentalMarket: 'Fort potentiel\\nlocatif',
      },
      pyramidInsights: {
        seniors: 'Seniors (65+):',
        totalPopulation: 'Population totale:',
        youngAdults: 'Jeunes adultes (20-39):',
      },
      stabilityAnalysis: {
        establishedRésidents: 'Résidents établis',
        marketDynamics: 'Dynamique du marché',
        marketTypes: {
          balancedMarket: 'Marché équilibré',
          mixedRentalOwnership: 'Location/propriété mixte',
          ownershipFocused: 'Axé sur la propriété',
          rentalFocused: 'Axé sur la location',
        },
        newcomers: 'Nouveaux arrivants',
        ownershipPotential: 'Potentiel de propriété',
        rentalMarketOpportunities: 'Opportunités du marché locatif',
        stability: 'Stabilité',
        stabilityLevels: {
          high: 'Élevée',
          low: 'Faible',
          moderate: 'Modérée',
          veryHigh: 'Très élevée',
        },
        title: 'Analyse de la stabilité communautaire',
        turnoverLevels: {
          high: 'Élevé',
          low: 'Faible',
          moderate: 'Modéré',
        },
        turnoverRate: 'Taux de rotation',
      },
      stabilityImplications: {
        established: 'Résidents établis, preference pour la propriété',
        longTerm: 'Résidents de longue durée, communauté stable',
        natives: 'Natifs locaux, liens communautaires profonds',
        newcomers: 'Arrivees récentes, forte demande locative',
        settling: 'Installation, transition de la location a la propriété',
      },
      totalGrowth: 'Croissance totale',
      trendSummary: 'Résumé des tendances sur {{years}} ans ({{startYear}}-{{endYear}})',
    },
    metrics: {
      annualGrowthRate: {
        subtitle: 'Taux composé sur 10 ans',
        title: 'Taux de croissance annuel (TCAC)',
      },
      averageHouseholdSize: {
        people: '{{count}} personnes',
        subtitle: '{{count}} ménages au total',
        title: 'Taille moyenné du ménage',
      },
      communityStability: {
        subtitle: '{{count}} résidents de longue durée',
        title: 'Stabilité de la communauté',
      },
      currentPopulation: {
        subtitle: 'En {{year}}',
        title: 'Population actuelle',
      },
      familyHouseholds: {
        subtitle: '{{count}} ménages',
        title: 'Ménages familiaux',
      },
      foreignResidents: {
        subtitle: '{{count}} résidents',
        title: 'Résidents étrangers',
      },
      growth10Year: {
        subtitle: 'Tendance à long terme',
        title: 'Croissance sur 10 ans',
      },
      growth1Year: {
        subtitle: 'Changement de population récent',
        title: 'Croissance sur 1 an',
      },
      growth2Year: {
        subtitle: 'Tendance à court terme',
        title: 'Croissance sur 2 ans',
      },
      growth5Year: {
        subtitle: 'Tendance à moyen terme',
        title: 'Croissance sur 5 ans',
      },
      householdSize: {
        subtitle: '{{count}} ménages',
        title: 'Taille du ménage',
      },
      medianAge: {
        subtitle: "Profil d'âge de la communauté",
        title: 'Âge médian',
        years: '{{age}} ans',
      },
      newResidents: {
        subtitle: '{{count}} arrivées récentes',
        title: 'Nouveaux résidents',
      },
      populationGrowth: {
        subtitle: 'Évolution sur 10 ans',
        title: 'Croissance démographique',
      },
      singlePersonHouseholds: {
        subtitle: '{{count}} ménages',
        title: "Ménages d'une personne",
      },
      totalPopulation: {
        subtitle: 'Résidents de la zone locale',
        title: 'Population totale',
      },
      twoPersonHouseholds: {
        subtitle: '{{count}} ménages',
        title: 'Ménages de deux personnes',
      },
    },
    states: {
      error: 'Erreur lors du chargement des données démographiques: {{error}}',
      fetchError: 'Échec du chargement des données démographiques',
      loading: 'Chargement des données démographiques...',
      noBuildingData: "Aucune donnée de bâtiment disponible pour l'analyse démographique",
      noData: 'Les données démographiques ne sont pas disponibles pour cet emplacement.',
      noTrendData: 'Aucune donnée de tendance disponible',
    },
    subtitle: 'Caractéristiques de la population et aperçu du marché pour la zone locale',
    tabs: {
      growth: 'Analyse de croissance',
      market: 'Composition du marché',
      overview: 'Aperçu',
    },
    title: 'Démographie',
    tooltips: {
      averageHouseholdSize: {
        calculation: 'Population totale / Nombre total de ménages',
        importance: "Détermine les tailles d'unités optimales et le mix de développement immobilier",
        limitations: "La moyenné peut né pas refleter l'eventail complet des compositions des ménages",
        shortDescription: 'Nombre moyen de personnes par ménage',
        source: "Données de recensement des ménages de l'Office fédéral de la statistique suisse",
        title: 'Taille moyenné du ménage',
      },
      communityStability: {
        calculation: '(Résidents 10+ ans + Résidents depuis la naissance) / Population totale x 100',
        importance: 'Une stabilité élevée indique des communautés matures avec un fort potentiel de propriété',
        limitations: 'Base sur le temps dans la municipalité actuelle, pas le quartier spécifique',
        shortDescription: 'Pourcentage de résidents vivant dans la zone depuis 10 ans ou plus ou depuis la naissance',
        source: "Données de durée de résidence de l'Office fédéral de la statistique suisse",
        title: 'Stabilité de la communauté',
      },
      compoundAnnualGrowthRate: {
        calculation: '((Pop actuelle / Pop il y a 10 ans)^(1/10) - 1) x 100',
        importance: 'Lisse les variations annuelles pour montrer la tendance de croissance sous-jacente',
        limitations: 'Suppose une croissance régulière, la croissance réelle peut etre irrégulière',
        shortDescription: 'Taux de croissance annuel moyen sur 10 ans, tenant compte de la capitalisation',
        source: "Calculé a partir des données de l'Office fédéral de la statistique suisse",
        title: 'Taux de croissance annuel compose',
      },
      currentPopulation: {
        calculation: 'Somme de tous les résidents dans un rayon de 500m autour de la propriété',
        importance: 'Base pour calculer les taux de croissance et la taille du marché',
        limitations: 'Base sur les limites administratives et la methodologie du recensement',
        shortDescription: "Population totale de la zone locale pour l'année la plus récente",
        source: "Données de population de l'année en cours de l'Office fédéral de la statistique suisse",
        title: 'Population actuelle',
      },
      familyHouseholds: {
        calculation: '(Ménages de 3+ personnes) / Total des ménages x 100',
        importance: 'Indique la demande de propriétés plus grandes avec des caractéristiques familiales',
        limitations: 'Inclut divers types de ménages, pas seulement les familles avec enfants',
        shortDescription: 'Pourcentage de ménages avec trois résidents ou plus',
        source: "Données de taille des ménages de l'Office fédéral de la statistique suisse",
        title: 'Ménages familiaux (3+ personnes)',
      },
      foreignResidents: {
        calculation: 'Population étrangere / Population totale x 100',
        importance: 'Indique le caractère international et le potentiel du marché locatif',
        limitations: 'Nationalité au moment du recensement, peut né pas refleter la diversité culturelle',
        shortDescription: 'Pourcentage de résidents de nationalité étrangere',
        source: "Données de nationalité de l'Office fédéral de la statistique suisse",
        title: 'Résidents étrangers',
      },
      growth10Year: {
        calculation: '(Population actuelle - Il y a 10 ans) / Il y a 10 ans x 100',
        importance: 'Revele les tendances démographiques à long terme et les changements structurels',
        limitations: 'Les performances historiques peuvent né pas prédire les tendances futures',
        shortDescription: 'Évolution de la population au cours de la dernière decennie',
        source: "Comparaison démographique decennale de l'Office fédéral de la statistique suisse",
        title: 'Croissance démographique sur 10 ans',
      },
      growth1Year: {
        calculation: '(Population actuelle - Année précédente) / Année précédente x 100',
        importance: 'Montre les tendances immédiates du marché et les changements de demande à court terme',
        limitations: 'Peut refléter des facteurs temporaires ou des variations saisonnières',
        shortDescription: 'Évolution de la population au cours de la dernière année',
        source: "Données de population annuelles de l'Office fédéral de la statistique suisse",
        title: 'Croissance démographique sur 1 an',
      },
      growth2Year: {
        calculation: '(Population actuelle - Il y a 2 ans) / Il y a 2 ans x 100',
        importance: 'Indique les tendances à court terme au-delà des fluctuations annuelles',
        limitations: 'Toujours soumis aux variations cycliques et aux facteurs temporaires',
        shortDescription: 'Évolution de la population au cours des deux dernières années',
        source: "Suivi démographique de l'Office fédéral de la statistique suisse",
        title: 'Croissance démographique sur 2 ans',
      },
      growth5Year: {
        calculation: '(Population actuelle - Il y a 5 ans) / Il y a 5 ans x 100',
        importance: 'Montre les tendances démographiques à moyen terme et les cycles économiques',
        limitations: 'Peut inclure les effets des cycles économiques ou des changements de politique',
        shortDescription: 'Évolution de la population au cours des cinq dernières années',
        source: "Analyse démographique quinquennale de l'Office fédéral de la statistique suisse",
        title: 'Croissance démographique sur 5 ans',
      },
      medianAge: {
        calculation: "Estimé à partir des distributions par groupe d'âge par interpolation linéaire",
        importance: 'Indique le marché cible pour différents types de propriétés et commodités',
        limitations: "Approximation basée sur les groupes d'âge, pas les âges individuels",
        shortDescription: "Valeur d'âge médiane lorsque tous les résidents sont classés par âge",
        source: "Données par groupe d'âge de l'Office fédéral de la statistique suisse",
        title: 'Âge médian',
      },
      newResidents: {
        calculation: 'Résidents 0-1 an / Population totale x 100',
        importance: 'Des pourcentages élevés indiquent des zonés dynamiques avec des opportunités de location',
        limitations: 'Inclut tous les types de deménagements, des relocalisations locales a la migration internationale',
        shortDescription: 'Pourcentage de résidents qui ont déménagé dans la zone au cours de la dernière année',
        source: "Données de migration de l'Office fédéral de la statistique suisse",
        title: 'Nouveaux résidents (0-1 an)',
      },
      populationGrowth: {
        calculation: '(Population actuelle - Population il y a 10 ans) / Population il y a 10 ans',
        importance: "La croissance indique une demande immobilière croissante et un potentiel d'investissement",
        limitations: 'Les tendances historiques peuvent né pas prédire les performances futures',
        shortDescription: 'Évolution de la population au cours des 10 dernières années',
        source: "Données de population annuelles de l'Office fédéral de la statistique suisse",
        title: 'Croissance démographique',
      },
      singlePersonHouseholds: {
        calculation: "Ménages d'une personne / Total des ménages x 100",
        importance: 'Des pourcentages élevés indiquent une forte demande locative pour les petites unités',
        limitations: 'Inclut tous les âgés, des jeunes professionnels aux résidents ages',
        shortDescription: 'Pourcentage de ménages avec un seul résident',
        source: "Données de composition des ménages de l'Office fédéral de la statistique suisse",
        title: "Ménages d'une personne",
      },
      totalPopulation: {
        calculation: 'Somme de tous les résidents dans la zone géographique définie',
        importance: 'Indique la taille du marché et la densité de la demande immobilière',
        limitations: 'Base sur les statistiques officielles, peut né pas refleter les variations saisonnières',
        shortDescription: 'Nombre total de résidents dans un rayon de 500m autour de la propriété',
        source: "Données démographiques de l'Office fédéral de la statistique suisse",
        title: 'Population totale',
      },
      twoPersonHouseholds: {
        calculation: 'Ménages de deux personnes / Total des ménages x 100',
        importance: 'Indique la demande de propriétés de 2-3 chambres, typique pour les couples et les petites familles',
        limitations: 'Inclut divers types de ménages: couples, colocataires, parent avec enfant, etc.',
        shortDescription: 'Pourcentage de ménages avec deux résidents',
        source: "Données de composition des ménages de l'Office fédéral de la statistique suisse",
        title: 'Ménages de deux personnes',
      },
    },
  },
  electricity: {
    categories: {
      C1: 'Très petite entreprise, max 8 kW',
      C2: 'Petite entreprise, max 15 kW',
      C3: 'Entreprise moyenne, max 50 kW',
      C4: 'Grande entreprise, 150 kW, basse tension',
      C5: 'Grande entreprise, 150 kW, moyenne tension',
      C6: 'Grande entreprise, 400 kW, moyenne tension',
      C7: "Grande entreprise, 1'630 kW, moyenne tension",
      H1: 'Apt. 2 pcs, cuisinière électrique',
      H2: 'Apt. 4 pcs, cuisinière électrique',
      H3: 'Apt. 4 pcs + cuisinière + chauffe-eau',
      H4: 'Apt. 5 pcs + cuisinière + sèche-linge',
      H5: 'Maison 5 pcs, tout équipement électrique',
      H6: 'Maison 5 pcs + chauffage résistance',
      H7: 'Maison 5 pcs + pompe à chaleur 5 kW',
      H8: 'Grand apt. copropriété haut. électrifié',
    },
    categoryDescriptions: {
      C1: "Très petite entreprise, puissance max 8 kW, 8'000 kWh/an",
      C2: "Petite entreprise, puissance max 15 kW, 30'000 kWh/an",
      C3: "Entreprise moyenne, puissance max 50 kW, 150'000 kWh/an",
      C4: "Grande entreprise, puissance 150 kW, basse tension, 500'000 kWh/an",
      C5: "Grande entreprise, puissance 150 kW, moyenne tension, propre station de transformation, 500'000 kWh/an",
      C6: "Grande entreprise, puissance 400 kW, moyenne tension, propre station de transformation, 1'500'000 kWh/an",
      C7: "Grande entreprise, puissance 1'630 kW, moyenne tension, propre station de transformation, 7'500'000 kWh/an",
      H1: "Appartement de 2 pièces avec cuisinière électrique, 1'600 kWh/an",
      H2: "Appartement de 4 pièces avec cuisinière électrique, 2'500 kWh/an",
      H3: "Appartement de 4 pièces avec cuisinière électrique, chauffe-eau électrique (sans sèche-linge), 4'500 kWh/an",
      H4: "Appartement de 5 pièces avec cuisinière électrique, chauffe-eau électrique et sèche-linge, 4'500 kWh/an",
      H5: "Maison individuelle, 5 pièces, cuisinière électrique, chauffe-eau électrique, sèche-linge, 7'500 kWh/an",
      H6: "Maison individuelle, 5 pièces, cuisinière électrique, chauffe-eau électrique, sèche-linge, chauffage à résistance électrique, 25'000 kWh/an",
      H7: "Maison individuelle, 5 pièces, cuisinière électrique, chauffe-eau électrique, sèche-linge, pompe à chaleur 5 kW, 13'000 kWh/an",
      H8: "Grand appartement en copropriété, hautement électrifié (cuisinière, chauffe-eau, sèche-linge, lave-vaisselle), 7'500 kWh/an",
    },
    categoryGroups: {
      commercial: 'Entreprises (C1-C7)',
      commercialSubtitle: 'Consommation commerciale / industrielle',
      residential: 'Ménages (H1-H8)',
      residentialSubtitle: 'Consommation résidentielle',
    },
    charts: {
      noData: 'Aucune donnée graphique disponible',
      priceEvolution: {
        axis: {
          price: 'Prix (ct./kWh)',
        },
        subtitle: 'Tendances historiques des tarifs (ct./kWh)',
        summary: {
          avgChange: 'Variation moy.',
          decreasing: 'En baisse',
          increasing: 'En hausse',
          stable: 'Stable',
          title: 'Tendances des prix {{startYear}}–{{endYear}}',
          trend: 'Tendance',
        },
        title: 'Évolution des prix par gestionnaire de réseau',
      },
    },
    comparison: {
      aboveCantonMedian: 'au-dessus de la médiane cantonale',
      aboveNationalMedian: 'au-dessus de la médiane nationale',
      belowCantonMedian: 'sous la médiane cantonale',
      belowNationalMedian: 'sous la médiane nationale',
      canton: 'Médiane canton',
      switzerland: 'Médiane Suisse',
      thisLocation: 'Cet emplacement',
      title: 'Comparaison géographique des prix',
    },
    efficiency: {
      high: 'Coût bas',
      low: 'Coût élevé',
      medium: 'Coût moyen',
    },
    evolution: {
      '10year': '10 ans',
      '1year': '1 an',
      '2year': '2 ans',
      '5year': '5 ans',
      na: 'N/D',
      title: "Résumé de l'évolution des prix",
    },
    filters: {
      category: 'Catégorie',
      categoryTrigger: 'Catégorie :',
      location: 'Emplacement',
    },
    gridOperators: {
      cheapest: 'Moins cher',
      distribution: 'Utilisation du réseau',
      energy: 'Énergie',
      name: 'Gestionnaire',
      supplement: 'Supplément',
      taxes: 'Taxes',
      title: 'Comparaison des gestionnaires de réseau',
      total: 'Total',
      unit: 'ct./kWh',
    },
    insights: {
      highEfficiency: "Les prix de l'électricité dans cette commune sont inférieurs aux médianes cantonale et nationale. C'est favorable pour les charges et les pompes à chaleur.",
      lowEfficiency: "Les prix de l'électricité dans cette commune sont supérieurs aux médianes cantonale et nationale. Cela augmente significativement les charges, surtout pour le chauffage électrique.",
      mediumEfficiency: "Les prix de l'électricité dans cette commune sont proches des médianes régionales et nationales. Les charges sont dans la fourchette typique pour la Suisse.",
      title: "Évaluation du coût d'électricité",
    },
    metrics: {
      annualCost: {
        subtitle: 'Facture annuelle estimée (moins cher)',
        title: 'Coût annuel',
      },
      cheapestPrice: {
        subtitle: 'Meilleur tarif disponible (ct./kWh)',
        title: 'Prix le plus bas',
      },
      priceRange: {
        subtitle: 'Min – Max entre gestionnaires',
        title: 'Fourchette de prix',
      },
    },
    states: {
      categoryNotAvailable: 'Aucune donnée disponible pour cette catégorie. Seule la catégorie H4 (Maison moyenne) est actuellement disponible.',
      error: 'Erreur : {{error}}',
      fetchError: "Échec du chargement des données d'électricité",
      loading: "Chargement des données de prix d'électricité...",
      noData: "Aucune donnée de prix d'électricité disponible pour cet emplacement.",
      noHistoricalData: 'Aucune donnée historique disponible.',
    },
    subtitle: 'Données tarifaires des gestionnaires de réseau (ElCom)',
    tabs: {
      overview: 'Aperçu',
      trends: 'Tendances',
    },
    title: "Prix de l'électricité",
    tooltips: {
      annualCost: {
        calculation: 'Tarif le plus bas (ct./kWh) × consommation annuelle (kWh) de la catégorie sélectionnée.',
        importance: 'Composante clé des charges pour le calcul du coût total de propriété.',
        limitations: 'La consommation réelle peut varier. Basé sur les profils de consommation standard ElCom.',
        shortDescription: 'Facture annuelle estimée basée sur le gestionnaire de réseau le moins cher et la consommation standard.',
        source: "ElCom (Commission fédérale de l'électricité)",
        title: 'Coût annuel estimé',
      },
      cheapestPrice: {
        calculation: 'Comprend utilisation du réseau, énergie, taxes et supplément fédéral (RPC).',
        importance: "Impact direct sur les charges d'exploitation pour propriétaires et locataires.",
        limitations: 'Les prix peuvent changer annuellement. Basé sur les profils ElCom.',
        shortDescription: "Le tarif d'électricité total le plus bas disponible dans cette commune de tout gestionnaire de réseau.",
        source: "ElCom (Commission fédérale de l'électricité)",
        title: "Prix d'électricité le plus bas",
      },
      priceRange: {
        calculation: 'Prix total minimum et maximum de tous les gestionnaires de réseau pour la catégorie sélectionnée.',
        importance: 'Un écart plus large signifie des économies potentielles en choisissant le bon gestionnaire de réseau.',
        limitations: 'Tous les gestionnaires de réseau ne desservent pas forcément toutes les adresses de la commune.',
        shortDescription: "L'écart entre le gestionnaire de réseau le moins cher et le plus cher dans cette commune.",
        source: "ElCom (Commission fédérale de l'électricité)",
        title: 'Fourchette de prix',
      },
    },
  },
  elevation: {
    constraints: {
      amongTallest: {
        description: "Ce bâtiment est déjà dans le top {{percentile}}% des hauteurs du quartier. Une hauteur supplémentaire peut faire l'objet d'un examen attentif.",
        title: 'Parmi les plus hauts du quartier:',
      },
      architecturalCohesion: {
        description: "Les bâtiments voisins datent d'une période de construction similaire. La conception de la surélévation doit maintenir l'harmonie architecturale.",
        title: 'Cohérence architecturale:',
      },
      heritageProtected: {
        description: 'Ce bâtiment a un statut de protection patrimoniale ({{rank}}). Toute modification nécessite une autorisation spéciale et peut être restreinte.',
        title: 'Patrimoine protégé:',
      },
      maxHeightReached: {
        description: 'Le bâtiment a déjà atteint ou dépassé la hauteur légale maximale pour cette zone. Aucun étage supplémentaire ne peut être ajouté.',
        title: 'Hauteur maximale atteinte:',
      },
      protectedNearby: {
        description: "Il y a des bâtiments protégés dans le voisinage immédiat. Les projets de surélévation peuvent nécessiter une évaluation d'impact patrimonial.",
        title: 'Bâtiments protégés à proximité:',
      },
      structuralAssessment: {
        description: 'Le bâtiment a {{age}} ans. Une évaluation structurelle complète est recommandée avant tout projet de surélévation.',
        title: 'Évaluation structurelle requise:',
      },
    },
    elevationCharts: {
      far: {
        available: 'Disponible',
        current: 'Actuel',
        maximum: 'Maximum',
        subtitle: 'Densité de développement actuelle vs maximum autorisé',
        title: "Utilisation du coefficient d'utilisation du sol ({{indiceType}})",
        used: 'CUS utilisé',
      },
      height: {
        available: 'Disponible',
        availableMeters: '+{{meters}}m disponible',
        currentBuilding: 'Bâtiment\nactuel',
        height: 'Hauteur',
        legalMaximum: 'Maximum\nlégal',
        legend: {
          availableSpace: 'Espace disponible (+{{height}}m)',
          currentBuilding: 'Bâtiment actuel ({{height}}m)',
          legalMaximum: 'Maximum légal ({{height}}m)',
          neighborsAverage: 'Moyenne voisins ({{height}}m)',
          neighborsMaximum: 'Max voisins ({{height}}m)',
        },
        maxAllowedByZoning: 'Maximum autorisé par la zone',
        neighborsAverage: 'Moyenne\nvoisins',
        neighborsMaximum: 'Maximum\nvoisins',
        subtitle: 'Hauteur du bâtiment vs maximum légal et contexte du quartier',
        title: 'Comparaison des hauteurs',
        utilization: 'Utilisation',
      },
    },
    header: {
      subtitle: "Analyse des possibilités d'extension verticale",
      subtitleFull: 'Analyse complète du potentiel de surélévation basée sur les règlements de zone, la capacité structurelle et le contexte du quartier',
      title: 'Potentiel de surélévation',
    },
    overview: {
      availableFloors: {
        label: 'Étages disponibles',
        tooltip: {
          calculation: 'Étages légaux max - Étages actuels = Étages disponibles',
          importance: "Métrique clé pour évaluer le potentiel d'expansion verticale",
          limitations: 'Soumis à la faisabilité structurelle et aux permis de construire',
          shortDescription: "Nombre d'étages supplémentaires pouvant potentiellement être ajoutés selon les règlements de zone",
          source: 'Règlements de zone cantonaux',
          title: 'Étages disponibles pour surélévation',
        },
      },
      availableHeight: {
        label: 'Hauteur disponible',
        limited: 'Espace limité',
        none: "Pas d'espace",
        oneFloor: '1 étage possible',
        tooltip: {
          calculation: 'Hauteur légale max - Hauteur actuelle = Hauteur disponible',
          importance: "Détermine l'espace physique disponible pour de nouveaux étages",
          limitations: 'Ne tient pas compte des exigences de structure de toit',
          shortDescription: 'Hauteur supplémentaire en mètres pouvant être ajoutée au bâtiment',
          source: 'Données de hauteur du bâtiment et limites de zone',
          title: 'Hauteur disponible pour surélévation',
        },
        twoFloors: '2+ étages possibles',
      },
      elevationScore: {
        label: 'Score de surélévation',
        tooltip: {
          calculation: 'Combinaison pondérée des étages disponibles, de la conformité réglementaire et des facteurs structurels',
          categories: {
            excellent: 'Excellent potentiel',
            limited: 'Potentiel limité',
            moderate: 'Potentiel modéré',
            veryLow: 'Très faible potentiel',
          },
          importance: "Évaluation rapide de la viabilité de surélévation pour les décisions d'investissement",
          limitations: "Ne remplace pas l'évaluation professionnelle structurelle et juridique",
          shortDescription: 'Score composite évaluant le potentiel global de surélévation du bâtiment',
          source: 'Algorithme propriétaire Popety.io',
          title: 'Score global de faisabilité de surélévation',
        },
      },
      feasibility: {
        buildingAge: {
          historic: 'Historique',
          label: 'Âge du bâtiment',
          mature: 'Mature',
          modern: 'Moderne',
          old: 'Ancien',
          tooltip: {
            calculation: 'Année actuelle - Année de construction',
            categories: {
              historic: 'Historique (100+ ans): Évaluation complète essentielle',
              mature: 'Mature (30-60 ans): Évaluation recommandée',
              modern: 'Moderne (0-30 ans): Capacité structurelle standard',
              old: 'Ancien (60-100 ans): Évaluation détaillée requise',
            },
            importance: 'Les bâtiments plus anciens peuvent nécessiter un renforcement structurel',
            shortDescription: "Comment l'âge du bâtiment affecte la faisabilité de surélévation et les évaluations requises",
            source: 'Registre fédéral des bâtiments (RegBL)',
            title: "Impact de l'âge du bâtiment sur la surélévation",
          },
          years: '{{years}} ans',
        },
        heritageProtection: {
          label: 'Protection patrimoniale',
          tooltip: {
            importance: 'Les bâtiments protégés font face à des restrictions importantes sur les modifications',
            shortDescription: 'La classification de protection patrimoniale du bâtiment, le cas échéant',
            source: 'Registres du patrimoine cantonaux',
            title: 'Statut de protection patrimoniale',
          },
        },
        overallRating: {
          excellent: 'Excellent',
          good: 'Bon',
          label: 'Évaluation globale',
          limited: 'Limité',
          poor: 'Faible',
          tooltip: {
            calculation: 'Combinaison pondérée des facteurs réglementaires, structurels et de quartier',
            categories: {
              excellent: {
                description: 'Conditions très favorables pour la surélévation',
                label: 'Excellent (70-100)',
              },
              good: {
                description: 'Favorable avec quelques considérations',
                label: 'Bon (40-69)',
              },
              limited: {
                description: 'Contraintes importantes à surmonter',
                label: 'Limité (20-39)',
              },
              poor: {
                description: 'Obstacles majeurs; surélévation peu probable',
                label: 'Faible (0-19)',
              },
            },
            importance: "Référence rapide pour la prise de décision d'investissement",
            limitations: 'Évaluation professionnelle recommandée pour les décisions finales',
            shortDescription: 'Évaluation complète combinant tous les facteurs de faisabilité',
            title: 'Évaluation globale de faisabilité',
          },
        },
        quartierBuildings: {
          label: 'Bâtiments du quartier',
          tooltip: {
            importance: 'Un échantillon plus grand fournit un contexte de quartier plus fiable',
            shortDescription: 'Nombre de bâtiments dans la zone de quartier analysée',
            source: 'Registre fédéral des bâtiments (RegBL)',
            title: 'Total des bâtiments dans le quartier',
          },
        },
        similarPeriod: {
          label: 'Bâtiments de période similaire',
          noFlexible: 'Non - Plus flexible',
          tooltip: {
            importance: 'Peut influencer les exigences de conception pour les projets de surélévation',
            shortDescription: 'Si les bâtiments voisins ont été construits dans une période similaire, nécessitant une cohérence architecturale',
            source: 'Analyse des dates de construction du quartier',
            title: 'Bâtiments voisins de période de construction similaire',
          },
          yesRequired: 'Oui - Cohérence requise',
        },
        title: 'Évaluation de faisabilité',
      },
      legalFramework: {
        availableFarSpace: {
          label: 'Espace CUS disponible',
          tooltip: {
            calculation: '(CUS max - CUS actuel) × Surface du terrain',
            importance: 'Métrique clé pour déterminer la surface constructible supplémentaire',
            shortDescription: 'Surface de plancher supplémentaire en m² pouvant être construite selon les règlements CUS',
            source: 'Calculé à partir du registre foncier et des données de zone',
            title: "Espace de coefficient d'utilisation du sol disponible",
          },
        },
        currentFloors: {
          label: 'Étages actuels',
          tooltip: {
            calculation: "Nombre d'étages au-dessus du niveau du sol, sous-sol exclu",
            importance: "Base pour calculer le potentiel d'étages supplémentaires",
            shortDescription: "Le nombre actuel d'étages hors sol dans le bâtiment",
            source: 'Registre fédéral des bâtiments (RegBL)',
            title: "Nombre actuel d'étages",
          },
        },
        currentHeight: {
          label: 'Hauteur actuelle',
          tooltip: {
            calculation: "Mesurée depuis le niveau du sol naturel jusqu'au faîte du toit",
            importance: "Point de référence pour calculer l'espace de surélévation disponible",
            shortDescription: "La hauteur mesurée du bâtiment depuis le niveau du sol jusqu'au point le plus haut",
            source: 'Registre fédéral des bâtiments (RegBL)',
            title: 'Hauteur actuelle du bâtiment',
          },
        },
        farIndex: {
          label: 'Indice CUS utilisé',
          tooltip: {
            calculation: 'Déterminé par les réglementations cantonales selon le type de zone',
            categories: {
              sp: {
                description: 'Indice de surface brute de plancher - Canton de Vaud',
                label: 'SP (Surface de plancher)',
              },
              spd: {
                description: 'Indice de surface de plancher déterminante - Canton de Genève',
                label: 'SPD (Surface de plancher déterminante)',
              },
              std: {
                description: 'Indice de surface totale déterminante',
                label: 'STD (Surface totale déterminante)',
              },
            },
            importance: 'Détermine la méthode de calcul de la surface constructible',
            shortDescription: "Le type d'indice de coefficient d'utilisation du sol applicable à cette propriété",
            source: 'Réglementations de construction cantonales',
            title: "Indice de coefficient d'utilisation du sol",
          },
        },
        maxLegalFloors: {
          label: 'Étages légaux max',
          tooltip: {
            calculation: "Dérivé de la hauteur maximale divisée par la hauteur standard d'un étage (3m)",
            importance: "Détermine la limite supérieure pour l'expansion verticale",
            limitations: 'Peut varier selon le type de bâtiment et les règles spécifiques de la zone',
            shortDescription: "Le nombre maximum d'étages autorisés pour les bâtiments dans cette zone",
            source: 'Règlements de zone cantonaux',
            title: "Nombre maximum légal d'étages",
          },
        },
        maxLegalHeight: {
          label: 'Hauteur légale max',
          tooltip: {
            calculation: 'Définie par les plans de zone cantonaux et communaux',
            importance: 'Limite stricte qui ne peut être dépassée sans dispense spéciale',
            limitations: 'Peut être soumise à des contraintes supplémentaires comme les règles de distance',
            shortDescription: 'La hauteur maximale autorisée pour les bâtiments dans cette zone selon les règlements de zone',
            source: 'Règlements de zone communaux',
            title: 'Hauteur légale maximale du bâtiment',
          },
        },
        title: 'Cadre juridique',
      },
      legalStatus: {
        floorsPossible: '{{count}} étage(s) possible(s)',
        label: 'Statut juridique',
        noExpansion: "Pas d'extension possible",
        tooltip: {
          categories: {
            allowed: {
              description: 'Le bâtiment peut être surélevé dans les limites de zone',
              label: 'Surélévation autorisée',
            },
            assessment: {
              description: 'Évaluation détaillée nécessaire pour déterminer la faisabilité',
              label: 'Évaluation requise',
            },
            maximum: {
              description: 'Le bâtiment a atteint la hauteur maximale autorisée',
              label: 'Maximum atteint',
            },
            protected: {
              description: 'La protection patrimoniale restreint les modifications',
              label: 'Bâtiment protégé',
            },
          },
          importance: 'Détermine si la surélévation est légalement possible',
          limitations: 'Basé sur les réglementations actuelles; peut changer au fil du temps',
          shortDescription: 'Statut réglementaire actuel concernant les possibilités de surélévation',
          source: 'Règlements de construction cantonaux et registres du patrimoine',
          title: 'Statut juridique pour surélévation',
        },
      },
      neighborhoodFit: {
        avgHeight: {
          label: 'Hauteur moy. voisins',
          tooltip: {
            calculation: 'Hauteur moyenne de tous les bâtiments dans le rayon du quartier',
            importance: "Référence pour l'évaluation contextuelle de la hauteur du bâtiment",
            shortDescription: 'La hauteur moyenne des bâtiments dans le voisinage immédiat',
            source: 'Registre fédéral des bâtiments (RegBL)',
            title: 'Hauteur moyenne des bâtiments voisins',
          },
        },
        buildingDensity: {
          label: 'Densité des bâtiments',
          tooltip: {
            calculation: 'Emprise au sol / Surface du terrain, comparé au quartier',
            importance: "Une densité élevée peut limiter les options d'expansion",
            shortDescription: 'À quel point la couverture des bâtiments est dense par rapport à la moyenne du quartier',
            source: "Registre foncier et données d'emprise au sol",
            title: 'Percentile de densité des bâtiments',
          },
        },
        contiguityRatio: {
          label: 'Ratio de contiguïté',
          tooltip: {
            calculation: 'Longueur des murs partagés / Périmètre total × 100',
            importance: 'Une forte contiguïté affecte la complexité de la construction et la coordination avec les voisins',
            shortDescription: 'Pourcentage du périmètre du bâtiment partagé avec les bâtiments adjacents',
            source: "Analyse de l'emprise au sol",
            title: 'Ratio de contiguïté du bâtiment',
          },
        },
        heightPercentile: {
          label: 'Percentile de hauteur',
          tooltip: {
            calculation: 'Pourcentage des bâtiments du quartier qui sont plus bas',
            categories: {
              belowAvg: 'En dessous de la moyenne',
              lowerMid: 'Milieu inférieur',
              tallest: 'Parmi les plus hauts',
              upperMid: 'Milieu supérieur',
            },
            importance: "Indique comment la surélévation pourrait affecter la ligne d'horizon du quartier",
            shortDescription: 'Comment la hauteur de ce bâtiment se compare aux autres dans le voisinage immédiat',
            source: 'Analyse des bâtiments voisins dans un rayon de 100m',
            title: 'Percentile de hauteur du bâtiment dans le quartier',
          },
        },
        protectedNearby: {
          label: 'Protégé à proximité',
          tooltip: {
            importance: "Peut nécessiter une évaluation d'impact patrimonial pour les projets de surélévation",
            shortDescription: "Indique s'il y a des bâtiments protégés dans le voisinage immédiat",
            source: 'Registres du patrimoine cantonaux',
            title: 'Bâtiments protégés à proximité',
          },
        },
        tallestNeighbor: {
          label: 'Voisin le plus haut',
          tooltip: {
            calculation: 'Hauteur maximale parmi tous les bâtiments du quartier',
            importance: 'Indique le précédent de hauteur existant dans la zone',
            shortDescription: 'La hauteur du bâtiment le plus haut dans le voisinage immédiat',
            source: 'Registre fédéral des bâtiments (RegBL)',
            title: 'Bâtiment le plus haut du quartier',
          },
        },
        title: 'Intégration au quartier',
      },
    },
    regulatory: {
      approvals: {
        architecturalPlans: 'Plans architecturaux',
        buildingPermit: 'Permis de construire',
        elevator: "Installation d'ascenseur",
        fireSafety: 'Approbation sécurité incendie',
        heritageConsultation: 'Consultation patrimoniale',
        heritageImpact: "Évaluation d'impact patrimonial",
        recommended: 'Recommandé',
        required: 'Requis',
        structuralReview: 'Revue structurelle',
        title: 'Autorisations requises',
      },
      farCompliance: {
        availableSpace: {
          label: 'Espace CUS disponible',
          tooltip: {
            importance: 'Métrique clé pour déterminer le potentiel de construction supplémentaire',
            shortDescription: 'Surface constructible supplémentaire en m² basée sur les limites CUS',
            source: 'Calculé à partir du registre foncier et des données de zone',
            title: 'Espace de surface de plancher disponible',
          },
        },
        indiceType: {
          label: "Type d'indice utilisé",
          tooltip: {
            shortDescription: 'La méthode de calcul CUS spécifique utilisée dans ce canton',
            source: 'Réglementations de construction cantonales',
            title: "Type d'indice de coefficient d'utilisation du sol",
          },
        },
        sp: 'SP (Surface de plancher)',
        spd: 'SPD (Surface de plancher déterminante)',
        std: 'STD (Surface totale déterminante)',
        title: 'Conformité CUS',
      },
      heightFloor: {
        availableFloors: 'Étages disponibles',
        availableHeight: 'Hauteur disponible',
        currentFloors: 'Étages actuels',
        currentHeight: {
          label: 'Hauteur actuelle',
          tooltip: {
            shortDescription: 'Hauteur mesurée du niveau du sol au faîte du toit',
            source: 'Registre fédéral des bâtiments (RegBL)',
            title: 'Hauteur actuelle du bâtiment',
          },
        },
        maxLegalFloors: 'Étages légaux max',
        maxLegalHeight: {
          label: 'Hauteur légale max',
          tooltip: {
            importance: 'Limite légale qui ne peut être dépassée sans autorisation spéciale',
            shortDescription: 'Hauteur maximale du bâtiment autorisée par les règlements de zone',
            source: 'Règlements de zone communaux',
            title: 'Hauteur légale maximale',
          },
        },
        title: "Réglementations de hauteur et d'étages",
      },
      timeline: {
        construction: 'Construction',
        constructionDuration: '{{min}}-{{max}} mois',
        heritageReview: 'Revue patrimoniale',
        heritageReviewDuration: '+3-6 mois',
        permitApplication: 'Demande de permis',
        permitApplicationDuration: '3-6 mois',
        preliminaryStudies: 'Études préliminaires',
        preliminaryStudiesDuration: '2-4 mois',
        title: 'Calendrier estimé',
        totalDuration: 'Durée totale',
        totalProtected: '18-24 mois',
        totalStandard: '12-18 mois',
      },
    },
    score: {
      label: 'Score de surélévation',
      tooltip: 'Évaluation globale de la faisabilité de surélévation combinant les facteurs réglementaires, structurels et de voisinage',
    },
    shared: {
      estimated: 'estimé',
      month: 'mois',
      na: 'N/D',
      no: 'Non',
      none: 'Aucun',
      units: 'unités',
      year: 'an',
      yes: 'Oui',
    },
    states: {
      error: 'Erreur de chargement: {{error}}',
      loading: 'Chargement des données de surélévation...',
      noBuilding: 'Aucun bâtiment sélectionné',
      noData: {
        description: "L'analyse du potentiel de surélévation n'est pas disponible pour ce bâtiment. Cela peut être dû à des données de zone manquantes ou au fait que le bâtiment se trouve dans une zone où l'analyse de surélévation n'est pas applicable.",
        title: 'Données de surélévation non disponibles',
      },
    },
    status: {
      elevationAllowed: 'Surélévation autorisée',
      maximumReached: 'Maximum atteint',
      protectedBuilding: 'Bâtiment protégé',
      requiresAssessment: 'Évaluation requise',
    },
    structural: {
      condition: {
        assessmentNeeded: 'Évaluation nécessaire',
        buildingAge: 'Âge du bâtiment',
        foundationReinforcement: 'Renforcement des fondations',
        inDepthRequired: 'Approfondie requise',
        likelyNotRequired: 'Probablement non requis',
        likelyRequired: 'Probablement requis',
        loadBearingWalls: 'Murs porteurs',
        mature: 'Mature',
        modern: 'Moderne',
        old: 'Ancien',
        professionalReview: 'Revue professionnelle requise',
        standardReview: 'Revue standard',
        structuralCapacity: {
          label: 'Capacité structurelle',
          tooltip: {
            importance: 'Facteur critique pour déterminer la faisabilité de surélévation',
            shortDescription: 'Évaluation de la capacité du bâtiment à supporter des étages supplémentaires',
            source: "Basé sur l'âge du bâtiment et les normes de construction",
            title: 'Capacité portante structurelle',
          },
        },
        title: "Évaluation de l'état du bâtiment",
        years: '{{years}} ans',
      },
      method: {
        craneAccess: 'Accès grue',
        critical: 'Critique',
        highCarefulPlanning: 'Élevé - planification soignée',
        lightSteelClt: 'Ossature acier léger/CLT',
        neighborImpact: 'Impact sur les voisins',
        recommended: 'Recommandé',
        recommendedMethod: 'Méthode recommandée',
        siteSurveyRequired: 'Étude de site requise',
        standardMeasures: 'Mesures standard',
        steelFrameConcrete: 'Ossature acier + béton',
        title: 'Méthode de construction',
        traditionalMasonry: 'Maçonnerie traditionnelle',
        weightOptimization: 'Optimisation du poids',
      },
      reinforcement: {
        assessmentRequired: 'Évaluation requise',
        basicAssessment: 'Évaluation de base',
        estimatedWeight: 'Poids supplémentaire estimé',
        foundationAssessment: 'Évaluation des fondations',
        inDepthGeotechnical: 'Étude géotechnique approfondie',
        reinforcementNeeded: 'Renforcement nécessaire',
        seismic: 'Conformité sismique',
        siaStandards: 'Normes SIA applicables',
        standardSoilTest: 'Test de sol standard',
        structuralFrame: 'Ossature structurelle',
        title: 'Besoins de renforcement structurel',
        typicallyAdequate: 'Généralement adéquat',
        weightRange: '{{min}}-{{max}} kg/m²',
      },
      requirements: {
        accessDuringConstruction: 'Accès pendant la construction',
        elevator: "Exigence d'ascenseur",
        elevatorRequired: 'Ascenseur requis (4+ étages)',
        enhancedRequirements: 'Exigences renforcées',
        fireSafety: 'Sécurité incendie',
        notRequired: 'Non requis',
        planningRequired: 'Planification requise',
        standard: 'Standard',
        temporaryRoof: 'Toit temporaire nécessaire',
        title: 'Exigences de construction',
        weatherProtection: 'Protection météo',
      },
    },
    tabs: {
      overview: 'Aperçu',
      regulatory: 'Réglementaire',
      structural: 'Structure',
    },
  },
  employment: {
    charts: {
      employmentTrend: {
        axis: {
          employment: 'Emploi',
        },
        legend: {
          fullTimeEmployment: 'Emploi à temps plein',
          totalEmployment: 'Emploi total',
        },
        noData: "Aucune donnée de tendance d'emploi disponible",
        subtitle: "Évolution historique de l'emploi montrant la trajectoire du marché du travail (2011-2022)",
        summary: {
          annualCompoundGrowth: 'croissance annuelle composée',
          cagr: 'TCAC',
          currentFTRatio: 'Ratio temps plein actuel',
          declining: 'En déclin',
          fullTimeGrowth: 'Croissance du temps plein',
          growing: 'En croissance',
          jobMarketStatus: "État du marché de l'emploi",
          ofJobsAreFullTime: 'des emplois sont à temps plein',
          rapidGrowth: 'Croissance rapide',
          stableGrowth: 'Croissance stable',
          title: "Tendance de l'emploi sur {{years}} ans ({{startYear}}-{{endYear}})",
          totalJobGrowth: "Croissance totale de l'emploi",
        },
        title: "Tendance de l'emploi",
        tooltips: {
          fullTime: 'Temps plein',
          totalJobs: 'Emplois totaux',
          year: 'Année',
        },
      },
      fullTimeVsTotal: {
        subtitle: "Comparaison des tendances d'emploi à temps plein et total montrant l'évolution de la qualité des emplois",
        title: 'Emploi à temps plein vs total',
      },
      jobsPerEstablishment: {
        average: 'Moy',
        axis: {
          ratio: 'Emplois par établissement',
        },
        noData: 'Aucune donnée emplois par établissement disponible',
        subtitle: "Indicateur d'efficacité économique montrant la taille moyenne des entreprises dans le temps",
        summary: {
          balancedMix: "Mix équilibré de tailles d'entreprises",
          consolidating: 'Consolidation - Grandes entreprises émergentes, moins de petites entreprises',
          currentRatio: 'Ratio actuel',
          fragmenting: 'Fragmentation - Plus de petites entreprises, croissance entrepreneuriale',
          historicalChange: 'Changement historique',
          interpretation: 'Interprétation',
          jobsPerEstablishment: 'emplois par établissement',
          largeEmployerDominated: 'Dominé par les grands employeurs - Économie corporative',
          periodAverage: 'Moyenne de la période',
          smallBusinessEconomy: 'Économie de petites entreprises - Environnement entrepreneurial',
          title: "Tendance de l'efficacité économique ({{startYear}}-{{endYear}})",
        },
        title: 'Ratio emplois par établissement',
        tooltips: {
          employment: 'Emploi',
          establishments: 'Établissements',
          jobsPerEstablishment: 'emplois/établissement',
          ratio: 'Ratio',
          year: 'Année',
        },
      },
      publicPrivate: {
        axis: {
          employment: 'Emploi',
          establishments: 'Établissements',
        },
        legend: {
          privateSector: 'Secteur privé',
          publicSector: 'Secteur public',
        },
        noData: 'Aucune donnée de répartition public/privé disponible',
        subtitle: 'Répartition historique entre établissements des secteurs public et privé',
        summary: {
          balancedMix: 'Équilibre public-privé',
          governmentDominated: 'Économie dominée par le gouvernement - Stable mais croissance plus lente',
          investmentImplications: "Implications pour l'investissement",
          marketCharacter: 'Caractère du marché',
          marketDrivenDemand: 'Demande du marché, potentiel de croissance plus élevé, mix de locataires diversifié',
          privateDriven: 'Économie menée par le secteur privé - Dynamique et entrepreneuriale',
          privateSector: 'Secteur privé',
          publicSector: 'Secteur public',
          stableTenantBase: 'Base locataire stable, risque de vacance plus faible, immobilier axé sur le gouvernement',
          title: 'Secteur public vs privé ({{year}})',
        },
        title: 'Répartition public vs privé',
        tooltips: {
          private: 'Privé',
          public: 'Public',
          total: 'Total',
          year: 'Année',
        },
      },
      sectorComposition: {
        noData: 'Aucune donnée sectorielle disponible',
        subtitle: "Structure économique par secteur montrant la répartition de l'emploi",
        summary: {
          balancedDiversified: 'Économie diversifiée et équilibrée',
          dominantSector: 'Secteur dominant',
          economicCharacter: 'Caractère économique',
          highlyServiceOriented: 'Économie fortement orientée vers les services',
          jobs: 'emplois',
          primarySectorEconomy: 'Économie du secteur primaire',
          strongIndustrialBase: 'Base industrielle solide',
          title: 'Structure économique',
        },
        title: 'Composition sectorielle',
        tooltips: {
          jobs: 'Emplois',
          share: 'Part',
        },
      },
      sectorEvolution: {
        axis: {
          employment: 'Emploi',
        },
        legend: {
          primarySector: 'Secteur primaire',
          secondarySector: 'Secteur secondaire',
          tertiarySector: 'Secteur tertiaire',
        },
        noData: "Aucune donnée d'évolution sectorielle disponible",
        subtitle: 'Composition sectorielle historique montrant les transitions économiques (2011-2022)',
        summary: {
          economicTransformation: 'Transformation économique',
          gradualTransition: 'Transition économique progressive',
          serviceSectorTrend: 'Tendance du secteur des services',
          significantStructuralChange: 'Changement structurel significatif',
          stableSectorComposition: 'Composition sectorielle stable',
          title: 'Évolution sectorielle ({{startYear}}-{{endYear}})',
          totalEmploymentChange: "Changement de l'emploi total",
        },
        title: 'Évolution des secteurs dans le temps',
        tooltips: {
          total: 'Total',
          year: 'Année',
        },
      },
      totalEmploymentTrend: {
        subtitle: "Emploi historique montrant les phases de croissance et les points d'inflexion (2011-2022)",
        title: "Tendance de l'emploi total",
      },
    },
    common: {
      establishments: 'établissements',
      jobs: 'emplois',
    },
    filters: {
      byBicycle: 'À vélo',
      byCar: 'En voiture',
      byWalk: 'À pied',
      city: 'Ville',
      district: 'District',
      location: 'Localisation :',
      minBike: '{{minutes}}min à vélo',
      minDrive: '{{minutes}}min en voiture',
      minWalk: '{{minutes}}min à pied',
      selectLocation: 'Sélectionner un lieu',
    },
    loading: {
      employment: "Chargement des données d'emploi...",
      error: "Erreur lors du chargement des données d'emploi :",
      fetchFailed: "Échec du chargement des données d'emploi",
      noData: "Les données d'emploi ne sont pas disponibles pour cet emplacement.",
    },
    metrics: {
      cagr: {
        subtitle: 'Taux composé sur 10 ans',
        title: 'Taux de croissance annuel (TCAC)',
      },
      dominantSector: {
        subtitle: "{{percentage}}% de l'emploi total",
        title: 'Secteur dominant',
      },
      employmentGrowth: {
        subtitle: 'Évolution sur 10 ans',
        title: "Croissance de l'emploi",
      },
      establishmentGrowth: {
        subtitle: 'Évolution sur 10 ans',
        title: 'Croissance des établissements',
      },
      fiveYearGrowth: {
        subtitle: 'Trajectoire à moyen terme',
        title: 'Croissance sur 5 ans',
      },
      fullTimeRatio: {
        subtitle: 'Indicateur de stabilité',
        title: "Ratio d'emploi à temps plein",
      },
      jobsPerEstablishment: {
        subtitle: 'Efficacité économique',
        title: 'Emplois par établissement',
      },
      oneYearGrowth: {
        subtitle: 'Tendance la plus récente',
        title: 'Croissance sur 1 an',
      },
      privateSectorShare: {
        subtitle: '{{count}} établissements',
        title: 'Part du secteur privé',
      },
      publicSectorShare: {
        subtitle: '{{count}} établissements',
        title: 'Part du secteur public',
      },
      tenYearGrowth: {
        subtitle: 'Changement structurel à long terme',
        title: 'Croissance sur 10 ans',
      },
      totalEmployment: {
        subtitle: 'Emplois dans la zone',
        title: 'Emploi total',
      },
      totalEstablishments: {
        subtitle: "Nombre d'entreprises",
        title: "Nombre d'entreprises",
      },
      twoYearGrowth: {
        subtitle: 'Confirmation de la tendance récente',
        title: 'Croissance sur 2 ans',
      },
    },
    section: {
      subtitle: "Tendances du marché de l'emploi et aperçu de l'activité économique locale",
      title: 'Emploi',
    },
    sectors: {
      agriculture: 'Agriculture',
      industry: 'Industrie',
      primary: {
        description: 'Agriculture, Extraction',
        name: 'Secteur primaire (Agriculture, Extraction)',
        short: 'Primaire',
      },
      privateSector: 'Secteur privé',
      publicSector: 'Secteur public',
      secondary: {
        description: 'Industrie, Construction',
        name: 'Secteur secondaire (Industrie, Construction)',
        short: 'Secondaire',
      },
      services: 'Services',
      tertiary: {
        description: 'Services',
        name: 'Secteur tertiaire (Services)',
        short: 'Tertiaire',
      },
    },
    tabs: {
      business: 'Activité économique',
      growth: "Croissance de l'emploi",
      overview: 'Aperçu',
      sectors: 'Secteurs économiques',
    },
    tooltips: {
      cagr: {
        calculation: '((Emploi actuel / Emploi il y a 10 ans)^(1/10) - 1) × 100',
        importance: "Lisse les variations annuelles pour montrer la tendance de croissance de l'emploi sous-jacente. Plus précis que la moyenne simple.",
        limitations: "Suppose une croissance régulière, la croissance réelle peut être irrégulière avec des cycles d'expansion/récession",
        shortDescription: "Taux de croissance annuel moyen de l'emploi sur 10 ans, tenant compte de la composition",
        source: "Calculé à partir des données de l'Office fédéral de la statistique suisse",
        title: 'Taux de croissance annuel composé',
      },
      dominantSector: {
        calculation: 'Secteur avec max(Secteur 1 %, Secteur 2 %, Secteur 3 %)',
        importance: "Indique le caractère économique de la zone. Les zones dominées par les services ont une main-d'œuvre de cols blancs soutenant des valeurs immobilières plus élevées. Les zones industrielles ont besoin de logements pour les travailleurs. L'agriculture indique un caractère rural.",
        limitations: 'Le secteur 3 (Services) est très large, incluant tout, du commerce de détail à la finance.',
        shortDescription: "Secteur économique avec la plus grande part d'emploi",
        source: "Office fédéral de la statistique suisse - Données sur l'emploi par secteur",
        title: 'Secteur dominant',
      },
      employmentGrowth: {
        calculation: '(Emploi actuel - Emploi il y a 10 ans) / Emploi il y a 10 ans',
        importance: "La croissance de l'emploi est LE principal moteur de la demande immobilière. Une croissance positive indique un potentiel d'appréciation et une demande immobilière croissante.",
        limitations: 'Les tendances historiques ne prédisent pas nécessairement les performances futures. Des chocs externes peuvent modifier la trajectoire.',
        shortDescription: "Évolution de l'emploi au cours des 10 dernières années",
        source: "Office fédéral de la statistique suisse - Données historiques sur l'emploi",
        title: "Croissance de l'emploi",
      },
      establishmentGrowth: {
        calculation: '(Établissements actuels - Établissements il y a 10 ans) / Établissements il y a 10 ans',
        importance: "Indicateur avancé de la croissance de l'emploi. Les nouvelles entreprises embauchent souvent avant les revenus. Une croissance positive suggère un écosystème entrepreneurial et une création d'emplois future.",
        limitations: "La création d'entreprises peut précéder l'échec. Le nombre net ne montre pas la dynamique du turnover.",
        shortDescription: "Évolution du nombre d'entreprises sur 10 ans",
        source: 'Office fédéral de la statistique suisse - Données historiques sur les établissements',
        title: 'Croissance des établissements',
      },
      fiveYearGrowth: {
        calculation: "(Emploi de l'année en cours - Emploi il y a 5 ans) / Emploi il y a 5 ans",
        importance: 'Indicateur de tendance à moyen terme. Plus fiable que le court terme mais encore réactif aux changements structurels.',
        limitations: 'Inclut la période de pandémie COVID-19 qui peut fausser les tendances.',
        shortDescription: "Évolution de l'emploi au cours des 5 dernières années",
        source: "Office fédéral de la statistique suisse - Données annuelles sur l'emploi",
        title: "Croissance de l'emploi sur 5 ans",
      },
      fullTimeRatio: {
        calculation: '(Emploi à temps plein / Emploi total) × 100',
        importance: "Des ratios plus élevés indiquent un emploi et un revenu plus stables. Plus de travailleurs à temps plein signifie une demande plus fiable pour le logement et l'espace commercial.",
        limitations: "Le temps partiel peut être volontaire ou involontaire. Ne reflète pas les niveaux de revenus ou la sécurité de l'emploi.",
        shortDescription: "Pourcentage de l'emploi total qui est à temps plein",
        source: "Office fédéral de la statistique suisse - Statistiques sur les types d'emploi",
        title: "Ratio d'emploi à temps plein",
      },
      jobsPerEstablishment: {
        calculation: "Emploi total / Nombre total d'établissements",
        importance: 'Indique la taille moyenne des entreprises et la structure économique. Des ratios plus élevés suggèrent de plus grands employeurs, des ratios plus bas indiquent une économie de petites entreprises.',
        limitations: 'Ne distingue pas entre les secteurs. Les grands employeurs peuvent fausser la moyenne.',
        shortDescription: "Nombre moyen d'employés par entreprise",
        source: "Calculé à partir des données du recensement des établissements et de l'emploi",
        title: 'Emplois par établissement',
      },
      oneYearGrowth: {
        calculation: "(Emploi de l'année en cours - Emploi de l'année précédente) / Emploi de l'année précédente",
        importance: "Montre l'élan le plus récent. Une croissance récente rapide peut indiquer une opportunité émergente, un déclin peut signaler un avertissement précoce.",
        limitations: "Peut être volatile en raison de la courte période. Les données d'une seule année peuvent ne pas refléter la tendance.",
        shortDescription: "Évolution de l'emploi au cours de la dernière année",
        source: "Office fédéral de la statistique suisse - Données annuelles sur l'emploi",
        title: "Croissance de l'emploi sur 1 an",
      },
      primarySector: {
        calculation: 'Somme de tous les emplois dans les activités du secteur NOGA 1',
        importance: 'La dominance du secteur primaire indique un caractère rural avec des opportunités immobilières spécialisées. Généralement des valeurs immobilières plus basses mais une demande stable à long terme.',
        limitations: 'Soumis à des variations saisonnières. Peut inclure des travailleurs agricoles à temps partiel.',
        shortDescription: "Emplois dans l'agriculture, la sylviculture, la pêche et l'extraction",
        source: 'Office fédéral de la statistique suisse - Classification sectorielle par codes NOGA',
        title: 'Emploi du secteur primaire',
      },
      privateSectorEstablishments: {
        calculation: "(Établissements du secteur privé / Nombre total d'établissements) × 100",
        importance: 'Un secteur privé élevé indique une économie entrepreneuriale, axée sur le marché. Plus dynamique mais potentiellement volatile. Demande immobilière commerciale diversifiée.',
        limitations: 'Ne distingue pas entre les petites entreprises et les grandes sociétés.',
        shortDescription: "Pourcentage d'établissements qui sont des entreprises privées",
        source: 'Office fédéral de la statistique suisse - Classification sectorielle',
        title: 'Établissements du secteur privé',
      },
      publicSectorEstablishments: {
        calculation: "(Établissements du secteur public / Nombre total d'établissements) × 100",
        importance: "Une forte présence du secteur public indique une économie dépendante du gouvernement. Plus stable mais croissance plus lente. Profil de locataire différent pour l'immobilier commercial.",
        limitations: "Ne reflète pas la taille de l'emploi. Une grande entité gouvernementale comptée comme un petit bureau.",
        shortDescription: "Pourcentage d'établissements qui sont des entités gouvernementales",
        source: 'Office fédéral de la statistique suisse - Classification sectorielle',
        title: 'Établissements du secteur public',
      },
      secondarySector: {
        calculation: 'Somme de tous les emplois dans les activités du secteur NOGA 2',
        importance: "La base industrielle crée une demande pour le logement des travailleurs, les installations logistiques et les propriétés commerciales. La main-d'œuvre ouvrière nécessite généralement des options de logement abordables.",
        limitations: "Peut être cyclique avec les conditions économiques. L'automatisation peut réduire l'emploi au fil du temps.",
        shortDescription: 'Emplois dans la fabrication, la construction et la production industrielle',
        source: 'Office fédéral de la statistique suisse - Classification sectorielle par codes NOGA',
        title: 'Emploi du secteur secondaire',
      },
      tenYearGrowth: {
        calculation: "(Emploi de l'année en cours - Emploi il y a 10 ans) / Emploi il y a 10 ans",
        importance: 'Tendance structurelle à long terme. Meilleur indicateur de transformation économique fondamentale et de trajectoire de la demande immobilière.',
        limitations: 'La longue période peut masquer les changements récents. Inclut plusieurs cycles économiques.',
        shortDescription: "Évolution de l'emploi au cours des 10 dernières années",
        source: "Office fédéral de la statistique suisse - Données annuelles sur l'emploi",
        title: "Croissance de l'emploi sur 10 ans",
      },
      tertiarySector: {
        calculation: 'Somme de tous les emplois dans les activités du secteur NOGA 3',
        importance: "La dominance du secteur des services indique un caractère urbain avec une forte demande de propriétés résidentielles et commerciales. La main-d'œuvre de cols blancs soutient des valeurs immobilières plus élevées.",
        limitations: "Catégorie large incluant des types d'emplois et des niveaux de revenus très différents.",
        shortDescription: "Emplois dans les services, le commerce de détail, la finance, l'éducation, la santé et l'hôtellerie",
        source: 'Office fédéral de la statistique suisse - Classification sectorielle par codes NOGA',
        title: 'Emploi du secteur tertiaire',
      },
      totalEmployment: {
        calculation: 'Somme de tous les emplois (temps plein et temps partiel) dans tous les secteurs',
        importance: "Indique le niveau d'activité économique et la taille du marché du travail. Un emploi plus élevé suggère une demande immobilière plus forte.",
        limitations: "Basé sur les statistiques officielles, peut ne pas inclure l'économie informelle ou les travailleurs indépendants",
        shortDescription: "Nombre total d'emplois dans la zone géographique définie",
        source: 'Office fédéral de la statistique suisse - Recensement des entreprises',
        title: 'Emploi total',
      },
      totalEstablishments: {
        calculation: 'Nombre de tous les sites commerciaux enregistrés (secteur public + privé)',
        importance: "Indique la taille de l'écosystème commercial et la diversité économique. Plus d'établissements suggèrent un environnement commercial dynamique soutenant les valeurs immobilières.",
        limitations: "Ne reflète pas la taille de l'entreprise ou le chiffre d'affaires. Inclut les très petites entreprises.",
        shortDescription: "Nombre total d'établissements commerciaux dans la zone",
        source: 'Office fédéral de la statistique suisse - Recensement des entreprises',
        title: "Nombre total d'établissements",
      },
      twoYearGrowth: {
        calculation: "(Emploi de l'année en cours - Emploi il y a 2 ans) / Emploi il y a 2 ans",
        importance: 'Confirme si la tendance sur 1 an est maintenue. Aide à filtrer les événements ponctuels.',
        limitations: 'Encore relativement à court terme. Peut inclure les effets de la pandémie.',
        shortDescription: "Évolution de l'emploi au cours des 2 dernières années",
        source: "Office fédéral de la statistique suisse - Données annuelles sur l'emploi",
        title: "Croissance de l'emploi sur 2 ans",
      },
    },
  },
  energy: {
    dataSource: {
      egid: 'ID du bâtiment (EGID)',
      regbl: 'Registre fédéral des bâtiments (RegBL)',
      title: 'Source des données',
      viewInRegBL: 'Voir dans le RegBL',
    },
    dataSourceBanner: {
      description: 'Ces données sont collectées et maintenues par les autorités fédérales et cantonales. Les dates de dernière mise à jour varient selon les champs et sont affichées à côté de chaque point de données.',
      title: 'Source des données : Registre fédéral des bâtiments (RegBL)',
      viewCompleteRecord: "Voir l'enregistrement complet du bâtiment dans le RegBL",
    },
    freshness: {
      daysAgo: 'Il y a {{count}} jours',
      fresh: 'Récemment mis à jour',
      levels: {
        aging: 'Vieillissant',
        outdated: 'Obsolète',
        recent: 'Récent',
      },
      monthsAgo: 'Il y a {{count}} mois',
      oneYearAgo: 'il y a 1 an',
      stale: 'Les données peuvent être obsolètes',
      thisYear: 'cette année',
      today: "Aujourd'hui",
      yearsAgo: 'Il y a {{count}} ans',
      yesterday: 'Hier',
    },
    header: {
      subtitle: 'Données énergétiques du bâtiment issues du Registre fédéral des bâtiments (RegBL)',
      title: 'Analyse énergétique',
    },
    heating: {
      card: {
        egidNotAvailable: 'EGID non disponible',
        entryOf: 'Entrée {{number}} sur {{total}}',
        mostRecent: 'Plus récent',
        title: 'Systèmes de chauffage',
      },
      checkRegBL: 'Vérifier le RegBL',
      metrics: {
        distributionSystem: 'Système de distribution',
        generatorType: 'Type de générateur',
        lastUpdated: 'Dernière mise à jour',
        noDataAvailable: 'Aucune donnée disponible',
        notDeclared: 'Non déclaré',
        powerSource: "Source d'énergie",
        status: 'Statut',
      },
      multipleEntries: {
        description: "Ce bâtiment a {{count}} entrées distinctes dans le RegBL, provenant possiblement de différentes dates d'enregistrement ou de mises à jour. Toutes les entrées sont affichées ci-dessous, triées par ordre chronologique décroissant.",
        title: 'Plusieurs entrées trouvées dans le registre',
      },
      noData: 'Aucune donnée de système de chauffage disponible dans le RegBL pour ce bâtiment.',
      sections: {
        additionalHeating: 'Chauffage supplémentaire',
        additionalWaterHeating: "Chauffage d'eau supplémentaire",
        primaryHeating: 'Chauffage principal',
        waterHeating: "Chauffage de l'eau",
      },
    },
    idc: {
      actionPlan: {
        heating: 'Moderniser le système de chauffage',
        insulation: "Améliorer l'isolation du bâtiment",
        solar: 'Installer des panneaux solaires',
        title: 'Actions recommandées',
        windows: 'Remplacer les fenêtres par des modèles écoénergétiques',
      },
      comparison: {
        buildingAge: 'Âge de bâtiment similaire',
        canton: 'Moyenne cantonale',
        district: 'Moyenne du district',
        title: 'Comparaison IDC',
      },
      costEstimator: {
        annual: 'Coût annuel',
        perM2: 'Coût au m²',
        title: 'Coûts énergétiques estimés',
      },
      gauge: {
        current: 'IDC actuel',
        legalLimit: 'Limite légale',
        target: 'Objectif',
      },
      ratings: {
        average: 'Moyen',
        critical: 'Critique',
        excellent: 'Excellent',
        good: 'Bon',
        poor: 'Faible',
      },
      regulatory: {
        compliant: 'Conforme',
        deadline: 'Date limite de conformité',
        nonCompliant: 'Non conforme',
        title: 'Conformité réglementaire',
      },
      subtitle: 'Indicateur de performance énergétique pour les bâtiments genevois',
      title: 'IDC - Indice de dépense de chaleur',
    },
    idcComparisonCard: {
      noData: 'Aucune donnée de comparaison disponible pour ce bâtiment.',
      noDataForZone: 'Aucune donnée disponible pour cette zone.',
      performanceText: 'Votre IDC de {{idc}} MJ/m² se situe au {{percentile}}e percentile parmi {{count}} bâtiments dans {{scope}}.',
      scopeLabels: {
        municipality: 'Commune',
        npa: 'Code postal',
        radius_500m: 'Rayon 500m',
        region: 'Canton',
      },
      stats: {
        average: 'Moyenne',
        maximum: 'Maximum',
        median: 'Médiane',
        minimum: 'Minimum',
        percentile25: '25e percentile',
        percentile75: '75e percentile',
      },
      title: 'Comparaisons IDC',
      tooltipDescription: "Comparez l'IDC de ce bâtiment avec les statistiques d'autres bâtiments de Genève. Un percentile plus bas indique une meilleure performance énergétique.",
      tooltipDescriptionLoading: "Comparez l'IDC de ce bâtiment avec les statistiques d'autres bâtiments de Genève dans différentes zones géographiques.",
    },
    idcDistributionChart: {
      title: 'Distribution IDC - {{scope}}',
      tooltipBuildings: 'Nombre de bâtiments : <strong>{{count}}</strong>',
      xAxisName: 'IDC (MJ/m²·année)',
      yAxisName: 'Nombre de bâtiments',
      yourBuilding: 'Votre bâtiment',
    },
    idcGaugeChart: {
      legend: {
        compliant: 'Conforme (0-{{threshold}})',
        critical: 'Critique (>{{threshold}})',
        optimizationRequired: 'Optimisation requise ({{min}}-{{max}})',
        warning: 'Avertissement ({{min}}-{{max}})',
      },
      title: 'Position IDC',
      unit: 'MJ/m²·an',
    },
    idcRegulatoryBanner: {
      actionTypes: {
        audit: 'Audit énergétique recommandé',
        mandatoryRenovation: 'Rénovation obligatoire requise',
        noObligation: 'Aucune obligation réglementaire',
        optimization: 'Optimisation énergétique requise',
      },
      deadline: 'Échéance : {{year}}',
      yearsRemaining: {
        one: '({{count}} an restant)',
        other: '({{count}} ans restants)',
      },
    },
    idcTab: {
      dataSourceNote: {
        description: "Office Cantonal de l'Énergie (OCEN) - Canton de Genève. L'IDC est calculé sur la base des consommations réelles déclarées et contrôlées. Pour plus d'informations :",
        linkText: 'ge.ch/energie',
        title: 'Source des données :',
      },
      infoBanner: "Indice de Dépense de Chaleur (IDC) - Indicateur obligatoire pour les bâtiments chauffés du Canton de Genève. L'IDC mesure la consommation annuelle d'énergie pour le chauffage et l'eau chaude sanitaire rapportée à la surface de référence énergétique (SRE).",
      metrics: {
        regulatoryThreshold: {
          title: 'Seuil réglementaire',
          tooltip: {
            calculation: 'Fixé à {{threshold}} MJ/m²·an ({{kWh}} kWh/m²·an) depuis septembre 2022',
            description: "Seuil fixé par le Canton de Genève au-delà duquel des mesures d'optimisation sont requises",
            importance: "Dépasser ce seuil entraîne l'obligation de mettre en œuvre des mesures d'optimisation énergétique",
            source: "Loi sur l'énergie (LEn) - Canton de Genève",
          },
        },
        significantExceedanceThreshold: {
          exceeded: 'Dépassé - Rénovation obligatoire',
          notExceeded: 'Non dépassé',
          periods: {
            from2031: 'dès 2031',
            until2026: "jusqu'à 2026",
            until2030: "jusqu'à 2030",
          },
          title: 'Seuil de dépassement significatif',
          tooltip: {
            calculation: 'Actuellement {{threshold}} MJ/m² ({{period}}). Le seuil est progressivement abaissé : 800 MJ/m² (2022-2026) → 650 MJ/m² (2027-2030) → 550 MJ/m² (2031+)',
            description: 'Au-delà de ce seuil, une rénovation énergétique obligatoire est requise',
            importance: "Dépasser ce seuil entraîne l'obligation légale de réaliser une rénovation énergétique dans les 3 ans suivant la décision administrative",
            limitations: "Le seuil varie selon l'année et sera progressivement réduit pour encourager l'amélioration continue du parc immobilier",
            source: "Règlement sur l'énergie (REn) - Canton de Genève",
          },
        },
        yourPosition: {
          title: 'Votre position',
          tooltip: {
            calculation: '(IDC du bâtiment - Seuil réglementaire) / Seuil réglementaire × 100',
            description: 'Écart par rapport au seuil réglementaire de {{threshold}} MJ/m²',
            importance: "Indique si votre bâtiment est conforme aux exigences réglementaires ou nécessite des mesures d'optimisation",
            source: 'Calculé à partir des données OCEN',
          },
        },
      },
    },
    regblLink: {
      viewBuildingTitle: 'Voir le bâtiment {{egid}} dans le Registre fédéral des bâtiments',
      viewInRegBL: 'Voir dans le RegBL',
    },
    solar: {
      comparison: {
        actual: 'Installation actuelle',
        optimal: 'Potentiel optimal',
        title: 'Comparaison du potentiel solaire',
        utilizationRate: "Taux d'utilisation",
      },
      history: {
        title: 'Historique des installations',
      },
      installation: {
        estimatedProduction: 'Production annuelle est.',
        installedPower: 'Puissance installée',
        moduleArea: 'Surface des modules',
        title: 'Installation solaire',
        yearInstalled: "Année d'installation",
      },
      potential: {
        electricalEfficiency: 'Efficacité électrique',
        roofArea: 'Surface de toit adaptée',
        thermalEfficiency: 'Efficacité thermique',
        title: 'Potentiel solaire',
      },
    },
    solarComparison: {
      actualConditions: 'Conditions réelles',
      annualProductionPotential: 'Potentiel de production annuelle',
      bestAnnualProduction: 'Meilleure production annuelle',
      bestCase: 'Meilleur cas',
      bestSolarIrradiance: 'Meilleure irradiance solaire',
      bestSuitableArea: 'Meilleure surface adaptée',
      estimatedCapacity: 'Capacité estimée',
      noData: 'Aucune donnée de potentiel solaire disponible pour ce bâtiment.',
      noteDescription: "Les conditions réelles incluent toutes les surfaces de toit adaptées, quelle que soit l'orientation. Les conditions optimales n'utilisent que les surfaces les mieux orientées (généralement orientées sud, pente d'environ 30°). Utilisez « Réel » pour une planification réaliste.",
      noteTitle: 'Quelle est la différence ?',
      optimalConditions: 'Conditions optimales',
      realistic: 'Réaliste',
      solarIrradiance: 'Irradiance solaire',
      suitableRoofArea: 'Surface de toit adaptée',
      title: 'Comparaison du potentiel solaire',
      titleActualVsOptimal: 'Potentiel solaire : Réel vs Optimal',
      tooltips: {
        annualProduction: {
          calculation: 'Surface du toit × Irradiance × Efficacité des panneaux (~17-20%) × Pertes du système (~15%)',
          description: "Production d'électricité estimée si la surface de toit adaptée est entièrement équipée de panneaux solaires",
          importance: "C'est la métrique clé pour estimer les économies d'énergie potentielles et le retour sur investissement",
          limitations: "Suppose une couverture complète du toit avec des panneaux standard. La production réelle dépend du type de panneau, de la qualité d'installation et de la maintenance.",
          source: "Cadastre solaire OFEN (Office fédéral de l'énergie)",
          title: 'Potentiel de production annuelle',
        },
        bestAnnualProduction: {
          calculation: 'Meilleure surface adaptée × Meilleure irradiance × Efficacité des panneaux × Pertes du système',
          description: "Production d'électricité maximale en utilisant uniquement les surfaces de toit orientées de manière optimale",
          importance: "Montre l'efficacité maximale théorique. Peut produire moins d'énergie totale que l'utilisation de toutes les surfaces adaptées si la surface optimale est petite.",
          limitations: 'Utile pour la comparaison mais peut ne pas représenter le meilleur choix économique si la surface optimale est limitée.',
          source: "Cadastre solaire OFEN (Office fédéral de l'énergie)",
          title: 'Meilleure production annuelle',
        },
        bestSolarIrradiance: {
          calculation: 'Irradiance moyenne sur les surfaces orientées sud avec inclinaison optimale (~30° en Suisse)',
          description: 'Rayonnement solaire maximum sur les sections de toit les mieux orientées',
          importance: "Représente le potentiel d'efficacité maximale. Comparez avec l'irradiance réelle pour voir à quel point l'orientation affecte la production.",
          limitations: 'Atteignable uniquement sur les sections de toit idéalement orientées. La plupart des bâtiments ont une surface optimale limitée.',
          source: "Cadastre solaire OFEN (Office fédéral de l'énergie)",
          title: 'Meilleure irradiance solaire',
        },
        bestSuitableArea: {
          calculation: "Sous-ensemble filtré de la surface totale adaptée : seules les surfaces orientées sud avec une pente d'environ 30° reçoivent l'irradiance annuelle maximale",
          description: 'Surface de toit avec orientation optimale pour les panneaux solaires (sections les mieux orientées uniquement)',
          importance: "Représente les zones de placement les plus efficaces. Installer ici maximise la production d'énergie par panneau.",
          limitations: "Peut être significativement plus petite que la surface totale adaptée. Se concentrer uniquement sur les zones optimales peut sous-utiliser l'espace de toit disponible.",
          source: "Cadastre solaire OFEN (Office fédéral de l'énergie)",
          title: 'Meilleure surface adaptée',
        },
        estimatedCapacity: {
          calculation: 'Surface de toit adaptée ÷ 6,5 m²/kWc (norme industrielle : ~6,5 m² nécessaires par 1 kWc de capacité installée)',
          description: "Capacité maximale théorique d'installation solaire en kilowatt-crête (kWc)",
          importance: "Aide à estimer la taille de l'installation, les coûts et à comparer avec les installations existantes. Un ménage typique a besoin de 3-5 kWc.",
          limitations: "Il s'agit d'une estimation approximative. La capacité réelle dépend de l'efficacité des panneaux, des contraintes d'installation et des obstacles sur le toit.",
          source: "Estimation calculée basée sur les normes de l'industrie",
          title: 'Capacité estimée',
        },
        estimatedCapacityOptimal: {
          calculation: 'Meilleure surface adaptée ÷ 6,5 m²/kWc (norme industrielle)',
          description: "Capacité d'installation maximale en utilisant uniquement les sections de toit les mieux orientées",
          importance: "Comparez avec l'estimation de capacité réelle pour voir à quel point l'orientation du toit affecte la taille potentielle de l'installation.",
          limitations: "Souvent plus petite que l'estimation de capacité réelle. Considérez si maximiser l'efficacité ou la production totale est plus important.",
          source: "Estimation calculée basée sur les normes de l'industrie",
          title: 'Capacité estimée (Optimale)',
        },
        solarIrradiance: {
          calculation: "Modélisé à partir de données météorologiques, de la topographie, de l'orientation du toit et de l'ombrage local des bâtiments et de la végétation",
          description: 'Énergie moyenne du rayonnement solaire reçue par mètre carré de surface de toit annuellement',
          importance: "Des valeurs d'irradiance plus élevées indiquent un meilleur potentiel d'énergie solaire. Les valeurs supérieures à 1000 kWh/m²/an sont considérées comme bonnes pour la Suisse.",
          limitations: 'Basé sur une modélisation, pas sur des mesures réelles. Les variations météorologiques entre les années peuvent affecter les valeurs réelles de ±10-15%.',
          source: "Cadastre solaire OFEN (Office fédéral de l'énergie)",
          title: 'Irradiance solaire',
        },
        suitableRoofArea: {
          calculation: 'Analyse 3D des surfaces de toit filtrant par pente (>10°), orientation et exigences de taille minimale',
          description: "Surface totale du toit adaptée à l'installation de panneaux solaires",
          importance: "Détermine le nombre maximum de panneaux solaires installables et impacte directement la production potentielle d'énergie",
          limitations: 'Ne tient pas compte des obstacles comme les cheminées, les puits de lumière, les unités CVC ou les limitations structurelles. Évaluation professionnelle recommandée.',
          source: "Cadastre solaire OFEN (Office fédéral de l'énergie)",
          title: 'Surface de toit adaptée',
        },
      },
    },
    solarInstallation: {
      added: 'ajouté',
      firstInstallation: 'Première installation',
      installationCount: '{{count}} installation',
      installationEvents: "Événements d'installation",
      installationHistory: 'Historique des installations',
      installationsCount: '{{count}} installations',
      installationYear: "Année d'installation",
      installed: 'installé',
      noData: 'Aucune installation solaire enregistrée pour ce bâtiment.',
      title: 'Installation solaire',
      totalInstalledCapacity: 'Capacité totale installée',
    },
    states: {
      error: "Erreur lors du chargement de l'analyse énergétique : {{error}}",
      loading: "Chargement de l'analyse énergétique...",
      noData: 'Aucune donnée de bâtiment disponible',
    },
    tabs: {
      heating: 'Chauffage',
      idc: 'IDC Genève',
      solar: 'Énergie solaire',
    },
  },
  environment: {
    air_quality: {
      aqi: "Indice de qualité de l'air",
      category: 'Catégorie',
      title: "Qualité de l'air",
    },
    failed_to_fetch: 'Échec de la récupération des données environnementales',
    loading: 'Chargement des données environnementales...',
    no_data: 'Aucune donnée environnementale disponible',
    no_data_description: 'Les données environnementales ne sont pas disponibles pour cet emplacement. Cela pourrait être dû à une couverture de surveillance limitée dans cette zone.',
    noise: {
      aircraft: "Bruit d'avion",
      description: 'Niveaux de bruit et analyse de la pollution sonore pour cet emplacement',
      guidelines: 'Directives de niveau de bruit',
      levels: {
        moderate: 'Modéré',
        noisy: 'Bruyant',
        quiet: 'Silencieux',
        very_noisy: 'Très bruyant',
        very_quiet: 'Très silencieux',
      },
      railway_day: 'Bruit ferroviaire (Jour)',
      road_day: 'Bruit routier (Jour)',
      road_night: 'Bruit routier (Nuit)',
      title: 'Niveaux de bruit',
    },
    noise_analysis: 'Analyse du bruit',
    sunlight: {
      afternoon_sun: "Soleil de l'après-midi",
      daily_hours: 'Ensoleillement quotidien',
      description: 'Exposition solaire et disponibilité de la lumière du soleil tout au long de la journée',
      levels: {
        excellent: 'Excellent',
        good: 'Bon',
        low: 'Faible',
        moderate: 'Modéré',
        very_low: 'Très faible',
      },
      morning_sun: 'Soleil du matin',
      seasonal_variation: 'Variation saisonnière',
      title: 'Exposition solaire',
    },
    sunlight_study: "Étude d'ensoleillement",
    title: 'Analyse environnementale',
  },
  estimate: {
    autoValuations: {
      back: 'Retour aux évaluations',
      details: 'Détails',
      empty: {
        text: 'Les évaluations automatiques des fournisseurs AVM ne sont pas disponibles pour cette propriété.',
        title: 'Aucune évaluation automatique',
      },
      meta: {
        confidenceScore: 'Score de confiance',
        dataRange: 'Plage de données',
        dealType: 'Type de transaction',
        landArea: 'Surface du terrain',
        listingsCount: "Nombre d'annonces",
        method: 'Méthode',
        modelVersion: 'Version du modèle',
        pricePerM2: 'Prix au m²',
        provider: 'Fournisseur',
        unknown: 'Inconnu',
        valuePerM2LandConservative: 'Valeur au m² de terrain (conservatrice)',
        valuePerM2LandOptimistic: 'Valeur au m² de terrain (optimiste)',
        values: {
          purchase: 'Achat',
          rent: 'Location',
          sale: 'Vente',
        },
      },
      methodDescriptions: {
        popety_io: "Évaluation automatisée basée sur l'algorithme propriétaire de Popety.io analysant les caractéristiques du bien, les transactions récentes du marché et les facteurs spécifiques à l'emplacement.",
        pricehubble: "Évaluation basée sur les modèles d'apprentissage automatique de PriceHubble utilisant des données de marché complètes et les attributs de la propriété.",
        wuest_partner: 'Évaluation professionnelle par Wüest Partner basée sur leur expertise approfondie du marché immobilier suisse et leurs données.',
      },
      methodology: 'Méthodologie',
      subtitle: 'Évaluations immobilières professionnelles des principaux fournisseurs AVM',
      title: 'Évaluations automatiques',
    },
    comparables: {
      active_listings: 'Annonces actives',
      allSaved: 'Tout enregistré',
      averagePrice: 'Prix moyen',
      avgLivingArea: 'Surface moyenne',
      avgPricePerSqm: 'Prix moyen/m²',
      listing_price: "Prix d'annonce",
      listings: 'Annonces',
      listingsStats: '{{count}} annonces enregistrées - Moy. {{average}}',
      listingsTitle: 'Annonces comparables',
      livingArea: 'Surface habitable',
      noListingsDescription: "Aucune annonce n'a été enregistrée pour cette estimation. Les annonces peuvent être enregistrées depuis l'application principale.",
      noListingsSaved: 'Aucune annonce enregistrée',
      noTransactionsDescription: "Aucune transaction n'a été enregistrée pour cette estimation. Les transactions peuvent être enregistrées depuis l'application principale.",
      noTransactionsSaved: 'Aucune transaction enregistrée',
      perListing: 'Par annonce',
      priceRange: 'Fourchette de prix',
      recent_sales: 'Ventes récentes',
      similar_properties: 'Biens similaires',
      sold_price: 'Prix de vente',
      sqm: 'm²',
      title: 'Biens comparables',
      to: 'à',
      totalSaved: 'Total enregistré',
      totalValue: 'Valeur totale',
      transactionsStats: '{{count}} transactions enregistrées - Moy. {{average}}',
      transactionsTitle: 'Transactions comparables',
    },
    confirmDelete: {
      cancel: 'Annuler',
      confirm: 'Supprimer',
      defaultItem: 'cet élément',
      deleting: 'Suppression...',
      message: 'Êtes-vous sûr de vouloir supprimer "{{name}}" ?',
      title: "Supprimer l'évaluation",
      warning: 'Cette action ne peut pas être annulée.',
    },
    error_loading_data: 'Erreur de chargement des données',
    failed_to_load: "Échec du chargement des données d'estimation",
    land: {
      area: 'Surface',
      buildableArea: 'Surface constructible',
      canton: 'Canton',
      coordinates: 'Coordonnées géographiques',
      generalInfo: 'Informations générales',
      latitude: 'Latitude',
      longitude: 'Longitude',
      maxFloors: 'Étages max',
      multiplePlots: '{{count}} parcelles',
      municipality: 'Commune',
      noLandData: 'Aucune donnée terrain disponible',
      plot: 'Parcelle',
      plotNumber: 'Numéro de parcelle',
      singlePlot: '1 parcelle',
      title: 'Informations terrain',
      zoneName: 'Nom de zone',
      zoneType: 'Type de zone',
      zoningInfo: 'Informations de zone',
    },
    manualValuations: {
      confidence: {
        high: 'Élevée',
        low: 'Faible',
        medium: 'Moyenne',
      },
      emptyText: "Aucune évaluation manuelle n'a été ajoutée pour cette estimation.",
      emptyTitle: 'Aucune évaluation manuelle',
      methods: {
        avm: 'Évaluation automatique',
        comparable: 'Ventes comparables',
        custom: 'Évaluation personnalisée',
        dcf: 'Méthode DCF',
        developer: 'Méthode du promoteur',
        intrinsic: 'Méthode de la valeur intrinsèque',
        staticYield: 'Méthode du rendement statique',
      },
      subtitle: "Méthodes d'évaluation professionnelles pour une estimation précise",
      title: 'Évaluations manuelles',
      ui: {
        chartColor: 'Couleur du graphique: {{color}}',
      },
    },
    market: {
      activity: 'Activité du marché',
      average_price: 'Prix moyen',
      time_on_market: 'Temps sur le marché',
      trends: 'Tendances du marché',
    },
    navigation: {
      amenities: 'Commodités',
      demographics: 'Démographie',
      history: 'Historique',
      listings_comparables: 'Annonces comparables',
      noise_analysis: 'Analyse du bruit',
      property_details: 'Détails de la propriété',
      purchase_market: "Marché d'achat",
      rental_market: 'Marché locatif',
      sunlight_study: "Étude d'ensoleillement",
      transactions_comparables: 'Transactions comparables',
      valuations: 'Évaluations',
    },
    pricePerSqm: {
      basisLabel: 'Base de calcul',
      basisLiving: 'Surface habitable',
      basisUsable: 'Surface utile',
      basisWeighted: 'Surface pondérée',
      fallbackHint: 'Utilise {{effective}} — {{requested}} non disponible',
      gearButton: 'Réglages du prix par m²',
      showToggle: 'Afficher le prix par m²',
      unavailable: 'Non disponible',
    },
    property: {
      address: 'Adresse',
      area: 'Surface',
      bathrooms: 'Salles de bain',
      bedrooms: 'Chambres',
      condition: 'État',
      rooms: 'Pièces',
      type: 'Type de bien',
      year_built: 'Année de construction',
    },
    propertyDetails: {
      attributes: 'Attributs de la propriété',
      description: 'Description',
      noDataAvailable: 'Aucun détail de propriété disponible',
      photos: 'Photos',
      situationLocation: 'Situation et emplacement',
      subtitle: 'Aperçu des caractéristiques de la propriété',
      title: 'Détails de la propriété',
    },
    sections: {
      environment: 'Environnement',
      estimate: 'Estimation',
      market: 'Marché',
      property: 'Propriété',
      social_economic: 'Social et économique',
    },
    share: {
      section_not_available: 'Section non disponible',
      section_not_shared: "Cette section n'a pas été incluse dans le lien de partage.",
    },
    sidebar: {
      autoValuations: 'Évaluations automatiques',
      building: 'Bâtiment',
      buildingPermits: 'Permis de construire',
      employment: 'Emploi',
      energy: 'Énergie',
      land: 'Terrain',
      manualValuations: 'Évaluations manuelles',
      overview: 'Aperçu',
      summary: 'Résumé',
      transportAccess: 'Accès transport',
    },
    summary: {
      checklist: {
        avmRetrieved: 'Évaluations AVM récupérées',
        finalSelected: 'Prix final sélectionné',
        listingsSelected: 'Annonces comparables sélectionnées',
        manualAdded: 'Évaluation manuelle ajoutée',
        propertyDetails: 'Détails de la propriété ajoutés',
        title: "Checklist d'évaluation",
        transactionsSelected: 'Transactions comparables sélectionnées',
      },
      finalValuation: 'Évaluation finale',
      finalValue: 'Valeur finale',
      listingsComparables: 'Annonces comparables',
      noFinalValuation: "Aucune évaluation finale n'a été définie pour cette estimation.",
      range: 'Fourchette : {{min}} - {{max}}',
      transactionsComparables: 'Transactions comparables',
      valuationComparison: 'Comparaison des évaluations',
    },
    title: 'Analyse immobilière',
    valuation: {
      confidence: 'Niveau de confiance',
      estimated_value: 'Valeur estimée',
      price_per_sqm: 'Prix au m²',
      range: 'Fourchette de valeur',
      title: 'Évaluation immobilière',
    },
    valuations: {
      confidence: {
        high: 'Élevée',
        low: 'Faible',
        medium: 'Moyenne',
      },
      detail: {
        confidence: 'Confiance',
        daysAgo: 'Il y a {{days}} jours',
        estimatedValue: 'Valeur estimée',
        today: "Aujourd'hui",
        valueRange: 'Fourchette de valeurs',
        weeksAgo: 'Il y a {{weeks}} semaines',
        yesterday: 'Hier',
      },
    },
  },
  explore: {
    aiFilter: {
      building: {
        description: 'Décrivez le bâtiment que vous recherchez, et je vous aiderai à le trouver.',
        placeholder: "p.ex., 'Immeubles de bureaux modernes au centre de Zurich'",
        prompts: {
          '0': 'Bâtiments résidentiels récents (après 2010) avec plus de 5 étages',
          '1': 'Bâtiments avec chauffage au gaz ou au pétrole mais un bon potentiel solaire sur le toit',
          '2': 'Bâtiments avec une annonce de location au cours des 6 derniers mois',
          '3': 'Bâtiments résidentiels avec au moins 20 unités et un temps de trajet court vers les centres',
        },
        title: 'Assistant de filtre bâtiment',
      },
      clearAllResponses: 'Effacer toutes les réponses ({{count}})',
      description: "Décrivez ce que vous recherchez en langage naturel, et j'appliquerai les filtres appropriés.",
      deviceSelector: {
        iphoneNotRecommended: ' (iPhone - Non recommandé)',
        microphoneDefault: 'Microphone {{id}}',
        recommended: ' (Recommandé)',
        selectMicrophone: '🎤 Sélectionnez le microphone :',
      },
      errors: {
        general: 'Erreur',
        processingFailed: 'Échec du traitement de votre demande. Veuillez réessayer.',
        voiceProcessingFailed: 'Échec du traitement de votre demande vocale. Veuillez réessayer.',
        voiceRecording: "Erreur d'enregistrement vocal",
      },
      examplePrompts: {
        '0': 'Montrez-moi des terrains vacants de plus de 500m² en Zone 3',
        '1': 'Propriétés privées construites après 2010',
        '2': 'Trouvez des terrains près du lac avec permis de construire',
      },
      land: {
        description: 'Décrivez le terrain que vous recherchez, et je vous aiderai à le trouver.',
        placeholder: "p.ex., 'Terrain de développement à Zurich avec de bons scores'",
        prompts: {
          '0': 'Terrains de plus de 1000m² avec un score de développement supérieur à 70% et sans bâtiments protégés',
          '1': 'Parcelles vierge dans les zones constructibles du canton de Zurich',
          '2': 'Terrains avec des bâtiments anciens (<1950) mais non protégés',
          '3': 'Terrains avec permis de construire pour des projets de développement publiés au cours des 2 dernières années',
        },
        title: 'Assistant de filtre terrain',
      },
      response: {
        filtersApplied: 'Filtres appliqués',
      },
      textInput: {
        apply: 'Appliquer',
        placeholder: 'Tapez ou parlez votre demande de filtre...',
      },
      thinkingAnimation: {
        analyzing: 'Analyse de votre demande...',
      },
      title: 'Assistant de filtrage IA',
      voiceInput: {
        notSupported: 'Enregistrement vocal non supporté',
        recording: 'Enregistrement... {{duration}}s - Cliquez pour arrêter et envoyer',
        startRecording: "Cliquez pour démarrer l'enregistrement vocal",
      },
    },
    buildingCategories: {
      characteristics: 'Caractéristiques',
      classification: 'Classification',
      energy: 'Énergie',
      environmental: 'Environnemental',
      history: 'Historique',
      myMaps: 'Mes cartes',
    },
    buildingClassification: {
      garage: 'Garage',
      industrial: 'Industriel',
      mixedLow: 'Minorité résidentielle(s)',
      mixHigh: 'Majorité résidentielle(s)',
      notClassified: 'Non classé',
      office: 'Bureaux',
      other: 'Autre',
      public: 'Public',
      residential: 'Résidentiel',
      retail: 'Commerce',
    },
    buildingClassifications: {
      Garage: 'Garage',
      Industrial: 'Industriel',
      Mixed_1: 'Usage Mixte',
      Mixed_2: 'Usage Mixte',
      Offices: 'Bureaux',
      Other: 'Autre',
      Public: 'Public',
      Residential: 'Résidentiel',
      Retail: 'Commercial',
    },
    buildingLayers: {
      buildingPeriod: 'Période de construction',
      buildingPermits: 'Permis de construire',
      buildingType: 'Type de bâtiment',
      constructionYear: 'Année de construction',
      favorites: 'Favoris',
      heatingSystem: 'Système de chauffage',
      lakeView: 'Vue sur le lac',
      mountainView: 'Vue sur les montagnes',
      myTags: 'Mes tags',
      noiseExposure: 'Exposition au bruit',
      numberOfDwellings: 'Nombre de logements',
      numberOfFloors: "Nombre d'étages",
      numberOfUnits: "Nombre d'unités",
      officialCategory: 'Catégorie officielle',
      popetyClassification: 'Classification des bâtiments',
      prospectiveBuildings: 'Bâtiments prospectifs',
      protectionLevel: 'Niveau de protection patrimoniale',
      publicTransportQuality: 'Qualité des transports publics',
      renovationPeriod: 'Période de rénovation',
      rentListings: 'Annonces de location',
      saleListings: 'Annonces de vente',
      solarExposure: 'Exposition solaire',
      transactions: 'Transactions',
      travelTimeToCenters: 'Temps de trajet vers les centres',
      waterHeatingSystem: "Système de chauffage de l'eau",
    },
    buildingPanel: {
      administrativeDetails: {
        addresses: 'Adresses',
        buildingName: 'Nom du bâtiment',
        egids: 'IDs Fédéraux des Bâtiments (EGIDs)',
        officialNumber: 'Numéro officiel',
        renovationRange: 'Année de rénovation',
        title: 'Détails administratifs',
        units: 'unités',
        yearRange: 'Année de construction',
      },
      dwellings: {
        area: 'Surface',
        dwellingNumber: 'Logement',
        features: 'Caractéristiques',
        floor: 'Étage',
        hideIndividual: 'Masquer les logements individuels',
        kitchen: 'Cuisine',
        lastConstruction: 'Dernière construction',
        medianArea: 'Surface médiane',
        medianRooms: 'Pièces médianes',
        monthlyRent: 'Loyer mensuel',
        multiFloor: 'Multi-étages',
        noDwellings: 'Aucune information sur les logements disponible',
        perMonth: '/ mois',
        pricePredictions: 'Prévisions de prix',
        purchasePrice: "Prix d'achat",
        rooms: 'Pièces',
        singleFloor: 'Simple étage',
        sizeRange: 'Fourchette de taille',
        status: 'Statut',
        title: 'Informations sur les logements',
        totalArea: 'Surface totale',
        totalDwellings: 'Total des logements',
        viewIndividual: 'Voir les logements individuels',
      },
      dwellingsLabel: 'Logements',
      emptyStates: {
        noAdministrativeDetails: 'Aucun détail administratif disponible',
      },
      error: {
        buildingId: 'ID du bâtiment: {{propertyId}}',
        general: 'Erreur lors du chargement des données du bâtiment',
        notFound: 'Aucune donnée de bâtiment trouvée',
        retry: 'Réessayer',
      },
      federalRegistry: {
        addressesLabel: 'Adresses',
        title: 'Registre fédéral des bâtiments',
      },
      floorsLabel: 'Étages',
      history: {
        empty: {
          description: "Il n'y a aucun événement enregistré pour ce bâtiment",
          title: 'Aucun historique trouvé',
        },
        error: {
          description: "Une erreur s'est produite lors du chargement des données d'historique du bâtiment",
          title: "Échec du chargement de l'historique",
        },
        filtered: {
          description: "Essayez d'ajuster votre sélection de filtres pour voir plus d'événements",
          title: 'Aucun événement ne correspond aux filtres',
        },
        filters: {
          permits: 'Permis',
          rentals: 'Locations',
          sales: 'Ventes',
          transactions: 'Transactions',
        },
        loading: "Chargement de l'historique du bâtiment",
      },
      information: {
        buildingYear: 'Année de construction',
        category: 'Catégorie',
        energyEfficiency: 'Efficacité énergétique',
        heatingType: 'Type de chauffage',
        height: 'Hauteur',
        notAvailable: 'N/D',
        title: 'Informations du bâtiment',
        type: 'Type',
        volume: 'Volume',
      },
      links: {
        description: 'Liens pour le bâtiment {{buildingId}}',
        title: 'Liens du bâtiment',
      },
      loading: 'Chargement des données du bâtiment ID: {{propertyId}}...',
      market: {
        description: 'Données du marché pour le bâtiment {{buildingId}}',
        title: 'Données du marché',
      },
    },
    buildingStatus: {
      existing: 'Existant',
      planned: 'Planifié',
      under_construction: 'En Construction',
    },
    buildingTooltip: {
      area: 'Surface',
      buildingInfo: 'Informations du Bâtiment',
      dwellings: 'Logements',
      energy: 'Énergie',
      environment: 'Environnement',
      floors: 'Étages',
      heating: 'Chauffage',
      height: 'Hauteur',
      listings: 'Annonces',
      noAddress: 'Adresse non disponible',
      noiseLevel: 'Niveau de Bruit',
      permits: 'Permis',
      relatedData: 'Données Associées',
      transactions: 'Transactions',
      transport: 'Transport',
      units: 'Unités',
      viewQuality: 'Qualité de la Vue',
      year: 'Année de Construction',
    },
    categories: {
      buildings: 'Bâtiments',
      environmental: 'Environnemental',
      externalMaps: 'Cartes externes',
      myMaps: 'Mes cartes',
      noise: 'OFS - Bruit',
      satelliteTimeTravel: 'OFS - Voyage dans le temps',
      score: 'Score',
      urbanization: 'OFS - Urbanisation',
      zone: 'Zone',
    },
    createDeal: {
      addContact: 'Ajouter un contact',
      addDescription: 'Ajoutez une description...',
      addNotes: 'Ajoutez des notes supplémentaires...',
      addParticipant: 'Ajouter un participant',
      addParticipantTitle: 'Ajouter un participant',
      addUser: "Ajouter l'utilisateur",
      buildingTitle: 'Créer un nouveau deal bâtiment',
      cancel: 'Annuler',
      contact: 'Contact',
      contactRole: 'Rôle du contact',
      created: 'Créé',
      createDeal: 'Créer le deal',
      creating: 'Création en cours...',
      dealId: 'ID du deal',
      dealInformation: 'Informations du deal',
      dealName: 'Nom du deal',
      dealType: 'Type de deal',
      dealValue: 'Valeur du deal',
      description: 'Description',
      editBuildingTitle: 'Modifier le deal bâtiment',
      editTitle: 'Modifier le deal',
      enterDealName: 'Entrez le nom du deal',
      expectedCloseDate: 'Date de clôture prévue',
      lastModified: 'Dernière modification',
      loadingUsers: 'Chargement des utilisateurs...',
      metadata: 'Métadonnées',
      noPipelines: 'Aucun pipeline disponible',
      notes: 'Notes',
      noUsersFound: 'Aucun utilisateur trouvé',
      optional: 'Optionnel',
      participantRole: 'Rôle',
      participants: 'Participants',
      pipeline: 'Pipeline',
      pipelineStage: 'Pipeline et étape',
      removeParticipant: 'Retirer le participant',
      roleContributor: 'Contributeur',
      roleOwner: 'Propriétaire',
      roleParticipant: 'Participant',
      roleViewer: 'Observateur',
      searchingUsers: "Recherche d'utilisateurs...",
      searchUsers: 'Rechercher des utilisateurs par nom ou email...',
      selectPipelineFirst: "Sélectionnez d'abord un pipeline",
      selectUser: 'Sélectionner un utilisateur à ajouter',
      stage: 'Étape',
      summary: 'Résumé',
      title: 'Créer un nouveau deal',
      updateDeal: 'Mettre à jour le deal',
    },
    dataSources: {
      faoData: "Feuille d'avis officielle (FAO)",
      faoDataHeritage: 'Patrimoine du Canton de Genève',
      federalEnergyOffice: "Office fédéral de l'énergie",
      federalEnvironmentOffice: "Office fédéral de l'environnement",
      federalSpatialDevelopment: 'Registre fédéral des bâtiments et logements',
      federalStatisticalOffice: 'Office fédéral de la statistique',
      federalTransportOffice: 'Office fédéral des transports',
      marketData: 'Portails immobilier Suisse',
      personalCollection: 'Collection personnelle',
      popetyioLabs: 'Popety.io Data Labs',
    },
    deals: {
      addDeal: 'Ajouter un deal',
      archived: 'Archivé',
      attachError: "Échec de l'attachement des deals. Veuillez réessayer.",
      attachExisting: 'Attacher un deal existant',
      attaching: 'Attachement en cours...',
      attachSelected: 'Attacher la sélection',
      availableDeals: 'Deals disponibles',
      cancel: 'Annuler',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce deal de la propriété ?',
      contact: 'Contact',
      created: 'Créé',
      createdOn: 'Créé le',
      createFirstDeal: 'Créer le premier deal',
      createNewDeal: 'Créez un nouveau deal pour commencer',
      dealName: 'Nom du deal',
      dealsSelected: 'deals sélectionnés',
      dealType: 'Type de deal',
      dealTypeDevelopment: 'Développement',
      dealTypeJointVenture: 'Joint-venture',
      dealTypeLease: 'Location',
      dealTypeSale: 'Vente',
      dealValue: 'Valeur du deal (CHF)',
      description: 'Description',
      edit: 'Modifier',
      editDeal: 'Modifier le deal',
      emptyDescription: 'Commencez par créer un deal pour cette propriété',
      emptyTitle: 'Aucun deal pour le moment',
      enterDealName: 'Entrez le nom du deal',
      enterDescription: 'Entrez une description',
      enterNotes: 'Entrez des notes',
      expectedClose: 'Clôture prévue',
      expectedCloseDate: 'Date de clôture prévue',
      loading: 'Chargement des deals...',
      loadingAvailableDeals: 'Chargement des deals disponibles...',
      noAvailableDeals: 'Aucun deal disponible',
      noMatchingDeals: 'Aucun deal correspondant trouvé',
      noParticipants: 'Aucun participant',
      notApplicable: 'N/D',
      notes: 'Notes',
      owner: 'Propriétaire',
      participants: 'Participants',
      pipeline: 'Pipeline',
      remove: 'Supprimer de la propriété',
      removing: 'Suppression...',
      retry: 'Réessayer',
      searchForDeals: 'Rechercher des deals',
      searchPlaceholder: 'Rechercher par nom, pipeline ou type...',
      title: 'Deals de la propriété',
      tryDifferentSearch: "Essayez d'ajuster vos critères de recherche",
      type: 'Type',
      unassigned: 'Non assigné',
      update: 'Mettre à jour le deal',
      updating: 'Mise à jour...',
      value: 'Valeur du deal',
      viewInPipeline: 'Voir dans le pipeline',
    },
    filterPanel: {
      area: {
        landArea: 'Surface du terrain',
        maxPlaceholder: 'Surface max',
        minPlaceholder: 'Surface min',
        title: 'Surface',
      },
      buildingFilters: {
        common: {
          loadingTags: 'Chargement des tags...',
          noTagsAvailable: 'Aucun tag disponible',
          noTagsHelpBuilding: 'Aucun tag disponible. Créez des tags depuis le panneau de détails du bâtiment.',
          noTagsHelpLand: 'Aucun tag disponible. Créez des tags depuis le panneau de détails du terrain.',
          selectPermitTypes: 'Sélectionner les types de permis',
          selectTags: 'Sélectionner des tags',
        },
        environmental: {
          distanceToPowerlines: {
            '0to100m': '0 à 100m',
            over100m: 'Plus de 100m',
            placeholder: 'Sélectionner la distance',
          },
          lakeView: {
            '0ha': '0 ha',
            '0to100ha': '0 à 100 ha',
            over100ha: 'Plus de 100 ha',
            placeholder: 'Sélectionner la vue lac',
          },
          mountainView: {
            '0to4peaks': '0 à 4 sommets',
            '5to13peaks': '5 à 13 sommets',
            moreThan13peaks: 'Plus de 13 sommets',
            placeholder: 'Sélectionner la vue montagne',
          },
          noiseExposure: {
            '45to52db': '45 à 52 dB',
            moreThan52db: 'Plus de 52 dB',
            placeholder: 'Sélectionner les niveaux de bruit',
            upTo45db: "Jusqu'à 45 dB",
          },
          publicTransport: {
            badlyServed: 'Mal desservi',
            mediumServed: 'Moyennement desservi',
            placeholder: 'Sélectionner la qualité de transport',
            veryBadlyServed: 'Très mal desservi',
            veryWellServed: 'Très bien desservi',
            wellServed: 'Bien desservi',
          },
          slope: {
            '0to4degrees': '0 à 4 degrés',
            '4to9degrees': '4 à 9 degrés',
            moreThan9degrees: 'Plus de 9 degrés',
            placeholder: 'Sélectionner la pente',
          },
          taxBurden: {
            high: 'Élevé (plus de 7.1%)',
            medium: 'Moyen (5.1% à 7.1%)',
            placeholder: 'Sélectionner la charge fiscale',
            small: 'Faible (0 à 5.1%)',
          },
          travelTime: {
            long: 'Long',
            medium: 'Moyen',
            placeholder: 'Sélectionner les temps de trajet',
            short: 'Court',
          },
        },
        status: {
          accessible: 'Accessible',
          active: 'Actif',
          activeStatus: 'Statut actif',
          approximate: 'Approximatif',
          exactLocation: 'Localisation exacte',
          furnished: 'Meublé',
          furnishedStatus: 'Statut meublé',
          inactive: 'Inactif',
          newConstruction: 'Nouvelle construction',
          no: 'Non',
          noPets: "Pas d'animaux",
          notAccessible: 'Non accessible',
          petsAllowed: 'Animaux autorisés',
          selectAccessibility: "Sélectionner l'accessibilité...",
          selectActiveStatus: 'Sélectionner le statut actif...',
          selectConstructionStatus: 'Sélectionner le statut de construction...',
          selectFurnishedStatus: 'Sélectionner le statut meublé...',
          selectLocationPrecision: 'Sélectionner la précision de localisation...',
          selectPetPolicy: 'Sélectionner la politique animaux...',
          title: 'Filtres de statut',
          unfurnished: 'Non meublé',
          wheelchairAccessible: 'Accessible en fauteuil roulant',
          yes: 'Oui',
        },
      },
      buildingFiltersTitle: 'Filtres de bâtiment',
      buildingMode: 'Bâtiment',
      clearAll: 'Effacer tous les filtres',
      close: 'Fermer les filtres',
      landFilters: {
        building: {
          buildingHeight: 'Hauteur du bâtiment',
          buildingVolume: 'Volume du bâtiment hors sol (m3)',
          constructionYear: 'Année de construction',
          floorNumber: "Nombre d'étages",
          grossFloorArea: 'Surface brute (SB)',
          groundingArea: "Surface d'emprise au sol (m2)",
          hideUnknownYear: "Masquer l'année inconnue",
          numberOfDwellings: 'Nombre de logements',
          title: 'Bâtiment',
        },
        common: {
          display: 'Afficher',
          displayOnly: 'Afficher uniquement',
          from: 'De',
          hide: 'Masquer',
          max: 'Max',
          min: 'Min',
          mixed: 'Mixte',
          private: 'Privé',
          public: 'Public',
          selectOption: 'Sélectionner une option',
          to: 'À',
        },
        development: {
          availableBuildableCapacity: 'Capacité constructible disponible (SP disponible)',
          buildableCapacity: 'Capacité constructible (SP zone)',
          developmentScore: 'Score de développement',
          title: 'Développement',
          underExploitedScore: 'Score de sous-exploitation',
        },
        history: {
          buildingPermit: 'Permis de construire',
          buildingPermitsClassification: 'Classification des permis de construire',
          onlyDevelopment: 'Développement uniquement',
          permitClassifications: {
            development: 'Développement',
            other: 'Autre',
          },
          purchaseDate: "Date d'achat",
          purchasePrice: "Prix d'achat",
          rentDate: 'Date de location',
          rentPrice: 'Prix de location',
          title: 'Historique',
          transactionDate: 'Date de transaction',
          transactionPrice: 'Prix de transaction',
        },
        land: {
          title: 'Parcelle',
        },
        landUsePlanAssignments: {
          label: "Affectation du plan d'aménagement",
          noAssignments: "Aucune affectation du plan d'aménagement disponible",
          placeholder: "Sélectionner une affectation du plan d'aménagement",
          selectLocationFirst: "Veuillez d'abord sélectionner une localisation",
        },
        locationZoning: {
          landUsePlan: "Plan d'affectation",
          location: 'Localisation',
          noBuildingZone: 'Zone non constructible',
          noLandUsePlans: "Aucun plan d'affectation disponible",
          plan: 'Plan',
          planPlaceholder: 'Numéro de plan',
          selectLandUsePlan: "Sélectionner un plan d'affectation",
          selectLocationFirst: "Veuillez d'abord sélectionner une localisation",
          specialZone: 'Zone spéciale',
          title: 'Localisation et zone',
        },
        ownership: {
          numberOfOwners: 'Nombre de propriétaires',
          ownersType: 'Type de propriétaires',
          title: 'Propriété',
        },
        plot: {
          area: 'Surface',
          bareLand: 'Parcelles vierge',
          title: 'Parcelle',
        },
        restrictions: {
          archaeologicalZone: 'Zone archéologique',
          buildingRight: 'Droit distinct permanent',
          builtSitesProtectedZone: 'Zone de sites construits protégés',
          dangerZone: 'Zone de danger',
          forestLimitZone: 'Limite de zone forestière',
          forestZone: 'Zone forestière',
          mandatoryPlanningZone: 'Zone de planification obligatoire',
          natureProtectionZone: 'Zone de protection de la nature',
          noMaxCosZone: 'Zone sans COS max',
          notYetDefinedSpecialZone: 'Zone spéciale non définie',
          otherZone: 'Autre zone',
          pollutedZone: 'Zone polluée',
          protectedBuilding: 'Bâtiment protégé',
          protectedObjects: 'Objets protégés',
          reservedZone: 'Zone réservée',
          title: 'Restrictions',
          underwaterProtectedZone: 'Zone protégée sous-marine',
          watercourseLimitZone: "Limite de cours d'eau",
        },
      },
      landFiltersTitle: 'Filtres de parcelle',
      loadFilters: 'Charger les filtres sauvegardés',
      location: {
        municipality: 'Commune',
        region: 'Région',
        searchPlaceholder: 'Rechercher des régions, communes, villes...',
        selectMunicipality: 'Veuillez sélectionner une commune',
        selectPlan: 'Veuillez sélectionner un plan',
        selectRegion: 'Veuillez sélectionner une région',
        title: 'Localisation',
      },
      municipalities: {
        carouge: 'Carouge',
        geneva: 'Genève',
        lancy: 'Lancy',
        meyrin: 'Meyrin',
        vernier: 'Vernier',
      },
      plotMode: 'Parcelle',
      propertyType: {
        placeholder: 'Sélectionner le type de propriété',
      },
      quickFilters: {
        maxArea: 'Max {{area}}m²',
        minArea: 'Min {{area}}m²',
        privateOwnership: 'Propriété privée',
        privateProperty: 'Propriété privée',
        title: 'Filtres rapides',
        zone3: 'Zone 3',
      },
      regions: {
        basel: 'Région de Bâle',
        central: 'Suisse centrale',
        lakeGeneva: 'Région du Léman',
        ticino: 'Tessin',
        zurich: 'Région de Zurich',
      },
      savePreset: 'Sauvegarder le préréglage de filtre',
      title: 'Filtres',
    },
    financial: {
      'Nombre de logements': 'Nombre de logements',
    },
    heatingTypes: {
      district: 'Chauffage à Distance',
      electric: 'Électrique',
      gas: 'Gaz',
      heat_pump: 'Pompe à Chaleur',
      oil: 'Mazout',
      solar: 'Solaire',
      wood: 'Bois',
    },
    landPlotTooltip: {
      buildings: 'Bâtiments',
      landArea: 'Surface terrain',
      noAddress: 'Aucune adresse disponible',
      noZoning: 'Aucune information de zone',
      units: 'Unités',
      zoning: 'Zone',
    },
    layers: {
      availability: 'Disponibilité',
      buildingArea: 'Surface bâtie',
      constructionYear: 'Année de construction',
      daytimeRailwayNoise: 'Bruit ferroviaire diurne',
      daytimeRoadTrafficNoise: 'Bruit routier diurne',
      densifiableArea: 'Surface densifiable',
      developmentPotential: 'Potentiel de développement',
      favorites: 'Favoris',
      legacyRiskScore: 'Score de risque patrimonial',
      livabilityScore: 'Score de qualité de vie',
      myTags: 'Mes tags',
      numberOfUnits: "Nombre d'unités",
      prospectiveProperties: 'Propriétés prospectives',
      protectedBuildings: 'Bâtiments protégés',
      restrictions: 'Restrictions',
      underExploitationIndex: 'Indice de sous-exploitation',
      zoneLayout: 'Aménagement des zones',
    },
    legends: {
      categoricalLabels: {
        availability: {
          available: 'Disponible',
          notAvailable: 'Non disponible',
        },
        buildingArea: {
          no: 'Non',
          yes: 'Oui',
        },
        buildingClassification: {
          garage: 'Garage',
          industrial: 'Industriel',
          mixed1: 'Mixte 1',
          mixed2: 'Mixte 2',
          notClassified: 'Non classé',
          offices: 'Bureaux',
          other: 'Autre',
          public: 'Public',
          residential: 'Résidentiel',
          retail: 'Commerce',
        },
        buildingPeriod: {
          '1919to1945': '1919-1945',
          '1946to1960': '1946-1960',
          '1961to1970': '1961-1970',
          '1971to1980': '1971-1980',
          '1981to1985': '1981-1985',
          '1986to1990': '1986-1990',
          '1991to1995': '1991-1995',
          '1996to2000': '1996-2000',
          '2001to2005': '2001-2005',
          '2006to2010': '2006-2010',
          '2011to2015': '2011-2015',
          '2015onward': 'Depuis 2015',
          before1919: 'Avant 1919',
        },
        buildingType: {
          exclusivelyResidential: 'Exclusivement résidentiel',
          nonResidential: 'Non résidentiel',
          partiallyResidential: 'Partiellement résidentiel',
          residentialWithAnnex: 'Résidentiel avec annexe',
          special: 'Construction particulière',
          temporary: 'Habitation provisoire',
          unknown: 'Inconnu',
        },
        customContent: {
          customTags: 'Tags personnalisés',
          favoriteProperties: 'Propriétés favorites',
          prospectiveProperties: 'Propriétés prospectives',
        },
        lakeView: {
          large: 'Grande vue sur lac (> 100 ha)',
          none: 'Aucune vue sur lac',
          small: 'Petite vue sur lac (< 100 ha)',
        },
        monumentProtection: {
          no: 'Non protégé',
          yes: 'Protégé',
        },
        mountainView: {
          few: 'Peu de sommets (< 5)',
          many: 'Beaucoup de sommets (> 13)',
          medium: 'Sommets moyens (5-13)',
        },
        noiseExposure: {
          high: 'Élevé (> 52 dB)',
          low: 'Faible (< 45 dB)',
          medium: 'Moyen (45-52 dB)',
        },
        officialCategory: {
          agricultural: 'Bâtiment agricole',
          apartment: 'Immeuble (3 logements et plus)',
          collectiveHousing: 'Hébergement collectif',
          commercial: 'Bâtiment commercial',
          communityHousing: 'Habitat communautaire',
          crops: 'Bâtiment pour cultures végétales',
          cultural: 'Culture / Loisirs',
          education: 'Enseignement / Recherche',
          garage: 'Garage',
          health: 'Hôpital / Santé',
          hotel: 'Hôtel',
          industrial: 'Bâtiment industriel',
          livestock: 'Bâtiment pour élevage',
          monument: 'Monument historique',
          museum: 'Musée / Bibliothèque',
          office: 'Immeuble de bureaux',
          otherAgricultural: 'Autre agricole',
          otherUnclassified: 'Autre non classé',
          religious: 'Édifice religieux',
          restaurant: 'Restaurant / Bar',
          singleFamily: 'Maison individuelle',
          sports: 'Installation sportive',
          tourism: 'Hébergement touristique',
          transport: 'Transport / Communication',
          twoFamily: 'Maison bifamiliale',
          unknown: 'Inconnu',
          warehouse: 'Entrepôt / Silo / Stockage',
        },
        powerSource: {
          air: 'Air',
          districtHeating: 'Chauffage à distance',
          electricity: 'Électricité',
          gas: 'Gaz',
          geothermal: 'Géothermie',
          none: 'Aucune',
          oil: 'Mazout',
          solar: 'Solaire (thermique)',
          unknown: 'Indéterminé',
          wood: 'Bois',
        },
        protectionStatus: {
          level1: 'Niveau 1',
          level2: 'Niveau 2',
          level3: 'Niveau 3',
          level4: 'Niveau 4 (Le plus élevé)',
          notProtected: 'Non protégé',
        },
        renovationPeriod: {
          '1919to1945': '1919-1945',
          '1946to1960': '1946-1960',
          '1961to1970': '1961-1970',
          '1971to1980': '1971-1980',
          '1981to1985': '1981-1985',
          '1986to1990': '1986-1990',
          '1991to1995': '1991-1995',
          '1996to2000': '1996-2000',
          '2001to2005': '2001-2005',
          '2006to2010': '2006-2010',
          '2011to2015': '2011-2015',
          '2015onward': 'Depuis 2015',
          before1919: 'Avant 1919',
        },
        transportQuality: {
          badly: 'Mal desservi',
          medium: 'Moyennement desservi',
          veryBadly: 'Très mal desservi',
          veryWell: 'Très bien desservi',
          well: 'Bien desservi',
        },
        travelTime: {
          long: 'Long',
          medium: 'Moyen',
          short: 'Court',
        },
        zoneTypes: {
          archaeological: 'Archéologique',
          danger: 'Danger',
          forest: 'Forêt',
          polluted: 'Pollué',
          reserved: 'Réservé',
          watercourse: "Cours d'eau",
        },
      },
      gradientLabels: {
        before1950: '< 1950',
        db45: '45 dB',
        db55: '55 dB',
        db65: '65 dB',
        db75Plus: '75+ dB',
        high: 'Élevé',
        low: 'Faible',
        medium: 'Moyen',
        older: 'Plus ancien',
        oneOrMore: '1+',
        recent: 'Récent',
        twentyOrMore: '20+',
        year1960: '1960',
        year1970: '1970',
        year1990: '1990',
        year2010: '2010',
        year2024: '2024',
      },
      titles: {
        availability: 'Disponibilité de la zone',
        averageBuildingYear: 'Année moyenne de construction',
        averageRenovationYear: 'Année moyenne de rénovation',
        buildingArea: 'Surface bâtie',
        buildingClassification: 'Classification du bâtiment',
        buildingPeriod: 'Période de construction',
        buildingPermitLastYear: "Permis de construire de l'année dernière",
        buildingProtectionStatus: 'Statut de protection du bâtiment',
        buildingType: 'Type de bâtiment',
        daytimeRailwayNoise: 'Bruit ferroviaire diurne',
        daytimeRoadTrafficNoise: 'Bruit routier diurne',
        developmentPotentialScore: 'Score de potentiel de développement',
        favorites: 'Favoris',
        heatingEnergySource: "Source d'énergie de chauffage",
        lakeView: 'Vue sur lac',
        legacyRiskScore: 'Score de risque patrimonial',
        listingRentLastYear: "Annonces de location de l'année dernière",
        listingSaleLastYear: "Annonces de vente de l'année dernière",
        livabilityScore: 'Score de qualité de vie',
        mountainView: 'Vue sur montagne',
        myTags: 'Mes tags',
        nighttimeRailwayNoise: 'Bruit ferroviaire nocturne',
        nighttimeRoadTrafficNoise: 'Bruit routier nocturne',
        noiseExposure: 'Exposition au bruit',
        numberOfDwellings: 'Nombre de logements',
        numberOfFloors: "Nombre d'étages",
        numberOfUnits: "Nombre d'unités",
        officialCategory: 'Catégorie officielle',
        prospects: 'Prospects',
        publicTransportQuality: 'Qualité des transports publics',
        renovationPeriod: 'Période de rénovation',
        solarExposure: 'Exposition solaire',
        transactionLastYear: "Transactions de l'année dernière",
        travelTimeToCenters: 'Temps de trajet vers les centres',
        underExploitationScore: 'Score de sous-exploitation',
        waterHeatingSource: "Source d'énergie pour eau chaude",
        zoneRestrictions: 'Restrictions de zone',
      },
      units: {
        decibels: 'Décibels',
        dwellings: 'logements',
        floors: 'étages',
        kwhPerM2: 'kWh/m²',
        score: 'Score',
        units: 'unités',
      },
    },
    listView: {
      actions: {
        addTag: 'Ajouter un tag',
        addToDeal: 'Ajouter au deal',
        addToFavorites: 'Ajouter aux favoris',
        export: 'Exporter',
      },
      columns: {
        activity: 'Activité',
        addLabel: '+ Ajouter un tag',
        address: 'Adresse',
        area: 'Surface',
        building: 'Bâtiment',
        buildings: 'Bâtiments',
        floors: 'Étages',
        history: 'Historique',
        labels: 'Tags',
        municipality: 'Commune',
        notClassified: 'Non classé',
        otherAddresses: '+{{count}} adresses',
        otherZones: '+{{count}} autres zones',
        plotNumber: 'Numéro de parcelle',
        score: 'Score',
        surface: 'Surface',
        type: 'Type',
        units: 'Unités',
        volume: 'Volume',
        year: 'Année',
        zone: 'Zone',
      },
      exportSelected: 'Exporter la sélection',
      found: 'trouvés',
      of: 'de',
      results: 'résultats',
      rowsPerPage: 'Lignes par page',
      selectAll: 'Tout sélectionner',
      sortBy: 'Trier par',
      sortOptions: {
        address: 'Adresse',
        buildings: 'Bâtiments',
        landType: 'Type de terrain',
        municipality: 'Commune',
        plotId: 'Numéro de parcelle',
        recentActivity: 'Activité récente',
        surfaceArea: 'Surface',
        units: 'Unités',
        utilizationRate: "Taux d'utilisation",
      },
    },
    mapControls: {
      '2d': '2D',
      '3d': '3D',
      layers: 'Couches',
      legend: 'Légende',
      print: 'Imprimer',
      satellite: 'Satellite',
      street: 'Rue',
    },
    mapLayerPanel: {
      activeLayer: {
        label: 'Couche active',
        neutralView: 'Vue neutre',
        noLayer: 'Aucune couche',
        noLayerSelected: 'Aucune couche sélectionnée',
        turnOff: 'Désactiver',
      },
      favorites: {
        add: 'Ajouter aux favoris',
        remove: 'Retirer des favoris',
        title: 'Couches favorites',
      },
      search: {
        legend: {
          category: 'Catégorie',
        },
        placeholder: 'Rechercher des couches...',
      },
      title: 'Couches de carte',
      wms: {
        error: 'Échec du chargement des couches externes',
        externalSource: 'Source externe',
        info: 'Informations sur la couche',
        loading: 'Chargement des couches externes...',
      },
    },
    propertyPanel: {
      actionLabels: {
        activity: 'Activité',
        alert: 'Alerte',
        deal: 'Deal',
        exit: 'Quitter',
        favorite: 'Favori',
        group: 'Groupe',
      },
      activities: {
        empty: {
          description: "Essayez d'ajuster vos filtres ou vos termes de recherche",
          title: 'Aucune activité trouvée',
        },
        filters: {
          all: 'Toutes les activités',
          analysis: 'Analyses',
          favorites: 'Favoris',
          files: 'Fichiers',
          notes: 'Notes',
          tags: 'Tags',
        },
        hoursAgo: 'Il y a {{count}} heure',
        hoursAgo_plural: 'Il y a {{count}} heures',
        minutesAgo: 'Il y a {{count}} minute',
        minutesAgo_plural: 'Il y a {{count}} minutes',
        searchPlaceholder: 'Rechercher des activités...',
        title: 'Activités',
        today: "Aujourd'hui",
        yesterday: 'Hier',
      },
      addToDeal: 'Ajouter à un deal',
      addToFavorites: 'Ajouter aux favoris',
      buildingsLabel: 'Bâtiments',
      createAlert: 'Créer une alerte',
      creatingEstimation: "Création de l'estimation...",
      deals: {
        addDeal: 'Ajouter un deal',
        allPipelines: 'Tous les pipelines',
        allStatuses: 'Tous les statuts',
        attachExisting: 'Joindre existant',
        attachExistingBuilding: 'Joindre un deal existant',
        attachSelected: 'Joindre la sélection',
        buildingTitle: 'Deals du bâtiment',
        cancel: 'Annuler',
        confirmDeleteText: 'Retirer ce deal de la propriété ?',
        created: 'Créé',
        createDeal: 'Créer un deal',
        createFirst: 'Créer le premier deal',
        daysAgo: 'Il y a {{days}}j',
        edit: 'Modifier',
        emptyBuildingDescription: 'Commencez par créer ou joindre un deal pour ce bâtiment',
        emptyDescription: 'Commencez par créer ou joindre un deal pour cette propriété',
        emptyTitle: 'Aucun deal pour le moment',
        foundDeals_one: '{{count}} deal trouvé',
        foundDeals_other: '{{count}} deals trouvés',
        hoursAgo: 'Il y a {{hours}}h',
        justNow: "À l'instant",
        loadingPipelines: 'Chargement des pipelines...',
        loadPipelinesError: 'Échec du chargement des pipelines',
        lost: 'Perdu',
        minsAgo: 'Il y a {{mins}} min',
        noDealsAvailable: 'Aucun deal disponible',
        noDealsFound: 'Aucun deal trouvé',
        noPipeline: 'Aucun pipeline',
        noResults: 'Aucun deal ne correspond à votre recherche',
        noStage: 'Aucune étape',
        open: 'Ouvert',
        participants: 'Participants',
        pipeline: 'Pipeline',
        remove: 'Supprimer',
        removeDeal: 'Retirer le deal',
        searchDealsError: 'Échec de la recherche de deals',
        searchPlaceholder: 'Rechercher des deals par nom, pipeline ou étape...',
        selectAll: 'Tout sélectionner',
        selected: 'Sélectionné',
        stage: 'Étape',
        status: 'Statut',
        summary: 'Résumé',
        title: 'Deals de propriété',
        untitledDeal: 'Deal sans titre',
        viewInPipeline: 'Voir dans le pipeline',
        won: 'Gagné',
      },
      errors: {
        noLandId: 'Aucun identifiant de terrain disponible',
      },
      estimateCreated: 'Estimation créée avec succès',
      files: {
        confirmDelete: 'Êtes-vous sûr de vouloir supprimer {{name}} ?',
        delete: 'Supprimer',
        download: 'Télécharger',
        empty: {
          description: 'Téléchargez des fichiers pour commencer ou ajustez votre recherche',
          title: 'Aucun fichier trouvé',
        },
        filters: {
          all: 'Tous les fichiers',
        },
        searchPlaceholder: 'Rechercher des fichiers...',
        title: 'Fichiers',
        uploadButton: 'Parcourir les fichiers',
        uploadText: 'Glissez-déposez vos fichiers ici ou cliquez pour parcourir',
      },
      history: {
        adjustFilters: "Essayez d'ajuster vos filtres pour voir plus d'événements",
        error: "Erreur lors du chargement des données d'historique",
        loading: "Chargement des données d'historique...",
        loadingText: 'Veuillez patienter pendant que nous récupérons les informations détaillées',
        noEvents: 'Aucun événement trouvé',
        onlineDays: 'En ligne : {{days}} jours',
        permitRequest: 'Demande de permis',
        permits: 'Permis',
        rentalListing: 'Annonce de location',
        rentals: 'Locations',
        rooms: 'Pièces',
        saleListing: 'Annonce de vente',
        sales: 'Ventes',
        transaction: 'Transaction',
        transactions: 'Transactions',
      },
      information: {
        active: 'Actif',
        beneficiary: 'Bénéficiaire',
        buildingCount: 'Nombre de bâtiments',
        buildingPeriod: 'Période de construction',
        buildings: 'Bâtiments',
        built: 'Construit',
        company: 'Entreprise',
        conditions: 'Conditions',
        constructible: 'Constructible',
        created: 'Créé',
        duration: 'Durée',
        dwellings: 'Logements',
        energyConsumption: "Consommation d'énergie",
        energySurface: 'Surface énergétique',
        floors: 'Étages',
        foundation: 'Fondation',
        grossFloorArea: 'Surface brute plancher',
        groundFloorArea: 'Surface rez-de-chaussée',
        heatingSource: 'Source de chauffage',
        inactive: 'Inactif',
        individual: 'Particulier',
        landArea: 'Surface du terrain',
        landInfo: 'Informations du terrain',
        landType: 'Type de terrain',
        lastOwnerChange: 'Dernier changement de propriétaire',
        lastRenovation: 'Dernière rénovation',
        maxHeight: 'Hauteur max',
        no: 'Non',
        noDataAvailable: 'Aucune information détaillée disponible pour cette propriété',
        owners: 'Propriétaires',
        plotNumber: 'Numéro de parcelle',
        protected: 'Protégé',
        renovated: 'Rénové',
        residentialArea: 'Surface résidentielle',
        residentialFloors: 'Étages résidentiels',
        restrictions: 'Restrictions',
        searchGoogle: 'Rechercher sur Google',
        searchLinkedIn: 'Rechercher sur LinkedIn',
        searchLocalCh: 'Rechercher sur local.ch',
        solarPotential: 'Potentiel solaire',
        totalResidentialArea: 'Surface résidentielle totale',
        type: 'Type',
        unitCount: "Nombre d'unités",
        validity: 'Validité',
        volume: 'Volume',
        yes: 'Oui',
        zones: 'Zones',
      },
      links: {
        accessOfficialData: 'Accédez aux données officielles et documents légaux',
        buildingInformation: 'Informations sur le bâtiment',
        buildingPermitsHistory: 'Permis de construire et historique de construction',
        buildingStatistics: 'Statistiques du bâtiment',
        cadastreRDPPF: 'Cadastre RDPPF',
        cantonalGeoportal: 'Géoportail cantonal',
        cantonalInteractiveMap: 'Carte interactive et données cantonales',
        constructionHistory: 'Historique de construction',
        constructionPermits: 'Autorisations de construire',
        demographics: 'Démographie',
        detailedBuildingData: 'Caractéristiques détaillées du bâtiment',
        energyAndEnvironmentalData: 'Performance énergétique et données environnementales',
        energyCertificate: 'Certificat énergétique',
        energyEnvironment: 'Énergie et environnement',
        exploreWithMaps: 'Explorez la parcelle avec différents outils cartographiques',
        federalBuildingRegistry: 'Registre fédéral des bâtiments et logements (RegBL)',
        federalGeoportal: 'Géoportail fédéral',
        geoAdminFederalData: 'map.geo.admin.ch - Données fédérales',
        googleEarth: 'Google Earth',
        googleMaps: 'Google Maps',
        landRegistry: 'Registre foncier',
        localBuildingRecords: 'Registres locaux des bâtiments et permis',
        mapsNavigation: 'Cartes et navigation',
        municipalPortal: 'Portail municipal',
        neighborhood: 'Voisinage',
        neighborhoodLocalMarket: 'Informations sur le quartier et le marché local',
        neighborhoodStatistics: 'Démographie et statistiques du quartier',
        noBuildingData: 'Les données du bâtiment sont requises pour générer les liens externes',
        noiseExposure: 'Exposition au bruit',
        noLinksAvailable: 'Aucun lien externe disponible',
        noPropertyData: 'Les données de propriété sont requises pour générer les liens externes',
        officialBuildingData: 'Données officielles des bâtiments et logements',
        officialBuildingStats: 'Statistiques officielles fédérales des bâtiments',
        officialEnergyRating: 'Étiquette énergétique officielle CECB',
        officialExtractServitudes: 'Extrait officiel et servitudes',
        officialRegistries: 'Registres officiels',
        permitsHistory: 'Historique des permis délivrés dans la région',
        publicLawRestrictions: 'Restrictions de droit public à la propriété foncière',
        purchaseListings: 'Annonces de vente',
        recentSalesHistory: 'Historique des ventes récentes dans le secteur',
        rentalListings: 'Annonces de location',
        rooftopSolarAnalysis: 'Analyse du potentiel solaire des toitures',
        similarPurchasePropertiesMarket: 'Annonces de vente dans le même secteur sur le marché',
        similarRentalPropertiesMarket: 'Annonces de location dans le même secteur sur le marché',
        situationPlan: 'cadastre.ch - Plan de situation',
        situationPlanDescription: 'Mensuration officielle Suisse',
        solarPotential: 'Potentiel solaire',
        streetViewRoutes: 'Street View et itinéraires',
        trafficNoiseData: 'Données de bruit routier et ferroviaire',
        transactions: 'Transactions',
        view3dSatelliteHistory: 'Vue 3D et historique satellite',
      },
      loading: 'Chargement des données de la propriété...',
      loadingForId: 'Chargement des données pour ID: {{id}}...',
      market: {
        all: 'Tous',
        allResidentialProperties: 'Tous biens résidentiels',
        apartment: 'Appartement',
        avgPricePerSqm: 'Prix moyen au m²',
        avgRentPerSqm: 'Loyer moyen au m²',
        canton: 'Canton',
        cantonLevel: 'Niveau cantonal',
        cityGeneva: 'Ville de Genève',
        dataUnavailable: 'Les données de marché sont actuellement indisponibles',
        district: 'District',
        districtGeneva: 'District de Genève',
        districtLevel: 'Niveau du district',
        faoData: 'Canton de Genève',
        house: 'Maison',
        locationRequired: 'La localisation de la propriété est requise pour afficher les informations de marché',
        marketComparison: 'Comparaison du marché',
        marketOverview: 'Aperçu du marché',
        medianPrice: 'Prix médian',
        medianPricePerSqm: 'Prix médian au m²',
        medianRent: 'Loyer médian',
        medianRentPerSqm: 'Loyer médian au m²',
        municipality: 'Commune',
        municipalityLevel: 'Niveau communal',
        noMarketData: 'Aucune donnée de marché disponible',
        noRecentListings: 'Aucune annonce récente disponible',
        priceEvolution: 'Évolution des prix',
        pricePerSqm: 'Prix au m²',
        pricePerSqmEvolution: 'Évolution du prix au m²',
        recentListings: 'Annonces récentes',
        rent: 'Location',
        rentPerSqm: 'Loyer au m²',
        rooms: 'pièces',
        sale: 'Vente',
        thisYear: 'cette année',
        viewMoreAnalysis: "Voir plus d'analyses",
        viewMoreListings: "Voir plus d'annonces",
        yearOverYear: 'sur 1 an',
      },
      noAddress: 'Aucune adresse disponible',
      noPropertyData: 'Aucune donnée de propriété trouvée',
      notes: 'Notes',
      notesPanel: {
        addNote: 'Ajouter une note',
        aiAssistant: 'IA Assistant',
        cancel: 'Annuler',
        clearSearch: 'Effacer la recherche',
        daysAgo: 'Il y a {{count}} jours',
        deleteConfirm: 'Supprimer cette note ?',
        deleteNote: 'Supprimer',
        editNote: 'Modifier',
        hoursAgo: 'Il y a {{count}} heure',
        hoursAgo_plural: 'Il y a {{count}} heures',
        justNow: "À l'instant",
        loading: 'Chargement des notes...',
        minutesAgo: 'Il y a {{count}} minute',
        minutesAgo_plural: 'Il y a {{count}} minutes',
        newNote: 'Nouvelle note',
        noNotes: 'Aucune note',
        noNotesText: 'Commencez par ajouter une première note sur cette propriété',
        noResults: 'Aucun résultat trouvé',
        noResultsText: "Essayez avec d'autres mots-clés",
        noteHint: 'Ajoutez vos observations sur cette propriété',
        resultsInfo: '{{visible}} résultat',
        resultsInfo_plural: '{{visible}} résultats sur {{total}} notes',
        saveNote: 'Enregistrer',
        searchPlaceholder: 'Rechercher dans les notes...',
        title: 'Notes',
        weeksAgo: 'Il y a {{count}} semaine',
        weeksAgo_plural: 'Il y a {{count}} semaines',
        yesterday: 'Hier',
      },
      openAnalysis: 'Ouvrir analyse',
      openEstimation: 'Ouvrir estimation',
      propertyIdLabel: 'ID propriété: {{id}}',
      removeFromFavorites: 'Retirer des favoris',
      retry: 'Réessayer',
      surfaceLabel: 'm² Surface',
      tabs: {
        comingSoon: 'Bientôt disponible...',
        history: 'Historique',
        information: 'Information',
        links: 'Liens',
        market: 'Marché',
      },
      unitsLabel: 'Logements',
    },
    propertyTooltip: {
      buildingInformation: {
        title: 'Informations du bâtiment',
      },
      buildings: {
        buildingLabel: 'Bâtiment {{id}}',
        buildingYear: 'Année de construction',
        energyReferenceSurface: 'Surface de référence énergétique',
        floorNumber: "Nombre d'étages",
        grossUsefulFloorArea: 'Surface brute de plancher utile',
        groundFloorArea: 'Surface au sol',
        heatingEnergySource: "Source d'énergie de chauffage",
        idc: 'IDC',
        maxHeight: 'Hauteur max',
        numberOfDwellings: 'Nombre de logements',
        protected: 'Bâtiment protégé',
        renovationYear: 'Année de rénovation',
        residentialFloorNumber: "Nombre d'étages résidentiels",
        solarPotential: 'Potentiel solaire',
        title: 'Bâtiments',
        totalResidentialArea: 'Surface résidentielle totale',
        units: 'logements',
        volume: 'Volume',
      },
      energy: {
        idc: 'IDC (Indice de dépense de chaleur)',
        minergie: 'Minergie',
        title: 'Énergie et durabilité',
      },
      landInformation: {
        area: 'Surface',
        buildingArea: 'Surface bâtie',
        buildingPeriod: 'Période de construction',
        buildingRights: 'Droits de construction',
        district: 'District',
        egrid: 'EGRID',
        lastRenovation: 'Dernière rénovation',
        municipality: 'Commune',
        notApplicable: 'Non applicable',
        numberOfBuildings: 'Nombre de bâtiments',
        numberOfDwellings: 'Nombre de logements',
        propertyNature: 'Nature de la propriété',
        propertyNatureBF: 'Bien-fonds',
        propertyNatureDDP: 'Droit distinct et permanent (DDP)',
        swimmingPool: 'Piscine',
        title: 'Parcelle',
        totalResidentialArea: 'Surface résidentielle totale',
        type: 'Type',
        zone: 'Zone',
      },
      lands: {
        title: 'Parcelles associées',
        unknownEgrid: 'EGRID inconnu',
        unknownType: 'Type inconnu',
      },
      owners: {
        company: 'Société',
        lastChange: 'Dernier changement',
        localLabel: 'local',
        searchGoogle: 'Rechercher sur Google',
        searchLinkedIn: 'Rechercher sur LinkedIn',
        searchLocal: 'Rechercher sur local.ch',
        searchZefix: 'Rechercher sur Zefix (registre du commerce)',
        title: 'Propriétaires',
        unknown: 'Propriétaire inconnu',
      },
      restrictions: {
        active: 'Actif',
        coverage: 'Couverture {{percent}}%',
        coverageArea: 'Surface de couverture',
        description: 'Description',
        inactive: 'Inactif',
        newConstruction: 'Nouvelle construction autorisée',
        status: 'Statut',
        title: 'Restrictions',
        type: 'Type',
      },
      transport: {
        title: 'Transport et accessibilité',
      },
      view: {
        title: 'Vues et orientation',
      },
      zones: {
        adoptedDate: 'adopté le {{date}}',
        authorizedCOS: 'COS autorisé',
        authorizedCUS: 'CUS autorisé',
        authorizedIBUS: 'IBUS autorisé',
        buildingArea: 'Surface constructible',
        category: 'Catégorie',
        categoryCantonal: 'Cantonal',
        categoryGeneral: 'Communal',
        categoryLocal: 'Local',
        categoryPartial: 'Partiel',
        name: 'Nom',
        notApplicable: 'N/D',
        part: 'Part',
        planType: 'Type de plan',
        title: 'Zones',
        zone: 'Zone',
      },
    },
    qualityLevels: {
      average: 'Moyen',
      excellent: 'Excellent',
      good: 'Bon',
      high: 'Élevé',
      low: 'Faible',
      medium: 'Moyen',
      poor: 'Faible',
      very_poor: 'Très Faible',
    },
    viewToggle: {
      list: 'Liste',
      map: 'Carte',
    },
    wmsLayers: {
      ' Cadastral Surveying (OpenData)': 'Cadastre officiel',
      airport_noise: 'Bruit des aéroports',
      building_zones_switzerland_harmonized: 'Zones de construction Suisse',
      daily_railway_noise: 'Bruit ferroviaire diurne',
      daily_traffic_noise: 'Bruit de circulation diurne',
      nightly_railway_noise: 'Bruit ferroviaire nocturne',
      nightly_traffic_noise: 'Bruit de circulation nocturne',
      swissimage_past_1960: '1960 Images aériennes Suisse',
      swissimage_past_1970: '1970 Images aériennes Suisse',
      swissimage_past_1980: '1980 Images aériennes Suisse',
      swissimage_past_1990: '1990 Images aériennes Suisse',
      swissimage_past_2000: '2000 Images aériennes Suisse',
      swissimage_past_2010: '2010 Images aériennes Suisse',
      swissimage_past_2015: '2015 Images aériennes Suisse',
      swissimage_past_2020: '2020 Images aériennes Suisse',
      unconsolidated_deposits_thickness_model: 'Épaisseur des dépôts meubles',
    },
  },
  feasibility: {
    assessment: {
      marginal: {
        description: "Le projet est proche du seuil de viabilité de {{target}} % ({{marginal}}–{{target}} %). Envisagez d'optimiser les coûts ou les revenus.",
        title: 'Viabilité marginale',
      },
      not_viable: {
        description: 'Le projet est sous le seuil de marge promoteur de {{marginal}} %. Des changements significatifs sont nécessaires.',
        title: 'Non viable',
      },
      viable: {
        description: "Le projet atteint l'objectif de marge promoteur de {{target}} % et montre une forte viabilité financière.",
        title: 'Projet viable',
      },
    },
    empty: {
      description: "Aucune donnée d'étude de faisabilité n'est disponible pour cette analyse partagée.",
      title: 'Aucune étude de faisabilité',
    },
    keyMetrics: {
      belowTarget: "Sous l'objectif",
      critical: 'Critique',
      developerMetrics: 'Métriques du promoteur',
      internalRateOfReturn: 'Taux de rendement interne (annualisé)',
      investmentOverview: "Aperçu de l'investissement",
      netProfitEquity: 'Bénéfice net / Total fonds propres investis',
      revenueInvestment: 'Revenus / Investissement total',
      targetLabel: 'Objectif: ≥ {{target}}%',
      targetMet: 'Objectif atteint',
      totalEquityInProject: 'Total des fonds propres engagés dans le projet',
    },
    metrics: {
      developerMargin: 'Marge du promoteur',
      equityInvested: 'Fonds propres investis',
      irr: 'TRI',
      profitMultiple: 'Multiple de profit',
      roiOnEquity: 'ROI sur fonds propres',
    },
    quickFacts: {
      durationValue: '{{months}} mois ({{years}} ans)',
      equityRequired: 'Fonds propres requis',
      landFinancing: 'Financement terrain',
      notAvailable: 'N/A',
      pricePerM2: 'Prix moyen/m²',
      projectDuration: 'Durée du projet',
      projectType: 'Type de projet',
      saleableArea: 'Surface vendable',
      timelineSplit: 'Répartition du calendrier',
      timelineValue: '{{planning}}m planification + {{build}}m construction',
      totalUnits: "Nombre d'unités",
    },
    residual: {
      interpretation: "À ce prix d'achat maximal, le bénéfice cible de {{pct}} % du GDV est atteint si les hypothèses se confirment. Le financement est pris tel que modélisé, sans itération avec le prix du terrain.",
      maxBid: "Prix d'achat maximal",
      negativeNote: 'La valeur résiduelle est négative — construction, financement et bénéfice cible dépassent la valeur du projet. La parcelle ne peut pas supporter ce programme à la marge cible.',
      noPlotArea: 'Surface de parcelle indisponible — CHF/m² non affiché',
      perM2Value: '{{value}} / m² de parcelle',
      question: 'Combien puis-je payer pour cette parcelle tout en atteignant le bénéfice cible ?',
      title: 'Valeur résiduelle du terrain',
    },
    sections: {
      costBreakdown: 'Décomposition des coûts',
      financialSummary: 'Résumé financier',
      keyPerformanceIndicators: 'Indicateurs clés de performance',
      projectQuickFacts: 'Faits essentiels du projet',
    },
    summaryCards: {
      costBreakdown: 'Terrain: {{land}} | Construction: {{construction}}',
      financingCosts: 'Coûts de financement',
      fromSales: "Ventes d'unités et revenus additionnels",
      grossProfit: 'Brut: {{gross}}',
      interestAndFees: 'Intérêts et frais pendant le projet',
      netProfit: 'Bénéfice net du promoteur',
      totalCosts: 'Coûts totaux',
      totalRevenue: 'Revenu total',
    },
    waterfall: {
      construction: 'Construction',
      financing: 'Financement',
      landCosts: 'Coûts terrain',
      netProfit: 'Bénéfice net',
      revenue: 'Revenus',
    },
  },
  geoAnalysis: {
    charts: {
      altitude: 'Altitude (mètres)',
      distance: 'Distance',
      flatArea: 'Zone plate',
      meters: 'm',
      plotBoundary: 'Limite de parcelle',
      position: 'Position',
      slopedArea: 'Zone en pente',
      status: 'Statut',
      xAxis: 'X (mètres)',
      yAxis: 'Y (mètres)',
    },
    directions: {
      east: 'Est',
      eastWest: 'Est-Ouest',
      flat: 'Plat',
      north: 'Nord',
      northEast: 'Nord-Est',
      northSouth: 'Nord-Sud',
      northWest: 'Nord-Ouest',
      south: 'Sud',
      southEast: 'Sud-Est',
      southWest: 'Sud-Ouest',
      square: 'Carré',
      west: 'Ouest',
    },
    error: 'Impossible de charger les données géographiques',
    header: {
      scoreLabel: 'Score géo',
      scoreTooltip: "Score global d'aptitude géographique basé sur la pente, l'orientation et la forme",
      subtitle: 'Analyse topographique et géométrique complète pour la parcelle {{egrid}}',
      title: 'Analyse géographique',
    },
    loading: 'Chargement des données géographiques...',
    metrics: {
      areaEfficiency: 'Efficacité de la surface',
      averageSlope: 'Pente moyenne',
      buildable: 'Constructible',
      compactness: 'Compacité',
      compactnessScore: 'Score de compacité',
      constructionSuitability: 'Aptitude à la construction',
      dataPoints: 'Points de données',
      dimensions: 'Dimensions (L x l)',
      dominantOrientation: 'Orientation dominante',
      elevationRange: "Plage d'altitude",
      faces: 'Orientation',
      gridSize: 'Taille de grille',
      lengthWidth: 'Longueur x Largeur',
      maxAltitude: 'Altitude max',
      maxFlatArea: 'Zone plate max',
      maximum: 'Maximum',
      maximumFlatArea: 'Zone plate maximale',
      maximumSlope: 'Pente maximale',
      minAltitude: 'Altitude min',
      minimum: 'Minimum',
      percentOfTotal: '% du total',
      perimeter: 'Périmètre',
      regularity: 'Régularité',
      shapeFactor: 'Facteur de forme',
      shapeRegularity: 'Régularité de forme',
      slopeThreshold: 'Seuil de pente',
      sunExposure: 'Exposition au soleil',
      totalArea: 'Surface totale',
    },
    noAltitudeData: "Aucune donnée d'altitude disponible",
    noData: 'Aucune donnée disponible',
    noElevationData: "Aucune donnée d'élévation disponible pour cette région",
    noPolygonData: 'Aucune donnée de polygone disponible',
    noSlopeAnalysis: 'Aucune analyse de pente disponible',
    plotTooSmall: "Parcelle trop petite pour l'analyse de pente",
    plotTooSmallDescription: 'La parcelle est trop petite pour effectuer une analyse détaillée de la pente. Surface minimale requise: 100m².',
    sections: {
      altitudeProfile: "Profil d'altitude",
      developmentAnalysis: 'Analyse de développement',
      flatAreaAnalysis: 'Analyse des zones plates',
      geometryAnalysis: 'Analyse de géométrie',
      orientationAnalysis: "Analyse d'orientation (Exposition au soleil)",
      plotBoundaryVisualization: 'Visualisation des limites de parcelle',
      shapeMetrics: 'Métriques de forme',
      slopeDistribution: 'Distribution des pentes',
      slopeSunOrientation: 'Pente et exposition au soleil',
      topographicVisualization: 'Visualisation topographique 3D',
    },
    slopeRanges: {
      flat: 'Plat (0-5°)',
      gentle: 'Légère (5-10°)',
      moderate: 'Modérée (10-15°)',
      range0_5: '0-5° (Plat)',
      range10_15: '10-15° (Modérée)',
      range15_25: '15-25° (Forte)',
      range5_10: '5-10° (Légère)',
      rangeOver25: '>25° (Très forte)',
      steep: 'Forte (15-25°)',
      verysteep: 'Très forte (>25°)',
    },
    status: {
      challenging: 'Difficile',
      excellent: 'Excellent',
      good: 'Bon',
      irregular: 'Irrégulier',
      loading: 'Chargement...',
      moderate: 'Modéré',
      na: 'N/A',
      neutral: 'Neutre',
      noData: 'Aucune donnée',
      poor: 'Faible',
      realData: 'Données réelles',
      regular: 'Régulier',
    },
    sunExposureNotes: {
      excellent: 'Potentiel de chauffage passif',
      moderate: 'Lumière équilibrée',
      neutral: 'Pas de pente dominante',
      poor: 'Ensoleillement direct limité',
    },
    tabs: {
      analysis: 'Pente et orientation',
      overview: 'Aperçu',
      shape: 'Forme et géométrie',
      topography: 'Topographie 3D',
    },
    tooltips: {
      areaEfficiency: {
        calculation: 'Surface plate / Surface totale × 100%',
        importance: "Une efficacité plus élevée signifie qu'une plus grande partie de la parcelle est immédiatement utilisable.",
        shortDescription: 'Pourcentage de surface plate et constructible par rapport à la surface totale de la parcelle.',
        source: "Analyse composite à partir des données d'élévation et cadastrales",
        title: 'Efficacité de la surface',
      },
      averageSlope: {
        calculation: "Moyenne pondérée des valeurs de pente des points de grille d'élévation.",
        categories: [
          {
            description: 'Idéal pour la construction, terrassement minimal requis',
            label: 'Plat',
            range: '0-5°',
          },
          {
            description: 'Bon pour la construction avec des adaptations mineures',
            label: 'Légère',
            range: '5-10°',
          },
          {
            description: 'Nécessite des terrassements importants et des structures de soutènement',
            label: 'Modérée',
            range: '10-15°',
          },
          {
            description: 'Construction difficile, techniques spécialisées nécessaires',
            label: 'Forte',
            range: '>15°',
          },
        ],
        importance: 'Critique pour la faisabilité de construction et la planification du drainage.',
        limitations: 'Ne montre pas les variations locales de pente dans la parcelle.',
        shortDescription: "L'angle de pente moyen sur toute la surface de la parcelle.",
        source: "Données d'élévation SwissTopo (swissALTI3D)",
        title: 'Pente moyenne',
      },
      compactness: {
        calculation: '4π × Surface / Périmètre² (1.0 = cercle parfait)',
        importance: 'Les formes plus compactes ont des coûts de limite plus bas par unité de surface.',
        shortDescription: "Rapport entre la surface et le périmètre de la parcelle, indiquant l'efficacité de la forme.",
        source: 'Calculé à partir des données polygonales cadastrales',
        title: 'Compacité',
      },
      compactnessScore: {
        calculation: 'Quotient isopérimétrique: 4π × Surface / Périmètre²',
        categories: [
          {
            description: "Forme très compacte, utilisation efficace de l'espace",
            label: 'Élevé',
            range: '>0.7',
          },
          {
            description: 'Compacité modérée, typique pour la plupart des parcelles',
            label: 'Moyen',
            range: '0.4-0.7',
          },
          {
            description: 'Forme allongée ou complexe, moins efficace',
            label: 'Faible',
            range: '<0.4',
          },
        ],
        importance: 'Une compacité plus élevée signifie moins de limite par rapport à la surface, réduisant les coûts.',
        shortDescription: 'Mesure la compacité (ressemblance à un cercle) de la forme de la parcelle.',
        source: 'Calculé à partir des données polygonales cadastrales',
        title: 'Score de compacité',
      },
      constructionSuitability: {
        calculation: 'Score composite basé sur la pente, la forme et le pourcentage de zone plate.',
        categories: [
          {
            description: 'Conditions idéales pour la construction',
            label: 'Excellent',
            range: '>80%',
          },
          {
            description: 'Conditions favorables avec des défis mineurs',
            label: 'Bon',
            range: '60-80%',
          },
          {
            description: 'Terrassement ou adaptation important nécessaire',
            label: 'Modéré',
            range: '40-60%',
          },
          {
            description: 'Exigences de construction complexes',
            label: 'Difficile',
            range: '<40%',
          },
        ],
        importance: 'Indicateur rapide du potentiel de développement et des coûts de construction.',
        shortDescription: "Évaluation globale de l'aptitude de la parcelle à la construction.",
        source: 'Analyse composite à partir de plusieurs sources de données',
        title: 'Aptitude à la construction',
      },
      dimensions: {
        calculation: 'Calculé à partir du rectangle englobant minimum.',
        importance: 'Aide à déterminer les dimensions maximales du bâtiment pouvant tenir sur la parcelle.',
        shortDescription: 'Longueur et largeur du rectangle englobant de la parcelle.',
        source: 'Calculé à partir des données polygonales cadastrales',
        title: 'Dimensions',
      },
      dominantOrientation: {
        calculation: "Déterminé en analysant l'aspect (direction de la pente) du terrain.",
        importance: "Affecte le gain solaire, l'éclairage naturel et l'efficacité énergétique des bâtiments.",
        shortDescription: "La direction principale vers laquelle la parcelle est orientée, affectant l'exposition au soleil.",
        source: "Données d'élévation SwissTopo (swissALTI3D)",
        title: 'Orientation dominante',
      },
      flatAreaAnalysis: {
        calculation: 'Analyse de grille pour identifier les zones plates contiguës.',
        importance: 'Les zones plates sont optimales pour le placement des bâtiments et nécessitent moins de terrassement.',
        shortDescription: 'Identifie et mesure les zones avec une pente inférieure à 5°.',
        source: "Données d'élévation SwissTopo (swissALTI3D)",
        title: 'Analyse des zones plates',
      },
      maxFlatArea: {
        calculation: 'Analyse de la plus grande composante connectée des cellules de grille plates.',
        importance: "Détermine l'empreinte maximale du bâtiment possible sans excavation.",
        shortDescription: 'La plus grande zone plate contiguë sur la parcelle.',
        source: "Données d'élévation SwissTopo (swissALTI3D)",
        title: 'Zone plate maximale',
      },
      maximumSlope: {
        calculation: "Valeur maximale de l'analyse de la grille de pente.",
        importance: 'Identifie les zones potentiellement problématiques pour la construction.',
        shortDescription: "L'angle de pente le plus raide trouvé n'importe où sur la parcelle.",
        source: "Données d'élévation SwissTopo (swissALTI3D)",
        title: 'Pente maximale',
      },
      perimeter: {
        calculation: 'Somme de toutes les longueurs des bords du polygone de délimitation.',
        importance: 'Affecte les coûts de clôture et les considérations de limites.',
        shortDescription: 'La longueur totale de la limite de la parcelle.',
        source: 'Calculé à partir des données polygonales cadastrales',
        title: 'Périmètre',
      },
      regularity: {
        calculation: 'Surface de la parcelle / Surface du rectangle englobant × 100%',
        importance: "Une régularité plus élevée signifie plus d'espace utilisable pour la construction.",
        shortDescription: 'À quel point la parcelle remplit son rectangle englobant.',
        source: 'Calculé à partir des données polygonales cadastrales',
        title: 'Régularité',
      },
      shapeFactor: {
        calculation: 'Longueur / Largeur du rectangle englobant minimum.',
        categories: [
          {
            description: 'Longueur et largeur presque égales',
            label: 'Carré',
            range: '1.0-1.5',
          },
          {
            description: 'Rapport longueur/largeur modéré',
            label: 'Rectangulaire',
            range: '1.5-3.0',
          },
          {
            description: 'Forme longue et étroite',
            label: 'Allongé',
            range: '>3.0',
          },
        ],
        importance: 'Indique si la parcelle est carrée, rectangulaire ou allongée.',
        shortDescription: 'Rapport longueur/largeur du rectangle englobant de la parcelle.',
        source: 'Calculé à partir des données polygonales cadastrales',
        title: 'Facteur de forme',
      },
      shapeRegularity: {
        calculation: 'Rapport entre la surface de la parcelle et la surface de son rectangle englobant minimum.',
        categories: [
          {
            description: 'Presque rectangulaire, optimal pour le placement des bâtiments',
            label: 'Régulier',
            range: '>80%',
          },
          {
            description: 'Forme complexe, peut limiter les options de construction',
            label: 'Irrégulier',
            range: '<80%',
          },
        ],
        importance: 'Les formes régulières sont plus faciles et plus rentables à construire.',
        shortDescription: "À quel point la forme de la parcelle est proche d'un rectangle régulier.",
        source: 'Calculé à partir des données polygonales cadastrales',
        title: 'Régularité de forme',
      },
      slopeDistribution: {
        calculation: 'Analyse de pente basée sur une grille avec catégorisation.',
        importance: 'Montre la variété des conditions de terrain sur la parcelle.',
        shortDescription: 'Répartition de la parcelle par catégories de pente.',
        source: "Données d'élévation SwissTopo (swissALTI3D)",
        title: 'Distribution des pentes',
      },
      totalArea: {
        calculation: 'Calculé en utilisant la formule du lacet sur les coordonnées du polygone.',
        importance: 'Essentiel pour déterminer le potentiel de construction et la valeur du bien.',
        limitations: 'Peut différer légèrement des mesures cadastrales officielles.',
        shortDescription: 'La surface totale de la parcelle calculée à partir de son polygone de délimitation.',
        source: 'Calculé à partir des données polygonales cadastrales',
        title: 'Surface totale',
      },
    },
  },
  history: {
    actions: {
      exportCSV: 'Exporter vers CSV',
      exportExcel: 'Exporter vers Excel',
      filterByType: 'Filtrer par type',
      sortByDate: 'Trier par date',
      sortByPrice: 'Trier par prix',
      viewDetails: 'Voir les détails',
    },
    adjustFilters: "Essayez d'ajuster vos filtres",
    back: 'Retour',
    buildingHistory: 'Historique du bâtiment',
    buildingHistorySubtitle: 'Tous les événements collectés par Popety.io concernant le bâtiment {{egid}} au cours des dernières années.',
    detailView: {
      active: 'Actif',
      addressNotSpecified: 'Adresse non spécifiée',
      available: 'Disponible',
      balcony: 'Balcon',
      bathrooms: 'Salles de bain',
      built: 'Construit',
      constructionYear: 'Année de construction',
      days: 'jours',
      description: 'Description',
      elevator: 'Ascenseur',
      energyLabel: 'Étiquette énergétique',
      featuresAndAmenities: 'Caractéristiques et équipements',
      floor: 'Étage',
      furnished: 'Meublé',
      garage: 'Garage',
      garden: 'Jardin',
      heatingType: 'Type de chauffage',
      immediately: 'Immédiatement',
      inactive: 'Inactif',
      landArea: 'Surface du terrain',
      livingArea: 'Surface habitable',
      onlineFor: 'En ligne depuis',
      parking: 'Parking',
      petsAllowed: 'Animaux acceptés',
      propertyAgents: 'Agents immobiliers',
      propertyCategory: 'Catégorie de propriété',
      propertyDetails: 'Détails de la propriété',
      propertyForRent: 'Propriété à louer',
      propertyForSale: 'Propriété à vendre',
      propertyType: 'Type de propriété',
      published: 'Publié',
      renovationYear: 'Année de rénovation',
      rooms: 'Pièces',
      statusLabel: 'Statut',
      terrace: 'Terrasse',
    },
    error: 'Erreur',
    eventDetails: "Détails de l'événement",
    fields: {
      address: 'Adresse',
      architect: 'Architecte',
      area: 'Surface',
      availableDate: 'Disponible',
      balcony: 'Balcon',
      bathrooms: 'Salles de bain',
      broker: 'Courtier',
      buildingClassification: 'Classification du bâtiment',
      buyers: 'Acheteurs',
      classification: 'Classe',
      constructionYear: 'Construit',
      date: 'Date',
      description: 'Description',
      elevator: 'Ascenseur',
      energyLabel: 'Énergie',
      floor: 'Étage',
      furnished: 'Meublé',
      garage: 'Garage',
      garden: 'Jardin',
      heatingType: 'Chauffage',
      inquiryEnd: 'Date de fin',
      inquiryStart: 'Date de début',
      landArea: 'Terrain',
      listingType: "Type d'annonce",
      onlineDays: 'Jours en ligne',
      owner: 'Propriétaire',
      ownersType: 'Type de propriétaires',
      parking: 'Parking',
      permitNumber: 'Permis',
      permitType: 'Type de permis',
      petsAllowed: 'Animaux acceptés',
      previousTransaction: 'Transaction précédente',
      price: 'Prix',
      pricePerSqm: 'Prix/m²',
      projectArea: 'Surface',
      projectValue: 'Valeur',
      propertyCategory: 'Catégorie',
      propertyType: 'Type de bien',
      reason: 'Raison',
      renovationYear: 'Rénové',
      rooms: 'Pièces',
      sellers: 'Vendeurs',
      status: 'Statut',
      terrace: 'Terrasse',
      type: 'Type',
      units: 'Unités',
      workDescription: 'Description des travaux',
      workType: 'Type',
    },
    filters: {
      allTime: 'Toute la période',
      buildingPermits: 'Permis de construire',
      dateRange: 'Période',
      export: 'Exporter',
      listings: 'Annonces',
      rentalListings: 'Annonces de location',
      saleListings: 'Annonces de vente',
      searchPlaceholder: "Rechercher dans l'historique...",
      transactions: 'Transactions',
    },
    loading: 'Chargement...',
    noBuildingDataAvailable: 'Aucune donnée de bâtiment disponible',
    noDataAvailable: 'Aucune donnée disponible',
    noEstimateDataAvailable: "Aucune donnée d'estimation disponible",
    noEvents: 'Aucun événement historique trouvé',
    noLandDataAvailable: 'Aucune donnée de parcelle disponible',
    ownershipType: 'Type de propriété',
    plotHistory: 'Historique de la parcelle',
    plotHistorySubtitle: 'Tous les événements collectés par Popety.io concernant la parcelle {{egrid}} au cours des dernières années.',
    propertyHistory: 'Historique de la propriété',
    propertyHistorySubtitle: 'Tous les événements collectés par Popety.io concernant cette propriété au cours des dernières années.',
    propertyTypes: {
      apartment: 'Appartement',
      commercial: 'Commercial',
      house: 'Maison',
      land: 'Terrain',
      office: 'Bureau',
      other: 'Autre',
      parking: 'Parking',
    },
    sections: {
      inquiryPeriod: "Période d'enquête publique",
      parties: 'Parties impliquées',
      permitDetails: 'Détails du permis',
      projectInfo: 'Informations sur le projet',
      propertyInfo: 'Informations sur la propriété',
      transactionDetails: 'Détails de la transaction',
      workDescription: 'Description des travaux',
    },
    status: {
      active: 'Actif',
      approved: 'Approuvé',
      inactive: 'Inactif',
      pending: 'En attente',
      rejected: 'Refusé',
    },
    subtitle: 'Chronologie des événements pour {{address}}',
    timeline: {
      active: 'Actif',
      buildingPermit: 'Permis de construire',
      completed: 'Terminé',
      days: 'jours',
      expired: 'Expiré',
      noEvents: 'Aucun événement historique trouvé',
      online: 'En ligne',
      pending: 'En attente',
      permitRequest: 'Demande de permis',
      rentalListing: 'Annonce de location',
      saleListing: 'Annonce de vente',
      transaction: 'Transaction',
    },
    title: 'Historique',
    transactionDetail: {
      fields: {
        city: 'Ville',
        legalType: 'Type juridique',
        numberOfBuyers: "Nombre d'acheteurs",
        numberOfProperties: 'Nombre de propriétés',
        numberOfSellers: 'Nombre de vendeurs',
        officialId: 'ID officiel',
        participant: 'Participant',
        participantType: 'Type',
        postalCode: 'Code postal',
        property: 'Propriété',
        propertyNumber: 'Numéro de propriété',
        publicationDate: 'Date de publication',
        role: 'Rôle',
        share: 'Part',
        totalPrice: 'Prix total',
        totalSurface: 'Surface totale',
        transactionDate: 'Date de la transaction',
        transactionId: 'ID de la transaction',
        transactionType: 'Type de transaction',
      },
      sections: {
        participants: 'Participants',
        properties: 'Propriétés',
        summary: 'Résumé',
        transactionInfo: 'Informations sur la transaction',
      },
    },
  },
  landAnalysis: {
    buildingDetails: {
      actions: {
        analysis: 'Analyse',
        cancel: 'Annuler',
        edit: 'Modifier',
        explore: 'Explorer',
        noBuildingId: 'Identifiant du bâtiment non disponible',
        noEgid: 'EGID non disponible pour ce bâtiment',
        regbl: 'RegBL',
        save: 'Enregistrer',
      },
      card: {
        building: 'Bâtiment {{number}}',
        egid: 'EGID {{egid}}',
        floor: 'Étage',
        floors: 'Étages',
      },
      header: {
        scoreLabel: "Score d'existant",
        scoreTooltip: "Score d'existant basé sur les années de construction et de rénovation",
        subtitle: 'Informations complètes sur tous les bâtiments à {{address}}',
        title: 'Détails des bâtiments',
      },
      legend: {
        estimatedValues: 'Valeurs estimées',
        fullCoverage: 'Couverture totale',
        garage: 'Garage',
        industrial: 'Industriel',
        offices: 'Bureaux',
        other: 'Autre',
        partialCoverage: 'Couverture partielle',
        public: 'Public',
        residential: 'Résidentiel',
        residentialMajority: 'Résidentiel majoritaire',
        residentialMinority: 'Résidentiel minoritaire',
        retail: 'Commerce',
      },
      sections: {
        dimensions: {
          estFloorArea: 'Surface estimée',
          grossFloorArea: 'Surface brute de plancher',
          groundArea: 'Surface au sol',
          height: 'Hauteur',
          title: 'Dimensions',
          volume: 'Volume',
        },
        energy: {
          mainHeating: 'Chauffage principal',
          secondaryHeating: 'Chauffage secondaire',
          solarPotential: 'Potentiel solaire',
          title: 'Énergie',
          waterHeating: 'Eau chaude',
        },
        propertyInfo: {
          classification: 'Classification OFS',
          officialNumber: 'Numéro officiel',
          ofsCategory: 'Catégorie OFS',
          title: 'Infos propriété',
          units: 'Unités',
        },
        status: {
          compliance: 'Conformité',
          constructionStatus: 'Statut de construction',
          lastRenovation: 'Dernière rénovation',
          protectionStatus: 'Statut de protection',
          title: 'Statut',
        },
      },
      states: {
        loading: 'Chargement des détails des bâtiments...',
        noData: 'Aucune donnée disponible',
        unknownLocation: 'Emplacement inconnu',
      },
      summary: {
        buildingsNumber: 'Nombre de bâtiments',
        protectedBuildings: 'Bâtiments protégés',
        unitsNumber: "Nombre d'unités",
      },
      summaryBar: {
        other: 'autres structures',
        plannedConstruction: 'planifiés/construction',
        protected: 'protégés',
        registered: 'enregistrés',
        total: 'bâtiments au total',
        underground: 'souterrains',
      },
      units: {
        cubicMeters: 'm³',
        meters: 'm',
        notAvailable: 'N/D',
        squareMeters: 'm²',
      },
      values: {
        building: 'Bâtiment {{index}}',
        compliant: 'Conforme',
        good: 'Bon',
        heritageProtected: 'Patrimoine protégé',
        na: 'N/D',
        notClassified: 'Non classifié',
        notProtected: 'Non protégé',
        notSpecified: 'Non spécifié',
        projected: 'Projeté',
        solarExcellent: 'Excellent',
        solarGood: 'Bon',
        solarLow: 'Faible',
        solarMedium: 'Moyen',
      },
    },
    buildingsOverview: {
      aboveGroundVolume: 'Volume hors sol',
      buildingCoverage: 'Emprise au sol (IDC)',
      constructionYear: 'Année de construction',
      dimensions: 'Dimensions',
      general: 'Général',
      maximumFloors: 'Étages maximum',
      maximumHeight: 'Hauteur maximale',
      notAvailable: 'N/D',
      numberOfBuildings: 'Nombre de bâtiments',
      title: 'Aperçu des bâtiments',
      totalFloorArea: 'Surface de plancher totale',
      totalGroundArea: 'Surface au sol totale',
    },
    common: {
      no: 'Non',
      notAvailable: 'N/D',
      yes: 'Oui',
    },
    filesPanel: {
      title: 'Fichiers',
    },
    header: {
      addTags: 'Ajouter des tags',
      addToDeal: 'Ajouter à un deal',
      buildingAnalysis: 'Analyse de bâtiment',
      built: 'Construit',
      createNewBuildingAnalysis: 'Créer une nouvelle analyse de bâtiment',
      createNewLandAnalysis: 'Créer une nouvelle analyse de terrain',
      favorite: 'Favori',
      files: 'Fichiers',
      floors: 'étages',
      groupLandAnalysis: 'Analyse de terrain groupée',
      landAnalysis: 'Analyse de terrain',
      newBuildingAnalysis: 'Nouvelle analyse de bâtiment',
      newLandAnalysis: 'Nouvelle analyse de terrain',
      notes: 'Notes',
      pdfReports: 'Rapports PDF',
      share: 'Partager',
      subtitle: 'Informations sur la parcelle',
      subtitleMultiplePlots: '{{count}} parcelles pour {{address}}',
      subtitleSinglePlot: 'Détails de la parcelle pour {{address}}',
      subtitleWithAddress: 'Informations terrain pour {{address}}',
      tags: 'Tags',
      title: 'Terrain',
      units: 'logements',
    },
    info: {
      area: 'Surface',
      buildable: 'Constructible',
      buildingAreaPresent: 'Zone à bâtir',
      egridNumber: 'Numéro EGRID',
      officialArea: 'Surface officielle',
      plotNumber: 'Numéro de parcelle',
      propertyNature: 'Nature du bien',
      propertyNatureBF: 'BF – Bien-fonds',
      propertyNatureDDP: 'DDP – Droit distinct et permanent',
      title: 'Informations terrain',
      type: 'Type de propriété',
    },
    links: {
      openLandAnalysis: "Ouvrir l'analyse de terrain",
      title: 'Liens rapides',
      viewInExplore: 'Voir dans Explorer',
    },
    marketActivity: {
      activeListings: 'Annonces actives',
      buildingPermits: 'Permis de construire',
      recentActivity: 'Activité récente',
      title: 'Activité du marché',
      transactions: 'Transactions',
    },
    metrics: {
      buildings: {
        subtext: 'Sur ce terrain',
        title: 'Bâtiments',
      },
      landArea: {
        subtext: 'Surface totale',
        title: 'Surface du terrain',
      },
      underExploitedScore: {
        subtext: 'Potentiel de développement',
        title: 'Sous-exploité',
        tooltip: {
          calculation: 'Basé sur le rapport de surface de plancher actuel vs. autorisé.',
          description: 'Mesure le potentiel constructible actuellement utilisé.',
          importance: "Un score plus élevé indique plus d'opportunités de développement.",
          source: 'Calculé à partir des règlements de zone et des bâtiments actuels.',
          title: 'Score de sous-exploitation',
        },
      },
      units: {
        subtext: 'Unités résidentielles',
        title: 'Unités',
      },
    },
    owners: {
      lastChange: 'Dernière modification',
      names: 'Noms des propriétaires',
      number: 'Nombre de propriétaires',
      ownershipType: 'Type de propriété',
      title: 'Propriétaires',
    },
    ownership: {
      contact: 'Contacter',
      lastChange: 'Dernière modification :',
      noOwnerInfo: 'Aucune information sur le propriétaire disponible',
      owners: 'Propriétaires :',
      title: 'Propriété',
      unknown: 'Inconnu',
      unknownOwner: 'Propriétaire inconnu',
      viewProfile: 'Voir le profil',
    },
    propertyInformation: {
      addresses: 'Adresses',
      area: 'Superficie',
      bareLand: 'Parcelles vierge',
      basicInformation: 'Informations de base',
      municipality: 'Commune',
      no: 'Non',
      notAvailable: 'N/D',
      plotNumber: 'Numéro de parcelle',
      privateLand: 'Terrain privé',
      propertyId: 'ID de propriété (EGRID)',
      publicLand: 'Terrain public',
      title: 'Informations sur la propriété',
      type: 'Type',
      unknown: 'Inconnu',
      viewAllAddresses: 'Voir les {{count}} adresses',
      viewOnGeoPortal: 'Voir sur le géoportail',
      yes: 'Oui',
    },
    restrictions: {
      activeRestrictions: {
        one: '{{count}} restriction active',
        other: '{{count}} restrictions actives',
      },
      affected: 'Concerné',
      affectedTypes: 'Types concernés',
      noActiveRestrictions: 'Aucune restriction active',
      notAffected: 'Non concerné',
      notAvailable: 'Non disponible',
      title: 'Restrictions (RDPPF)',
      typesChecked: '{{total}} types vérifiés, {{affected}} affectés',
      viewDetailedRestrictions: 'Voir les restrictions détaillées',
    },
    scoreOverview: {
      developmentScore: 'Score de développement',
      legacyScore: "Score d'existant",
      livabilityScore: "Score d'habitabilité",
      underExploitedScore: 'Score de sous-exploitation',
    },
    sidebar: {
      items: {
        amenities: 'Commodités',
        buildingDetails: 'Détails bâtiments',
        buildingPermits: 'Permis de construire',
        demographics: 'Démographie',
        electricity: 'Électricité',
        employment: 'Emploi',
        feasibilityStudy: 'Étude de faisabilité',
        geoAnalysis: 'Analyse géo',
        history: 'Historique',
        noiseAnalysis: 'Analyse du bruit',
        purchaseListings: 'Annonces achat',
        purchaseMarket: 'Marché achat',
        rentalListings: 'Annonces location',
        rentalMarket: 'Marché location',
        restrictions: 'Restrictions',
        summary: 'Résumé',
        sunlightStudy: 'Étude ensoleillement',
        taxes: 'Impôts',
        transactions: 'Transactions',
        transportAccess: 'Transport & Accès',
        zoning: 'Zone',
        zoningRules: 'Règles de zone',
      },
      sections: {
        development: 'Développement',
        environment: 'Environnement',
        market: 'Marché',
        overview: 'Aperçu',
        socialEconomic: 'Social & Économique',
      },
    },
    states: {
      empty: {
        description: 'Aucune information de terrain disponible pour cette propriété.',
        title: 'Aucune donnée de terrain',
      },
      error: {
        retry: 'Réessayer',
        title: 'Erreur de chargement',
      },
      errorLoadingData: 'Erreur de chargement des données',
      loading: 'Chargement des données du terrain...',
      noDataAvailable: 'Aucune donnée de terrain disponible',
      notAvailable: 'N/D',
      retry: 'Réessayer',
    },
    summaryTab: {
      loading: 'Chargement des données...',
      noData: 'Aucune donnée disponible',
      subtitle: 'Aperçu et informations clés pour {{address}}',
      title: 'Résumé de la propriété',
      unknownLocation: 'Emplacement inconnu',
    },
    tagsPanel: {
      add: 'Ajouter',
      adding: 'Ajout en cours...',
      addNewTag: 'Ajouter un nouveau tag',
      buildingTags: 'Tags du bâtiment',
      closePanel: 'Fermer le panneau',
      currentTags: 'Tags actuels ({{count}})',
      emptyStateHint: 'Ajoutez des tags ci-dessus pour organiser et catégoriser cette propriété',
      enterTagName: 'Entrez le nom du tag...',
      groupLandTags: 'Tags du groupe de terrains',
      landTags: 'Tags du terrain',
      loadingTags: 'Chargement des tags...',
      manageTags: 'Gérer les tags',
      noTagsAssigned: 'Aucun tag assigné',
      title: 'Tags',
    },
    transactionsTab: {
      filters: {
        additionalFilters: 'Filtres supplémentaires',
        advancedFilters: 'Filtres avancés',
        allLocations: 'Tous les emplacements',
        clearAll: 'Tout effacer',
        hideFilters: 'Masquer les filtres',
        landArea: 'Surface du terrain (m²)',
        legalTypeBF: 'B-F',
        legalTypeCOP: 'COP',
        legalTypeDDP: 'DDP',
        legalTypeDP: 'DP',
        legalTypeOther: 'Autre',
        legalTypePPE: 'PPE',
        numberOfBuyers: "Nombre d'acheteurs",
        numberOfSellers: 'Nombre de vendeurs',
        others: 'Autres',
        participantAssociation: 'Association',
        participantCompany: 'Société',
        participantCooperative: 'Coopérative',
        participantFoundation: 'Fondation',
        participantIndividual: 'Particulier',
        participantOther: 'Autre',
        participantPublicEntity: 'Entité publique',
        participants: 'Participants',
        participantType: 'Type de participant',
        propertyLegalType: 'Type juridique de la propriété',
        radius: 'Rayon',
        showFilters: 'Afficher les filtres',
        stepTransactionPrice: 'Prix de transaction par étape (CHF)',
        transactionDate: 'Date de transaction',
        transactionType: 'Type de transaction',
        typeAreaPrice: 'Type, Surface & Prix',
        unitApartment: 'Appartement',
        unitCommercial: 'Commercial',
        unitHouse: 'Maison',
        unitLand: 'Terrain',
        unitOther: 'Autre',
        unitParking: 'Parking',
        unitType: "Type d'unité",
      },
      subtitle: "Explorez l'historique des transactions autour de la parcelle et enregistrez celles qui vous intéressent pour cette analyse.",
      tabs: {
        aroundPlot: 'Transactions autour de la parcelle',
        saved: 'Transactions enregistrées',
      },
      title: 'Transactions',
    },
    units: {
      percent: '%',
      score: '/100',
      squareMeters: 'm²',
    },
    zoneAssignment: {
      buildable: 'Constructible',
      nonBuildable: 'Non constructible',
      title: 'Affectation de zone',
      unknownZone: 'Zone inconnue',
    },
    zones: {
      adopted: 'Adopté',
      buildingArea: 'Surface constructible',
      cos: 'COS',
      coverageArea: 'Couverture',
      cus: 'CUS',
      defaultName: 'Zone {{number}}',
      ibus: 'IBUS',
      planTypeAdoption: 'Type de plan',
      title: 'Zone',
      zoneName: 'Nom de zone',
    },
  },
  listings: {
    aiFilter: {
      description: 'Décrivez la propriété que vous recherchez, et je vous aiderai à la trouver.',
      errors: {
        processingFailed: 'Une erreur est survenue lors du traitement de votre demande',
      },
      examplePrompts: {
        '0': 'Montrez-moi des appartements à louer à Zurich sous 3000 CHF',
        '1': 'Trouvez des maisons à vendre à Genève avec 4+ pièces',
      },
      placeholder: "p.ex., 'Appartement 2 chambres à louer à Lausanne sous 2500 CHF'",
      processing: 'Traitement...',
      recentSearches: 'Recherches récentes',
      search: 'Rechercher',
      title: 'Assistant de filtre annonces',
    },
    common: {
      active: 'Actif',
      addressNotAvailable: 'Adresse non disponible',
      allLocations: 'Tous les emplacements',
      built: 'construit',
      days: 'jours',
      distance: 'Distance',
      expired: 'Expiré',
      km: 'km',
      m: 'm',
      na: 'N/D',
      perSqm: '/ m²',
      priceOnRequest: 'Prix sur demande',
      propertyImage: 'Image de la propriété',
      propertyListing: 'Annonce immobilière',
      radius: 'Rayon',
      rooms: 'pièces',
      sqm: 'm²',
      to: 'à',
      unknown: 'Inconnu',
    },
    dates: {
      daysAgo: 'Il y a {{count}} jours',
      listed: 'Publié',
      monthsAgo: 'Il y a {{count}} mois',
      today: "Aujourd'hui",
      weeksAgo: 'Il y a {{count}} semaines',
      yearsAgo: 'Il y a {{count}} ans',
      yesterday: 'Hier',
    },
    detail: {
      agents: {
        unknownAgent: 'Agent inconnu',
      },
      buttons: {
        addToFavorites: 'Ajouter aux favoris',
        estimate: 'Estimer',
        findAddress: "Trouver l'adresse",
        findExactAddress: "Trouver l'adresse exacte",
        goToAnalysis: "Aller à l'analyse",
        goToEstimate: "Aller à l'estimation",
        goToExplore: 'Aller à Explorer',
        viewInLandAnalysis: "Voir dans l'analyse du terrain",
        viewOnExplore: 'Voir sur Explorer',
      },
      error: 'Erreur',
      fallbacks: {
        addressNotSpecified: 'Adresse non spécifiée',
        day: 'jour',
        days: 'jours',
        house: 'Maison',
        immediately: 'Immédiatement',
        listedOnPlatform: 'Publié sur cette plateforme',
        noAdditionalImages: 'Aucune image supplémentaire disponible',
        noDescriptionAvailable: 'Aucune description disponible',
        property: 'Bien',
        propertyId: 'ID du bien',
        propertyImage: 'Image du bien',
      },
      labels: {
        agency: 'Agence',
        available: 'Disponible',
        bathrooms: 'Salles de bain',
        buildingYear: 'Année de construction',
        category: 'Catégorie',
        constructionYear: 'Année de construction',
        floor: 'Étage',
        id: 'ID',
        landSurface: 'Surface du terrain',
        listedOn: 'Publié sur',
        mandateType: 'Type de mandat',
        newConstruction: 'Construction neuve',
        onlineFor: 'En ligne depuis',
        published: 'Publié',
        status: 'Statut',
        type: 'Type',
      },
      loading: "Chargement des détails de l'annonce...",
      metrics: {
        bathrooms: 'Salles de bain',
        buildYear: 'Année de construction',
        landArea: 'Surface terrain',
        livingArea: 'Surface habitable',
        price: 'Prix',
        rooms: 'Pièces',
      },
      sections: {
        description: 'Description',
        features: 'Caractéristiques et équipements',
        listedOnPortals: 'Publié sur les portails',
        listingInformation: "Informations de l'annonce",
        propertyAgents: 'Agents immobiliers',
        propertyDetails: 'Détails du bien',
        propertyGallery: 'Galerie du bien',
      },
      status: {
        active: 'Actif',
        expired: 'Expiré',
      },
      vendorTypes: {
        private: 'Privé',
        professional: 'Professionnel',
        unknown: 'Inconnu',
      },
    },
    detailPanel: {
      columns: {
        change: 'Variation',
        date: 'Date',
        price: 'Prix',
        pricePerSqm: 'Prix/m²',
      },
      empty: {
        noDescription: 'Aucune description disponible',
        noFeatures: 'Aucune caractéristique listée',
        noPriceHistory: 'Aucun historique de prix disponible',
      },
      labels: {
        address: 'Adresse',
        availability: 'Disponibilité',
        daysOnMarket: 'Jours sur le marché',
        description: 'Description',
        features: 'Caractéristiques',
        floor: 'Étage',
        listingDate: 'Date de publication',
        livingArea: 'Surface habitable',
        price: 'Prix',
        pricePerSqm: 'Prix au m²',
        propertyDetails: 'Détails du bien',
        propertyListing: 'Annonce immobilière',
        propertyType: 'Type de bien',
        rooms: 'Pièces',
        status: 'Statut',
        usableArea: 'Surface utile',
        viewOriginal: "Voir l'annonce originale",
        yearBuilt: 'Année de construction',
      },
      tabs: {
        details: 'Détails',
        location: 'Emplacement',
        overview: 'Aperçu',
        priceHistory: 'Historique des prix',
      },
    },
    distanceOptions: {
      '1km': '1km',
      '2km': '2km',
      '500m': '500m',
      '5km': '5km',
    },
    filter: {
      activeFilter: 'filtre actif',
      activeFilters: 'filtres actifs',
      additionalFilters: 'Filtres supplémentaires',
      advancedFilters: 'Filtres avancés',
      allLocations: 'Tous les emplacements',
      clearAll: 'Tout effacer',
      customPriceRange: 'Fourchette de prix personnalisée (CHF)',
      floorLevel: 'Étage',
      from: 'De',
      hideFilters: 'Masquer les filtres',
      listingDate: 'Date de publication',
      livingArea: 'Surface habitable (m²)',
      max: 'Max',
      min: 'Min',
      priceSizeRooms: 'Prix, Surface & Pièces',
      propertyType: 'Type de bien',
      propertyTypes: {
        apartment: 'Appartement',
        commercial: 'Commercial',
        garageParking: 'Garage/Parking',
        house: 'Maison',
        other: 'Autre',
        plot: 'Terrain',
        residential: 'Résidentiel',
      },
      radius: 'Rayon',
      rooms: 'Pièces',
      roomsLabel: 'pièces',
      showFilters: 'Afficher les filtres',
      to: 'À',
      yearBuilt: 'Année de construction',
    },
    filters: {
      actions: {
        activeFilters: 'Filtres actifs',
        apply: 'Appliquer',
        clearAll: 'Tout effacer',
        clearAllFilters: 'Effacer tous les filtres',
        closeFilters: 'Fermer les filtres',
        lessFilters: 'Moins de filtres',
        loadSavedFilters: 'Charger les filtres enregistrés',
        moreFilters: 'Plus de filtres',
        openFilters: 'Ouvrir les filtres',
        saveCurrentFilters: 'Enregistrer les filtres actuels',
      },
      ai: {
        textSearchError: 'Échec du traitement de votre demande. Veuillez réessayer.',
        voiceSearchError: 'Échec du traitement de votre demande vocale. Veuillez réessayer.',
      },
      fields: {
        area: 'Surface',
        floor: 'Étage',
        from: 'Du',
        listingDate: "Date d'annonce",
        listingDuration: "Durée de l'annonce",
        mandateType: 'Type de mandat',
        max: 'Max',
        min: 'Min',
        price: 'Prix',
        pricePerSqm: 'Prix au m²',
        status: 'Statut',
        to: 'Au',
        typeOfProperty: 'Type de bien',
        vendorType: 'Type de vendeur',
        yearOfConstruction: 'Année de construction',
      },
      loading: 'Chargement des filtres...',
      mandateTypes: {
        exclusive: 'Exclusif',
        simple: 'Simple',
        unknown: 'Inconnu',
      },
      placeholders: {
        enterValue: 'Entrez une valeur',
        from: 'Du',
        max: 'Max',
        min: 'Min',
        searchLocation: 'Rechercher une localisation...',
        selectOption: 'Sélectionnez une option',
        to: 'Au',
      },
      propertyTypes: {
        apartment: 'Appartement',
        commercial: 'Commercial',
        garageParking: 'Garage/Parking',
        house: 'Maison',
        other: 'Autre',
        plot: 'Terrain',
      },
      quickFilters: {
        listed: 'Publié',
        propertyCategory: 'Catégorie de bien',
      },
      saved: {
        appliedFilter: 'Filtre appliqué : {{name}}',
        failedToSave: "Échec de l'enregistrement du filtre",
        savedFilter: 'Filtre enregistré : {{name}}',
        savedOn: 'Enregistré le {{date}}',
      },
      sections: {
        brokerInfo: 'Infos courtier',
        buildingYear: 'Année de construction',
        dateRange: 'Période',
        floor: 'Étage',
        landArea: 'Surface terrain',
        livingArea: 'Surface habitable',
        location: 'Localisation',
        locationDate: 'Localisation et date',
        mandateType: 'Type de mandat',
        portals: 'Portails',
        price: 'Prix',
        priceRange: 'Fourchette de prix',
        propertyCharacteristics: 'Caractéristiques du bien',
        propertyType: 'Type de bien',
        rooms: 'Pièces',
        status: 'Statut',
        vendorType: 'Type de vendeur',
      },
      title: "Filtres d'annonces",
      validation: {
        invalidRange: 'Plage invalide',
        requiredField: 'Champ requis',
      },
      vendorTypes: {
        private: 'Particulier',
        professional: 'Professionnel',
        unknown: 'Inconnu',
      },
    },
    list: {
      columns: {
        area: 'Surface',
        date: 'Date',
        duration: 'Durée',
        image: 'Image',
        location: 'Localisation',
        mandateType: 'Type de mandat',
        portals: 'Portails',
        price: 'Prix',
        property: 'Bien',
        rooms: 'Pièces',
        status: 'Statut',
        vendor: 'Vendeur',
        year: 'Année',
      },
      duration: {
        day: 'jour',
        days: 'jours',
      },
      export: {
        filename: 'annonces_export',
        toExcel: 'Exporter en Excel',
        toPdf: 'Exporter en PDF',
      },
      fallbacks: {
        dash: '—',
        noData: 'Pas de données',
        noImage: "Pas d'image",
        unknown: 'Inconnu',
      },
      mandate: {
        exclusive: 'Exclusif',
        shared: 'Partagé',
        unknown: 'Inconnu',
      },
      status: {
        active: 'Actif',
        expired: 'Expiré',
      },
      vendor: {
        individual: 'Particulier',
        pro: 'Professionnel',
        unknown: 'Inconnu',
      },
    },
    map: {
      errorLoadingMapData: 'Erreur lors du chargement des données de la carte',
      loading: 'Chargement...',
      loadingMapData: 'Chargement des données de la carte...',
      tooltip: {
        area: 'Surface',
        forRent: 'À louer',
        forSale: 'À vendre',
        listingAlt: 'Annonce',
        location: 'Localisation',
        noImageAvailable: 'Aucune image disponible',
        priceOnRequest: 'Prix sur demande',
        propertyId: 'ID du bien',
        rooms: 'pièces',
      },
    },
    priceRanges: {
      '1MTo2M': '1M - 2M',
      '500kTo1M': '500k - 1M',
      over2M: '> 2M',
      under500k: '< 500k',
    },
    print: {
      about: {
        realTimeData: 'Ce rapport fournit des analyses de marché en temps réel basées sur des annonces agrégées des principaux portails immobiliers suisses.',
      },
      contact: {
        email: 'Email',
        forQuestions: 'Pour toute question concernant ce rapport, veuillez contacter:',
        popetyContact: 'Popety.io | info@popety.io | www.popety.io',
        title: 'Informations de contact',
        website: 'Site web',
        yourContact: 'Votre contact',
      },
      cover: {
        aboutThisReport: 'À propos de ce rapport',
        analyticsFooter: "Plateforme d'analyse du marché immobilier",
        appliedFilters: 'Filtres appliqués',
        createdOnPopety: "Créé sur Popety.io - Plateforme d'analyse du marché immobilier",
        dealType: 'Type de transaction',
        generated: 'Généré',
        generatedOn: 'Généré le',
        listingDate: "Date de l'annonce",
        listingsList: 'Liste des annonces',
        listingsSelectedOn: 'Annonces sélectionnées le',
        location: 'Localisation',
        priceRange: 'Fourchette de prix',
        propertyType: 'Type de bien',
        realEstateMarketReport: 'Rapport du marché immobilier',
        rentalListingsReport: 'Rapport statistique des annonces de location',
        rentals: 'Locations',
        sales: 'Ventes',
        salesListingsReport: 'Rapport statistique des annonces de vente',
        switzerland: 'Suisse',
        timePeriod: 'Période',
      },
      dataSource: {
        collectionPeriod: 'Période de collecte des données: Continue, avec des mises à jour régulières',
        description: 'Ce rapport agrège les données des sources suivantes:',
        includesOutlierFiltering: "Sources de données: Annonces immobilières officielles et transactions de marché. L'analyse inclut un filtrage des valeurs aberrantes pour plus de précision.",
        lastRefresh: 'Dernière mise à jour des données: En temps réel au moment de la génération du rapport',
        popetyAnalytics: "Plateforme d'analyse propriétaire Popety.io",
        publicListings: 'Annonces immobilières publiques et données de marché',
        statisticalAnalysis: 'Analyse statistique effectuée par les algorithmes de Popety.io',
        swissPortals: 'Principaux portails immobiliers suisses dont Homegate, ImmoScout24, et autres',
        title: 'Sources de données',
      },
      details: {
        built: 'Construit',
        listingOf: 'Annonce {{current}} sur {{total}}',
        noImageAvailable: 'Aucune image disponible',
        propertyListing: 'Annonce immobilière',
        unknownAddress: 'Adresse inconnue',
      },
      disclaimer: {
        accuracyOfInformation: {
          content: "Les informations contenues dans ce rapport sont fournies à titre d'information générale uniquement. Bien que nous nous efforcions de maintenir les informations à jour et exactes, nous ne faisons aucune déclaration ni garantie d'aucune sorte, expresse ou implicite, concernant l'exhaustivité, l'exactitude, la fiabilité, l'adéquation ou la disponibilité du rapport ou des informations, produits, services ou graphiques connexes contenus dans le rapport à quelque fin que ce soit.",
          title: 'Exactitude des informations',
        },
        copyrightNotice: {
          content: "© {{year}} Popety.io. Tous droits réservés. Ce rapport et son contenu sont protégés par le droit d'auteur et d'autres droits de propriété intellectuelle. La reproduction, la distribution ou l'utilisation non autorisée de ce rapport est strictement interdite.",
          title: "Avis de droit d'auteur",
        },
        dataPrivacy: {
          content: 'Nous respectons votre vie privée et nous nous engageons à protéger vos données personnelles. Ce rapport peut contenir des données de marché agrégées et anonymisées collectées à partir de sources accessibles au public.',
          title: 'Confidentialité des données',
        },
        noInvestmentAdvice: {
          content: "Ce rapport ne constitue pas un conseil en investissement, juridique, fiscal ou autre conseil professionnel. Vous ne devez pas vous fier à ce rapport comme seule base pour prendre des décisions d'investissement. Consultez toujours des professionnels qualifiés avant de prendre des décisions d'investissement.",
          title: 'Pas de conseil en investissement',
        },
        title: 'Avertissement et mentions légales',
      },
      format: {
        details: 'Détails',
        fullPage: 'Une page par annonce',
        summary: 'Résumé',
        tableView: 'Vue tableau, plusieurs par page',
      },
      modal: {
        cancel: 'Annuler',
        close: 'Fermer',
        downloadPdf: 'Télécharger le PDF',
        exportListingsToPdf: 'Exporter les annonces en PDF',
        failedToGeneratePdf: 'Échec de la génération du PDF. Veuillez réessayer.',
        fullMarketReport: 'Rapport de marché complet',
        generatePdf: 'Générer le PDF',
        generatingPdf: 'Génération du PDF...',
        listing: 'annonce',
        listings: 'annonces',
        pageOf: 'Page {{current}} sur {{total}}',
        pagesTotal: 'pages au total',
        preview: 'Aperçu',
        previewAndDownload: 'Prévisualiser et télécharger un rapport de marché complet avec toutes les sections',
        priceEvolution: 'Évolution des prix',
        rentEvolution: 'Évolution des loyers',
        resetZoom: 'Réinitialiser le zoom',
        zoomIn: 'Zoom avant',
        zoomOut: 'Zoom arrière',
      },
      progress: {
        addingContent: 'Ajout du contenu',
        addingPageNumbers: 'Ajout des numéros de page et touches finales',
        addingTitleAndBranding: "Ajout du titre, des informations de l'entreprise et du branding",
        convertingCharts: 'Conversion des graphiques en images haute qualité',
        creatingCoverPage: 'Création de la page de couverture',
        exportingCharts: 'Exportation des graphiques',
        finalizingPdf: 'Finalisation du PDF',
        generatingPdfReport: 'Génération du rapport PDF',
        generatingSections: 'Génération des sections, analyses et données',
        initializingPdf: 'Initialisation du PDF',
        pleaseWait: 'Veuillez patienter pendant que nous créons votre analyse de marché complète',
        settingUpDocument: 'Configuration de la structure et des styles du document',
      },
      sections: {
        tableOfContents: 'Table des matières',
      },
      summary: {
        area: '{{value}} m²',
        builtYear: 'Construit en {{year}}',
        id: 'ID',
        pageOfListings: 'Page {{page}} sur {{total}} • Annonces {{start}}-{{end}}',
        rooms: '{{count}} pièces',
        type: 'Type',
      },
    },
    propertyTypes: {
      apartment: 'Appartement',
      commercial: 'Commercial',
      house: 'Maison',
      parking: 'Parking',
      plot: 'Terrain',
    },
    roomOptions: {
      '1room': '1 pièce',
      '2rooms': '2 pièces',
      '3rooms': '3 pièces',
      '4rooms': '4 pièces',
      '5plusRooms': '5+ pièces',
    },
    saved: {
      addressNotAvailable: 'Adresse non disponible',
      allSaved: 'Tous sauvegardés',
      averagePrice: 'Prix moyen',
      avgLivingArea: 'Surface habitable moyenne',
      avgPricePerSqm: 'Prix moyen/m²',
      avgRooms: 'Pièces moyennes',
      empty: 'Aucune annonce sauvegardée',
      emptyDescription: 'Sauvegardez des annonces depuis l\'onglet "Annonces autour de la parcelle" pour les comparer plus tard',
      emptyTitle: 'Aucune annonce sauvegardée',
      listings: 'Annonces',
      livingArea: 'Surface habitable',
      loading: 'Chargement des annonces sauvegardées...',
      perListing: 'Par annonce',
      perListing2: 'Par annonce',
      perSqm: '/m²',
      priceOnRequest: 'Prix sur demande',
      priceRangeLabel: 'Fourchette de prix',
      propertyImage: 'Image de la propriété',
      propertyListing: 'Annonce immobilière',
      removeFromSaved: 'Retirer des sauvegardés',
      saveListing: "Sauvegarder l'annonce",
      sqm: 'm²',
      to: 'à',
      totalSaved: 'Total sauvegardé',
      totalValue: 'Valeur totale',
    },
    sections: {
      purchaseSubtitleBuilding: 'Voir les annonces de vente autour de ce bâtiment',
      purchaseSubtitleLand: 'Voir les annonces de vente autour de ce terrain',
      purchaseTitle: 'Annonces de vente',
      rentSubtitleBuilding: 'Voir les annonces de location autour de ce bâtiment',
      rentSubtitleLand: 'Voir les annonces de location autour de ce terrain',
      rentTitle: 'Annonces de location',
    },
    stats: {
      actions: {
        showLess: 'Afficher moins',
        showMore: 'Afficher plus',
      },
      charts: {
        byPropertyType: 'par type de bien',
        distributionByQuantiles: 'Distribution par quantiles',
        distributionByRooms: 'Distribution par pièces',
        geographicVolumeDistribution: 'Distribution géographique des volumes',
        portalMarketShareEvolution: 'Évolution des parts de marché par portail',
        pricePerSquareMeter: 'Prix au mètre carré',
        rankingsByPrice: 'Classement par prix',
        rankingsByRent: 'Classement par loyer',
        rentPerSquareMeter: 'Loyer au mètre carré',
      },
      dataSource: {
        description: 'Données agrégées des principaux portails immobiliers suisses',
        disclaimer: 'Avertissement',
        title: 'Sources de données',
      },
      defaults: {
        allProperties: 'Tous les biens',
        allSwitzerland: 'Toute la Suisse',
      },
      descriptions: {
        agencyAnalysis: 'Évaluez la performance et les parts de marché des différentes agences immobilières pour identifier les leaders du marché.',
        agencyAnalysisRental: 'Évaluez la performance et les parts de marché des différentes agences de location.',
        cityAnalysis: 'Analyse des modèles de densité de prix dans les grandes villes pour comprendre les variations du marché et identifier les opportunités.',
        cityAnalysisRental: 'Analyse des modèles de densité des loyers dans les grandes villes pour comprendre les variations du marché locatif.',
        newVsResale: 'Comparez les tendances de prix et la dynamique du marché entre les propriétés neuves et les reventes.',
        newVsResaleRental: 'Comparez les taux de location entre les propriétés neuves et les propriétés plus anciennes.',
        portalAnalysis: "Évaluez l'efficacité et la portée des différents portails d'annonces immobilières pour le marketing immobilier.",
        portalAnalysisRental: "Évaluez l'efficacité des différents portails de location pour le marketing immobilier.",
        priceEvolution: "Suivez l'évolution des prix de l'immobilier dans le temps pour identifier les tendances et les modèles du marché immobilier.",
        priceGeography: "Visualisez les prix de l'immobilier dans différentes zones géographiques pour identifier les régions à haute valeur et abordables.",
        priceM2Evolution: "Analysez l'évolution des prix au mètre carré pour comprendre les tendances de valeur selon les différentes tailles de biens.",
        priceM2PerRoom: 'Explorez comment le prix au mètre carré varie avec le nombre de pièces pour identifier les configurations de biens les plus efficaces.',
        pricePerRoom: 'Analysez comment les prix des biens varient en fonction du nombre de pièces pour comprendre les modèles de prix selon la taille.',
        rentEvolution: 'Suivez les tendances des prix de location dans le temps pour comprendre la dynamique du marché locatif.',
        rentGeography: 'Visualisez les prix de location dans différentes zones pour identifier les emplacements premium et abordables.',
        rentM2Evolution: 'Suivez les prix de location au mètre carré pour analyser les tendances de valeur sur le marché locatif.',
        rentM2PerRoom: 'Explorez comment le loyer au mètre carré varie avec le nombre de pièces pour identifier les configurations locatives les plus efficaces.',
      },
      footer: {
        dataSources: 'Homegate, ImmoScout24, Newhome, Acheter-Louer',
        dataSourcesLabel: 'Sources des données:',
        description: 'Ce rapport statistique est généré à partir de données en temps réel collectées sur les portails immobiliers suisses. Les données sont continuellement mises à jour et analysées pour fournir des informations précises sur le marché.',
        title: 'À propos de ce rapport',
      },
      interface: {
        chartPlaceholder: 'Espace réservé au graphique pour',
        downloadFullReport: 'Télécharger le rapport complet',
        hideSection: 'Masquer la section',
        showSection: 'Afficher la section',
        sources: 'Sources:',
        sourcesList: 'Portails immobiliers suisses • Popety.io',
      },
      kpi: {
        keyInsights: 'Informations clés',
        keyMetrics: 'Indicateurs clés',
        oneYearGrowth: 'Croissance sur 1 an',
      },
      periods: {
        allAvailable: 'Toutes les données disponibles',
        fullHistory: 'Historique complet',
        last12Months: '12 derniers mois',
        since2022: 'Depuis 2022',
        sinceJanuary2022: 'Depuis janvier 2022',
      },
      sections: {
        agencyAnalysis: 'Analyse des agences',
        cityAnalysis: 'Analyse par ville',
        marketShare: 'Parts de marché',
        newVsResale: 'Construction neuve vs revente',
        portalAnalysis: 'Analyse des portails',
        priceDistribution: 'Distribution des prix',
        priceEvolution: 'Évolution des prix',
        priceGeography: 'Géographie des prix',
        priceM2Evolution: 'Évolution du prix/m²',
        priceM2PerRoom: 'Prix/m² par pièce',
        pricePerRoom: 'Prix par pièce',
        rentDistribution: 'Distribution des loyers',
        rentEvolution: 'Évolution des loyers',
        rentGeography: 'Géographie des loyers',
        rentM2Evolution: 'Évolution du loyer/m²',
        rentM2PerRoom: 'Loyer/m² par pièce',
      },
      table: {
        city: 'Ville',
        listings: 'Annonces',
        medianChfM2: 'Médiane CHF/m²',
        percentile25: '25ème percentile',
        percentile75: '75ème percentile',
        stdDeviation: 'Écart-type',
      },
    },
    statusOptions: {
      all: 'Tous',
    },
    tabs: {
      aroundPlot: 'Annonces autour de la parcelle',
      saved: 'Annonces sauvegardées',
    },
    views: {
      list: 'Liste',
      map: 'Carte',
      stats: 'Statistiques',
    },
  },
  market: {
    common: {
      currency: {
        chf: 'CHF',
        chfPerM2: 'CHF/m²',
      },
      errors: {
        loadingData: 'Erreur lors du chargement des données. Veuillez réessayer plus tard.',
      },
      filters: {
        advancedFilters: 'Filtres avancés',
        city: 'Commune',
        district: 'District',
        hideFilters: 'Masquer les filtres',
        location: 'Localisation',
        postalCode: 'Code Postal',
        propertyType: 'Type de bien',
      },
      month: 'mois',
      na: 'N/D',
      placeholder: {
        chartPlaceholder: 'Espace réservé pour le graphique {{section}}',
      },
      propertyTypes: {
        apartment: 'Appartement',
        commercial: 'Commercial',
        house: 'Maison',
        houseApartment: 'Maison & Apt',
        plot: 'Terrain',
      },
      year: 'an',
    },
    distribution: {
      charts: {
        area: 'Distribution des surfaces',
        constructionYear: 'Année de construction',
        price: 'Distribution des prix',
        priceM2: 'Distribution du prix/m²',
        rent: 'Distribution des loyers',
        rentM2: 'Distribution du loyer/m²',
        rooms: 'Distribution des pièces',
        timeOnMarket: 'Durée sur le marché',
      },
      empty: {
        description: "Il n'y a pas de données de distribution disponibles pour la sélection actuelle.",
        title: 'Aucune donnée disponible',
      },
      insights: {
        areaRange: 'Aperçu des surfaces',
        areaRangeDesc: 'La surface moyenne est de {{avg}} m² avec une médiane de {{median}} m².',
        mostCommonRooms: 'Configuration la plus courante',
        mostCommonRoomsDesc: 'Les biens de {{rooms}} pièces représentent {{percentage}}% des annonces dans cette zone.',
        priceRange: 'Aperçu des prix',
        priceRangeDesc: 'Le prix moyen est de {{avg}} CHF avec une médiane de {{median}} CHF.',
        rentRange: 'Aperçu des loyers',
      },
      kpis: {
        medianArea: 'Surface médiane',
        medianPrice: 'Prix médian',
        medianRent: 'Loyer médian',
        medianRooms: 'Pièces médiane',
        totalListings: 'Total annonces',
      },
      states: {
        loading: 'Chargement des données de distribution...',
      },
      stats: {
        avg: 'Moy',
        median: 'Médiane',
        total: 'Total',
      },
      units: {
        days: 'jours',
        rooms: 'pièces',
        year: 'année',
      },
    },
    distributionView: {
      combined: 'Combiné',
      listings: 'annonces',
      perMonth: '/mois',
      perYear: '/an',
      separate: 'Par type de bien',
    },
    purchase: {
      header: {
        subtitle: 'Analysez les tendances et les modèles du marché pour les achats immobiliers dans la zone sélectionnée',
        title: "Analyse du marché de l'achat",
      },
      sections: {
        distribution: {
          description: 'Explorez la composition du marché selon les pièces, les gammes de prix, les surfaces, les années de construction et la durée sur le marché pour comprendre les caractéristiques du marché local.',
          title: 'Distribution du marché',
        },
        newVsResale: {
          description: 'Comparez les tendances de prix et la dynamique du marché entre les biens neufs et les biens de revente.',
          title: 'Neuf vs revente',
        },
        priceEvolution: {
          description: "Suivez l'évolution des prix immobiliers au fil du temps pour identifier les tendances et les modèles du marché immobilier.",
          title: 'Évolution des prix',
        },
        priceM2Evolution: {
          description: "Analysez l'évolution des prix immobiliers au mètre carré pour comprendre les tendances de valeur selon les différentes tailles de biens.",
          title: 'Évolution du prix/m²',
        },
        priceM2PerRoom: {
          description: 'Explorez comment le prix au mètre carré varie avec le nombre de pièces pour identifier les configurations immobilières les plus efficientes.',
          title: 'Prix/m² par pièce',
        },
        pricePerRoom: {
          description: 'Analysez comment les prix immobiliers varient en fonction du nombre de pièces pour comprendre les modèles de tarification selon la taille du bien.',
          title: 'Prix par pièce',
        },
      },
    },
    readOnly: {
      purchaseDescription: "L'analyse du marché de l'achat avec l'évolution des prix, les comparaisons de biens et les tendances du marché est disponible dans l'application complète. Cette vue publique affiche un résumé de l'estimation du bien.",
      rentalDescription: "L'analyse du marché locatif avec l'évolution des prix, les comparaisons de biens et les tendances du marché est disponible dans l'application complète. Cette vue publique affiche un résumé de l'estimation du bien.",
      title: 'Analyse de marché',
    },
    rental: {
      header: {
        subtitle: 'Analysez les tendances et les modèles du marché locatif pour les biens dans la zone sélectionnée',
        title: 'Analyse du marché locatif',
      },
      sections: {
        availability: {
          description: "Surveillez la disponibilité du marché locatif, les taux de vacance et les modèles de rotation pour comprendre la dynamique de l'offre et de la demande.",
          title: 'Disponibilité et rotation des locations',
        },
        distribution: {
          description: 'Explorez la composition du marché locatif selon les pièces, les gammes de loyers, les surfaces, les années de construction et la durée sur le marché pour comprendre les caractéristiques du marché local.',
          title: 'Distribution du marché',
        },
        priceEvolution: {
          description: "Suivez l'évolution des loyers au fil du temps pour identifier les tendances et les modèles du marché locatif.",
          title: 'Évolution des loyers',
        },
        priceM2Evolution: {
          description: "Analysez l'évolution des loyers au mètre carré pour comprendre les tendances de valeur selon les différentes tailles de biens.",
          title: 'Évolution du loyer/m²',
        },
        priceM2PerRoom: {
          description: 'Explorez comment le loyer au mètre carré varie avec le nombre de pièces pour identifier les configurations locatives les plus efficientes.',
          title: 'Loyer/m² par pièce',
        },
        pricePerRoom: {
          description: 'Analysez comment les loyers varient en fonction du nombre de pièces pour comprendre les modèles de tarification selon la taille du bien.',
          title: 'Loyer par pièce',
        },
      },
      summary: {
        marketVolume: {
          subtitle: 'Annonces actives (12 mois)',
          title: 'Volume du marché',
        },
        medianRent: {
          subtitle: 'Par {{period}}',
          title: 'Loyer médian',
        },
        medianRentM2: {
          subtitle: 'Par {{period}}',
          title: 'Loyer médian/m²',
        },
      },
    },
    shared: {
      average: 'Moyenne',
      avgPrice: 'Prix moyen',
      keyInsights: 'Informations clés',
      listings: 'annonces',
      marketShare: 'Part de marché',
      median: 'Médiane',
      noData: 'Aucune donnée disponible',
      totalListings: 'Total annonces',
    },
    summary: {
      marketVolume: {
        subtitle: 'Annonces actives (12 mois)',
        title: 'Volume du marché',
      },
      medianPrice: {
        subtitle: 'Tous types de biens',
        title: 'Prix médian',
      },
      medianPriceM2: {
        subtitle: 'Tous types de biens',
        title: 'Prix médian/m²',
      },
    },
  },
  noise: {
    dataSources: {
      federal: "Office fédéral de l'environnement",
      geneva: 'État de Genève - DALE',
      sitg: 'SITG',
    },
    descriptions: {
      day: 'Niveau de bruit maximum pendant la journée',
      night: 'Niveau de bruit maximum la nuit',
    },
    periods: {
      day: 'JOUR',
      night: 'NUIT',
    },
    scale: {
      examples: {
        breathing: 'Respiration, bruissement de feuilles',
        conversation: 'Conversation normale',
        lawnmower: 'Tondeuse, ambulance',
        sleepInterference: 'Début des troubles du sommeil',
        traffic: 'Aspirateur, circulation urbaine',
        whispering: 'Chuchotement, réfrigérateur',
      },
      indicators: {
        day: 'Jour : {{value}} dB',
        night: 'Nuit : {{value}} dB',
      },
      levels: {
        harmful: 'Nocif',
        loud: 'Fort',
        moderate: 'Modéré',
        quiet: 'Calme',
        silent: 'Silencieux',
        veryLoud: 'Très fort',
      },
      ranges: {
        '0-20': '0-20 dB',
        '30-40': '30-40 dB',
        '40+': '40+ dB',
        '50-60': '50-60 dB',
        '70-80': '70-80 dB',
        '90-100': '90-100 dB',
      },
      title: "Référence de l'échelle des décibels",
    },
    sources: {
      railway: 'Chemin de fer',
      roadTraffic: 'Trafic routier',
    },
    states: {
      error: 'Erreur lors du chargement des données de bruit',
      errorDescription: "Impossible de charger les données d'analyse du bruit. Veuillez réessayer plus tard.",
      loading: 'Chargement des données de bruit...',
      noData: 'Aucune donnée de bruit disponible',
      noDataDescription: "Les données d'analyse du bruit ne sont pas disponibles pour cet emplacement.",
    },
    subtitle: 'Niveaux de bruit et de nuisances estimés à cette adresse',
    title: 'Analyse du bruit',
    unit: 'dB',
  },
  property: {
    analysis_types: {
      building_analysis: {
        description: 'Analyse complète du bâtiment incluant les unités, données de marché, commodités et facteurs environnementaux.',
        title: 'Analyse de bâtiment',
      },
      land_analysis: {
        description: 'Analyse détaillée du terrain avec règles de zone, potentiel de développement et perspectives de marché.',
        title: 'Analyse de terrain',
      },
      property_estimate: {
        description: 'Évaluation immobilière et estimation de marché avec analyse comparative.',
        title: 'Estimation de propriété',
      },
    },
    available_analysis: 'Analyse disponible',
    available_sections: 'Sections disponibles :',
    loading: 'Chargement des données de propriété...',
    loading_failed: 'Échec du chargement des données de propriété',
    title: 'Aperçu de la propriété',
    view_analysis: "Voir l'analyse",
  },
  restrictions: {
    affected: 'Concerné',
    affectedTypes: 'Types concernés',
    categories: {
      affecting: 'Restrictions affectant la parcelle',
      notAffecting: "Restrictions n'affectant pas la parcelle",
    },
    error: 'Échec du chargement des restrictions régionales',
    heritage: {
      buildingUnderProtection: 'Bâtiment sous protection patrimoniale',
      heritageProtection: 'Protection du patrimoine',
      protectedBuilding: 'Bâtiment protégé',
      protectedObjects: 'Objets protégés',
    },
    instances: {
      instanceNumber: 'Instance {{number}}',
      multiple: '{{count}} instances',
      single: '1 instance',
    },
    labels: {
      additionalInformation: 'Informations supplémentaires',
      additionalText: 'Texte complémentaire',
      affectedArea: 'Zone affectée',
      area: 'Surface',
      class: 'Classe',
      classification: 'Classification',
      content: 'Contenu',
      heritageDatabase: 'Base de données patrimoniale',
      integrationDate: "Date d'intégration",
      registryNumber: 'Numéro de registre',
      servitudeClass: 'Type de servitude',
      servitudeRegistryNumber: 'No registre servitude',
      status: 'Statut',
      type: 'Type',
      validity: 'Validité',
      viewDocumentation: 'Voir la documentation',
      viewInSipatrimoine: 'Voir dans SIPATRIMOINE',
    },
    legalNotice: {
      disclaimer: "Les informations ci-dessus ne sont pas exhaustives. Veuillez consulter le RDPPF et contacter le service d'urbanisme de la commune concernée pour plus d'informations.",
      rdppfOfficialReport: 'Rapport RDPPF officiel',
      sources: 'Sources :',
      sourcesList: 'SITG • RDPPF • SIPATRIMOINE • État de Genève - DALE',
    },
    loading: 'Chargement des données de restrictions...',
    messages: {
      coverage: 'Couverture : {{percent}}%',
      notApplicable: "Cette restriction ne s'applique pas à la parcelle actuelle.",
    },
    metrics: {
      affectingPlot: 'Affectant la parcelle',
      notAffecting: 'Sans effet',
      typesAnalyzed: 'Types analysés',
    },
    noData: 'Aucune donnée disponible',
    notAffected: 'Non concerné',
    notAvailable: 'Non disponible',
    restrictionTypes: {
      archaeologicalZone: 'Zone archéologique protégée',
      buildingRight: 'Droit distinct et permanent (DDP)',
      builtSitesProtectedZone: 'Zone de protection des sites construits',
      dangerZone: 'Zone de danger',
      forestLimitZone: 'Limite de forêt',
      forestZone: 'Zone forestière',
      heritageInventory: 'Inventaire du patrimoine',
      mandatoryPlanningZone: 'Zone de planification obligatoire (ZPO)',
      natureProtectionZone: 'Zone de protection de la nature',
      noiseSensibilityLevel: 'Degré de sensibilité au bruit',
      noiseSensitivityLevel: 'Degré de sensibilité au bruit',
      noMaxCosZone: 'Zone sans COS maximum',
      notYetDefinedSpecialZone: 'Zone spéciale non encore définie',
      otherZone: 'Autre zone',
      pollutedZone: 'Zone polluée',
      protectedBuilding: 'Bâtiment protégé',
      protectedObjects: 'Objets protégés',
      protectionZone: 'Zone de protection',
      reservedZone: 'Zone réservée',
      servitude: 'Servitude',
      underwaterProtectedZone: 'Zone de protection des eaux',
      watercourseLimitZone: "Limite de cours d'eau",
    },
    status: {
      active: 'Actif',
      clear: 'Libre',
      inactive: 'Inactif',
      protected: 'Protégé',
      valid: 'Valide',
    },
    subtitle: 'Analyse des restrictions légales et de développement pour {{address}}',
    title: 'Restrictions (RDPPF)',
  },
  sunlight: {
    common: {
      blueHour: 'Heure bleue',
      daylight: 'lumière du jour',
      goldenHour: "Heure d'ensoleillement",
      hours: 'heures',
      location: 'Emplacement',
      ofDaylight: 'de lumière du jour',
      solarNoon: 'Midi solaire',
    },
    dataSources: {
      label: 'Sources :',
      list: 'MétéoSuisse • Office fédéral de météorologie • Algorithmes de calcul solaire',
    },
    header: {
      subtitle: "Données d'exposition solaire complètes pour {{latitude}}°, {{longitude}}°",
      title: 'Étude ensoleillement',
    },
    legalNotice: {
      text: "Ces heures d'ensoleillement sont théoriques et basées sur des calculs astronomiques. L'exposition réelle au soleil peut varier considérablement en raison de la topographie locale, des bâtiments environnants, des arbres et autres obstructions. Nous recommandons de consulter la carte interactive pour une analyse détaillée des ombres et des conditions d'ensoleillement réelles tout au long de la journée et de l'année.",
    },
    overview: {
      annualAverage: {
        longestDay: 'Jour le plus long',
        shortestDay: 'Jour le plus court',
        subtitle: 'luminosité moyenne par jour',
        title: 'Moyenne annuelle',
        totalAnnual: 'Total annuel',
      },
      lightQuality: {
        evening: {
          title: 'Qualité de la lumière du soir',
        },
        morning: {
          title: 'Qualité de la lumière matinale',
        },
      },
      solarEnergy: {
        efficiencyPotential: "potentiel d'efficacité",
        optimalAngle: 'Angle optimal',
        peakHoursDay: 'Heures de pointe/jour',
        title: 'Énergie solaire',
        yearlyAverage: 'Moyenne annuelle',
      },
      todaySunlight: {
        title: 'Ensoleillement du jour',
      },
    },
    seasonal: {
      average: {
        title: 'Moyenne Annuelle',
      },
      duration: 'Durée',
      summer: {
        title: "Solstice d'Été",
      },
      sunrise: 'Lever',
      sunset: 'Coucher',
      title: 'Comparaison Saisonnière de la Luminosité',
      winter: {
        title: "Solstice d'Hiver",
      },
    },
    seasons: {
      analysis: {
        daylightDuration: 'Durée de la lumière',
        energyEfficiency: 'Efficacité énergétique',
        high: 'Élevé',
        limited: 'Limité',
        low: 'Bas',
        medium: 'Moyen',
        moderate: 'Modéré',
        optimal: 'Optimal',
        propertyImpact: 'Impact immobilier',
        sunriseTime: 'Heure du lever',
        sunsetTime: 'Heure du coucher',
        title: 'Analyse {{season}}',
        vsAnnualAverage: 'vs Moyenne annuelle',
      },
      autumn: {
        equinox: "Équinoxe d'automne",
        name: 'Automne',
      },
      spring: {
        equinox: 'Équinoxe de printemps',
        name: 'Printemps',
      },
      summer: {
        name: 'Été',
        solstice: "Solstice d'été",
      },
      winter: {
        name: 'Hiver',
        solstice: "Solstice d'hiver",
      },
    },
    section: {
      subtitle: 'Heures de soleil estimées et analyse de la luminosité naturelle pour cet emplacement',
      title: "Étude d'Ensoleillement",
    },
    solar: {
      energySavings: {
        annualProduction: {
          label: 'Production annuelle',
          tooltip: {
            calculation: "Heures de soleil de pointe × 5 kWc × 20 % d'efficacité des panneaux",
            importance: 'Essentiel pour calculer le retour sur investissement et déterminer la taille optimale du système pour vos besoins énergétiques',
            limitations: "Calcul théorique uniquement. Ne prend pas en compte l'espace disponible sur le toit, l'orientation des panneaux, l'ombrage des structures voisines, la couverture de neige, la dégradation des panneaux au fil du temps ou les pertes du système onduleur/batterie.",
            shortDescription: "Production annuelle estimée d'énergie par kWc de capacité solaire installée",
            source: "Calculs d'irradiance solaire basés sur des données astronomiques",
            title: 'Production annuelle',
          },
        },
        co2Reduction: {
          label: 'Réduction CO2',
          tooltip: {
            calculation: "Production annuelle × 0,4 kg CO2/kWh ÷ 1000 (basé sur les facteurs d'émission moyens du réseau suisse)",
            importance: "Quantifie le bénéfice environnemental de l'installation solaire pour les objectifs de réduction de l'empreinte carbone",
            limitations: "Basé sur les émissions moyennes du réseau suisse. Les économies réelles de CO2 dépendent de votre source d'énergie actuelle, des modèles de consommation selon les heures d'utilisation et des changements de composition du réseau au fil du temps.",
            shortDescription: "Réduction annuelle estimée des émissions de dioxyde de carbone grâce à l'énergie solaire",
            source: "Facteurs d'émission du réseau suisse - Office fédéral de l'environnement OFEV",
            title: 'Réduction de CO2',
          },
          unit: 'tonnes/an',
        },
        estimated: 'Estimé',
        propertyValue: {
          label: 'Impact sur la valeur immobilière',
          tooltip: {
            calculation: 'Basé sur les études du marché immobilier suisse montrant une augmentation typique de 3-5% de la valeur',
            categories: {
              buyerPreferences: {
                description: "Conscience environnementale et priorités d'efficacité énergétique",
                label: 'Préférences des acheteurs',
              },
              locationFactors: {
                description: 'Préférences du marché régional et coûts énergétiques',
                label: 'Facteurs de localisation',
              },
              marketTrends: {
                description: 'Conditions actuelles du marché immobilier et énergétique',
                label: 'Tendances du marché',
              },
              systemCondition: {
                description: 'Âge, performance et état de maintenance',
                label: 'État du système',
              },
            },
            importance: "Avantage financier supplémentaire potentiel au-delà des économies d'énergie",
            limitations: "Moyennes d'études de marché uniquement. L'impact réel sur la valeur immobilière varie considérablement et n'est pas garanti. Une évaluation immobilière professionnelle est recommandée pour une évaluation précise.",
            shortDescription: "Augmentation estimée de la valeur immobilière grâce à l'installation solaire",
            source: 'Études du marché immobilier suisse',
            title: 'Impact sur la valeur immobilière',
          },
          value: '+3-5%',
        },
        roiPeriod: {
          label: 'Période de retour',
          tooltip: {
            calculation: 'Basé sur les moyennes du marché suisse pour les systèmes résidentiels de CHF 15 000-25 000',
            categories: {
              electricityPrices: {
                description: 'Tarifs énergétiques actuels et projetés',
                label: "Prix de l'électricité",
              },
              feedInTariffs: {
                description: "Paiement pour l'énergie excédentaire vendue au réseau",
                label: 'Tarifs de rachat',
              },
              installationCosts: {
                description: 'Prix du système, permis et installation',
                label: "Coûts d'installation",
              },
              maintenanceCosts: {
                description: 'Nettoyage, réparations et remplacement de composants',
                label: 'Coûts de maintenance',
              },
              subsidies: {
                description: 'Incitations gouvernementales et locales',
                label: 'Subventions',
              },
            },
            importance: "Métrique financière critique pour la prise de décision d'investissement",
            limitations: "Estimation générique du marché. Le ROI réel nécessite une évaluation financière professionnelle tenant compte de la configuration spécifique du système, des incitations locales et des habitudes de consommation d'énergie individuelles.",
            shortDescription: "Temps estimé pour récupérer l'investissement initial dans le système solaire",
            source: 'Études financières du marché solaire suisse',
            title: 'Période de retour sur investissement',
          },
          value: '7-10 ans',
        },
        selfSufficiency: {
          label: 'Autosuffisance',
          tooltip: {
            calculation: "Estimation résidentielle générique basée sur les modèles d'installation typiques",
            categories: {
              batteryCapacity: {
                description: "Stockage d'énergie pour la nuit et les jours nuageux",
                label: 'Capacité de la batterie',
              },
              consumptionPatterns: {
                description: "Habitudes de consommation d'énergie quotidiennes et saisonnières",
                label: 'Modèles de consommation',
              },
              electricVehicle: {
                description: 'Besoins énergétiques supplémentaires',
                label: 'Recharge de véhicule électrique',
              },
              heatPumpUsage: {
                description: "Forte demande d'électricité en hiver",
                label: 'Utilisation de la pompe à chaleur',
              },
              seasonalVariations: {
                description: 'Excédent estival vs déficit hivernal',
                label: 'Variations saisonnières',
              },
            },
            importance: "Métrique clé pour l'indépendance énergétique et la réduction de la dépendance au réseau",
            limitations: "Estimation générique uniquement. L'autosuffisance réelle varie considérablement selon les circonstances individuelles et nécessite une analyse détaillée de la consommation.",
            shortDescription: 'Pourcentage estimé des besoins énergétiques couverts par la production solaire',
            source: "Moyennes statistiques de l'industrie solaire suisse",
            title: 'Autosuffisance',
          },
          value: '60-80%',
        },
        title: "Potentiel d'économies d'énergie",
      },
      monthlyGeneration: {
        perDay: 'h/jour',
        quarterAverage: 'Moyenne {{quarter}}',
        title: 'Potentiel de génération solaire mensuel',
      },
      panelInstallation: {
        efficiencyRating: {
          label: "Note d'efficacité",
          tooltip: {
            calculation: '(Heures de pointe moyennes ÷ 6,5h) × 100 - où 6,5h représente les conditions équatoriales optimales',
            importance: "Indique dans quelle mesure votre emplacement est adapté à l'énergie solaire par rapport aux conditions idéales",
            limitations: "Basé uniquement sur les calculs de latitude. Ne prend pas en compte la couverture nuageuse réelle, les conditions météorologiques, la qualité de l'air ou les conditions climatiques locales qui impactent significativement l'efficacité réelle.",
            shortDescription: "Note d'efficacité solaire basée sur la position géographique (100 % = optimum équatorial)",
            source: "Calculs d'irradiance solaire basés sur des données astronomiques",
            title: "Note d'efficacité",
          },
        },
        highPotential: 'Fort potentiel',
        monthlyAverage: {
          label: 'Moyenne mensuelle',
          tooltip: {
            calculation: "Basé sur des calculs astronomiques utilisant les données de position du soleil tout au long de l'année",
            importance: "Fournit un aperçu des variations saisonnières de production d'énergie solaire à des fins de planification",
            limitations: "Calcul théorique uniquement. Ne prend pas en compte les modèles climatiques locaux, les conditions météorologiques réelles ou l'ombrage spécifique au site par les bâtiments, les arbres ou le terrain.",
            shortDescription: 'Heures de soleil de pointe quotidiennes moyennes calculées sur un mois type',
            source: "Calculs d'irradiance solaire basés sur des données astronomiques",
            title: 'Moyenne mensuelle',
          },
        },
        optimalPanelAngle: {
          label: 'Angle optimal des panneaux',
          tooltip: {
            calculation: 'Formule : Latitude ({{latitude}}°) × 0,9 + 29° pour une performance annuelle',
            importance: "Un angle de panneau correct maximise la production d'énergie en optimisant l'exposition au soleil toute l'année",
            limitations: "Ne prend pas en compte la topographie locale, l'orientation réelle du toit, les limitations structurelles ou les options d'ajustement saisonnier. Une évaluation professionnelle du site est recommandée pour des résultats optimaux.",
            shortDescription: "L'angle d'inclinaison théorique idéal pour les panneaux solaires basé sur votre emplacement",
            source: 'Calculs astronomiques basés sur les coordonnées géographiques',
            title: 'Angle optimal des panneaux',
          },
        },
        peakSunHours: {
          label: 'Heures de pointe/jour',
          tooltip: {
            calculation: "Heures de soleil de pointe théoriques par ciel clair à 1000 W/m² d'intensité, calculées à partir de la latitude et des angles solaires saisonniers",
            importance: "Les heures de soleil de pointe sont directement corrélées au potentiel de production d'énergie solaire et aident à estimer les performances du système",
            limitations: 'Basé uniquement sur des conditions théoriques de ciel clair. Ne prend pas en compte la couverture nuageuse, le brouillard, la pollution atmosphérique, les ombres des bâtiments ou des arbres, ni les conditions météorologiques locales réelles.',
            shortDescription: "Heures quotidiennes d'ensoleillement direct à l'efficacité optimale des panneaux solaires",
            source: "Calculs d'irradiance solaire basés sur des données astronomiques",
            title: 'Heures de soleil de pointe par jour',
          },
        },
        title: 'Installation de panneaux solaires',
        yearlyTotal: {
          label: 'Total annuel',
          tooltip: {
            calculation: 'Moyenne mensuelle × 365 jours',
            importance: "Aide à estimer le potentiel de production annuelle d'énergie solaire pour le dimensionnement du système et l'analyse coûts-bénéfices",
            limitations: 'Cela représente la limite supérieure théorique dans des conditions de ciel parfaitement clair. Les valeurs réelles sont généralement 30 à 50 % plus basses en raison des conditions météorologiques, des variations saisonnières et des conditions atmosphériques.',
            shortDescription: "Total des heures de soleil de pointe attendues tout au long de l'année",
            source: "Calculs d'irradiance solaire basés sur des données astronomiques",
            title: 'Total annuel',
          },
        },
      },
    },
    states: {
      error: "Erreur lors du chargement des données d'ensoleillement",
      errorDescription: "Impossible de charger les données d'analyse d'ensoleillement. Veuillez réessayer plus tard.",
      loading: "Chargement des données d'ensoleillement...",
      noData: "Aucune donnée d'ensoleillement disponible",
      noDataDescription: "Les données d'analyse d'ensoleillement ne sont pas disponibles pour cet emplacement.",
    },
    sunPath: {
      dawn: 'Aube',
      dusk: 'Crépuscule',
      noon: 'Midi',
    },
    tabs: {
      overview: 'Aperçu',
      seasonal: 'Saisonnier',
      solar: 'Potentiel solaire',
      yearly: 'Analyse annuelle',
    },
    today: {
      badge: 'Proche du pic estival',
      dayDuration: 'Durée du jour',
      sunrise: 'Lever du soleil',
      sunset: 'Coucher du soleil',
      title: "Aujourd'hui - {{date}}",
    },
    yearly: {
      bestMonths: {
        averagePeak: 'Moyenne haute',
        excellent: 'Excellent',
        peakPeriod: 'Mai - Août',
        peakSeason: 'Haute saison',
        qualityRating: 'Note de qualité',
        title: 'Meilleurs mois',
      },
      challengingMonths: {
        averageLow: 'Moyenne basse',
        limited: 'Limité',
        lowPeriod: 'Nov - Février',
        lowSeason: 'Basse saison',
        title: 'Mois difficiles',
      },
      chartTitle: "Heures de luminosité tout au long de l'année",
      daylightHours: 'Heures de luminosité',
      months: {
        apr: 'Avr',
        aug: 'Aoû',
        dec: 'Déc',
        feb: 'Fév',
        jan: 'Jan',
        jul: 'Jul',
        jun: 'Jun',
        mar: 'Mar',
        may: 'Mai',
        nov: 'Nov',
        oct: 'Oct',
        sep: 'Sep',
      },
      variation: {
        leastSunlight: 'Moins de lumière',
        maxVariation: 'Variation maximale',
        mostSunlight: 'Plus de lumière',
        title: 'Analyse des variations',
      },
    },
  },
  taxes: {
    calculatorLink: {
      description: "Utilisez le calculateur officiel suisse pour estimer les impôts en fonction d'une situation spécifique.",
      title: 'Calculer un impôt personnalisé',
    },
    charts: {
      noData: 'Aucune donnée disponible',
      taxAmountEvolution: {
        axis: {
          amount: "Montant d'impôt (CHF)",
        },
        subtitle: "Montants d'impôts historiques en CHF par profil",
        summary: {
          title: 'Variations ({{startYear}}-{{endYear}})',
        },
        title: "Évolution du montant d'impôt annuel",
      },
      taxBurdenEvolution: {
        axis: {
          burden: 'Charge fiscale (%)',
        },
        subtitle: 'Pourcentage historique de la charge fiscale par profil',
        summary: {
          avgChange: 'Variation moyenne',
          decreasing: 'En baisse - les impôts diminuent',
          increasing: 'En hausse - les impôts augmentent',
          stable: 'Stable - les impôts restent relativement constants',
          title: 'Analyse de tendance ({{startYear}}-{{endYear}})',
          trend: 'Tendance',
        },
        title: 'Évolution de la charge fiscale',
      },
      taxRateEvolution: {
        subtitle: 'Coefficients cantonaux et communaux au fil du temps',
        summary: {
          title: 'Variations des taux ({{startYear}}-{{endYear}})',
        },
        title: "Évolution des taux d'imposition",
      },
    },
    common: {
      downloadChart: 'Télécharger le graphique',
    },
    comparison: {
      aboveCantonAvg: 'au-dessus de la moyenne cantonale',
      aboveNationalAvg: 'au-dessus de la moyenne nationale',
      belowCantonAvg: 'sous la moyenne cantonale',
      belowNationalAvg: 'sous la moyenne nationale',
      canton: 'Canton',
      profileFamily: 'Charge fiscale (Famille - revenu {{income}})',
      profileMarried: 'Charge fiscale (Marié - revenu {{income}})',
      profileSingle: 'Charge fiscale (Célibataire - revenu {{income}})',
      switzerland: 'Suisse',
      thisLocation: 'Cette localisation',
      title: 'Comparaison géographique',
    },
    efficiency: {
      high: 'Élevée',
      low: 'Basse',
      medium: 'Moyenne',
    },
    filters: {
      location: 'Localisation',
      year: 'Année',
    },
    insights: {
      highEfficiency: 'Cette localisation offre des impôts inférieurs aux moyennes cantonale et nationale, ce qui en fait un choix attractif pour les acheteurs soucieux de la fiscalité.',
      lowEfficiency: "La charge fiscale à cette localisation est supérieure aux moyennes cantonale et nationale. Prenez en compte ce facteur lors de l'évaluation du coût total de propriété.",
      mediumEfficiency: "Les niveaux d'imposition à cette localisation présentent des résultats mitigés en comparant les moyennes cantonale et nationale. Les impôts sont favorables à un niveau mais pas aux deux.",
      title: "Évaluation de l'efficacité fiscale",
    },
    metrics: {
      annualTax: {
        subtitle: 'Impôts totaux moyens',
        title: 'Impôt annuel',
      },
      taxBurden: {
        subtitle: 'Moyenne tous profils',
        title: 'Charge fiscale',
      },
      taxFreedomDay: {
        subtitle: 'Date moyenne',
        title: 'Jour de libération fiscale',
      },
    },
    profileDetails: {
      annualTax: 'Impôt annuel',
      profile: 'Profil',
      taxBurden: 'Charge fiscale',
      taxFreedomDay: 'Jour de libération',
      title: 'Détails par profil',
    },
    profiles: {
      all: 'Tous les profils',
      family: 'Famille',
      married: 'Marié',
      single: 'Célibataire',
    },
    states: {
      error: 'Erreur lors du chargement des données fiscales: {{error}}',
      fetchError: 'Échec du chargement des données fiscales',
      loading: 'Chargement des données fiscales...',
      noData: 'Les données fiscales ne sont pas disponibles pour cet emplacement.',
      noHistoricalData: 'Aucune donnée fiscale historique disponible',
    },
    subtitle: 'Analyse de la charge fiscale pour cette localisation',
    tabs: {
      overview: "Vue d'ensemble",
      trends: 'Évolution historique',
    },
    taxRates: {
      canton: 'Canton',
      cantonRate: 'Taux cantonal',
      churchChrist: 'Catholique chrétienne',
      churchNote: 'Impôts ecclésiastiques (optionnel)',
      churchProtestant: 'Protestante',
      churchRoman: 'Catholique romaine',
      city: 'Commune',
      cityRank: 'Rang communal',
      cityRate: 'Taux communal',
      cityRateComparison: 'Taux communal parmi {{total}} communes dans {{canton}}',
      inCanton: 'dans {{canton}}',
      ofCities: 'sur {{total}} communes',
      rateAxis: 'Taux (%)',
      subtitle: "Multiplicateurs appliqués sur l'impôt cantonal de base",
      title: "Coefficients d'imposition",
    },
    title: 'Fiscalité',
    tooltips: {
      annualTax: {
        calculation: "Somme de l'impôt fédéral direct + impôt cantonal sur le revenu + impôt communal sur le revenu. Profils : Célibataire = CHF 84'000 (salaire médian suisse), Marié = couple sans enfants à CHF 168'000, Famille = couple marié avec 2 enfants à CHF 168'000.",
        importance: "Le montant absolu en CHF aide les clients à comprendre les différences de coûts réels entre les localisations. Une différence annuelle de CHF 5'000 représente des économies significatives sur la durée de propriété.",
        limitations: "N'inclut pas l'impôt sur la fortune, les impôts fonciers ou autres impôts indirects. Basé sur des profils standardisés (Célibataire : CHF 84'000, Marié/Famille : CHF 168'000) sans déductions individuelles.",
        shortDescription: 'Total des impôts payés par an, incluant les impôts fédéraux, cantonaux et communaux',
        source: 'Administration fédérale des contributions (AFC) - Statistiques annuelles de la charge fiscale',
        title: 'Impôt annuel',
      },
      taxBurden: {
        calculation: "Impôt annuel total / Revenu brut annuel × 100. Profils : Célibataire = CHF 84'000 (salaire médian suisse), Marié = couple sans enfants à CHF 168'000, Famille = couple marié avec 2 enfants à CHF 168'000.",
        calculation_family: "Impôt annuel total / Revenu brut annuel × 100. Basé sur un couple marié avec 2 enfants avec un revenu brut combiné de CHF 168'000.",
        calculation_married: "Impôt annuel total / Revenu brut annuel × 100. Basé sur un couple marié sans enfants avec un revenu brut combiné de CHF 168'000.",
        calculation_single: "Impôt annuel total / Revenu brut annuel × 100. Basé sur une personne célibataire avec un revenu brut de CHF 84'000 (salaire médian suisse).",
        importance: "Impact direct sur le pouvoir d'achat et le revenu disponible. Une charge fiscale plus faible signifie plus d'argent disponible pour les paiements hypothécaires et les dépenses courantes. Facteur clé pour les décisions d'investissement immobilier.",
        limitations: "Basé sur des profils de revenus standardisés (Célibataire : CHF 84'000, Marié/Famille : CHF 168'000). La charge fiscale réelle peut varier selon les circonstances individuelles, les déductions et la fortune.",
        limitations_family: "Basé sur un revenu combiné standardisé de CHF 168'000 pour un couple avec 2 enfants. La charge fiscale réelle peut varier selon les circonstances individuelles, les déductions et la fortune.",
        limitations_married: "Basé sur un revenu combiné standardisé de CHF 168'000 pour un couple sans enfants. La charge fiscale réelle peut varier selon les circonstances individuelles, les déductions et la fortune.",
        limitations_single: "Basé sur un revenu standardisé de CHF 84'000. La charge fiscale réelle peut varier selon les circonstances individuelles, les déductions et la fortune.",
        shortDescription: 'Pourcentage du revenu brut payé en impôts (fédéral, cantonal, communal)',
        source: 'Administration fédérale des contributions (AFC) - Statistiques annuelles de la charge fiscale',
        title: 'Charge fiscale',
      },
      taxFreedomDay: {
        calculation: 'Charge fiscale × 365 jours. Si la charge fiscale est de 18,9%, le Jour de libération fiscale = Jour 69 (10 mars). Date plus tôt = impôts plus bas.',
        importance: "Façon intuitive de communiquer la charge fiscale aux clients. 'Vous travaillez jusqu'au 10 mars pour payer vos impôts' est plus tangible que '18,9% de charge fiscale'. Métrique largement utilisée en Suisse.",
        limitations: "Représentation symbolique. Les paiements d'impôts réels sont répartis tout au long de l'année. Ne tient pas compte des cotisations sociales obligatoires.",
        shortDescription: "Le jour de l'année où vous cessez de travailler pour payer des impôts et commencez à gagner pour vous-même",
        source: 'Administration fédérale des contributions (AFC) - Publication du Jour de libération fiscale',
        title: 'Jour de libération fiscale',
      },
    },
  },
  transactions: {
    actions: {
      removeFromSaved: 'Retirer des favoris',
      saveTransaction: 'Enregistrer la transaction',
    },
    aiFilter: {
      description: 'Décrivez les transactions que vous recherchez, et je vous aiderai à les trouver.',
      examplePrompts: {
        '0': "Transactions d'achat des 12 derniers mois de plus de 5 millions CHF",
        '1': 'Transactions avec un seul acheteur',
      },
      placeholder: "Montrez-moi les transactions d'achat de ce dernier mois",
      title: 'Assistant de filtre transactions',
    },
    columns: {
      address: 'Adresse',
      area: 'Surface',
      buyers: 'Acheteurs',
      buyersCount: 'Nb acheteurs',
      date: 'Date',
      ownershipType: 'Type de propriété',
      parcel: 'Parcelle {{number}}',
      previousTransaction: 'Transaction précédente',
      price: 'Prix',
      pricePerM2: 'Prix/m²',
      reason: 'Raison',
      sellers: 'Vendeurs',
      sellersCount: 'Nb vendeurs',
      transactionId: 'ID de transaction',
    },
    dataSources: {
      label: 'Sources :',
      list: 'Registre foncier • État de Genève • Extrait du registre des mutations',
    },
    detail: {
      backToList: 'Retour à la liste',
      description: 'Description',
      details: 'Détails',
      landInfo: 'Informations sur le terrain',
      multipleLotsWarning: 'Cette transaction concerne plusieurs parcelles',
      parcel: 'Parcelle',
      propertiesInvolved: 'Propriétés concernées',
      transaction: 'Transaction',
      transactionInfo: 'Informations sur la transaction',
    },
    detailPanel: {
      initializingMap: 'Initialisation de la carte...',
      labels: {
        buyers: 'Acheteurs',
        capacity: 'Capacité',
        floors: 'Étages',
        land: 'Terrain',
        landArea: 'Surface du terrain',
        language: 'Langue',
        location: 'Emplacement',
        officialId: 'ID officiel',
        participants: 'Participants',
        previous: 'Précédent',
        properties: 'Propriétés',
        property: 'Propriété {{index}}',
        publicationDate: 'Date de publication',
        region: 'Région',
        sellers: 'Vendeurs',
        share: 'Part',
        stepPrice: "Prix de l'étape",
        surface: 'Surface',
        totalPrice: 'Prix total',
        totalSurface: 'Surface totale',
        transactionDate: 'Date de transaction',
        transactionId: 'ID de transaction',
        units: 'Unités',
        unitsCount: 'Unités ({{count}})',
      },
      legalTypes: {
        BF: 'B-F - Bien-fonds',
        COP: 'COP - Copropriété',
        DDP: 'DDP - Droit distinct et permanent',
        DP: 'DP - Domaine Public',
        PPE: 'PPE - Propriété par étages',
      },
      loading: 'Chargement des détails de la transaction...',
      loadingMap: 'Chargement de la carte...',
      locationsNotAvailable: 'Emplacements exacts des propriétés non disponibles',
      mapPopup: {
        land: 'Terrain : {{area}} m²',
        propertiesAtLocation: '{{count}} propriétés à cet emplacement',
        propertyNumber: 'Propriété {{index}}',
        surface: 'Surface : {{area}} m²',
      },
      mapTokenNotConfigured: 'Token de carte non configuré',
      notFound: 'Transaction non trouvée',
      participantTypes: {
        company: 'Entreprise',
        estate: 'Succession',
        individual: 'Particulier',
        nonProfit: 'Association',
        other: 'Autre',
        publicBody: 'Organisme public',
        unknown: 'Inconnu',
      },
      removeFromSaved: 'Retirer des enregistrements',
      saveTransaction: 'Enregistrer la transaction',
      sections: {
        participants: 'Participants',
        properties: 'Propriétés',
        propertiesCount: 'Propriétés ({{count}})',
        rawTransactionData: 'Données brutes de la transaction',
        transactionDescription: 'Description de la transaction',
        transactionDetails: 'Détails de la transaction',
      },
      title: 'Détails',
      transactionNumber: 'Transaction n°{{id}}',
      type: 'Transaction',
      unitTypes: {
        appartement: 'Appartement',
        balcon: 'Balcon',
        box: 'Box de rangement',
        cave: 'Cave',
        garage: 'Garage',
        loggia: 'Loggia',
        privateGarage: 'Garage privé',
        singleFamily: 'Maison individuelle',
      },
    },
    empty: {
      message: "Essayez d'ajuster vos filtres pour voir plus de résultats",
      title: 'Aucune transaction trouvée',
    },
    errors: {
      loadFailed: 'Échec du chargement des transactions',
      tryAgain: 'Veuillez réessayer plus tard',
    },
    fields: {
      assignmentArea: "Zone d'affectation",
      buildingClassification: 'Type de bâtiment',
      buyers: 'Acheteurs',
      landInfo: 'Information terrain',
      livingArea: 'Surface habitable',
      numberOfBuyers: "Nombre d'acheteurs",
      numberOfSellers: 'Nombre de vendeurs',
      numberOfUnits: "Nombre d'unités",
      parcelNumber: 'Numéro de parcelle',
      parties: 'Parties',
      previousTransaction: 'Transaction précédente',
      price: 'Prix',
      pricePerM2: 'Prix par m²',
      propertyType: 'Type de propriété',
      publishedOn: 'Publié le',
      reason: 'Raison',
      sellers: 'Vendeurs',
      transactionDate: 'Date de transaction',
      transactionOn: 'Transaction le',
    },
    filter: {
      additionalFilters: 'Filtres supplémentaires',
      advancedFilters: 'Filtres avancés',
      allLocations: 'Tous les emplacements',
      clearAll: 'Tout effacer',
      hideFilters: 'Masquer les filtres',
      landArea: 'Surface du terrain (m²)',
      legalTypeBF: 'B-F',
      legalTypeCOP: 'COP',
      legalTypeDDP: 'DDP',
      legalTypeDP: 'DP',
      legalTypeOther: 'Autre',
      legalTypePPE: 'PPE',
      numberOfBuyers: "Nombre d'acheteurs",
      numberOfSellers: 'Nombre de vendeurs',
      others: 'Autres',
      participantAssociation: 'Association',
      participantCompany: 'Entreprise',
      participantCooperative: 'Coopérative',
      participantFoundation: 'Fondation',
      participantIndividual: 'Particulier',
      participantOther: 'Autre',
      participantPublicEntity: 'Entité publique',
      participants: 'Participants',
      participantType: 'Type de participant',
      propertyLegalType: 'Type juridique de propriété',
      radius: 'Rayon',
      showFilters: 'Afficher les filtres',
      stepTransactionPrice: 'Prix de transaction (CHF)',
      transactionDate: 'Date de transaction',
      transactionType: 'Type de transaction',
      typeAreaPrice: 'Type, Surface & Prix',
      unitApartment: 'Appartement',
      unitCommercial: 'Commercial',
      unitHouse: 'Maison',
      unitLand: 'Terrain',
      unitOther: 'Autre',
      unitParking: 'Parking',
      unitType: "Type d'unité",
    },
    filterPanel: {
      appliedFilter: 'Filtre appliqué : {{name}}',
      clearAllFilters: 'Effacer tous les filtres',
      closeFilters: 'Fermer les filtres',
      failedToSave: "Échec de l'enregistrement du filtre",
      loadSavedFilters: 'Charger les filtres enregistrés',
      saveCurrentFilters: 'Enregistrer les filtres actuels',
      savedFilter: 'Filtre enregistré : {{name}}',
      savedOn: 'Enregistré le {{date}}',
      title: 'Filtres de transactions',
    },
    filters: {
      any: 'Tous',
      apply: 'Appliquer',
      area: 'Surface habitable',
      areaQuickOptions: {
        '100to150': '100-150m²',
        '50to100': '50-100m²',
        over150: 'Plus de 150m²',
        under50: 'Moins de 50m²',
      },
      areaRange: 'Surface habitable (m²)',
      clear: 'Effacer',
      clearAll: 'Effacer tous les filtres',
      labels: {
        buyers: 'Acheteurs',
        city: 'Ville',
        district: 'District',
        floors: 'Étages',
        landArea: 'Surface du terrain',
        legalType: 'Type juridique',
        mapSearchLocation: 'Recherche de localisation sur la carte',
        municipality: 'Commune',
        npa: 'NPA (Code postal)',
        numberOfBuyers: "Nombre d'acheteurs",
        numberOfFloors: "Nombre d'étages",
        numberOfProperties: 'Nombre de propriétés',
        numberOfRooms: 'Nombre de pièces',
        numberOfSellers: 'Nombre de vendeurs',
        participantLegalForm: 'Forme juridique du participant',
        participantName: 'Nom du participant',
        participantType: 'Type de participant',
        propertyPrice: 'Prix du bien',
        publicationDate: 'Date de publication',
        reason: 'Raison',
        region: 'Région',
        rooms: 'Pièces',
        sellers: 'Vendeurs',
        stepPrice: "Prix de l'étape",
        stepTransactionPrice: "Prix de l'étape de transaction",
        surfaceArea: 'Surface',
        totalPrice: 'Prix total',
        totalSurfaceArea: 'Surface totale',
        totalTransactionPrice: 'Prix total de la transaction',
        transactionDate: 'Date de transaction',
        unitArea: "Surface de l'unité",
        unitType: "Type d'unité",
      },
      legalTypes: {
        BF: 'B-F - Bien-fonds',
        COP: 'COP - Copropriété',
        DDP: 'DDP - Droit distinct et permanent',
        DP: 'DP - Domaine Public',
        PPE: 'PPE - Propriété par étages',
      },
      lessFilters: 'Moins de filtres',
      location: 'Localisation',
      locationOptions: {
        geneva1205: '1205 Genève',
        genevaCanton: 'Canton de Genève',
        genevaCity: 'Ville de Genève',
        within100m: 'Dans les 100m',
        within1km: 'Dans 1km',
        within2km: 'Dans 2km',
        within300m: 'Dans les 300m',
        within500m: 'Dans les 500m',
      },
      locationSections: {
        location: 'Localisation',
        radius: 'Rayon depuis la propriété',
      },
      max: 'MAX',
      min: 'MIN',
      moreFilters: 'Plus de filtres',
      participantTypes: {
        company: 'Entreprise',
        estate: 'Succession',
        individual: 'Particulier',
        nonProfit: 'Organisation à but non lucratif',
        other: 'Autre',
        others: 'Autres',
        publicBody: 'Organisme public',
      },
      placeholders: {
        enterCity: 'Saisir le nom de la ville...',
        enterDistrict: 'Saisir le nom du district...',
        enterLegalForm: 'Saisir la forme juridique...',
        enterMunicipality: 'Saisir le nom de la commune...',
        enterNpa: 'Saisir le NPA...',
        enterRegion: 'Saisir le nom de la région...',
        from: 'De',
        max: 'Max',
        min: 'Min',
        searchParticipants: 'Rechercher des participants...',
        to: 'À',
      },
      price: 'Prix (CHF)',
      priceQuickOptions: {
        '1MTo2M': '1M - 2M',
        '500kTo1M': '500k - 1M',
        over2M: 'Plus de 2M',
        under500k: 'Moins de 500k',
      },
      priceRange: 'Fourchette de prix (CHF)',
      propertyType: 'Type de propriété',
      propertyTypeOptions: {
        bienFonds: 'Parcelles de terrain',
        ppe: 'Propriété en copropriété',
      },
      reason: 'Type de transaction',
      reasonOptions: {
        achat: "Transactions d'achat",
        donation: 'Transferts de donation',
        heritage: "Transferts d'héritage",
        vente: 'Transactions de vente',
      },
      sections: {
        locationDate: 'Localisation et date',
        participants: 'Participants',
        price: 'Prix',
        properties: 'Propriétés',
        propertyLocation: 'Localisation du bien',
        transactionDetails: 'Détails de la transaction',
        units: 'Unités',
      },
      unitTypes: {
        apartment: 'Appartement',
        balcony: 'Balcon',
        cellar: 'Cave',
        garage: 'Garage',
        loggia: 'Loggia',
        privateGarage: 'Garage privé',
        singleFamily: 'Maison individuelle',
        storageBox: 'Box de rangement',
      },
      year: 'Année',
      yearOptions: {
        all: 'Tous les temps',
        last10Years: '10 dernières années',
        last2Years: '2 dernières années',
        last5Years: '5 dernières années',
        lastYear: 'Dernière année',
      },
    },
    placeholders: {
      searchBuyers: 'Rechercher des acheteurs...',
      searchSellers: 'Rechercher des vendeurs...',
    },
    print: {
      cover: {
        generatedOn: 'Généré le {{date}}',
        subtitle: 'Analyse complète du marché',
        title: 'Rapport de statistiques des transactions',
      },
      dataSource: {
        description: 'Les statistiques de transactions présentées dans ce rapport sont dérivées de registres complets de transactions immobilières collectés auprès de sources officielles. Les données incluent toutes les transactions immobilières enregistrées dans la zone géographique et la période sélectionnées.',
        lastUpdated: 'Dernière mise à jour : {{date}} | Sources des données : Registres publics, Bases de données gouvernementales',
        title: 'À propos de ces données',
      },
      disclaimer: {
        dataAccuracy: {
          description: "Bien que tous les efforts aient été faits pour garantir l'exactitude des informations présentées dans ce rapport, Popety.io ne peut garantir l'exhaustivité ou l'exactitude de toutes les données. Les statistiques et analyses sont basées sur les données disponibles au moment de la génération et peuvent être sujettes à révision.",
          title: 'Exactitude des données',
        },
        dataSources: {
          description: 'Ce rapport est basé sur des données de transactions collectées à partir de diverses sources publiques et privées, notamment :',
          items: {
            databases: 'Bases de données du marché immobilier',
            records: 'Registres publics des transactions',
            registries: 'Registres fonciers officiels',
            statistical: 'Offices statistiques gouvernementaux',
          },
          title: 'Sources des données',
        },
        footer: '© {{year}} Popety.io - Tous droits réservés | www.popety.io',
        intellectualProperty: {
          description: "Tout le contenu de ce rapport, y compris mais sans s'y limiter le texte, les graphiques, les tableaux et les visualisations de données, est la propriété de Popety.io et est protégé par les lois sur le droit d'auteur. La reproduction ou la distribution sans autorisation écrite est interdite.",
          title: 'Propriété intellectuelle',
        },
        title: 'Avertissement légal et sources des données',
        usageLimitations: {
          description: 'Ce rapport est fourni à titre informatif uniquement et ne doit pas être considéré comme :',
          items: {
            complete: 'Une représentation complète de toutes les transactions du marché',
            guarantee: 'Une garantie de performance future du marché',
            investment: "Conseils ou recommandations d'investissement",
            legal: 'Conseils juridiques ou financiers',
          },
          title: "Limitations d'utilisation",
        },
      },
    },
    propertyTypeBadges: {
      bienFonds: 'Bien-fonds (B-F)',
      commune: 'Communauté héréditaire',
      individuelle: 'Individuelle',
      ppe: 'Propriété par étage',
    },
    propertyTypes: {
      all: 'Toutes les propriétés',
      bienFonds: 'Bien-fonds (B-F)',
      commune: 'Communauté héréditaire',
      individuelle: 'Individuelle',
      ppe: 'PPE',
    },
    quickFilters: {
      buyers: 'Acheteurs',
      city: 'Ville',
      district: 'District',
      floors: 'Étages',
      landArea: 'Surface terrain',
      legalForm: 'Forme juridique',
      legalType: 'Type juridique',
      municipality: 'Commune',
      npa: 'NPA',
      participant: 'Participant',
      participantType: 'Type de participant',
      properties: 'Propriétés',
      propertyPrice: 'Prix du bien',
      publicationDate: 'Date de publication',
      reason: 'Raison',
      region: 'Région',
      rooms: 'Pièces',
      sellers: 'Vendeurs',
      stepPrice: "Prix de l'étape",
      surfaceArea: 'Surface',
      totalPrice: 'Prix total',
      transactionDate: 'Date de transaction',
      unitArea: 'Surface unité',
      unitType: "Type d'unité",
    },
    resultsCount: '{{count}} transactions trouvées {{location}} {{timeframe}}',
    sections: {
      parties: 'Parties',
      propertyDetails: 'Détails de la propriété',
      transactionInfo: 'Informations de transaction',
    },
    sorting: {
      distance: 'Distance',
      priceHigh: 'Prix : du plus élevé au plus bas',
      priceLow: 'Prix : du plus bas au plus élevé',
      recent: 'Plus récent',
      sortBy: 'Trier par :',
    },
    stats: {
      charts: {
        geographicDistribution: {
          activeCantons: 'Cantons actifs',
          avg: 'Moy.',
          avgTransactionPrice: 'Prix moyen des transactions',
          noData: 'Aucune donnée disponible',
          topCitiesByVolume: 'Principales villes par volume de transactions',
          totalMarketVolume: 'Volume total du marché',
          totalTransactions: 'Total des transactions',
          transactions: 'transactions',
          transactionsByCanton: 'Transactions par canton',
        },
        inheritanceAnalysis: {
          donation: 'Donation',
          flowAnalysis: "Analyse des flux d'héritage",
          flowAnalysisSubtext: 'Transfert de patrimoine des vendeurs aux acheteurs par type de propriété',
          heritage: 'Héritage',
          inheritanceOverTime: "Transactions d'héritage au fil du temps",
          inheritanceOverTimeSubtext: 'Tendances trimestrielles par type de transaction',
          noData: "Aucune donnée d'héritage disponible",
          partage: 'Partage',
          shareDistribution: 'Analyse de la distribution des parts',
          shareDistributionSubtext: 'Schémas de parts de propriété dans les transferts',
          transactionCount: 'Nombre de transactions',
          transactions: 'transactions',
        },
        marketTiming: {
          activityCalendar: "Calendrier d'activité du marché",
          activityCalendarSubtext: 'Volume des transactions par jour',
          avgLagDays: 'Délai moyen (jours)',
          monthlyActivity: 'Activité mensuelle des transactions',
          monthlyActivitySubtext: 'Volume des transactions au fil du temps',
          noActivity: 'Aucune activité',
          noData: 'Aucune donnée de timing du marché',
          numberOfTransactions: 'Nombre de transactions',
          publicationLag: 'Analyse du délai de publication',
          publicationLagSubtext: 'Jours moyens entre la transaction et la publication',
          totalTransactions: 'Total des transactions',
          transactions: 'Transactions',
        },
        participantDemographics: {
          buyersByGender: 'Acheteurs par genre',
          companies: 'Entreprises',
          companyParticipants: 'Entreprises participantes',
          female: 'Femme',
          genderDistributionOverTime: 'Distribution par genre des acheteurs au fil du temps',
          genderParity: 'Parité 50%',
          individualParticipants: 'Participants individuels',
          individuals: 'Particuliers',
          male: 'Homme',
          noData: 'Aucune donnée disponible',
          participantTypesByLegalForm: 'Types de participants par forme juridique',
          personVsCompany: 'Particuliers vs Entreprises',
          sellersByGender: 'Vendeurs par genre',
          totalBuyers: 'Total des acheteurs',
          totalSellers: 'Total des vendeurs',
        },
        priceDynamics: {
          avgTransactionPrice: 'Prix moyen des transactions',
          mom: 'M/M',
          noData: 'Aucune donnée disponible',
          priceByPropertyType: 'Prix par type de propriété',
          priceDistribution: 'Distribution des prix',
          priceVelocityIndex: 'Indice de vélocité des prix',
          totalMarketVolume: 'Volume total du marché',
          yearlyMarketVolume: 'Volume annuel du marché',
          yoy: 'A/A',
        },
        propertyCharacteristics: {
          avgPrice: 'Prix moyen',
          avgSurfaceArea: 'Surface moyenne (m²)',
          avgSurfaceAreaM2: 'Surface moyenne (m²)',
          complexityIndex: 'Indice de complexité des bâtiments',
          complexityIndexSubtext: "Prix et surface par nombre d'étages",
          noData: 'Aucune donnée sur les caractéristiques des propriétés',
          numberOfFloors: "Nombre d'étages",
          performanceMatrix: 'Matrice de performance par type de propriété',
          performanceMatrixSubtext: 'Surface moyenne vs Prix moyen',
          transactions: 'Transactions',
        },
        seasonalPatterns: {
          averageTransactionCount: 'Nombre moyen de transactions',
          month: 'Mois',
          monthlyActivity: 'Activité mensuelle des transactions',
          monthlyActivitySubtext: 'Tendances du volume et de la valeur par mois',
          noData: 'Aucune donnée de schéma saisonnier',
          quarterlyComparison: 'Comparaison trimestrielle',
          quarterlyComparisonSubtext: 'Volume des transactions par trimestre',
          seasonalPatterns: 'Schémas saisonniers',
          seasonalPatternsSubtext: 'Activité moyenne par mois sur toutes les années',
          totalValue: 'Valeur totale',
          transactionCount: 'Nombre de transactions',
          transactions: 'Transactions',
        },
        transactionTypes: {
          averageValue: 'Valeur moyenne',
          distributionTitle: 'Répartition par type de transaction',
          dominantType: 'Type dominant',
          totalTransactions: 'Total des transactions',
          totalVolume: 'Volume total',
          trendsTitle: 'Évolution temporelle',
        },
        unitComposition: {
          averageArea: 'Surface moyenne',
          noData: 'Aucune donnée de composition des unités',
          numberOfRooms: 'Nombre de pièces',
          numberOfUnits: "Nombre d'unités",
          room: 'Pièce',
          roomDistribution: 'Distribution des pièces',
          roomDistributionSubtext: "Nombre d'unités par nombre de pièces",
          rooms: 'Pièces',
          units: 'unités',
          unitTypeComposition: "Composition par type d'unité",
          unitTypeCompositionSubtext: "La taille représente le nombre d'unités, la couleur représente la surface moyenne",
        },
      },
      description: 'Les statistiques et analyses des transactions seront bientôt disponibles ici.',
      errors: {
        loadFailed: 'Échec du chargement des statistiques',
        loginRequired: 'Veuillez vous connecter pour voir les statistiques des transactions',
        noData: 'Aucune donnée disponible pour les critères sélectionnés',
        noTransactionData: 'Aucune donnée de transaction disponible',
        retryError: 'Échec du chargement des statistiques. Veuillez réessayer.',
      },
      indicators: {
        allProperties: 'Toutes les propriétés',
        allSwitzerland: 'Toute la Suisse',
        location: 'Localisation',
        type: 'Type',
      },
      periods: {
        all: 'Historique complet',
        last12Months: '12 derniers mois',
        since2022: 'Depuis janvier 2022',
      },
      sections: {
        geographicDistribution: {
          description: 'Explorez les schémas de transaction dans différentes régions et municipalités.',
          title: 'Distribution géographique',
        },
        inheritanceAnalysis: {
          description: "Analysez les schémas d'héritage, de donation et de transfert de patrimoine, y compris l'analyse des flux et des parts de propriété.",
          title: 'Héritage et transfert de patrimoine',
        },
        marketTiming: {
          description: "Analysez le délai de publication, les schémas d'activité du marché et la vélocité des transactions au fil du temps.",
          title: 'Timing et vélocité du marché',
        },
        participantDemographics: {
          description: 'Comprenez les profils des acheteurs et vendeurs, les données démographiques et les schémas de transaction.',
          title: 'Démographie des participants',
        },
        priceDynamics: {
          description: 'Suivez les principales métriques de prix, y compris les prix moyens des transactions, le prix au mètre carré et les tendances du volume du marché.',
          title: 'Dynamique des prix',
        },
        propertyCharacteristics: {
          description: 'Analysez les types de propriétés, la complexité des bâtiments, la distribution des unités et les caractéristiques physiques.',
          title: 'Caractéristiques des propriétés',
        },
        seasonalPatterns: {
          description: "Explorez les tendances saisonnières, les schémas d'activité mensuelle et les comparaisons trimestrielles au fil du temps.",
          title: 'Schémas saisonniers et temporels',
        },
        transactionTypes: {
          description: 'Analysez la répartition des différents types de transactions pour comprendre la dynamique et les tendances du marché.',
          title: 'Types de transactions',
        },
        unitComposition: {
          description: "Explorez les types d'unités, la distribution des pièces et l'analyse par étage des propriétés résidentielles.",
          title: 'Composition des unités',
        },
      },
    },
    subtitle: 'Transactions immobilières historiques trouvées dans le quartier',
    title: 'Transactions',
    tooltip: {
      additionalProperties: '(+{{count}} propriétés)',
      area: 'Surface',
      buyersSellers: '{{buyers}} acheteurs / {{sellers}} vendeurs',
      date: 'Date',
      parcel: 'Parcelle {{code}} {{city}}',
      parties: 'Parties',
      price: 'Prix',
      pricePerM2: 'Prix/m²',
      properties: '{{count}} propriétés',
      property: '1 propriété',
      transactionNumber: 'Transaction n°{{id}}',
      type: 'Type',
      unknownLocation: 'Emplacement inconnu',
    },
    transactionTypes: {
      achat: 'Achat',
      all: 'Tous les types',
      donation: 'Donation',
      exchange: 'Échange',
      heritage: 'Héritage',
      vente: 'Vente',
    },
  },
  transport: {
    emptyStates: {
      noBuilding: 'Aucune donnée de bâtiment disponible',
      noEstimate: "Aucune donnée de bâtiment disponible pour l'analyse transport et accessibilité",
      noLand: 'Aucune donnée de terrain disponible',
    },
    evCharging: {
      charger: {
        plural: 'chargeurs',
        singular: 'chargeur',
      },
      chargingTypes: {
        fast: 'Recharge rapide',
        medium: 'Recharge moyenne',
        standard: 'Recharge standard',
      },
      metrics: {
        fastCharging: {
          title: 'Recharge rapide',
        },
        freeAccess: {
          title: 'Accès libre',
        },
        nearestStation: {
          title: 'Station la plus proche',
        },
        totalStations5km: {
          title: 'Total stations (5km)',
        },
      },
      more: '+{{count}} de plus',
      nearbyStations: 'Stations de recharge à proximité',
      overview: 'Aperçu recharge VE',
      plugTypes: {
        ccsCombo2: 'Prise CCS Combo 2 (Câble intégré)',
        chademo: 'CHAdeMO',
        schuko: 'Schuko',
        type1Connector: 'Connecteur Type 1 (Câble intégré)',
        type1Outlet: 'Prise Type 1',
        type2Connector: 'Connecteur Type 2 (Câble intégré)',
        type2Outlet: 'Prise Type 2',
        unknown: 'Inconnu',
      },
      unknownOperator: 'Opérateur inconnu',
    },
    header: {
      scoreLabel: 'Score TP',
      scoreTooltip: "Score global d'accessibilité des transports basé sur les transports publics, l'accès routier et les options de mobilité active",
      subtitle: "Analyse complète des infrastructures de transport et de l'accessibilité",
      title: 'Transport & Accès',
    },
    overview: {
      class: 'Classe',
      keyMetrics: 'Métriques clés',
      metrics: {
        cyclingRoutes: {
          subtext: 'Dans un rayon de 2km',
          title: 'Pistes cyclables',
        },
        evCharging: {
          title: 'Recharge VE',
        },
        highwayAccess: {
          title: 'Accès autoroute',
        },
        mainRoad: {
          title: 'Route principale',
        },
        nearestBusStop: {
          title: 'Arrêt de bus le plus proche',
        },
        nearestTrainStation: {
          title: 'Gare la plus proche',
        },
        ptQualityClass: {
          title: 'Classe qualité TP',
        },
        stopsWithin500m: {
          subtext: 'Arrêts de transports publics',
          title: 'Arrêts à moins de 500m',
        },
      },
    },
    publicTransport: {
      everyMinutes_one: 'toutes les minutes',
      everyMinutes_other: 'toutes les {{minutes}} min',
      metrics: {
        busStops: {
          title: 'Arrêts de bus',
        },
        qualityClass: {
          none: 'Aucune classe de qualité',
          title: 'Classe de qualité',
        },
        stopsUnder500m: {
          title: 'Arrêts < 500m',
        },
        totalStops1km: {
          title: 'Total arrêts (1km)',
        },
        trainStations: {
          title: 'Gares',
        },
        tramStops: {
          title: 'Arrêts de tram',
        },
      },
      nearbyStops: 'Arrêts à proximité',
      noStopsFound: 'Aucun arrêt de transport public trouvé dans un rayon de 1,5km',
      overview: 'Aperçu des transports publics',
      stopTypes: {
        bus: 'Bus',
        other: 'Autre',
        train: 'Train',
        tram: 'Tram',
      },
      unknownOperator: 'Opérateur inconnu',
      unknownStop: 'Arrêt inconnu',
    },
    scores: {
      activeMobility: {
        description: 'Évalue les infrastructures piétonnes, cyclables et les options de mobilité électrique (bornes de recharge, vélos en libre-service) autour du bien.',
        title: 'Mobilité active',
        tooltip: {
          shortDescription: "Score d'accessibilité de la mobilité active",
        },
      },
      common: {
        calculation: 'Moyenne pondérée de plusieurs facteurs',
        importance: 'Des scores plus élevés indiquent une meilleure accessibilité',
        outOf100: '/ 100',
        source: 'Swiss Geo Admin et Mapbox APIs',
      },
      details: {
        cycling: 'Vélo',
        diversity: 'Diversité',
        eMobility: 'E-Mobilité',
        frequency: 'Fréquence',
        highwayAccess: 'Accès autoroute',
        mainRoadDistance: 'Distance route principale',
        proximity: 'Proximité',
      },
      publicTransport: {
        title: 'Transports publics',
        tooltip: {
          shortDescription: "Score d'accessibilité des transports publics",
        },
      },
      qualityClassDescriptions: {
        A: 'Très bonne connexion aux transports publics',
        B: 'Bonne connexion aux transports publics',
        C: 'Connexion modérée aux transports publics',
        D: 'Connexion basique aux transports publics',
        E: 'Connexion limitée aux transports publics',
        F: 'Mauvaise ou aucune connexion aux transports publics',
        unknown: 'Aucune donnée disponible',
      },
      qualityClassLabels: {
        A: 'Excellent',
        B: 'Bon',
        C: 'Modéré',
        D: 'Basique',
        E: 'Limité',
        F: 'Faible',
        unknown: 'Inconnu',
      },
      roadAccess: {
        title: 'Accès routier',
        tooltip: {
          shortDescription: "Score d'accessibilité routière",
        },
      },
      scoreLabels: {
        basic: 'Basique',
        excellent: 'Excellent',
        good: 'Bon',
        limited: 'Limité',
        moderate: 'Modéré',
        poor: 'Faible',
        unknown: 'Inconnu',
      },
    },
    states: {
      error: 'Échec du chargement des données de transport. Veuillez réessayer.',
      loading: 'Chargement des données de transport...',
      noData: 'Aucune donnée de transport disponible',
    },
    tabs: {
      evCharging: 'Recharge VE',
      overview: 'Aperçu',
      publicTransport: 'Transports publics',
    },
    units: {
      kilometers: 'km',
      kw: 'kW',
      meters: 'm',
      na: 'N/D',
    },
  },
  valuations: {
    chart: {
      estimated_value: 'Valeur estimée',
      final_value: 'Valeur finale',
      hide_from_chart: 'Masquer du graphique',
      range: 'Fourchette',
      show_in_chart: 'Afficher dans le graphique',
      value: 'Valeur',
      value_range: 'Fourchette de valeur',
      variance: 'Variance',
    },
    confidence: {
      high: 'Élevé',
      high_confidence: 'Confiance élevée',
      low: 'Bas',
      low_confidence: 'Confiance faible',
      medium: 'Moyen',
      medium_confidence: 'Confiance moyenne',
    },
    fields: {
      automated_valuation: 'Évaluation automatisée',
      average_estimate: 'Estimation moyenne',
      avm: 'AVM',
      building_year: 'Année de construction',
      confidence_level: 'Niveau de confiance',
      confidence_score: 'Score de confiance',
      conservative: 'Conservateur',
      conservative_estimate: 'Estimation conservatrice',
      currency: 'Devise',
      data_range: 'Période de données',
      deal_type: 'Type de transaction',
      listings_count: "Nombre d'annonces",
      living_area: 'Surface habitable',
      market_value_type: 'Type de valeur marchande',
      method: 'Méthode',
      model_version: 'Version du modèle',
      number_of_rooms: 'Nombre de pièces',
      optimistic: 'Optimiste',
      optimistic_estimate: 'Estimation optimiste',
      price_per_sqm: 'Prix au m²',
      property_type: 'Type de bien',
      scenario: 'Scénario',
      status: 'Statut',
      value_before_correction: 'Valeur avant correction',
    },
    loading: 'Chargement des évaluations...',
    no_data: "Aucune donnée d'évaluation disponible",
    no_valuations: 'Aucune évaluation disponible',
    providers: {
      manual: {
        name: 'Évaluation personnalisée',
      },
      popety_io: {
        description: "Évaluation automatisée basée sur l'algorithme propriétaire de Popety.io analysant les caractéristiques de la propriété, les transactions de marché récentes et les facteurs spécifiques à l'emplacement.",
        name: 'Évaluation Popety.io',
      },
      pricehubble: {
        description: "Évaluation automatisée utilisant la méthode AVM de PriceHubble basée sur des algorithmes d'apprentissage automatique et des données de marché complètes.",
        name: 'Évaluation PriceHubble',
      },
      wuest_partner: {
        conservative_description: 'Évaluation automatisée conservatrice utilisant la méthodologie Wüest Partner.',
        description: 'Évaluation automatisée utilisant la méthodologie Wüest Partner avec une fourchette de marché allant de scénarios conservateurs à optimistes.',
        name: 'Évaluation Wüest Partner',
        optimistic_description: 'Évaluation automatisée optimiste utilisant la méthodologie Wüest Partner.',
      },
    },
  },
  zoning: {
    buildable: 'Constructible',
    cancel: 'Annuler',
    developingArea: 'Zone à développer',
    documents: {
      clearSearchAriaLabel: 'Effacer la recherche',
      documentTypes: {
        map: 'Carte',
        rule: 'Règlement',
      },
      important: 'Important',
      loading: 'Chargement des documents...',
      modalTitle: 'Documents de zone',
      noDocuments: 'Aucun document disponible',
      noDocumentSelected: 'Aucun document sélectionné',
      noPreviewAvailable: 'Aperçu non disponible',
      noPreviewHint: "Ce document n'a pas d'URL de prévisualisation PDF disponible",
      searchAriaLabel: 'Rechercher des documents',
      searchPlaceholder: 'Rechercher des documents...',
      selectDocumentHint: 'Sélectionnez un document dans la liste pour voir son contenu',
      sourceLabels: {
        country: 'Fédéral',
        lup: 'Plan communal',
        lupa: 'Plan local',
        lupc: 'Plan cantonal',
        lupo: 'Plan superposé',
        region: 'Cantonal',
      },
      sourceTitles: {
        country: 'Documents fédéraux (Suisse)',
        lup: 'Documents du plan communal',
        lupa: 'Documents du plan local',
        lupc: 'Documents du plan cantonal',
        lupo: 'Documents du plan superposé',
        region: 'Documents cantonaux',
      },
      title: 'Documents',
      view: 'Voir',
    },
    edit: 'Modifier',
    header: {
      abrogated: 'Abrogé',
      adopted: 'Adopté',
      buildingArea: 'Zone constructible',
      constructionArrangement: 'Disposition constructive',
      constructionArrangementValues: {
        C: 'Contigu',
        'C / NC': 'Contigu / Non contigu',
        NC: 'Non contigu',
      },
      nonBuildingArea: 'Zone non constructible',
      plotCoverage: 'de la parcelle',
      purpose: 'Affectation',
    },
    legalNotice: {
      blackText: 'Le texte en noir indique des valeurs exactes extraites directement du PGA ou du registre foncier.',
      blueText: 'Le texte en bleu indique des valeurs estimées calculées par les algorithmes de PROPETY.IO.',
      disclaimer: "Bien que nous nous efforcions de fournir les données les plus précises possible, toutes les informations doivent être vérifiées de manière indépendante. Veuillez consulter les documents officiels et contacter le service d'urbanisme de la commune concernée pour une confirmation officielle.",
      greenText: 'Le texte en vert indique des valeurs que vous avez modifiées.',
      title: 'Sources de données :',
    },
    legend: {
      agreement: {
        conflict: 'Sources en conflit',
        conflictNote: '(valeur barrée = source non retenue)',
        identical: 'Sources identiques',
        title: 'Accord des sources',
        unique: 'Source unique',
      },
      authorizedValues: {
        clickForDetails: 'Cliquer pour les détails',
        notAvailable: 'Non disponible',
        title: 'Valeurs autorisées',
      },
      difference: {
        exceeded: 'Dépassement',
        remaining: 'Potentiel restant',
        title: 'Différence',
      },
      sources: {
        algorithm: 'Estimation algorithmique',
        geoportal: 'Géoportail officiel',
        manual: 'Remplacée manuellement',
        regulation: 'Extrait du règlement',
        title: 'Sources de données',
        userEdit: "Remplacée par l'utilisateur",
      },
      title: 'Légende',
    },
    messages: {
      error: 'Échec du chargement des données de zone',
      loading: 'Chargement des données de zone...',
      noData: 'Aucune donnée de zone disponible pour ce terrain',
      noZonesForType: 'Aucune zone trouvée pour ce type',
      sectionDescription: 'Réglementations de zone et potentiel de développement pour cette parcelle',
    },
    metricLabels: {
      altitude: 'Altitude',
      atticFloors: 'Étages sous combles',
      bigSetback: 'Grande distance',
      buildingDepth: 'Profondeur du bâtiment',
      commercialRatio: 'Ratio commercial',
      constructionArrangement: 'Disposition constructive',
      cos: "Coefficient d'Occupation du Sol (COS)",
      cus: "Coefficient d'Utilisation du Sol (CUS)",
      density: 'Densité',
      distanceLimit: 'Distance limite',
      greenRatio: 'Ratio vert',
      heightWithoutRoof: 'Hauteur sans toit',
      ibus: "Indice Brut d'Utilisation du Sol (IBUS)",
      im: 'Indice de Masse (IM)',
      ios: "Indice d'Occupation du Sol (IOS)",
      ius: "Indice d'Utilisation du Sol (IUS)",
      livingRatio: "Ratio d'habitation",
      mainFloors: 'Étages principaux',
      maxLength: 'Longueur max',
      noiseSensitivityLevel: 'Niveau de sensibilité au bruit',
      numberOfUnits: "Nombre d'unités",
      officeRatio: 'Ratio de bureaux',
      openSpaceRatio: "Ratio d'espace ouvert",
      roofHeight: 'Hauteur du toit',
      roofSlope: 'Pente du toit',
      smallSetback: 'Petite distance',
      totalFloors: 'Étages totaux',
      totalHeight: 'Hauteur totale',
      undergroundFloors: 'Étages souterrains',
      vbr: 'Volume Bâti de Référence (VBR)',
    },
    metrics: {
      authorised: 'Autorisé',
      current: 'Actuel',
      determiningBuiltArea: 'Surface bâtie déterminante (SBd)',
      determiningBuiltAreaInfo: 'Surface Bâtie déterminante',
      determiningFloorArea: 'Surface de plancher déterminante (SPd)',
      determiningFloorAreaInfo: 'Surface de Plancher déterminante',
      determiningSurfaceArea: 'Surface déterminante du terrain (STd)',
      difference: 'Différence',
      landOccupationIndex: "Indice d'occupation du sol (IOS)",
      landOccupationIndexInfo: "Indice d'Occupation du Sol",
      landUseIndex: "Indice d'utilisation du sol (IUS)",
      landUseIndexInfo: "Indice d'Utilisation du Sol",
    },
    metricsTable: {
      confirmReset: 'Êtes-vous sûr de vouloir réinitialiser toutes les valeurs par défaut ? Cette action est irréversible.',
      derivedSurfaces: {
        builtArea: 'Surface bâtie (SB)',
        builtAreaDesc: 'Surface Bâtie',
        builtVolume: 'Volume bâti de référence (VBR)',
        builtVolumeDesc: 'Volume Bâti de Référence',
        determiningBuiltArea: 'Surface bâtie déterminante (SBd)',
        determiningBuiltAreaDesc: 'Surface Bâtie déterminante',
        determiningFloorArea: 'Surface de plancher déterminante (SPd)',
        determiningFloorAreaDesc: 'Surface de Plancher déterminante',
        floorArea: 'Surface de plancher (SP)',
        floorAreaDesc: 'Surface de Plancher',
        grossUsefulFloorArea: 'Surface brute de plancher utile (SBPU)',
        grossUsefulFloorAreaDesc: 'Surface Brute de Plancher Utile',
      },
      editAuthorizedValues: 'Modifier les valeurs autorisées',
      groups: {
        environmental: 'ENVIRONNEMENT',
        floors: 'ÉTAGES',
        heights: 'HAUTEURS',
        other: 'AUTRES',
        setbacks: 'DISTANCES & DIMENSIONS',
        usageRatios: "RATIOS D'UTILISATION",
      },
      headers: {
        authorized: 'Autorisé',
        current: 'Actuel',
        difference: 'Différence',
        indices: 'Indices',
      },
      noneOption: 'Aucun (masquer cette métrique)',
      resetToDefault: 'Réinitialiser par défaut',
      saveChanges: 'Enregistrer les modifications',
      title: 'Métriques de zone',
      unitLabels: {
        floors: 'étages',
        units: 'unités',
      },
    },
    metricsTitle: 'Surfaces et Indices',
    parameters: {
      limitDistances: 'Distances limites',
      maxFloor: 'Étage max',
      maxHeight: 'Hauteur max',
      noiseSensibilityLevel: 'Niveau de sensibilité au bruit',
    },
    planDetails: {
      affectationName: "Nom d'affectation",
      part: 'Partie',
      planName: 'Nom du plan',
      planType: 'Type de plan',
    },
    progressBar: {
      authorized: 'Autorisé',
      available: 'Disponible',
      currentSituation: 'Situation actuelle',
      remainingPotential: 'Potentiel restant',
      used: 'Utilisé',
      utilization: 'Utilisation',
    },
    purpose: 'Objectif',
    save: 'Enregistrer',
    sourceLabels: {
      estimate: 'Estimé',
      geoportal: 'Géoportail',
      llm: 'Généré par IA',
      manual: 'Manuel',
      old: 'Ancien',
    },
    specialPlans: 'Plan(s) spéciaux',
    status: {
      current: 'En vigueur',
      future: 'Futur',
      past: 'Passé',
    },
    subtitle: 'Réglementations de zone actuelles et potentiel de développement pour',
    title: 'Zone et Règles',
    underExploited: 'Sous-exploité',
    underExploitedInfo: 'Calcul basé sur un IUS informé',
    underExploitedScore: 'Score de sous-exploitation',
    unknownZone: 'Zone inconnue',
    viewDocuments: 'Voir les documents',
    zoneDescriptions: {
      cantonal: "Réglementations de zone cantonales (PAC, Kantonaler Nutzungsplan) définies par les autorités régionales. Ces règles ont la priorité absolue sur tous les plans municipaux et définissent les contraintes de développement générales telles que les zones protégées, les corridors d'infrastructure régionaux et les intérêts cantonaux.",
      general: "Zone municipale de base (PGA, PAL, BZO, Nutzungszonenplan) qui établit la catégorie d'utilisation du sol fondamentale pour cette parcelle, définissant si elle est destinée à un usage résidentiel, commercial, industriel, agricole ou s'il s'agit d'une zone non constructible.",
      local: "Plans d'aménagement de quartier détaillés (PQ, PLQ, Quartierplan, Gestaltungsplan) qui spécifient les exigences de construction précises, y compris l'implantation des bâtiments, les dimensions, les accès et les directives de conception pour des quartiers spécifiques de la commune.",
      partial: 'Zones superposées spéciales (PPA, Sondernutzungsplan, zones IBUS) qui appliquent des restrictions ou modifications supplémentaires à la zone de base. Celles-ci peuvent inclure la protection du patrimoine, des ratios de densité modifiés, des contraintes environnementales ou des exigences de développement spécifiques.',
    },
    zonePriorityLabels: {
      cantonal: 'Autorité cantonale - Priorité absolue',
      general: 'Zone de base - Usage fondamental du sol',
      local: 'Planification détaillée - Règles de quartier',
      partial: 'Zones spéciales - Restrictions supplémentaires',
    },
    zoneTypes: {
      cantonal: 'Cantonal',
      general: 'Communal',
      local: 'Local',
      partial: 'Partiel',
    },
  },
} satisfies AppTranslations
